import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

const _excluded = ["color", "size"];
/**
 * @typedef {Object} CreateProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CreateProps} props
 * @returns {JSX.Element}
 */

const Create = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M117.572 81V49C117.572 44.5817 113.99 41 109.572 41H39C34.5817 41 31 44.5817 31 49V99.0182C31 103.436 34.5817 107.018 39 107.018H91M105 106H128M117 95V118M32 56H116",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const _excluded$1 = ["color", "size"];
/**
 * @typedef {Object} GtCheckboxProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtCheckboxProps} props
 * @returns {JSX.Element}
 */

const GtCheckbox = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M58.9412 73.5294L66.9363 81.5245C68.4984 83.0866 71.031 83.0866 72.5931 81.5245L90.4706 63.647M48 108H100C104.418 108 108 104.418 108 100V48C108 43.5817 104.418 40 100 40H48C43.5817 40 40 43.5817 40 48V100C40 104.418 43.5817 108 48 108Z",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const _excluded$2 = ["color", "size"];
/**
 * @typedef {Object} GtFbCommentProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtFbCommentProps} props
 * @returns {JSX.Element}
 */

const GtFbComment = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M56 55H92M56 67H92M56 79H92M54 105.371C54 106.946 55.7362 107.903 57.068 107.062L72.9535 94.4344C73.3074 94.1531 73.7461 94 74.1981 94H99C103.418 94 107 90.4183 107 86V49C107 44.5817 103.418 41 99 41H49C44.5817 41 41 44.5817 41 49V86C41 90.4183 44.5817 94 49 94H52C53.1046 94 54 94.8954 54 96V105.371Z",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round"
  }));
};

const _excluded$3 = ["color", "size"];
/**
 * @typedef {Object} GtAdsJsonProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtAdsJsonProps} props
 * @returns {JSX.Element}
 */

const GtAdsJson = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M60.6353 69.8767L72.0356 47.5517C72.1508 47.3129 72.1508 47.0742 72.1508 46.8354L71.2348 36.6747C71.0918 35.0879 71.9106 33.5305 73.4696 33.2017C75.0463 32.8691 77.1464 32.8212 79.0601 34.0612C83.3208 36.8071 84.8179 41.4631 84.8179 47.1935C84.8179 51.4914 83.8966 56.028 83.6663 58.0576H102.437C105.546 58.0576 108.31 60.2065 108.885 63.4299C109.346 66.1757 108.194 68.6828 106.237 69.996C107.849 71.1899 109 73.1001 109 75.3684C109 77.8754 107.619 80.1438 105.546 81.2182C106.237 82.2927 106.697 83.6059 106.697 84.9192C106.697 88.1425 104.394 90.8884 101.4 91.3659C101.976 92.5598 102.321 93.873 102.091 95.3056C101.631 98.6484 98.7516 101.036 95.5273 101.036H67.5446C64.0899 101.036 60.6353 98.6484 60.6353 95.0669V69.8767Z",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0005 75.2927C39.0005 70.8744 42.5822 67.2927 47.0005 67.2927H52.7647C57.183 67.2927 60.7647 70.8744 60.7647 75.2927V99.2927C60.7647 103.711 57.183 107.293 52.7647 107.293H41.0005C39.8959 107.293 39.0005 106.397 39.0005 105.293V75.2927Z",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const _excluded$4 = ["color", "size"];
/**
 * @typedef {Object} GtBarProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtBarProps} props
 * @returns {JSX.Element}
 */

const GtBar = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M31.2505 60.5657V99.0341C31.2505 103.452 34.8322 107.034 39.2505 107.034H108.75C113.169 107.034 116.75 103.452 116.75 99.0341V60.5657",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0005 40H111C114.314 40 117 42.6863 117 46V63.0908H31.0005V46C31.0005 42.6863 33.6868 40 37.0005 40Z",
    stroke: color,
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7275 51.0455L70.3185 51.0455",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1372 47.6656H104.137C105.242 47.6656 106.137 48.5611 106.137 49.6656V53.6656C106.137 54.7702 105.242 55.6656 104.137 55.6656H84.1372C83.0326 55.6656 82.1372 54.7702 82.1372 53.6656V49.6656C82.1372 48.5611 83.0326 47.6656 84.1372 47.6656Z",
    stroke: color,
    strokeWidth: "4"
  }));
};

const _excluded$5 = ["color", "size"];
/**
 * @typedef {Object} GtModalProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtModalProps} props
 * @returns {JSX.Element}
 */

const GtModal = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    x: "31.0005",
    y: "40",
    width: "86",
    height: "66",
    rx: "8",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0005 51H94.3335C95.4381 51 96.3335 51.8954 96.3335 53V93.8057C96.3334 94.9102 95.438 95.8057 94.3335 95.8057H54.0005C52.896 95.8057 52.0005 94.9102 52.0005 93.8057V53L52.0112 52.7959C52.1135 51.7872 52.9648 51 54.0005 51Z",
    stroke: color,
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9312 70.8057H78.7506M63.0005 65.3057H85.931M65.5007 59.8193H83.1396",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "62.0005",
    y: "79.3223",
    width: "24",
    height: "8",
    rx: "2",
    stroke: color,
    strokeWidth: "4"
  }));
};

const _excluded$6 = ["color", "size"];
/**
 * @typedef {Object} GtSlideInProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtSlideInProps} props
 * @returns {JSX.Element}
 */

const GtSlideIn = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M31.0005 47.5C31.0005 43.0817 34.5822 39.5 39.0005 39.5H109C113.419 39.5 117 43.0817 117 47.5V97.5C117 101.918 113.419 105.5 109 105.5H39.0005C34.5822 105.5 31.0005 101.918 31.0005 97.5V47.5Z",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7778 80.5H90.5973M74.8472 73H97.7777",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0005 62.6943H104.333C105.438 62.6943 106.333 63.5898 106.333 64.6943V105.5H66.0005V64.6943L66.0112 64.4902C66.1135 63.4816 66.9648 62.6943 68.0005 62.6943Z",
    stroke: color,
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "73.8696",
    y: "90.0166",
    width: "24",
    height: "8",
    rx: "2",
    stroke: color,
    strokeWidth: "4"
  }));
};

const _excluded$7 = ["color", "size"];
/**
 * @typedef {Object} GtBoxProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtBoxProps} props
 * @returns {JSX.Element}
 */

const GtBox = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    x: "30.0005",
    y: "39",
    width: "88",
    height: "67.4545",
    rx: "8",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7778 75.5H94.5973M78.8472 68H101.778",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0005 60H108C109.105 60 110 60.8954 110 62V97C110 98.1046 109.105 99 108 99H72.0005C70.8959 99 70.0005 98.1046 70.0005 97V62C70.0005 60.8954 70.8959 60 72.0005 60Z",
    stroke: color,
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "78.0005",
    y: "83.3223",
    width: "24",
    height: "8",
    rx: "2",
    stroke: color,
    strokeWidth: "4"
  }));
};

const _excluded$8 = ["color", "size"];
/**
 * @typedef {Object} GtFbCodeProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtFbCodeProps} props
 * @returns {JSX.Element}
 */

const GtFbCode = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0005 36C71.6169 36 69.6847 37.9322 69.6847 40.3158C69.6847 42.6993 71.6169 44.6316 74.0005 44.6316C76.384 44.6316 78.3163 42.6993 78.3163 40.3158C78.3163 37.9322 76.384 36 74.0005 36ZM65.6847 40.3158C65.6847 35.7231 69.4078 32 74.0005 32C78.5932 32 82.3163 35.7231 82.3163 40.3158C82.3163 44.9085 78.5932 48.6316 74.0005 48.6316C69.4078 48.6316 65.6847 44.9085 65.6847 40.3158ZM59.6026 36.1765C60.0574 37.1831 59.6101 38.3678 58.6035 38.8226C56.676 39.6935 54.8326 40.7218 53.0895 41.8914C52.1723 42.5069 50.9298 42.2623 50.3144 41.3451C49.6989 40.4279 49.9435 39.1854 50.8607 38.5699C52.7866 37.2776 54.8244 36.1407 56.9565 35.1774C57.9631 34.7226 59.1478 35.1699 59.6026 36.1765ZM93.5534 38.4844C94.1398 37.5484 95.374 37.2649 96.31 37.8513C103.608 42.4232 109.417 49.1837 112.841 57.2248C113.273 58.2411 112.8 59.4157 111.784 59.8484C110.768 60.2811 109.593 59.808 109.16 58.7917C106.058 51.5054 100.794 45.3802 94.1865 41.2411C93.2504 40.6547 92.967 39.4205 93.5534 38.4844ZM48.1493 43.0788C48.9092 43.8804 48.8755 45.1462 48.0739 45.9062C44.6719 49.1314 41.8559 52.9803 39.805 57.2715C39.3287 58.2681 38.1346 58.6899 37.1381 58.2136C36.1415 57.7373 35.7197 56.5433 36.196 55.5467C38.4597 50.8102 41.5673 46.5629 45.3219 43.0034C46.1235 42.2434 47.3893 42.2772 48.1493 43.0788ZM84.4973 46.1855C84.9471 45.1767 86.1296 44.7235 87.1384 45.1734C90.7484 46.783 93.9995 49.0324 96.7411 51.7747C97.522 52.5559 97.5219 53.8222 96.7407 54.6032C95.9596 55.3841 94.6933 55.384 93.9123 54.6028C91.5147 52.2046 88.6697 50.2358 85.5094 48.8266C84.5006 48.3768 84.0475 47.1943 84.4973 46.1855ZM60.1509 47.5944C60.7153 48.5439 60.4032 49.7712 59.4538 50.3356C55.4307 52.7273 52.0761 56.0837 49.7229 60.0711C49.1615 61.0223 47.9352 61.3384 46.984 60.777C46.0327 60.2156 45.7167 58.9893 46.2781 58.038C48.9766 53.4656 52.8156 49.6285 57.4097 46.8973C58.3591 46.3329 59.5864 46.645 60.1509 47.5944ZM40.3163 69.6842C37.9327 69.6842 36.0005 71.6165 36.0005 74C36.0005 76.3835 37.9327 78.3158 40.3163 78.3158C42.6998 78.3158 44.6321 76.3835 44.6321 74C44.6321 71.6165 42.6998 69.6842 40.3163 69.6842ZM32.0005 74C32.0005 69.4073 35.7236 65.6842 40.3163 65.6842C44.909 65.6842 48.6321 69.4073 48.6321 74C48.6321 78.5927 44.909 82.3158 40.3163 82.3158C35.7236 82.3158 32.0005 78.5927 32.0005 74ZM107.685 69.6842C105.301 69.6842 103.369 71.6165 103.369 74C103.369 76.3835 105.301 78.3158 107.685 78.3158C110.068 78.3158 112 76.3835 112 74C112 71.6165 110.068 69.6842 107.685 69.6842ZM99.3689 74C99.3689 69.4073 103.092 65.6842 107.685 65.6842C112.277 65.6842 116 69.4073 116 74C116 78.5927 112.277 82.3158 107.685 82.3158C103.092 82.3158 99.3689 78.5927 99.3689 74ZM101.873 84.5086C102.867 84.9903 103.282 86.1866 102.8 87.1806C101.767 89.312 100.497 91.3096 99.0239 93.1409C98.3316 94.0016 97.0726 94.1381 96.212 93.4458C95.3513 92.7534 95.2148 91.4945 95.9072 90.6338C97.1938 89.0343 98.3012 87.292 99.2007 85.4361C99.6825 84.4421 100.879 84.0268 101.873 84.5086ZM111.784 88.1516C112.8 88.5843 113.273 89.7589 112.841 90.7752C110.25 96.8609 106.293 102.212 101.359 106.437C100.52 107.155 99.2574 107.057 98.539 106.218C97.8206 105.379 97.9184 104.117 98.7574 103.398C103.227 99.571 106.813 94.7216 109.16 89.2083C109.593 88.192 110.768 87.7189 111.784 88.1516ZM49.6994 91.0791C50.538 90.3603 51.8006 90.4574 52.5195 91.2961C54.9697 94.1549 58.007 96.5172 61.4503 98.2039C62.4423 98.6898 62.8525 99.8878 62.3667 100.88C61.8808 101.872 60.6827 102.282 59.6908 101.796C55.7578 99.8696 52.286 97.1703 49.4823 93.8992C48.7635 93.0605 48.8607 91.7979 49.6994 91.0791ZM38.6886 93.069C39.6387 92.5056 40.8656 92.819 41.4291 93.7691C45.4378 100.529 51.4382 105.94 58.6035 109.177C59.6101 109.632 60.0574 110.817 59.6026 111.823C59.1478 112.83 57.9631 113.277 56.9565 112.823C49.0328 109.242 42.4105 103.266 37.9886 95.8094C37.4252 94.8594 37.7386 93.6324 38.6886 93.069ZM94.2258 95.4069C94.9082 96.2754 94.7574 97.5327 93.8888 98.2151C92.6323 99.2025 91.2981 100.099 89.8967 100.893C88.9358 101.438 87.7152 101.101 87.1704 100.14C86.6256 99.1789 86.9629 97.9584 87.9237 97.4135C89.1504 96.718 90.318 95.9338 91.4175 95.0699C92.286 94.3875 93.5433 94.5383 94.2258 95.4069ZM74.0005 103.368C71.6169 103.368 69.6847 105.301 69.6847 107.684C69.6847 110.068 71.6169 112 74.0005 112C76.384 112 78.3163 110.068 78.3163 107.684C78.3163 105.301 76.384 103.368 74.0005 103.368ZM65.6847 107.684C65.6847 103.092 69.4078 99.3684 74.0005 99.3684C78.5932 99.3684 82.3163 103.092 82.3163 107.684C82.3163 112.277 78.5932 116 74.0005 116C69.4078 116 65.6847 112.277 65.6847 107.684ZM96.9431 107.392C97.5295 108.328 97.2461 109.562 96.31 110.149C94.8867 111.04 93.4065 111.849 91.8762 112.567C90.8764 113.037 89.6853 112.607 89.2158 111.607C88.7463 110.607 89.1763 109.416 90.1761 108.947C91.5597 108.297 92.8985 107.566 94.1865 106.759C95.1225 106.173 96.3568 106.456 96.9431 107.392Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3379 65.8312L58.471 78.5568C58.0603 78.9629 58.5511 79.6264 59.0597 79.3525L69.1416 73.9227C69.3351 73.8184 69.574 73.8528 69.7303 74.0074L75.9601 80.1688C76.1549 80.3614 76.4685 80.3614 76.6633 80.1688L89.6595 67.3154C90.067 66.9124 89.5864 66.2522 89.0777 66.516L78.6792 71.9094C78.4867 72.0092 78.2517 71.9736 78.0974 71.821L72.0411 65.8312C71.8463 65.6386 71.5327 65.6386 71.3379 65.8312Z",
    fill: color
  }));
};

const _excluded$9 = ["color", "size"];
/**
 * @typedef {Object} GtRefProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtRefProps} props
 * @returns {JSX.Element}
 */

const GtRef = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M64.9338 97.6869C62.2648 98.5373 59.3926 99 56.4005 99H43.6005C29.462 99 18.0005 88.6681 18.0005 75.9231V72.0769C18.0005 59.3319 29.462 49 43.6005 49H56.4005C70.539 49 82.0005 59.3319 82.0005 72.0769V75.9231C82.0005 78.6203 81.4872 81.2094 80.5438 83.6154M83.0672 50.3131C85.7362 49.4627 88.6084 49 91.6005 49H104.4C118.539 49 130 59.3319 130 72.0769V75.9231C130 88.6681 118.539 99 104.4 99H91.6005C77.462 99 66.0005 88.6681 66.0005 75.9231V72.0769C66.0005 69.2462 66.5659 66.5344 67.6005 64.0285",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const _excluded$a = ["color", "size"];
/**
 * @typedef {Object} GtCustomerChatProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtCustomerChatProps} props
 * @returns {JSX.Element}
 */

const GtCustomerChat = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M71.3379 63.8311L58.471 76.5566C58.0603 76.9628 58.5511 77.6262 59.0597 77.3524L69.1416 71.9225C69.3351 71.8183 69.574 71.8527 69.7303 72.0072L75.9601 78.1686C76.1549 78.3613 76.4685 78.3613 76.6633 78.1686L89.6595 65.3152C90.067 64.9123 89.5864 64.252 89.0777 64.5159L78.6792 69.9092C78.4867 70.0091 78.2517 69.9734 78.0974 69.8209L72.0411 63.8311C71.8463 63.6385 71.5327 63.6385 71.3379 63.8311Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0005 39.5C55.9508 39.5 41.5005 53.1205 41.5005 69.7056C41.5005 78.772 45.8003 86.9287 52.656 92.4832C53.0222 92.7798 53.2276 93.2314 53.2107 93.7024L52.7838 105.62C52.7701 106.003 53.1749 106.258 53.5147 106.081L66.3068 99.4085C66.6082 99.2513 66.9541 99.2011 67.2878 99.2662C69.4525 99.6887 71.6977 99.9111 74.0005 99.9111C92.0502 99.9111 106.5 86.2907 106.5 69.7056C106.5 53.1205 92.0502 39.5 74.0005 39.5ZM38.5005 69.7056C38.5005 51.2697 54.4948 36.5 74.0005 36.5C93.5062 36.5 109.5 51.2697 109.5 69.7056C109.5 88.1415 93.5062 102.911 74.0005 102.911C71.6879 102.911 69.4255 102.704 67.2339 102.309L54.9022 108.741C52.523 109.982 49.6897 108.194 49.7858 105.512L50.1862 94.3328C43.0276 88.2728 38.5005 79.4948 38.5005 69.7056Z",
    fill: color
  }));
};

const _excluded$b = ["color", "size"];
/**
 * @typedef {Object} GtButtonProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtButtonProps} props
 * @returns {JSX.Element}
 */

const GtButton = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0005 41C37.4601 41 36.9394 41.0709 36.4457 41.2029C35.3786 41.4881 34.2823 40.8543 33.997 39.7872C33.7118 38.7201 34.3456 37.6238 35.4127 37.3386C36.2403 37.1174 37.1082 37 38.0005 37H40.0005C41.1051 37 42.0005 37.8954 42.0005 39C42.0005 40.1046 41.1051 41 40.0005 41H38.0005ZM46.0005 39C46.0005 37.8954 46.8959 37 48.0005 37H52.0005C53.1051 37 54.0005 37.8954 54.0005 39C54.0005 40.1046 53.1051 41 52.0005 41H48.0005C46.8959 41 46.0005 40.1046 46.0005 39ZM58.0005 39C58.0005 37.8954 58.8959 37 60.0005 37H64.0005C65.1051 37 66.0005 37.8954 66.0005 39C66.0005 40.1046 65.1051 41 64.0005 41H60.0005C58.8959 41 58.0005 40.1046 58.0005 39ZM70.0005 39C70.0005 37.8954 70.8959 37 72.0005 37H76.0005C77.1051 37 78.0005 37.8954 78.0005 39C78.0005 40.1046 77.1051 41 76.0005 41H72.0005C70.8959 41 70.0005 40.1046 70.0005 39ZM82.0005 39C82.0005 37.8954 82.8959 37 84.0005 37H88.0005C89.1051 37 90.0005 37.8954 90.0005 39C90.0005 40.1046 89.1051 41 88.0005 41H84.0005C82.8959 41 82.0005 40.1046 82.0005 39ZM94.0005 39C94.0005 37.8954 94.8959 37 96.0005 37H100C101.105 37 102 37.8954 102 39C102 40.1046 101.105 41 100 41H96.0005C94.8959 41 94.0005 40.1046 94.0005 39ZM106 39C106 37.8954 106.896 37 108 37H110C110.893 37 111.761 37.1174 112.588 37.3386C113.655 37.6238 114.289 38.7201 114.004 39.7872C113.719 40.8543 112.622 41.4881 111.555 41.2029C111.062 41.0709 110.541 41 110 41H108C106.896 41 106 40.1046 106 39ZM30.7877 42.9965C31.8548 43.2818 32.4886 44.3781 32.2034 45.4452C32.0714 45.9389 32.0005 46.4596 32.0005 47V49.1439C32.0005 50.2485 31.1051 51.1439 30.0005 51.1439C28.8959 51.1439 28.0005 50.2485 28.0005 49.1439V47C28.0005 46.1077 28.1178 45.2398 28.3391 44.4122C28.6243 43.3451 29.7206 42.7113 30.7877 42.9965ZM117.213 42.9965C118.28 42.7113 119.377 43.3451 119.662 44.4122C119.883 45.2398 120 46.1077 120 47V49.1439C120 50.2485 119.105 51.1439 118 51.1439C116.896 51.1439 116 50.2485 116 49.1439V47C116 46.4596 115.93 45.9389 115.798 45.4452C115.512 44.3781 116.146 43.2818 117.213 42.9965ZM30.0005 55.7197C31.1051 55.7197 32.0005 56.6151 32.0005 57.7197V62.0076C32.0005 63.1121 31.1051 64.0076 30.0005 64.0076C28.8959 64.0076 28.0005 63.1121 28.0005 62.0076V57.7197C28.0005 56.6151 28.8959 55.7197 30.0005 55.7197ZM118 55.7197C119.105 55.7197 120 56.6151 120 57.7197V62.0076C120 63.1121 119.105 64.0076 118 64.0076C116.896 64.0076 116 63.1121 116 62.0076V57.7197C116 56.6151 116.896 55.7197 118 55.7197ZM30.0005 68.5833C31.1051 68.5833 32.0005 69.4788 32.0005 70.5833V74.8712C32.0005 75.9758 31.1051 76.8712 30.0005 76.8712C28.8959 76.8712 28.0005 75.9758 28.0005 74.8712V70.5833C28.0005 69.4788 28.8959 68.5833 30.0005 68.5833ZM118 68.5833C119.105 68.5833 120 69.4788 120 70.5833V74.8712C120 75.9758 119.105 76.8712 118 76.8712C116.896 76.8712 116 75.9758 116 74.8712V70.5833C116 69.4788 116.896 68.5833 118 68.5833ZM30.0005 81.447C31.1051 81.447 32.0005 82.3424 32.0005 83.447V87.7348C32.0005 88.8394 31.1051 89.7348 30.0005 89.7348C28.8959 89.7348 28.0005 88.8394 28.0005 87.7348V83.447C28.0005 82.3424 28.8959 81.447 30.0005 81.447ZM118 81.447C119.105 81.447 120 82.3424 120 83.447V87.7349C120 88.8394 119.105 89.7349 118 89.7349C116.896 89.7349 116 88.8394 116 87.7349V83.447C116 82.3424 116.896 81.447 118 81.447ZM30.0005 94.3106C31.1051 94.3106 32.0005 95.206 32.0005 96.3106V98.4545C32.0005 98.9949 32.0714 99.5157 32.2034 100.009C32.4886 101.076 31.8548 102.173 30.7877 102.458C29.7206 102.743 28.6243 102.109 28.3391 101.042C28.1178 100.215 28.0005 99.3468 28.0005 98.4545V96.3106C28.0005 95.206 28.8959 94.3106 30.0005 94.3106ZM118 94.3106C119.105 94.3106 120 95.206 120 96.3106V98.4545C120 99.3468 119.883 100.215 119.662 101.042C119.377 102.109 118.28 102.743 117.213 102.458C116.146 102.173 115.512 101.076 115.798 100.009C115.93 99.5157 116 98.9949 116 98.4545V96.3106C116 95.206 116.896 94.3106 118 94.3106ZM33.997 105.667C34.2823 104.6 35.3786 103.966 36.4457 104.252C36.9393 104.384 37.4601 104.455 38.0005 104.455H40.0005C41.1051 104.455 42.0005 105.35 42.0005 106.455C42.0005 107.559 41.1051 108.455 40.0005 108.455H38.0005C37.1082 108.455 36.2403 108.337 35.4127 108.116C34.3456 107.831 33.7118 106.734 33.997 105.667ZM114.004 105.667C114.289 106.734 113.655 107.831 112.588 108.116C111.761 108.337 110.893 108.455 110 108.455H108C106.896 108.455 106 107.559 106 106.455C106 105.35 106.896 104.455 108 104.455H110C110.541 104.455 111.062 104.384 111.555 104.252C112.622 103.966 113.719 104.6 114.004 105.667ZM46.0005 106.455C46.0005 105.35 46.8959 104.455 48.0005 104.455H52.0005C53.1051 104.455 54.0005 105.35 54.0005 106.455C54.0005 107.559 53.1051 108.455 52.0005 108.455H48.0005C46.8959 108.455 46.0005 107.559 46.0005 106.455ZM58.0005 106.455C58.0005 105.35 58.8959 104.455 60.0005 104.455H64.0005C65.1051 104.455 66.0005 105.35 66.0005 106.455C66.0005 107.559 65.1051 108.455 64.0005 108.455H60.0005C58.8959 108.455 58.0005 107.559 58.0005 106.455ZM70.0005 106.455C70.0005 105.35 70.8959 104.455 72.0005 104.455H76.0005C77.1051 104.455 78.0005 105.35 78.0005 106.455C78.0005 107.559 77.1051 108.455 76.0005 108.455H72.0005C70.8959 108.455 70.0005 107.559 70.0005 106.455ZM82.0005 106.455C82.0005 105.35 82.8959 104.455 84.0005 104.455H88.0005C89.1051 104.455 90.0005 105.35 90.0005 106.455C90.0005 107.559 89.1051 108.455 88.0005 108.455H84.0005C82.8959 108.455 82.0005 107.559 82.0005 106.455ZM94.0005 106.455C94.0005 105.35 94.8959 104.455 96.0005 104.455H100C101.105 104.455 102 105.35 102 106.455C102 107.559 101.105 108.455 100 108.455H96.0005C94.8959 108.455 94.0005 107.559 94.0005 106.455Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0005 92.9998C52.0005 91.8952 52.8959 90.9998 54.0005 90.9998H74.0005C75.1051 90.9998 76.0005 91.8952 76.0005 92.9998C76.0005 94.1043 75.1051 94.9998 74.0005 94.9998H54.0005C52.8959 94.9998 52.0005 94.1043 52.0005 92.9998Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0005 77.2517H44.0005L44.0005 81.2517H84.0005V77.2517ZM44.0005 73.2517C41.7913 73.2517 40.0005 75.0426 40.0005 77.2517V81.2517C40.0005 83.4608 41.7913 85.2517 44.0005 85.2517H84.0005C86.2096 85.2517 88.0005 83.4608 88.0005 81.2517V77.2517C88.0005 75.0426 86.2096 73.2517 84.0005 73.2517H44.0005Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0005 96.9998C46.2096 96.9998 48.0005 95.2089 48.0005 92.9998C48.0005 90.7906 46.2096 88.9998 44.0005 88.9998C41.7913 88.9998 40.0005 90.7906 40.0005 92.9998C40.0005 95.2089 41.7913 96.9998 44.0005 96.9998Z",
    fill: color
  }));
};

const _excluded$c = ["color", "size"];
/**
 * @typedef {Object} GtTakeoverProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtTakeoverProps} props
 * @returns {JSX.Element}
 */

const GtTakeover = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("rect", {
    x: "30.0005",
    y: "39",
    width: "88",
    height: "67.4545",
    rx: "8",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5005 70.1875H82.5005",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7505 54H87.2505",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0005 62H92.0005",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "51.0005",
    y: "82.125",
    width: "44",
    height: "8",
    rx: "2",
    stroke: color,
    strokeWidth: "4"
  }));
};

const _excluded$d = ["color", "size"];
/**
 * @typedef {Object} GtLandingProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtLandingProps} props
 * @returns {JSX.Element}
 */

const GtLanding = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M30.0005 48C30.0005 43.5817 33.5822 40 38.0005 40H110C114.419 40 118 43.5817 118 48V100C118 104.418 114.419 108 110 108H38.0005C33.5822 108 30.0005 104.418 30.0005 100V48Z",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9731 57H84.155L77.7033 63.3636L84.155 69.7273H65.9731V57Z",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9731 87.5L65.9731 57.5",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0005 91.5808C56.761 83.9587 64.8426 78.9492 73.9723 78.9492C83.102 78.9492 91.1837 83.9587 95.9441 91.5808",
    stroke: color,
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

const _excluded$e = ["color", "size"];
/**
 * @typedef {Object} CheckCircleProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CheckCircleProps} props
 * @returns {JSX.Element}
 */

const CheckCircle = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.4902 17.5122 22 12.0488 22C6.58537 22 2 17.5882 2 12C2 6.41176 6.4878 2 11.9512 2C13.5122 2 14.9756 2.39216 16.3415 3.07843V4.7451C14.9756 3.96078 13.5122 3.47059 11.9512 3.47059C7.26829 3.47059 3.46341 7.29412 3.46341 12C3.46341 16.7059 7.26829 20.6275 11.9512 20.6275C16.6341 20.6275 20.5366 16.7059 20.5366 12C20.5366 10.8235 20.2439 9.54902 19.7561 8.47059H21.3171C21.7073 9.64706 22 10.8235 22 12ZM9.5122 10.1373H7.46341L12.0488 14.7451L21.5122 3.56863H19.561L11.9512 12.5882L9.5122 10.1373Z",
    fill: color
  }));
};

const _excluded$f = ["color", "size"];
/**
 * @typedef {Object} TimeProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TimeProps} props
 * @returns {JSX.Element}
 */

const Time = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.51923 2 2 6.51923 2 12C2 17.4808 6.51923 22 12 22C17.4808 22 22 17.4808 22 12C22 6.51923 17.5769 2 12 2ZM12 20.5577C7.28846 20.5577 3.44231 16.7115 3.44231 12C3.44231 7.28846 7.28846 3.44231 12 3.44231C16.7115 3.44231 20.5577 7.28846 20.5577 12C20.5577 16.7115 16.7115 20.5577 12 20.5577ZM18.9231 11.3269V12.7692H11.7115L8.44231 8.53846V6.23077L12.3846 11.2308H18.9231V11.3269Z",
    fill: color
  }));
};

const _excluded$g = ["color", "size"];
/**
 * @typedef {Object} NationalityProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {NationalityProps} props
 * @returns {JSX.Element}
 */

const Nationality = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.46602 2 2 6.46602 2 12C2 17.534 6.46602 22 12 22C17.534 22 22 17.534 22 12C22 6.46602 17.534 2 12 2ZM20.5437 11.3204H17.0485C16.9515 8.11651 15.9806 5.39806 14.6214 3.94175C17.8252 4.91262 20.2524 7.82524 20.5437 11.3204ZM12 20.0583C10.4466 20.0583 8.60194 17.1456 8.50485 12.7767H15.5922C15.3981 17.0485 13.5534 20.0583 12 20.0583ZM8.50485 11.3204C8.69903 6.95146 10.4466 4.03883 12 4.03883C13.5534 4.03883 15.3981 6.95146 15.4951 11.3204H8.50485ZM9.37864 3.84466C8.01942 5.39806 7.14563 8.11651 7.04854 11.3204H3.45631C3.74757 7.82524 6.17476 4.91262 9.37864 3.84466ZM3.45631 12.7767H6.95146C7.04854 15.9806 8.01942 18.699 9.37864 20.1553C6.17476 19.0874 3.74757 16.2718 3.45631 12.7767ZM14.6214 20.1553C15.9806 18.6019 16.9515 15.9806 17.0485 12.7767H20.5437C20.2524 16.2718 17.8252 19.0874 14.6214 20.1553Z",
    fill: color
  }));
};

const _excluded$h = ["color", "size"];
/**
 * @typedef {Object} MentionProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MentionProps} props
 * @returns {JSX.Element}
 */

const Mention = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21.9574 10.9C21.461 5.7 17.3901 2 11.9291 2C6.46809 2 2 6.5 2 12C2 17.5 6.46809 22 11.9291 22V20.5C7.26241 20.5 3.48936 16.7 3.48936 12C3.48936 7.3 7.26241 3.5 11.9291 3.5C16.5957 3.5 19.9716 6.5 20.3688 11.1C20.6667 13.9 19.7731 15.2 19.3759 15.6C19.078 15.9 18.6809 16.1 18.383 16.1C17.8865 16.1 17.5887 15.7 17.3901 15.4C16.5957 14.2 16.3972 11.6 17.8865 7.8H16.2979C16.0993 8.3 15.9007 8.8 15.8014 9.3C15.1064 7.7 13.8156 6.6 12.227 6.4C9.64539 6.1 7.3617 8.4 7.06383 11.6C6.76596 14.7 8.55319 17.4 11.1348 17.7C13.0213 17.9 14.7092 16.8 15.6028 15C15.7021 15.5 15.9007 15.9 16.1986 16.3C16.7943 17.2 17.4894 17.6 18.383 17.7C19.1773 17.7 19.8723 17.4 20.4681 16.7C21.6596 15.4 22.156 13.3 21.9574 10.9ZM14.8085 12.3C14.6099 14.6 13.0213 16.3 11.3333 16.1C9.5461 16 8.35461 14 8.55319 11.7C8.75177 9.5 10.1418 7.9 11.8298 7.9C11.9291 7.9 12.0284 7.9 12.0284 7.9C13.8156 8.1 15.0071 10 14.8085 12.3Z",
    fill: color
  }));
};

const _excluded$i = ["color", "size"];
/**
 * @typedef {Object} QuestionProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {QuestionProps} props
 * @returns {JSX.Element}
 */

const Question = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.51923 2 2 6.51923 2 12C2 17.4808 6.51923 22 12 22C17.4808 22 22 17.4808 22 12C22 6.51923 17.5769 2 12 2ZM12 20.5577C7.28846 20.5577 3.44231 16.7115 3.44231 12C3.44231 7.28846 7.28846 3.44231 12 3.44231C16.7115 3.44231 20.5577 7.28846 20.5577 12C20.5577 16.7115 16.7115 20.5577 12 20.5577ZM12.9615 17.6731C12.9615 18.1538 12.5769 18.6346 12 18.6346C11.5192 18.6346 11.0385 18.25 11.0385 17.6731C11.0385 17.0962 11.4231 16.7115 12 16.7115C12.5769 16.7115 12.9615 17.1923 12.9615 17.6731ZM16.2308 9.01923C16.2308 10.3654 15.6538 11.4231 14.3077 12.4808C13.0577 13.4423 12.6731 14.2115 12.6731 15.4615H11.2308C11.2308 13.7308 11.8077 12.6731 13.3462 11.3269C14.5 10.3654 14.7885 9.69231 14.7885 9.01923C14.7885 8.25 14.2115 7.28846 12.9615 7C12 6.80769 11.0385 7 10.3654 7.57692C9.78846 8.05769 9.59615 8.82692 9.59615 9.98077H8.15385C8.15385 8.44231 8.63462 7.28846 9.5 6.51923C10.4615 5.65385 12 5.36538 13.3462 5.65385C15.0769 6.03846 16.2308 7.38462 16.2308 9.01923Z",
    fill: color
  }));
};

const _excluded$j = ["color", "size"];
/**
 * @typedef {Object} AddCircleProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AddCircleProps} props
 * @returns {JSX.Element}
 */

const AddCircle = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.5098 2 2 6.5098 2 12C2 17.4902 6.5098 22 12 22C17.4902 22 22 17.4902 22 12C22 6.5098 17.5882 2 12 2ZM12 20.6275C7.29412 20.6275 3.47059 16.8039 3.47059 12.098C3.47059 7.39216 7.29412 3.56863 12 3.56863C16.7059 3.56863 20.6275 7.29412 20.6275 12C20.6275 16.8039 16.8039 20.6275 12 20.6275ZM12.7843 11.3137H17.7843V12.7843H12.7843V17.8824H11.3137V12.7843H6.31373V11.3137H11.4118V6.21569H12.7843V11.3137Z",
    fill: color
  }));
};

const _excluded$k = ["color", "size"];
/**
 * @typedef {Object} UnsubscribedProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {UnsubscribedProps} props
 * @returns {JSX.Element}
 */

const Unsubscribed = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M15.5357 7.42392L12.0002 10.9595L8.39534 7.3546L7.4248 8.32513L11.0297 11.93L7.4248 15.5349L8.46467 16.5747L12.0002 13.0392L15.6051 16.644L16.6449 15.6042L13.0401 11.9993L16.5756 8.46378L15.5357 7.42392Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5098 6.5098 2 12 2C17.5882 2 22 6.5098 22 12C22 17.4902 17.4902 22 12 22C6.5098 22 2 17.4902 2 12ZM3.47059 12.098C3.47059 16.8039 7.29412 20.6275 12 20.6275C16.8039 20.6275 20.6275 16.8039 20.6275 12C20.6275 7.29412 16.7059 3.56863 12 3.56863C7.29412 3.56863 3.47059 7.39216 3.47059 12.098Z",
    fill: color
  }));
};

const _excluded$l = ["color", "size"];
/**
 * @typedef {Object} SmileProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SmileProps} props
 * @returns {JSX.Element}
 */

const Smile = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.0874 4.91262C17.2427 3.06796 14.7184 2 12 2C9.28155 2 6.85437 3.06796 4.91262 4.91262C3.06796 6.85437 2 9.37864 2 12C2 14.6214 3.06796 17.1456 4.91262 19.0874C6.75728 20.932 9.28155 22 12 22C14.7184 22 17.1456 20.932 19.0874 19.0874C22.9709 15.2039 22.9709 8.79612 19.0874 4.91262ZM18.0194 18.0194C16.3689 19.6699 14.233 20.5437 12 20.5437C9.76699 20.5437 7.53398 19.6699 5.98058 18.0194C4.3301 16.3689 3.45631 14.233 3.45631 12C3.45631 9.76699 4.3301 7.53398 5.98058 5.98058C7.53398 4.3301 9.76699 3.45631 12 3.45631C14.233 3.45631 16.466 4.3301 18.0194 5.98058C21.4175 9.28155 21.4175 14.7184 18.0194 18.0194ZM8.31068 10.932C8.31068 9.6699 8.69903 8.69903 9.18447 8.69903C9.6699 8.69903 10.0583 9.6699 10.0583 10.932C10.0583 12.1942 9.6699 13.165 9.18447 13.165C8.69903 13.165 8.31068 12.1942 8.31068 10.932ZM13.9417 10.932C13.9417 9.6699 14.3301 8.69903 14.8155 8.69903C15.301 8.69903 15.6893 9.6699 15.6893 10.932C15.6893 12.1942 15.301 13.165 14.8155 13.165C14.3301 13.165 13.9417 12.1942 13.9417 10.932ZM16.1748 15.9806H18.0194C17.7282 16.3689 17.4369 16.7573 17.1456 17.1456C15.7864 18.6019 13.9417 19.3786 12 19.3786C10.0583 19.3786 8.21359 18.6019 6.85437 17.1456C6.56311 16.7573 6.27184 16.3689 5.98058 15.9806H7.82524L7.92233 16.0777C8.99029 17.2427 10.4466 17.8252 12 17.8252C13.5534 17.8252 15.0097 17.1456 16.0777 16.0777C16.0777 16.0777 16.0777 16.0777 16.1748 15.9806Z",
    fill: color
  }));
};

const _excluded$m = ["color", "size"];
/**
 * @typedef {Object} TimeAddProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TimeAddProps} props
 * @returns {JSX.Element}
 */

const TimeAdd = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21.3103 11.604C21.3103 11.802 21.3103 12.099 21.3103 12.297C21.3103 17.6436 16.9754 22 11.6552 22C6.33498 22 2 17.6436 2 12.198C2 6.75248 6.33498 2.49505 11.6552 2.49505C12.1478 2.49505 12.5419 2.49505 13.0345 2.59406V4.07921C12.5419 4.07921 12.1478 3.9802 11.6552 3.9802C7.12315 3.9802 3.47783 7.64356 3.47783 12.198C3.47783 16.7525 7.12315 20.4158 11.6552 20.4158C16.1872 20.4158 19.8325 16.7525 19.8325 12.198C19.8325 12 19.8325 11.703 19.8325 11.505H21.3103V11.604ZM18.8473 5.16832V2H17.3695V5.16832H14.2167V6.65346H17.3695V9.82178H18.8473V6.65346H22V5.16832H18.8473ZM8.10837 6.55446V8.93069L11.2611 12.9901H18.0591V11.505H11.9507L8.10837 6.55446Z",
    fill: color
  }));
};

const _excluded$n = ["color", "size"];
/**
 * @typedef {Object} RetryProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {RetryProps} props
 * @returns {JSX.Element}
 */

const Retry = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.9378 16.8718H18.6978C17.1333 19.5385 14.2 22 10.8756 22C10.5822 22 10.2889 22 9.89778 21.8975C6.28 21.3846 3.93333 18 4.03111 13.5898H5.49778C5.4 17.1795 7.25778 19.9487 10.0933 20.2564C13.1244 20.8718 15.6667 18.718 16.9378 16.8718ZM20.9467 11.7436L19.1867 13.4872L17.5244 11.7436H15.4711L19.1867 15.641L23.0978 11.7436H20.9467ZM6.57333 13.6923H8.62667L4.91111 9.69233L1 13.5898H3.15111L4.91111 11.8462L6.57333 13.6923ZM13.32 3.53848C14.9822 3.64105 16.2533 4.35899 17.1333 5.69233C18.6 7.74361 18.6978 10.4103 18.4044 11.7436H19.8711C20.1644 10 19.8711 7.02566 18.3067 4.76925C17.1333 3.12822 15.4711 2.20515 13.32 2.10258C8.92 1.69233 6.08444 5.28207 4.81333 8.66669H6.37778C7.55111 6.00002 9.89778 3.33335 13.32 3.53848Z",
    fill: color
  }));
};

const _excluded$o = ["color", "size"];
/**
 * @typedef {Object} StopProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {StopProps} props
 * @returns {JSX.Element}
 */

const Stop = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.46602 22 2 17.534 2 12C2 6.46602 6.46602 2 12 2C17.534 2 22 6.46602 22 12C22 17.534 17.534 22 12 22ZM12 3.45631C7.24272 3.45631 3.45631 7.24272 3.45631 12C3.45631 16.7573 7.24272 20.5437 12 20.5437C16.7573 20.5437 20.5437 16.7573 20.5437 12C20.5437 7.24272 16.7573 3.45631 12 3.45631ZM15.8835 14.8155L8.11651 7.04854V9.08738L15.8835 16.8544V14.8155Z",
    fill: color
  }));
};

const _excluded$p = ["color", "size"];
/**
 * @typedef {Object} InfoProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {InfoProps} props
 * @returns {JSX.Element}
 */

const Info = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.2308 9.01923L12.6731 9.01923L12.6731 18.6346L11.2308 18.6346L11.2308 9.01923ZM2 12C2 6.51923 6.51923 2 12 2C17.4808 2 22 6.42308 22 12C22 17.4808 17.4808 22 12 22C6.51923 22 2 17.4808 2 12ZM3.44231 12C3.44231 16.7115 7.28846 20.5577 12 20.5577C16.7115 20.5577 20.5577 16.7115 20.5577 12C20.5577 7.28846 16.7115 3.44231 12 3.44231C7.28846 3.44231 3.44231 7.28846 3.44231 12ZM12 7.19231C12.4808 7.19231 12.9615 6.80769 12.9615 6.23077C12.9615 5.65385 12.5769 5.26923 12 5.26923C11.5192 5.26923 11.0385 5.65385 11.0385 6.23077C11.0385 6.80769 11.4231 7.19231 12 7.19231Z",
    fill: color
  }));
};

const _excluded$q = ["color", "size"];
/**
 * @typedef {Object} AttentionProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AttentionProps} props
 * @returns {JSX.Element}
 */

const Attention = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.7692 14.9808H11.3269V5.36538H12.7692V14.9808ZM22 12C22 17.4808 17.4808 22 12 22C6.51923 22 2 17.5769 2 12C2 6.51923 6.51923 2 12 2C17.4808 2 22 6.51923 22 12ZM20.5577 12C20.5577 7.28846 16.7115 3.44231 12 3.44231C7.28846 3.44231 3.44231 7.28846 3.44231 12C3.44231 16.7115 7.28846 20.5577 12 20.5577C16.7115 20.5577 20.5577 16.7115 20.5577 12ZM12 16.8077C11.5192 16.8077 11.0385 17.1923 11.0385 17.7692C11.0385 18.3462 11.4231 18.7308 12 18.7308C12.4808 18.7308 12.9615 18.3462 12.9615 17.7692C12.9615 17.1923 12.5769 16.8077 12 16.8077Z",
    fill: color
  }));
};

const _excluded$r = ["color", "size"];
/**
 * @typedef {Object} HelpProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {HelpProps} props
 * @returns {JSX.Element}
 */

const Help = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.46602 2 2 6.46602 2 12C2 17.534 6.46602 22 12 22C17.534 22 22 17.534 22 12C22 6.46602 17.534 2 12 2ZM17.534 5.49515L15.5922 7.43689C14.6214 6.66019 13.3592 6.17476 11.9029 6.17476C10.5437 6.17476 9.28155 6.66019 8.31068 7.43689L6.46602 5.49515C7.92233 4.23301 9.86408 3.45631 12 3.45631C14.1359 3.45631 16.0777 4.23301 17.534 5.49515ZM16.3689 12C16.3689 14.4272 14.4272 16.3689 12 16.3689C9.57282 16.3689 7.63107 14.4272 7.63107 12C7.63107 9.57282 9.57282 7.63107 12 7.63107C14.4272 7.63107 16.3689 9.57282 16.3689 12ZM3.45631 12C3.45631 9.86408 4.23301 8.01942 5.49515 6.46602L7.33981 8.31068C6.56311 9.28155 6.07767 10.5437 6.07767 11.9029C6.07767 13.2621 6.56311 14.5243 7.33981 15.5922L5.39806 17.534C4.23301 16.0777 3.45631 14.1359 3.45631 12ZM6.56311 18.6019L8.50485 16.6602C9.47573 17.4369 10.7379 17.8252 12 17.8252C13.3592 17.8252 14.6214 17.3398 15.5922 16.5631L17.534 18.5049C16.0777 19.767 14.1359 20.5437 12 20.5437C9.96117 20.5437 8.01942 19.767 6.56311 18.6019ZM18.5049 17.534L16.5631 15.5922C17.3398 14.6214 17.8252 13.3592 17.8252 12C17.8252 10.6408 17.3398 9.47573 16.6602 8.50485L18.6019 6.56311C19.8641 8.01942 20.5437 9.96117 20.5437 12C20.5437 14.1359 19.767 15.9806 18.5049 17.534Z",
    fill: color
  }));
};

const _excluded$s = ["color", "size"];
/**
 * @typedef {Object} SpinnerProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SpinnerProps} props
 * @returns {JSX.Element}
 */

const Spinner = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M3.56863 13.4706C3.47059 12.9804 3.37255 12.4902 3.37255 11.902C3.37255 7.29412 7.29412 3.37255 12 3.37255C16.7059 3.37255 20.5294 7.29412 20.5294 12C20.5294 16.7059 16.7059 20.5294 12 20.5294C11.5098 20.5294 11.0196 20.4314 10.5294 20.4314L10.5294 21.902C11.0196 22 11.5098 22 12 22C17.4902 22 22 17.4902 22 12C22 6.50981 17.4902 2 12 2C6.5098 2 2 6.5098 2 12C2 12.4902 2.09804 13.0784 2.09804 13.5686L3.56863 13.5686L3.56863 13.4706Z",
    fill: color
  }));
};

const _excluded$t = ["color", "size"];
/**
 * @typedef {Object} SettingsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SettingsProps} props
 * @returns {JSX.Element}
 */

const Settings = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39921 11.9498C8.39921 9.93976 10.0009 8.29108 12 8.29108C13.9991 8.29108 15.6008 9.93976 15.6008 11.9498C15.6008 13.9599 13.9991 15.6086 12 15.6086C10.0009 15.6086 8.39921 13.9599 8.39921 11.9498ZM12 9.78869C10.8456 9.78869 9.89072 10.7457 9.89072 11.9498C9.89072 13.154 10.8456 14.111 12 14.111C13.1544 14.111 14.1093 13.154 14.1093 11.9498C14.1093 10.7457 13.1544 9.78869 12 9.78869Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.953 2L19.052 4.35003L18.6378 6.17975C18.4103 7.45427 19.1276 8.75598 20.2983 9.12887L20.3051 9.13103L22 9.70685V14.3935L20.3051 14.9693L20.2983 14.9715C19.1295 15.3438 18.4127 16.6418 18.6367 17.9144L19.0611 19.6448L14.953 22L13.6578 20.8265C12.7755 20.0022 11.3384 19.9735 10.3266 20.8407L9.04696 22L4.93891 19.6448L5.36335 17.9144C5.58735 16.6419 4.8705 15.3438 3.70166 14.9715L3.69487 14.9693L2 14.3935V9.70685L3.67418 9.13806C4.9476 8.645 5.6576 7.38559 5.36892 6.20867L5.36079 6.17554L5.08215 4.32954L5.52636 4.07487C6.3048 3.62857 6.66769 3.40665 7.03267 3.18345L7.03419 3.18253C7.40706 2.9545 7.78263 2.72486 8.57829 2.2687L9.04696 2L10.3441 3.1752C11.3492 4.1208 12.7565 4.09125 13.6346 3.1962L13.65 3.18052L14.953 2ZM6.70988 5.11917L6.82555 5.88547C7.30074 7.90309 6.05094 9.83211 4.19245 10.5425L4.1794 10.5474L3.49151 10.7811V13.3192L4.15979 13.5462C6.13049 14.1782 7.18136 16.2771 6.82638 18.2068L6.8224 18.2284L6.65646 18.9049L8.84918 20.1621L9.3413 19.7162L9.34821 19.7102C10.8942 18.3769 13.1907 18.3487 14.6695 19.7259L15.1508 20.1621L17.3435 18.9049L17.1776 18.2284L17.1736 18.2068C16.8186 16.2771 17.8695 14.1782 19.8402 13.5462L20.5085 13.3192V10.7811L19.8402 10.5541C17.8695 9.92215 16.8186 7.82321 17.1736 5.89358L17.1764 5.87853L17.3526 5.10026L15.1508 3.83794L14.6809 4.26368C13.1973 5.75845 10.8785 5.72552 9.32957 4.27317L8.8505 3.83914C8.3759 4.11553 8.09435 4.28771 7.81154 4.46066L7.81002 4.46159C7.51436 4.64239 7.21701 4.82421 6.70988 5.11917Z",
    fill: color
  }));
};

const _excluded$u = ["color", "size"];
/**
 * @typedef {Object} DashboardProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DashboardProps} props
 * @returns {JSX.Element}
 */

const Dashboard = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.9038 8.83168C10.1731 8.83168 8.73077 10.3168 8.73077 12.099C8.73077 13.8812 10.1731 15.3663 11.9038 15.3663C13.6346 15.3663 15.0769 13.8812 15.0769 12.099C15.0769 11.5049 14.8846 11.0099 14.6923 10.5149L17 8.33663V6.35644L13.7308 9.42574C13.1538 9.0297 12.5769 8.83168 11.9038 8.83168ZM11.9038 13.9802C10.9423 13.9802 10.1731 13.1881 10.1731 12.198C10.1731 11.2079 10.9423 10.4158 11.9038 10.4158C12.8654 10.4158 13.6346 11.2079 13.6346 12.198C13.6346 13.1881 12.8654 13.9802 11.9038 13.9802ZM12 2C6.51923 2 2 6.45545 2 12C2 17.5446 6.51923 22 12 22C17.4808 22 22 17.5446 22 12C22 6.45545 17.5769 2 12 2ZM12 20.5149C7.28846 20.5149 3.44231 16.6535 3.44231 12C3.44231 7.34653 7.28846 3.48515 12 3.48515C16.7115 3.48515 20.5577 7.34653 20.5577 12C20.5577 16.6535 16.8077 20.5149 12 20.5149Z",
    fill: color
  }));
};

const _excluded$v = ["color", "size"];
/**
 * @typedef {Object} MaleProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MaleProps} props
 * @returns {JSX.Element}
 */

const Male = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M18.241 4.87081L14.7711 8.31579C13.3253 6.78469 11.494 5.92344 9.46988 5.92344C7.44578 5.92344 5.61446 6.78469 4.16867 8.31579C1.27711 11.378 1.27711 16.4498 4.16867 19.6077C5.61446 21.1388 7.44578 22 9.46988 22C11.494 22 13.3253 21.1388 14.7711 19.6077C17.2771 16.8325 17.5663 12.622 15.6386 9.55981L19.2048 5.82775L18.241 4.87081ZM13.6145 18.555C12.4578 19.799 11.012 20.4689 9.37349 20.4689C7.73494 20.4689 6.28916 19.799 5.13253 18.555C2.72289 15.9713 2.72289 11.7608 5.13253 9.27273C6.28916 8.02871 7.73494 7.35885 9.37349 7.35885C11.012 7.35885 12.4578 8.02871 13.6145 9.27273C16.0241 11.7608 16.0241 15.9713 13.6145 18.555ZM22 2V10.5L20.4578 8.88995V3.43541H14.9639L13.5181 2H22Z",
    fill: color
  }));
};

const _excluded$w = ["color", "size"];
/**
 * @typedef {Object} FemaleProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FemaleProps} props
 * @returns {JSX.Element}
 */

const Female = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M15.2728 14.9363C16.9322 13.9687 18.1307 12.4205 18.6838 10.582C19.237 8.74354 19.0526 6.80829 18.2229 5.26009C17.301 3.71189 15.8259 2.55074 14.0743 2.16369C12.3227 1.77664 10.3867 2.06693 8.72723 3.13131C7.0678 4.09894 5.86933 5.64714 5.31618 7.48563C4.76304 9.32411 4.94742 11.2594 5.77714 12.8076C6.69904 14.3558 8.17409 15.5169 9.92571 15.904C10.3867 16.0007 10.8476 16.0975 11.3086 16.0975V18.0327H6.51466V19.3874H11.3086V22H12.6914V19.3874H17.4853V17.936H12.6914V15.904C13.5211 15.7104 14.4431 15.4201 15.2728 14.9363ZM6.97561 12.0335C6.23809 10.7755 6.1459 9.32411 6.60685 7.87268C7.0678 6.42124 8.0819 5.16333 9.46476 4.29246C10.4789 3.71189 11.5851 3.4216 12.5992 3.4216C12.968 3.4216 13.429 3.4216 13.7977 3.51836C15.1806 3.80865 16.3791 4.67951 17.0244 5.93743C17.6697 7.19534 17.8541 8.64678 17.3931 10.0982C16.9322 11.5497 15.9181 12.8076 14.5352 13.6784C13.1524 14.4525 11.6773 14.7428 10.2023 14.4525C8.81943 14.1622 7.62095 13.2914 6.97561 12.0335Z",
    fill: color
  }));
};

const _excluded$x = ["color", "size"];
/**
 * @typedef {Object} SearchProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SearchProps} props
 * @returns {JSX.Element}
 */

const Search = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 20.8794L17.5054 16.3968C19.1398 14.8686 20.0591 12.933 20.0591 10.8954C20.0591 8.75603 19.1398 6.82038 17.5054 5.29223C14.2366 2.23592 8.82258 2.23592 5.45161 5.29223C3.91935 6.82038 3 8.75603 3 10.8954C3 13.0349 3.91935 14.9705 5.55376 16.4987C7.18817 18.0268 9.43548 18.7399 11.5806 18.7399C13.2151 18.7399 14.9516 18.3324 16.3817 17.4156L20.9785 22L22 20.8794ZM6.57527 15.2761C5.24731 14.0536 4.53226 12.5255 4.53226 10.7936C4.53226 9.16354 5.24731 7.53351 6.57527 6.31099C7.90323 5.08847 9.74193 4.47721 11.5806 4.47721C13.4194 4.47721 15.1559 5.08847 16.586 6.31099C17.914 7.53351 18.629 9.06166 18.629 10.7936C18.629 12.4236 17.914 14.0536 16.586 15.2761C13.7258 17.8231 9.33333 17.8231 6.57527 15.2761Z",
    fill: color
  }));
};

const _excluded$y = ["color", "size"];
/**
 * @typedef {Object} MicProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MicProps} props
 * @returns {JSX.Element}
 */

const Mic = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 15.5294C14.5 15.5294 16.6 13.4706 16.6 10.9216V6.60784C16.6 4.05882 14.5 2 11.9 2C9.3 2 7.2 4.05882 7.2 6.60784V10.9216C7.2 13.4706 9.3 15.5294 11.9 15.5294ZM8.7 6.60784C8.7 4.84314 10.1 3.47059 11.9 3.47059C13.7 3.47059 15.1 4.84314 15.1 6.60784V10.9216C15.1 12.6863 13.7 14.0588 11.9 14.0588C10.1 14.0588 8.7 12.6863 8.7 10.9216V6.60784ZM20 12.8824C19.6 13.6667 19.2 14.3529 18.7 14.9412C17.1 17 15 18.1765 12.7 18.3725V22H11.3V18.3725C9 18.1765 6.9 17 5.3 14.9412C4.8 14.3529 4.4 13.5686 4 12.8824H5.7C5.9 13.2745 6.2 13.6667 6.5 14.0588C8 15.9216 10 17 12 17C14.1 17 16.1 15.9216 17.5 14.0588C17.8 13.6667 18 13.2745 18.3 12.8824H20Z",
    fill: color
  }));
};

const _excluded$z = ["color", "size"];
/**
 * @typedef {Object} TransgenderProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TransgenderProps} props
 * @returns {JSX.Element}
 */

const Transgender = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.2048 5.82775L18.241 4.87081L16.7952 6.30622L15.1566 4.67943L14.0964 5.73206L15.7349 7.35885L14.7711 8.31579C13.3253 6.78469 11.494 5.92344 9.46988 5.92344C7.44578 5.92344 5.61446 6.78469 4.16867 8.31579C1.27711 11.378 1.27711 16.4498 4.16867 19.6077C5.61446 21.1388 7.44578 22 9.46988 22C11.494 22 13.3253 21.1388 14.7711 19.6077C17.2771 16.8325 17.5663 12.622 15.6386 9.55981L16.7952 8.41148L18.4337 10.0383L19.3976 8.88995L17.759 7.26316L19.2048 5.82775ZM13.6145 18.555C12.4578 19.799 11.012 20.4689 9.37349 20.4689C7.73494 20.4689 6.28916 19.799 5.13253 18.555C2.72289 15.9713 2.72289 11.7608 5.13253 9.27273C6.28916 8.02871 7.73494 7.35885 9.37349 7.35885C11.012 7.35885 12.4578 8.02871 13.6145 9.27273C16.0241 11.7608 16.0241 15.9713 13.6145 18.555ZM22 2V10.5L20.4578 8.88995V3.43541H14.9639L13.5181 2H22Z",
    fill: color
  }));
};

const _excluded$A = ["color", "size"];
/**
 * @typedef {Object} CloseProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CloseProps} props
 * @returns {JSX.Element}
 */

const Close = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.0557 12L18.5 6.55573L17.4443 5.5L12 10.9443L6.55574 5.5L5.50001 6.55573L10.9443 12L5.5 17.4443L6.55573 18.5L12 13.0557L17.4443 18.5L18.5 17.4443L13.0557 12Z",
    fill: color
  }));
};

const _excluded$B = ["color", "size"];
/**
 * @typedef {Object} PlusProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {PlusProps} props
 * @returns {JSX.Element}
 */

const Plus = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19V12.75H5V11.25H11.25V5H12.75V11.25H19V12.75H12.75V19H11.25Z",
    fill: color
  }));
};

const _excluded$C = ["color", "size"];
/**
 * @typedef {Object} MinusProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MinusProps} props
 * @returns {JSX.Element}
 */

const Minus = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.25V12.75H19V11.25H5Z",
    fill: color
  }));
};

const _excluded$D = ["color", "size"];
/**
 * @typedef {Object} TickProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TickProps} props
 * @returns {JSX.Element}
 */

const Tick = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.3 4L10.9 17.3818L5.8 10.0121H4L11 20L21 4H19.3Z",
    fill: color
  }));
};

const _excluded$E = ["color", "size"];
/**
 * @typedef {Object} DoubleTickProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DoubleTickProps} props
 * @returns {JSX.Element}
 */

const DoubleTick = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 4L12.0001 19.9042L5.39628 9.94012H7.09439L12.0001 17.3174L20.3019 4H22.0001ZM17.7548 4H16.151L10.3963 14.0599H12.0001L17.7548 4ZM2.06379 10.0359L8.69816 20L9.45288 18.6587L3.69816 10.0359H2.06379Z",
    fill: color
  }));
};

const _excluded$F = ["color", "size"];
/**
 * @typedef {Object} HomeProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {HomeProps} props
 * @returns {JSX.Element}
 */

const Home = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 11.8492H19.8788L12 4.11055L4.12121 11.8492H2L12 2L22 11.8492ZM17.9596 20.4925H15.7374C16.2424 18.0804 16.4444 15.1658 15.1313 13.5578C14.5253 12.8543 13.7172 12.4523 12.6061 12.4523C10.6869 12.4523 8.26263 13.8593 7.55556 20.4925H6.14141V12.4523H4.62626V22H9.07071V21.2965C9.27273 18.5829 9.9798 13.9598 12.6061 13.9598C13.2121 13.9598 13.6162 14.1608 13.9192 14.5628C14.7273 15.5678 14.7273 17.9799 14.0202 21.0955L13.8182 22H19.4747V12.4523H17.9596V20.4925Z",
    fill: color
  }));
};

const _excluded$G = ["color", "size"];
/**
 * @typedef {Object} CreditCardProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CreditCardProps} props
 * @returns {JSX.Element}
 */

const CreditCard = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 20H2V4H22V20ZM3.5 18.4211H20.5V5.57895H3.5V18.4211ZM9.9 17.2632H4.8V11.8947H9.9V17.2632ZM6.3 15.6842H8.4V13.4737H6.3V15.6842ZM19.2 7.05263C17.1 7.47368 14.2 8.10526 13 8.31579L12.4 6.84211L8.2 8.10526L7.5 6.73684L6.9 6.94737C6.8 6.94737 5.8 7.36842 4.8 7.78947V9.47368C5.4 9.15789 6.2 8.84211 6.8 8.63158L7.4 9.89474L11.5 8.63158L12.1 10L12.7 9.89474C12.7 9.89474 16.5 9.05263 19.2 8.52632V7.05263Z",
    fill: color
  }));
};

const _excluded$H = ["color", "size"];
/**
 * @typedef {Object} OtnRequestProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OtnRequestProps} props
 * @returns {JSX.Element}
 */

const OtnRequest = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.5 2 2 6.1791 2 11.3532C2 14.1393 3.4 16.2289 4.4 17.3234L3 22L7.9 19.8109C9.1 20.3085 10.6 20.607 12 20.607C17.5 20.607 22 16.4279 22 11.2537C21.9 6.1791 17.5 2 12 2ZM12 19.1144C10.8 19.1144 9.3 18.8159 8.3 18.3184L8 18.1194L5.4 19.3134L6 16.9254L5.7 16.6269C5.1 15.9303 3.5 14.0398 3.5 11.3532C3.5 6.97512 7.3 3.49254 12 3.49254C16.7 3.49254 20.5 6.97512 20.5 11.3532C20.4 15.6318 16.6 19.1144 12 19.1144ZM12.6 16.6269C12.6 17.1244 12.2 17.6219 11.6 17.6219C11 17.6219 10.6 17.2239 10.6 16.6269C10.6 16.0299 11 15.6318 11.6 15.6318C12.2 15.6318 12.6 16.1294 12.6 16.6269ZM15.9 8.76617C15.9 10.0597 15.3 11.0547 14 12.1493C12.8 13.1443 12.4 13.6418 12.4 14.7363H10.9C10.9 12.9453 11.6 11.9502 13 10.9552C14.1 10.0597 14.4 9.46269 14.4 8.76617C14.4 8.06965 13.9 7.17413 12.6 6.97512C11.7 6.77612 10.7 6.97512 10.1 7.47264C9.5 7.97015 9.3 8.66667 9.3 9.66169H7.8C7.8 8.16915 8.2 7.07463 9.1 6.37811C10.1 5.58209 11.5 5.28358 12.9 5.58209C14.7 5.8806 15.9 7.17413 15.9 8.76617Z",
    fill: color
  }));
};

const _excluded$I = ["color", "size"];
/**
 * @typedef {Object} AssignGroupProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AssignGroupProps} props
 * @returns {JSX.Element}
 */

const AssignGroup = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1117 6.3C20.1117 8.1 18.6511 9.6 16.8983 9.6C15.1456 9.6 13.685 8.1 13.685 6.2C13.685 4.4 15.1456 3 16.8983 3C18.6511 3 20.1117 4.5 20.1117 6.3ZM18.6511 6.2C18.6511 5.2 17.8721 4.4 16.8983 4.4C15.9246 4.4 15.1456 5.2 15.1456 6.2C15.1456 7.2 15.9246 8 16.8983 8C17.8721 8 18.6511 7.2 18.6511 6.2Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.767 16.3C21.9618 15.6 22.0592 14.9 21.9618 14.3C21.5723 11.4 18.0668 10.6 16.2167 10.5H16.1193C15.2429 10.5 13.9771 10.7 12.906 11.2V13C13.9771 12.3 15.5351 12.1 16.2167 12.1C17.2878 12.1 20.3064 12.5 20.5012 14.5C20.5986 15 20.5012 15.6 20.3064 16.3H21.767Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8086 8.5C12.8086 10.8 10.9585 12.7 8.71885 12.7C6.38186 12.7 4.62912 10.8 4.62912 8.5C4.62912 6.2 6.47923 4.3 8.71885 4.3C10.9585 4.3 12.8086 6.2 12.8086 8.5ZM11.348 8.5C11.348 7 10.1795 5.8 8.71885 5.8C7.16086 5.8 5.99236 7 5.99236 8.5C5.99236 10 7.25823 11.2 8.71885 11.2C10.1795 11.2 11.348 10 11.348 8.5Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5679V14H12.1226C10.9365 13.56 9.6632 13.4 8.71885 13.4H8.62148C6.47923 13.4 2.3895 14.3 2 17.7C2 18.4 2.09737 19.2 2.19475 20H3.75274C3.55799 19.2 3.46062 18.4 3.46062 17.9C3.75274 15.4 7.3556 14.9 8.71885 14.9C9.45237 14.9 10.8343 15.0448 12 15.5679Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.466 19.8578V22L17.1744 19.1127L13.3709 16.3186V18.4608H7V19.8578H13.466Z",
    fill: color
  }));
};

const _excluded$J = ["color", "size"];
/**
 * @typedef {Object} AllProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AllProps} props
 * @returns {JSX.Element}
 */

const All = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71155 5.19995H21.75V6.69995H5.71155V5.19995ZM3.9808 11.2499H20.0193V12.7499H3.9808V11.2499ZM2.25 17.3H18.2885V18.8H2.25V17.3Z",
    fill: color
  }));
};

const _excluded$K = ["color", "size"];
/**
 * @typedef {Object} ReelsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ReelsProps} props
 * @returns {JSX.Element}
 */

const Reels = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1918 13.1384L9.73131 9.32475V16.9521L16.1918 13.1384ZM13.241 13.1384L11.2313 14.3248V11.9521L13.241 13.1384Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0993 3.03333C13.1083 3.03316 13.1174 3.03316 13.1264 3.03333H20.9666V20.9665H3.03345V3.03333H7.98529C7.99378 3.03318 8.00227 3.03318 8.01075 3.03333H13.0993ZM15.7051 6.74994L14.4169 4.53333H19.4666V6.74994H15.7051ZM12.682 4.53333L13.9702 6.74994H10.6054L9.30715 4.53333H12.682ZM7.56881 4.53333L8.86705 6.74994H4.53345V4.53333H7.56881ZM19.4666 8.24994H4.53345V19.4665H19.4666V8.24994Z",
    fill: color
  }));
};

const _excluded$L = ["color", "size"];
/**
 * @typedef {Object} InstagramChannel3Props
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {InstagramChannel3Props} props
 * @returns {JSX.Element}
 */

const InstagramChannel3 = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M18.497 6.82353C18.497 7.55449 17.9045 8.14706 17.1735 8.14706C16.4425 8.14706 15.85 7.55449 15.85 6.82353C15.85 6.09256 16.4425 5.5 17.1735 5.5C17.9045 5.5 18.497 6.09256 18.497 6.82353Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.005 7.08008C9.28502 7.08008 7.08002 9.28508 7.08002 12.0051C7.08002 14.7251 9.28502 16.9301 12.005 16.9301C14.725 16.9301 16.93 14.7251 16.93 12.0051C16.93 9.28508 14.725 7.08008 12.005 7.08008ZM8.93002 12.0051C8.93002 10.3068 10.3067 8.93008 12.005 8.93008C13.7033 8.93008 15.08 10.3068 15.08 12.0051C15.08 13.7034 13.7033 15.0801 12.005 15.0801C10.3067 15.0801 8.93002 13.7034 8.93002 12.0051Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53648 2.37373C8.67861 2.24999 10.1182 2.24999 11.9548 2.25H12.0452C13.8818 2.24999 15.3214 2.24999 16.4635 2.37373C17.6291 2.50001 18.5734 2.76232 19.3798 3.34815C19.8679 3.70281 20.2972 4.13209 20.6518 4.62024C21.2377 5.42656 21.5 6.37094 21.6263 7.53648C21.75 8.67859 21.75 10.1182 21.75 11.9547V12.0453C21.75 13.8818 21.75 15.3214 21.6263 16.4635C21.5 17.6291 21.2377 18.5734 20.6518 19.3798C20.2972 19.8679 19.8679 20.2972 19.3798 20.6518C18.5734 21.2377 17.6291 21.5 16.4635 21.6263C15.3214 21.75 13.8818 21.75 12.0453 21.75H11.9547C10.1182 21.75 8.67859 21.75 7.53648 21.6263C6.37094 21.5 5.42656 21.2377 4.62024 20.6518C4.13209 20.2972 3.70281 19.8679 3.34815 19.3798C2.76232 18.5734 2.50001 17.6291 2.37373 16.4635C2.24999 15.3214 2.24999 13.8818 2.25 12.0452V11.9548C2.24999 10.1182 2.24999 8.67861 2.37373 7.53648C2.50001 6.37094 2.76232 5.42656 3.34815 4.62024C3.70281 4.13209 4.13209 3.70281 4.62024 3.34815C5.42656 2.76232 6.37094 2.50001 7.53648 2.37373ZM7.69805 3.865C6.66013 3.97745 6.00992 4.19259 5.50191 4.56168C5.14111 4.82382 4.82382 5.14111 4.56168 5.50191C4.19259 6.00992 3.97745 6.66013 3.865 7.69805C3.75103 8.74999 3.75 10.1084 3.75 12C3.75 13.8916 3.75103 15.25 3.865 16.302C3.97745 17.3399 4.19259 17.9901 4.56168 18.4981C4.82382 18.8589 5.14111 19.1762 5.50191 19.4383C6.00992 19.8074 6.66013 20.0225 7.69805 20.135C8.74999 20.249 10.1084 20.25 12 20.25C13.8916 20.25 15.25 20.249 16.302 20.135C17.3399 20.0225 17.9901 19.8074 18.4981 19.4383C18.8589 19.1762 19.1762 18.8589 19.4383 18.4981C19.8074 17.9901 20.0225 17.3399 20.135 16.302C20.249 15.25 20.25 13.8916 20.25 12C20.25 10.1084 20.249 8.74999 20.135 7.69805C20.0225 6.66013 19.8074 6.00992 19.4383 5.50191C19.1762 5.14111 18.8589 4.82382 18.4981 4.56168C17.9901 4.19259 17.3399 3.97745 16.302 3.865C15.25 3.75103 13.8916 3.75 12 3.75C10.1084 3.75 8.74999 3.75103 7.69805 3.865Z",
    fill: color
  }));
};

const _excluded$M = ["color", "size"];
/**
 * @typedef {Object} CannedResponseProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CannedResponseProps} props
 * @returns {JSX.Element}
 */

const CannedResponse = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.5 2 2 6.1791 2 11.3532C2 14.1393 3.4 16.2289 4.4 17.3234L3 22L7.9 19.8109C9.1 20.3085 10.6 20.607 12 20.607C17.5 20.607 22 16.4279 22 11.2537C21.9 6.1791 17.5 2 12 2ZM12 19.1144C10.8 19.1144 9.3 18.8159 8.3 18.3184L8 18.1194L5.4 19.3134L6 16.9254L5.7 16.6269C5.1 15.9303 3.5 14.0398 3.5 11.3532C3.5 6.97512 7.3 3.49254 12 3.49254C16.7 3.49254 20.5 6.97512 20.5 11.3532C20.4 15.6318 16.6 19.1144 12 19.1144Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.34989L13.3238 9.53273L16.76 9.8082L14.142 12.0508L14.9418 15.4039L12 13.607L9.05819 15.4039L9.85802 12.0508L7.24004 9.8082L10.6762 9.53273L12 6.34989Z",
    fill: color
  }));
};

const _excluded$N = ["color", "size"];
/**
 * @typedef {Object} DataProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DataProps} props
 * @returns {JSX.Element}
 */

const Data = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M5.21302 10.1818C5.11243 9.37374 5.01183 7.65657 5.21302 5.93939C5.51479 4.22222 6.31953 2 9.63905 2V3.51515C7.62722 3.51515 7.02367 4.52525 6.72189 6.14141C6.42012 8.16162 6.72189 10.3838 6.72189 10.3838L6.82249 10.8889L5.4142 12L6.6213 13.1111V13.5152C6.6213 13.5278 6.61817 13.5782 6.61307 13.66C6.57731 14.2345 6.44527 16.3561 6.6213 17.8586C6.92308 19.6768 7.72781 20.4848 9.53846 20.4848V22C7.02367 22 5.61538 20.6869 5.21302 18.0606C5.01183 16.5455 5.11243 14.6263 5.21302 13.8182L3 12L5.21302 10.1818Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12L18.787 10.1818C18.8876 9.37374 18.9882 7.65657 18.6864 5.93939C18.3846 4.22222 17.6805 2 14.3609 2V3.51515C16.3728 3.51515 16.9763 4.52525 17.2781 6.14141C17.5799 8.16162 17.2781 10.3838 17.2781 10.3838L17.1775 10.7879L18.5858 11.899L17.1775 13.1111V13.5152C17.1775 13.5152 17.3787 16.1414 17.1775 17.8586C16.8757 19.7778 16.071 20.4848 14.2604 20.4848V22C16.7751 22 18.284 20.6869 18.5858 18.0606C18.787 16.5455 18.6864 14.6263 18.5858 13.8182L21 12Z",
    fill: color
  }));
};

const _excluded$O = ["color", "size"];
/**
 * @typedef {Object} ShareProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ShareProps} props
 * @returns {JSX.Element}
 */

const Share = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M9.8392 6.2H7.72864L11.8492 2L16.2714 6.2H14.0603L11.9497 4.1L9.8392 6.2ZM16.5729 6.8V8.3H20.4925V20.5H3.50754V8.3H7.12563V6.8H2V22H22V6.8H16.5729ZM11.2462 17.7H12.7538V6.8H11.2462V17.7Z",
    fill: color
  }));
};

const _excluded$P = ["color", "size"];
/**
 * @typedef {Object} SmsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SmsProps} props
 * @returns {JSX.Element}
 */

const Sms = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.0526 20.0415C12.7502 20.0415 13.3157 19.4745 13.3157 18.7751C13.3157 18.0757 12.7502 17.5088 12.0526 17.5088C11.355 17.5088 10.7894 18.0757 10.7894 18.7751C10.7894 19.4745 11.355 20.0415 12.0526 20.0415Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1578 5.59546H13.842V4.09546H10.1578V5.59546Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09216 4.00119C5.09216 2.639 6.16302 1.56274 7.52637 1.56274H16.4737C17.8371 1.56274 18.908 2.639 18.908 4.00119V19.8983C19.0434 21.3757 17.7388 22.3743 16.4737 22.3743H7.52637C6.16302 22.3743 5.09216 21.298 5.09216 19.9359V4.00119ZM7.52637 3.06274C6.99499 3.06274 6.59216 3.46388 6.59216 4.00119V19.9359C6.59216 20.4732 6.99499 20.8743 7.52637 20.8743H16.4737C17.0906 20.8743 17.4566 20.4158 17.4125 20.0185L17.408 19.9773V4.00119C17.408 3.46388 17.0051 3.06274 16.4737 3.06274H7.52637Z",
    fill: color
  }));
};

const _excluded$Q = ["color", "size"];
/**
 * @typedef {Object} LogoutProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {LogoutProps} props
 * @returns {JSX.Element}
 */

const Logout = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.9L16.8305 16.1V13.9L18.8644 11.9L16.8305 10V7.9L21 11.9ZM3 22H16.0169V16.6H14.4915V20.5H4.52542V3.5H14.4915V7.2H16.0169V2H3V22ZM6.55932 12.7H15.9153V11.2H6.55932V12.7Z",
    fill: color
  }));
};

const _excluded$R = ["color", "size"];
/**
 * @typedef {Object} ArchiveProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ArchiveProps} props
 * @returns {JSX.Element}
 */

const Archive = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 2V22H22V2H2ZM20.5 20.5H3.5V3.5H20.6V20.5H20.5ZM12 10.8H9.5V9.4H12V7.9H9.5V6.5H12V5H14.5V6.5H12V8H14.5V9.5H12V10.8H14.5V12.3H12V10.8ZM14.5 13.8H9.5V18.8H14.5V13.8ZM13 17.3H10.9V15.2H13V17.3Z",
    fill: color
  }));
};

const _excluded$S = ["color", "size"];
/**
 * @typedef {Object} CheckboxDoneProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CheckboxDoneProps} props
 * @returns {JSX.Element}
 */

const CheckboxDone = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 2V22H22V2H2ZM20.5366 20.5366H3.46341V3.46341H20.5366V20.5366ZM11.2683 17.2195L5.21951 11.0732H7.26829L11.1707 15.0732L16.7317 8.53659H18.6829L11.2683 17.2195Z",
    fill: color
  }));
};

const _excluded$T = ["color", "size"];
/**
 * @typedef {Object} InboxProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {InboxProps} props
 * @returns {JSX.Element}
 */

const Inbox = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.3134 2H4.58706L2 13.0833V21H22V12.2917L19.3134 2ZM5.78109 3.48438H18.1194L20.209 11.599H15.0348L14.9353 12.1927C14.9353 12.2917 14.0398 17.1406 10.6567 16.9427C9.9602 16.8438 9.36318 16.6458 9.06468 16.151C8.26866 15.1615 8.56716 13.3802 8.56716 13.3802L8.66667 12.4896H3.69154L5.78109 3.48438ZM3.49254 19.6146V14.0729H6.97512C6.97512 14.8646 7.07463 16.151 7.87065 17.1406C8.46766 17.9323 9.36318 18.4271 10.5572 18.4271C10.6567 18.4271 10.7562 18.4271 10.9552 18.4271C14.1393 18.4271 15.7313 15.2604 16.3284 13.0833H20.5075V19.5156H3.49254V19.6146Z",
    fill: color
  }));
};

const _excluded$U = ["color", "size"];
/**
 * @typedef {Object} CopyToAnotherFlowProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CopyToAnotherFlowProps} props
 * @returns {JSX.Element}
 */

const CopyToAnotherFlow = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 2H7.47264V7.2H2V22H16.7264V16.6H22V2ZM15.2338 20.5H3.49254V8.7H15.2338V20.5ZM20.5075 15.1H16.7264V7.1H8.96517V3.5H20.5075V15.1ZM13.9403 14.7L9.76119 18.9V16.8L11.8507 14.7L9.76119 12.6V10.5L13.9403 14.7ZM9.76119 15.4H4.88557V13.9H9.76119V15.4Z",
    fill: color
  }));
};

const _excluded$V = ["color", "size"];
/**
 * @typedef {Object} ConvertChannelsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ConvertChannelsProps} props
 * @returns {JSX.Element}
 */

const ConvertChannels = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.2463 10.6139L13.33 11.703L8.99507 16.0594L7.91133 14.9703L12.2463 10.6139ZM14.8079 9.0297V12.7921L16.2857 14.2772V7.54455H9.68473L11.1626 9.0297H14.8079ZM22 16.5545L16.6798 16.6535V22H2V7.14852H7.41872V2H22V16.5545ZM20.5222 3.38614H8.89655V8.53465H3.47783V20.4158H15.3005V15.0693L20.6207 14.9703V3.38614H20.5222Z",
    fill: color
  }));
};

const _excluded$W = ["color", "size"];
/**
 * @typedef {Object} CopyProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CopyProps} props
 * @returns {JSX.Element}
 */

const Copy = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 2H7.47264V7.2H2V22H16.7264V16.6H22V2ZM15.2338 20.5H3.49254V8.7H15.2338V20.5ZM20.5075 15.1H16.7264V7.1H8.96517V3.5H20.5075V15.1Z",
    fill: color
  }));
};

const _excluded$X = ["color", "size"];
/**
 * @typedef {Object} AdsAdProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AdsAdProps} props
 * @returns {JSX.Element}
 */

const AdsAd = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 2V22H12.7538H22V12.7538V2H2ZM20.4925 3.50754V12.7538H12.7538H3.50754V3.50754H20.4925ZM3.50754 20.4925V14.2613H12.7538V20.4925H3.50754ZM20.4925 20.4925H14.2613V14.2613H20.4925V20.4925Z",
    fill: color
  }));
};

const _excluded$Y = ["color", "size"];
/**
 * @typedef {Object} ActionProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ActionProps} props
 * @returns {JSX.Element}
 */

const Action = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.3134 5.51397V3H17.8209V5.51397H6.27861V3H4.78607V5.51397H2V21H22V5.51397H19.3134ZM20.5075 19.4916H3.49254V7.02235H20.5075V19.4916ZM11.3532 17.3799L6.97512 12.6536H9.06468L11.2537 15.067L15.2338 9.73743H17.1244L11.3532 17.3799Z",
    fill: color
  }));
};

const _excluded$Z = ["color", "size"];
/**
 * @typedef {Object} AdsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AdsProps} props
 * @returns {JSX.Element}
 */

const Ads = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4729 8.35116C13.0143 8.79757 12.8228 9.29883 12.8228 9.81568V12.5229H15.4513L15.2563 13.8042H13.1402V22.1601L14.0335 21.9862C15.1284 21.773 16.262 21.4469 17.3016 20.8872C18.2155 20.4407 19.0175 19.8808 19.8102 19.1091C20.3719 18.5623 20.9338 17.9066 21.3873 17.2443L21.3936 17.2351L21.3996 17.2257C21.9499 16.3686 22.4219 15.4641 22.6614 14.4221C22.8875 13.5385 23 12.6545 23 11.6699C23 10.7018 22.8916 9.68228 22.5359 8.74633C22.1881 7.62999 21.6188 6.63765 20.952 5.76898C20.2446 4.74246 19.3176 3.96247 18.3197 3.31487L18.3105 3.30893L18.3012 3.30326C17.3955 2.7522 16.3878 2.31774 15.3915 1.99446C14.7455 1.78483 13.9097 1.5458 13.0437 1.5458C12.8045 1.5458 12.6028 1.53482 12.3907 1.52327C12.2921 1.5179 12.1912 1.51241 12.0833 1.50784C11.7634 1.49431 11.4189 1.4921 11.034 1.55304C10.1396 1.66302 9.23304 1.88203 8.42463 2.2182C7.31368 2.65154 6.28544 3.20416 5.36156 3.99111C4.49841 4.72632 3.67748 5.51454 3.08244 6.55549L3.06348 6.58778C2.65805 7.27831 2.19459 8.06765 1.95432 8.98229C1.60752 10.0092 1.5 11.1197 1.5 12.185C1.5 13.3179 1.73272 14.442 2.18803 15.5526C2.52102 16.4154 2.97716 17.3139 3.67562 18.115C4.25049 18.8915 5.04678 19.6663 5.96748 20.2305C6.76471 20.782 7.66167 21.2163 8.54639 21.5398C9.07057 21.7428 9.67908 21.8574 10.1479 21.9457C10.2227 21.9598 10.2939 21.9732 10.3606 21.9862L11.254 22.1601V13.8042H8.71429V12.5229H11.254V9.71267C11.254 9.29974 11.2565 9.07663 11.3362 8.76609C11.4297 8.40222 11.5973 8.04683 11.7679 7.8808L11.8125 7.83733L11.8494 7.78708C12.2452 7.24759 12.8063 6.91449 13.6255 6.73728L13.6349 6.73524L13.6443 6.73296C13.9662 6.65462 14.2998 6.65122 14.7368 6.65122C15.0857 6.65122 15.4687 6.69187 15.7857 6.7376L15.7847 7.72652H14.724L14.6111 7.76314L14.5622 7.77889C14.2829 7.86862 13.8137 8.01935 13.4729 8.35116ZM11.259 3.03612C11.5029 2.99655 11.7355 2.99446 12.0199 3.0065C12.0948 3.00967 12.1772 3.01413 12.2656 3.01892C12.4939 3.03128 12.7622 3.0458 13.0437 3.0458C13.6591 3.0458 14.3048 3.21881 14.9286 3.42123C15.8335 3.71487 16.7271 4.1026 17.5123 4.57909C18.4095 5.16245 19.1674 5.81777 19.7264 6.63404L19.7383 6.65136L19.7511 6.66799C20.3438 7.43729 20.8243 8.28556 21.11 9.21247L21.1176 9.23712L21.1269 9.26119C21.3987 9.96678 21.5 10.7922 21.5 11.6699C21.5 12.5359 21.4016 13.2973 21.2061 14.0586L21.2036 14.0684L21.2014 14.0783C21.0176 14.883 20.6465 15.621 20.1435 16.4058C19.7515 16.9767 19.2578 17.5535 18.7639 18.0343C18.0793 18.7007 17.4041 19.1691 16.6308 19.5455L16.6163 19.5526L16.6022 19.5602C15.9967 19.8877 15.3338 20.1282 14.6402 20.311V15.3042H16.5453L17.1969 11.0229H14.3228V9.81568C14.3228 9.75008 14.3333 9.69762 14.3548 9.64725C14.3769 9.5957 14.4213 9.52125 14.5192 9.42598C14.5741 9.37251 14.6824 9.32078 14.963 9.22652H17.2857V5.50214L16.6936 5.37405L16.6925 5.37382L16.6894 5.37315L16.679 5.37096L16.6426 5.36344C16.6117 5.35715 16.5676 5.3484 16.5125 5.33802C16.4025 5.3173 16.2476 5.28989 16.0648 5.26251C15.7042 5.20851 15.2132 5.15122 14.7368 5.15122L14.7057 5.15122C14.3039 5.15113 13.8073 5.15103 13.2992 5.27317C12.2366 5.50466 11.3327 5.98245 10.6749 6.8528C10.24 7.30362 9.99754 7.94839 9.88336 8.39298C9.75388 8.89716 9.75392 9.28705 9.75397 9.69019L9.75397 11.0229H7.21429V15.3042H9.75397V20.3357C9.51464 20.2813 9.28874 20.2192 9.08298 20.1391L9.07554 20.1362L9.06803 20.1334C8.26889 19.8417 7.48257 19.4571 6.80515 18.9861L6.78636 18.973L6.76681 18.9611C6.01332 18.5027 5.34309 17.8521 4.86526 17.2009L4.84552 17.174L4.82348 17.149C4.26668 16.5166 3.88297 15.7798 3.58479 15.0057L3.5818 14.998L3.57864 14.9903C3.18948 14.0432 3 13.1096 3 12.185C3 11.1995 3.10218 10.2602 3.38284 9.44057L3.39238 9.4127L3.39971 9.38416C3.58084 8.67886 3.94636 8.04693 4.37833 7.31104L4.38287 7.30309C4.84584 6.49186 5.50537 5.83901 6.33421 5.13302C7.10116 4.47975 7.97488 4.00303 8.97716 3.61276L8.98552 3.6095L8.9938 3.60605C9.66046 3.32792 10.4385 3.13656 11.2295 3.04031L11.2443 3.03851L11.259 3.03612ZM16.5357 6.10725L16.6936 5.37405C16.6936 5.37405 16.6943 5.3742 16.5357 6.10725Z",
    fill: color
  }));
};

const _excluded$_ = ["color", "size"];
/**
 * @typedef {Object} ShowFlowProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ShowFlowProps} props
 * @returns {JSX.Element}
 */

const ShowFlow = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.51402 11.5468C7.51402 13.8849 9.38318 15.7554 11.7196 15.7554C14.0561 15.7554 16.0187 13.7914 16.0187 11.5468C16.0187 9.20863 14.1495 7.33813 11.8131 7.33813C9.47663 7.33813 7.51402 9.20863 7.51402 11.5468ZM14.6168 11.5468C14.6168 13.1367 13.3084 14.3525 11.8131 14.3525C10.3178 14.3525 9.00935 13.0432 9.00935 11.5468C9.00935 9.95683 10.3178 8.74101 11.8131 8.74101C13.3084 8.74101 14.6168 9.95683 14.6168 11.5468ZM4.61682 10.7986H3.02804C5.08411 6.96403 8.07477 5 11.8131 5C15.6449 5 18.8224 6.77698 22 10.7986H20.1308C17.514 7.80576 14.8972 6.40288 11.7196 6.40288C8.82243 6.40288 6.39252 7.89928 4.61682 10.7986ZM20.972 12.295C18.9159 15.1007 16.3925 18 11.7196 18C7.3271 18 4.8972 15.6619 2 12.295H3.86916C6.57944 15.2878 8.54206 16.5971 11.7196 16.5971C15.271 16.5971 17.4206 14.5396 19.1963 12.295H20.972Z",
    fill: color
  }));
};

const _excluded$$ = ["color", "size"];
/**
 * @typedef {Object} UnpinProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {UnpinProps} props
 * @returns {JSX.Element}
 */

const Unpin = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M14.1905 2L13.7143 2.60302C11.1429 5.61809 9.90476 8.33166 9.42857 9.33668C8.47619 9.53769 6.19048 10.2412 4.28571 11.4472L3.52381 11.9497L6.7619 15.3668L2 22H4.38095L9.2381 17.9799L12.4762 21.397L12.9524 20.593C14.1905 18.4824 14.7619 16.0704 14.9524 15.1658C15.9048 14.6633 18.5714 13.2563 21.3333 10.6432L22 10.2412L14.1905 2Z",
    fill: color
  }));
};

const _excluded$10 = ["color", "size"];
/**
 * @typedef {Object} PinProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {PinProps} props
 * @returns {JSX.Element}
 */

const Pin = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$10);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M14.1905 2L13.7143 2.60302C11.1429 5.61809 9.90476 8.33166 9.42857 9.33668C8.47619 9.53769 6.19048 10.2412 4.28571 11.4472L3.52381 11.9497L6.7619 15.3668L2 22H4.38095L9.2381 17.9799L12.4762 21.397L12.9524 20.593C14.1905 18.4824 14.7619 16.0704 14.9524 15.1658C15.9048 14.6633 18.5714 13.2563 21.3333 10.6432L22 10.2412L14.1905 2ZM14.0952 14.0603L13.7143 14.2613L13.619 14.6633C13.619 14.6633 13.2381 16.8744 12.1905 19.0854L9.33333 16.0704L6.47619 18.4824L8.7619 15.4673L5.90476 12.4523C7.90476 11.3467 10.0952 10.9447 10.0952 10.8442L10.4762 10.7437L10.5714 10.3417C10.5714 10.3417 11.5238 7.62814 14.1905 4.31156L19.8095 10.2412C16.8571 12.7538 14.0952 13.9598 14.0952 14.0603Z",
    fill: color
  }));
};

const _excluded$11 = ["color", "size"];
/**
 * @typedef {Object} HideProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {HideProps} props
 * @returns {JSX.Element}
 */

const Hide = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$11);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M8.91589 11.3538C8.91589 11.7436 9.00935 12.2308 9.19626 12.5231L8.35514 13.9846C7.79439 13.2051 7.51402 12.3282 7.51402 11.3538C7.51402 8.91795 9.38318 6.96923 11.7196 6.96923C11.9065 6.96923 12.0935 6.96923 12.2804 7.06667L11.4393 8.5282C10.1308 8.5282 8.91589 9.79487 8.91589 11.3538ZM11.8131 6.09231C12.1869 6.09231 12.5607 6.09231 12.9346 6.18974L13.6822 4.82564C13.1215 4.72821 12.4673 4.63077 11.8131 4.63077C8.07477 4.63077 5.17757 6.67692 3.1215 10.6718H4.71028C6.39252 7.65128 8.82243 6.09231 11.8131 6.09231ZM19.1963 12.1333H20.972C18.9159 15.0564 16.3925 18.0769 11.7196 18.0769C10.8785 18.0769 10.1308 17.9795 9.47664 17.7846L7.60748 21H6.01869L16.8598 2H18.4486L16.3925 5.60513C18.3551 6.57949 20.2243 8.2359 22 10.6718H20.1308C18.6355 8.91795 17.1402 7.65128 15.6449 6.96923L14.8037 8.43077C15.5514 9.11282 16.0187 10.1846 16.0187 11.3538C16.0187 13.7897 14.1495 15.7385 11.8131 15.7385C11.4393 15.7385 11.0654 15.641 10.6916 15.5436L10.1308 16.5179C10.5981 16.6154 11.1589 16.6154 11.6262 16.6154C15.271 16.7128 17.4206 14.5692 19.1963 12.1333ZM11.4393 14.2769C11.5327 14.2769 11.6262 14.2769 11.7196 14.2769C13.3084 14.2769 14.5234 12.9128 14.5234 11.3538C14.5234 10.6718 14.3364 10.0872 13.9626 9.69744L11.4393 14.2769ZM7.51402 15.5436C6.29907 14.7641 5.17757 13.6923 3.86916 12.1333H2C3.58879 14.0821 5.08411 15.7385 6.85981 16.8103L7.51402 15.5436Z",
    fill: color
  }));
};

const _excluded$12 = ["color", "size"];
/**
 * @typedef {Object} ShowProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ShowProps} props
 * @returns {JSX.Element}
 */

const Show = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$12);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.8095 8.26904L9.04762 13.1878C8.7619 12.7056 8.57143 12.1269 8.57143 11.5482C8.57143 9.71574 10 8.26904 11.8095 8.26904ZM8.38095 14.3452C7.71429 13.5736 7.33333 12.6091 7.33333 11.4518C7.33333 8.94416 9.33333 6.91878 11.8095 6.91878C12.0952 6.91878 12.381 6.91878 12.6667 7.01523L13.619 5.37563C13.0476 5.27919 12.4762 5.18274 11.8095 5.18274C7.52381 5.18274 4.28571 8.07614 2 11.4518C3.71429 13.3807 5.33333 15.2132 7.14286 16.3706L8.38095 14.3452ZM22 11.4518C18.9524 14.9239 16.0952 17.7208 11.8095 17.7208C11.0476 17.7208 10.381 17.6244 9.71429 17.4315L7.71429 21H6.19048L17.2381 2H18.7619L16.2857 6.24365C18.381 7.30457 20.1905 9.13706 22 11.4518ZM16.2857 11.4518C16.2857 10.2944 15.8095 9.13706 15.0476 8.36548L14.381 9.61929C14.7619 10.198 15.0476 10.8731 15.0476 11.5482C15.0476 13.3807 13.619 14.8274 11.8095 14.8274C11.619 14.8274 11.5238 14.8274 11.3333 14.8274L10.6667 15.8883C11.0476 15.9848 11.3333 16.0812 11.7143 16.0812C14.2857 15.9848 16.2857 13.9594 16.2857 11.4518Z",
    fill: color
  }));
};

const _excluded$13 = ["color", "size"];
/**
 * @typedef {Object} ClearMobileProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ClearMobileProps} props
 * @returns {JSX.Element}
 */

const ClearMobile = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$13);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.9654 10.9595L15.5009 7.42394L16.5408 8.4638L13.0053 11.9993L16.6101 15.6042L15.5703 16.6441L11.9654 13.0392L8.42988 16.5747L7.39001 15.5349L10.9949 11.93L7.39002 8.32515L8.36055 7.35461L11.9654 10.9595Z",
    fill: color
  }));
};

const _excluded$14 = ["color", "size"];
/**
 * @typedef {Object} NewMessageProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {NewMessageProps} props
 * @returns {JSX.Element}
 */

const NewMessage = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$14);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#3B42C3"
  }));
};

const _excluded$15 = ["color", "size"];
/**
 * @typedef {Object} IdProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {IdProps} props
 * @returns {JSX.Element}
 */

const Id = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$15);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M18.5854 11.3684H12.7317V9.78947H18.5854V11.3684ZM17.5122 12.6316H12.7317V14.2105H17.5122V12.6316ZM22 4V20H2V4H22ZM20.5366 5.57895H3.46341V18.4211H20.5366V5.57895ZM10.9756 15.2632H4.92683V8.73684H10.878V15.2632H10.9756ZM9.5122 10.3158H6.39024V13.5789H9.41463V10.3158H9.5122Z",
    fill: color
  }));
};

const _excluded$16 = ["color", "size"];
/**
 * @typedef {Object} CalendarProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CalendarProps} props
 * @returns {JSX.Element}
 */

const Calendar = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$16);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37561 4.0051V2H7.87561V4.0051H16.2249V2H17.7249V4.0051H22.0465V21.9337H2.05408V4.0051H6.37561ZM6.37561 5.5051H3.55408V20.4337H20.5465V5.5051H17.7249V6.28571H16.2249V5.5051H7.87561V6.28571H6.37561V5.5051ZM10.4423 7.88266H13.5578V9.38266H10.4423V7.88266ZM15.4673 7.88266H18.5829V9.38266H15.4673V7.88266ZM5.51758 12.2704H8.63316V13.7704H5.51758V12.2704ZM10.4423 12.2704H13.5578V13.7704H10.4423V12.2704ZM15.4673 12.2704H18.5829V13.7704H15.4673V12.2704ZM5.51758 16.5561H8.63316V18.0561H5.51758V16.5561ZM10.4423 16.5561H13.5578V18.0561H10.4423V16.5561ZM15.4673 16.5561H18.5829V18.0561H15.4673V16.5561Z",
    fill: color
  }));
};

const _excluded$17 = ["color", "size"];
/**
 * @typedef {Object} SponsoredMessagesProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SponsoredMessagesProps} props
 * @returns {JSX.Element}
 */

const SponsoredMessages = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$17);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 5V19H22V5H2ZM20.5 17.5517H3.5V6.44828H20.5V17.5517ZM12 13.8828L5 8.28276H7.4L12 11.9517L16.6 8.28276H19L12 13.8828Z",
    fill: color
  }));
};

const _excluded$18 = ["color", "size"];
/**
 * @typedef {Object} ImageProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ImageProps} props
 * @returns {JSX.Element}
 */

const Image = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$18);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 3.5V12.483V12.6761V13.5455H2.97087L7.92233 8.8125L12.1942 12.8693L8.01942 17.2159H10.0583L15.4951 11.6136L21.8058 17.7955L22 17.9886V16.3466V15.9602V3.5H2ZM15.3981 9.48864L13.165 11.8068L7.92233 6.78409L3.45631 11.1307V4.94886H20.5437V14.4148L15.3981 9.48864ZM3.45631 19.0511H22V20.5H2V15.4773H3.45631V19.0511ZM19.2816 7.75C19.2816 8.61932 18.5049 9.29545 17.6311 9.29545C16.7573 9.29545 15.9806 8.61932 15.9806 7.65341C15.9806 6.6875 16.6602 6.01136 17.6311 6.01136C18.6019 6.01136 19.2816 6.78409 19.2816 7.75Z",
    fill: color
  }));
};

const _excluded$19 = ["color", "size"];
/**
 * @typedef {Object} VideoProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {VideoProps} props
 * @returns {JSX.Element}
 */

const Video = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$19);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M6.05797 17.5455H4.31884V16.1818H5.96135V17.5455H6.05797ZM6.05797 13.7273H4.31884V15.0909H5.96135V13.7273H6.05797ZM6.05797 11.2727H4.31884V12.6364H5.96135V11.2727H6.05797ZM6.05797 8.81818H4.31884V10.1818H5.96135V8.81818H6.05797ZM6.05797 6.45455H4.31884V7.81818H5.96135V6.45455H6.05797ZM19.5845 16.1818H17.942V17.5455H19.5845V16.1818ZM19.5845 13.7273H17.942V15.0909H19.5845V13.7273ZM19.5845 11.2727H17.942V12.6364H19.5845V11.2727ZM19.5845 8.81818H17.942V10.1818H19.5845V8.81818ZM19.5845 6.45455H17.942V7.81818H19.5845V6.45455ZM22 4V20H2V4H22ZM20.5507 5.36364H3.44928V18.6364H20.5507V5.36364ZM16.2029 12L9.14976 16.2727V7.72727L16.2029 12ZM10.599 13.7273L13.4976 12L10.599 10.2727V13.7273Z",
    fill: color
  }));
};

const _excluded$1a = ["color", "size"];
/**
 * @typedef {Object} VideoCircleTgProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {VideoCircleTgProps} props
 * @returns {JSX.Element}
 */

const VideoCircleTg = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9091 11.9897L9.15002 7.61633V16.5041L16.9091 11.9897ZM13.8909 12.0103L10.65 13.8959V10.1836L13.8909 12.0103Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.95001C6.44949 1.95001 1.94995 6.44955 1.94995 12C1.94995 17.5505 6.44949 22.05 12 22.05C17.5504 22.05 22.0499 17.5505 22.0499 12C22.0499 6.44955 17.5504 1.95001 12 1.95001ZM3.44995 12C3.44995 7.27798 7.27792 3.45001 12 3.45001C16.722 3.45001 20.5499 7.27798 20.5499 12C20.5499 16.722 16.722 20.55 12 20.55C7.27792 20.55 3.44995 16.722 3.44995 12Z",
    fill: color
  }));
};

const _excluded$1b = ["color", "size"];
/**
 * @typedef {Object} GrowthToolsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GrowthToolsProps} props
 * @returns {JSX.Element}
 */

const GrowthTools = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M3.83674 17.8858C5.36735 20.2989 7.91837 21.606 10.9796 21.9076C12.3422 22.0417 14.3724 22.0193 16.5281 21.9076C18.4668 21.8071 20.3673 21.3043 21.3878 21.0027L22 20.7774L22 13.9647L21.0816 14.2663C20.5714 14.3668 20.0612 14.5679 19.551 14.6685L19.449 14.6685C18.6327 14.8695 17.8163 15.0706 17.102 15.2717C15.2653 15.7744 13.9388 15.9755 12.8163 15.9755C11.3878 15.9755 10.3673 15.7744 9.65306 15.1712C8.73469 14.4674 8.32653 13.3614 8.32653 11.9538C8.32653 10.5462 8.83674 9.4402 9.65306 8.73639C10.3673 8.13313 11.3878 7.93205 12.8163 7.93205C14.2449 7.93205 15.9796 8.33422 17.102 8.63585C17.8163 8.83694 18.7347 9.03803 19.449 9.23911C19.6064 9.27013 19.7638 9.31072 19.9212 9.35498C20.6237 9.55247 21.3211 9.77589 22 10.0435L22 3.10596L21.3878 2.90488C20.3673 2.60325 18.7347 2.40216 16.5918 2.20107C15.0612 2.10053 13.8367 1.99999 12.6122 1.99999C12 1.99999 11.3878 1.99998 10.8776 2.10053C7.71429 2.40216 5.26531 3.70922 3.7347 6.12226C2.51021 7.93205 2 9.74183 2 11.9538C2.10204 14.2663 2.61225 16.0761 3.83674 17.8858ZM19.7551 16.1766L19.9592 16.0761C20.0612 16.0761 20.2653 15.9755 20.4694 15.9755L20.4694 19.6956C20.0612 19.7962 19.449 19.8967 18.9388 19.9973L18.9388 16.3777C19.1429 16.2772 19.449 16.1766 19.7551 16.1766ZM20.4694 8.13314C20 8 20.0612 8.03259 19.7551 7.93205C19.449 7.8315 19.1429 7.73096 18.9388 7.63042L18.9388 4.01086C19.551 4.1114 20.0612 4.21194 20.4694 4.31249L20.4694 8.13314ZM5.06123 7.02716C6.38776 5.01629 8.42857 3.91031 11.0816 3.70922C12.4082 3.60868 14.2449 3.60868 16.4898 3.80977C17.3061 3.91031 16.4323 3.80465 17.3061 3.91031L17.3061 7.22824C15.4694 6.72553 14.0408 6.52444 12.8163 6.52444C11.0816 6.4239 9.75511 6.82607 8.7347 7.63042C7.81633 8.33422 6.79592 9.64129 6.79592 12.0543C6.79592 14.4674 7.81633 15.7744 8.7347 16.4782C9.7551 17.2826 11.0816 17.5842 12.8163 17.5842C14.0408 17.5842 15.4694 17.2826 17.3061 16.8804L17.3061 20.1983C16.4898 20.2989 16.7875 20.268 16.4898 20.2989C14.551 20.5 12.5102 20.5 11.0816 20.3994C8.42857 20.1983 6.38776 19.0924 5.06123 17.0815C4.04082 15.5733 3.53061 13.9647 3.53061 12.0543C3.63266 10.144 4.04082 8.53531 5.06123 7.02716Z",
    fill: color
  }));
};

const _excluded$1c = ["color", "size"];
/**
 * @typedef {Object} GtPageTakeoverProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GtPageTakeoverProps} props
 * @returns {JSX.Element}
 */

const GtPageTakeover = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M18.2927 13.697H5.60976V12.2424H18.2927V13.697ZM7.7561 16.2182H16.2439V14.7636H7.7561V16.2182ZM22 4V20H2V4H22ZM20.5366 5.45455H3.46341V18.5455H20.5366V5.45455Z",
    fill: color
  }));
};

const _excluded$1d = ["color", "size"];
/**
 * @typedef {Object} BuilderCardProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BuilderCardProps} props
 * @returns {JSX.Element}
 */

const BuilderCard = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 4V20H22V4H2ZM20.5366 5.45455V14.0848H3.46341V5.45455H20.5366ZM3.46341 18.5455V15.5394H20.5366V18.5455H3.46341Z",
    fill: color
  }));
};

const _excluded$1e = ["color", "size"];
/**
 * @typedef {Object} BuilderListProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BuilderListProps} props
 * @returns {JSX.Element}
 */

const BuilderList = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 4V20H22V4H2ZM20.4925 8.8H16.6734V5.5H20.4925V8.8ZM16.6734 10.3H20.4925V13.7H16.6734V10.3ZM15.1658 13.7H3.50754V10.3H15.1658V13.7ZM15.1658 5.5V8.8H3.50754V5.5H15.1658ZM3.50754 15.2H15.1658V18.6H3.50754V15.2ZM16.6734 18.5V15.1H20.4925V18.5H16.6734Z",
    fill: color
  }));
};

const _excluded$1f = ["color", "size"];
/**
 * @typedef {Object} BuilderGalleryProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BuilderGalleryProps} props
 * @returns {JSX.Element}
 */

const BuilderGallery = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 7.59763V4H2V16.4024H6.9V20H22V7.59763H17.3ZM15.8 5.42012V11.6686H3.5V5.42012H15.8ZM3.5 13.0888H15.8V14.8876H3.5V13.0888ZM20.5 18.5799H8.4V16.4024H17.3V9.01775H20.5V18.5799ZM7.1 7.59763H4.6V6.17751H7.1V7.59763Z",
    fill: color
  }));
};

const _excluded$1g = ["color", "size"];
/**
 * @typedef {Object} BuilderInputProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BuilderInputProps} props
 * @returns {JSX.Element}
 */

const BuilderInput = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.26829 15.8588H5.80488V8.14118H7.26829V15.8588ZM22 4V20H2V4H22ZM20.5366 5.41176H3.46341V18.5882H20.5366V5.41176Z",
    fill: color
  }));
};

const _excluded$1h = ["color", "size"];
/**
 * @typedef {Object} GoToFlowProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GoToFlowProps} props
 * @returns {JSX.Element}
 */

const GoToFlow = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 4V20H22V4H2ZM20.5366 18.5882H3.46341V12.7529H12.7317V11.3412H3.46341V5.41176H20.5366V18.5882ZM18.2927 12L12.7317 16.5176V14.6353L15.9512 12L12.7317 9.36471V7.48235L18.2927 12Z",
    fill: color
  }));
};

const _excluded$1i = ["color", "size"];
/**
 * @typedef {Object} NodeAddProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {NodeAddProps} props
 * @returns {JSX.Element}
 */

const NodeAdd = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.2683 14.8421H9.5122V13.2632H11.2683V11.3684H12.7317V13.2632H14.4878V14.8421H12.7317V16.7368H11.2683V14.8421ZM22 4V20H2V4H22ZM20.5366 10.1053H3.46341V18.4211H20.5366V10.1053ZM20.5366 5.57895H3.46341V8.52632H20.5366V5.57895Z",
    fill: color
  }));
};

const _excluded$1j = ["color", "size"];
/**
 * @typedef {Object} TemplatesProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TemplatesProps} props
 * @returns {JSX.Element}
 */

const Templates = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M9.10383 5.61538C8.66667 4.08974 7.2459 3 5.60656 3C3.63934 3 2 4.63462 2 6.59615V16.4038C2 18.3654 3.63934 20 5.60656 20H22V5.61538H9.10383ZM3.63934 6.59615C3.63934 5.50641 4.51366 4.63462 5.60656 4.63462C6.69945 4.63462 7.57377 5.50641 7.57377 6.59615V13.3526C7.13661 13.0256 6.37158 12.8077 5.60656 12.8077C5.06011 12.8077 4.51366 12.9167 4.0765 13.1346C3.96721 13.1346 3.74863 13.2436 3.63934 13.3526V6.59615ZM20.3607 18.3654H5.60656C4.51366 18.3654 3.63934 17.4936 3.63934 16.4038C3.63934 15.3141 4.51366 14.4423 5.60656 14.4423C6.69945 14.4423 7.57377 15.3141 7.57377 16.4038H9.21311V7.25H20.2514V18.3654H20.3607ZM13.694 10.1923H11V8.55769H13.694V10.1923ZM16.7541 10.1923H15.3333V8.55769H18.3934V11.609H16.7541V10.1923ZM18.3934 17.1667H15.3333V15.5321H16.7541V14.1154H18.3934V17.1667ZM11 17.1667V15.5321H13.694V17.1667H11Z",
    fill: color
  }));
};

const _excluded$1k = ["color", "size"];
/**
 * @typedef {Object} AudioProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AudioProps} props
 * @returns {JSX.Element}
 */

const Audio = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M10.4238 8.23762H3.8136V15.7624H10.4238M10.4238 8.23762L20.2882 3.18811V20.7129L10.4238 15.7624M10.4238 8.23762V15.7624",
    stroke: color,
    strokeWidth: "1.5"
  }));
};

const _excluded$1l = ["color", "size"];
/**
 * @typedef {Object} KeyboardProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {KeyboardProps} props
 * @returns {JSX.Element}
 */

const Keyboard = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.65854 15.1579H16.439V16.7368H7.65854V15.1579ZM22 4V20H2V4H22ZM20.5366 5.57895H3.46341V18.4211H20.5366V5.57895ZM8.73171 7.89474H5.70732V9.47368H8.73171V7.89474ZM8.73171 11.1579H5.70732V12.7368H8.73171V11.1579ZM18.2927 7.89474H15.2683V9.47368H18.2927V7.89474ZM13.5122 7.89474H10.4878V9.47368H13.5122V7.89474ZM18.2927 11.1579H15.2683V12.7368H18.2927V11.1579ZM13.5122 11.1579H10.4878V12.7368H13.5122V11.1579Z",
    fill: color
  }));
};

const _excluded$1m = ["color", "size"];
/**
 * @typedef {Object} TemplateMediaBgProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TemplateMediaBgProps} props
 * @returns {JSX.Element}
 */

const TemplateMediaBg = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 4.25H21.75V19.75H2.25V4.25ZM3.75 7.9295H6.70264V5.75H3.75V7.9295ZM8.20264 7.9295H11.1553V5.75H8.20264V7.9295ZM12.6553 7.9295H15.7026V5.75H12.6553V7.9295ZM17.2026 7.9295H20.1553V5.75H17.2026V7.9295ZM20.25 9.4295H3.75V14.3911H20.25V9.4295ZM3.75 18.25V15.8911H6.70264V18.25H3.75ZM8.20264 18.25V15.8911H11.1553V18.25H8.20264ZM12.6553 18.25V15.8911H15.7026V18.25H12.6553ZM17.2026 18.25V15.8911H20.1553V18.25H17.2026Z",
    fill: color
  }));
};

const _excluded$1n = ["color", "size"];
/**
 * @typedef {Object} TemplateTextMediaProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TemplateTextMediaProps} props
 * @returns {JSX.Element}
 */

const TemplateTextMedia = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12ZM13.5 9C13.5 9.82843 12.8284 10.5 12 10.5C11.1716 10.5 10.5 9.82843 10.5 9C10.5 8.17157 11.1716 7.5 12 7.5C12.8284 7.5 13.5 8.17157 13.5 9Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 13.25H7V14.75H16.8V13.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16.25H15.6V17.75H8V16.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 21V3H2V21H22ZM3.5 4.5H20.5V19.5H3.5V4.5Z",
    fill: color
  }));
};

const _excluded$1o = ["color", "size"];
/**
 * @typedef {Object} WhatsAppWidgetProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {WhatsAppWidgetProps} props
 * @returns {JSX.Element}
 */

const WhatsAppWidget = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M15.9604 13.7C15.9604 13.7 16.1584 13.7 16.1584 14C16.1584 14.024 16.1598 14.0538 16.1615 14.0884C16.1736 14.3413 16.1979 14.8481 15.7624 15.2C15.2673 15.8 14.2772 16 13.5841 15.9C12.8911 15.8 11.3069 15.2 10.2178 14.2C9.02969 13.2 8.1386 12 7.74256 11.2C6.95049 9.79999 7.34652 8.49999 8.23761 7.99999C8.23761 7.99999 8.53464 7.79999 8.63365 7.79999H9.32672C9.32672 7.79999 9.52474 7.79999 9.62375 7.99999C9.72276 8.19999 10.3168 9.59999 10.3168 9.69999C10.4158 9.79999 10.5148 10.1 10.3168 10.3C10.1188 10.6 9.72276 11 9.72276 11C9.72276 11 9.62375 11.1 9.72276 11.3C9.82177 11.5 10.3168 12.3 10.8119 12.8C11.4059 13.4 12.099 13.8 12.495 13.9C12.8911 14 12.9901 13.9 13.0891 13.7C13.2871 13.6 13.6832 13 13.6832 13C13.6832 13 13.8812 12.8 14.1782 12.9C14.4752 13 15.9604 13.7 15.9604 13.7Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 2.95001C6.52857 2.95001 2.04199 6.79997 2.04199 11.8C2.04199 14.546 3.41815 16.4985 4.41048 17.5161L2.96415 22.0313L7.94997 19.911C9.19057 20.3791 10.7248 20.65 11.9999 20.65C17.4713 20.65 21.9578 16.8001 21.9578 11.8C21.9578 6.90068 17.3731 2.95001 11.9999 2.95001ZM3.54199 11.8C3.54199 7.80005 7.17423 4.45001 11.9999 4.45001C16.7258 4.45001 20.4578 7.89934 20.4578 11.8C20.4578 15.8 16.8256 19.15 11.9999 19.15C10.8058 19.15 9.32128 18.8674 8.23142 18.4087L7.93898 18.2857L5.39211 19.3688L6.12963 17.0663L5.76828 16.7419C4.96263 16.0186 3.54199 14.3055 3.54199 11.8Z",
    fill: color
  }));
};

const _excluded$1p = ["color", "size"];
/**
 * @typedef {Object} TriggerFbCommentsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TriggerFbCommentsProps} props
 * @returns {JSX.Element}
 */

const TriggerFbComments = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.9512 3C6.4878 3 2 6.93782 2 11.8601C2 14.5181 3.36585 16.487 4.34146 17.5699L2.97561 22L7.95122 19.9326C9.12195 20.4249 10.6829 20.7202 12.0488 20.7202C17.6098 20.7202 22 16.7824 22 11.8601C22 6.93782 17.5122 3 11.9512 3ZM11.9512 19.1451C10.6829 19.1451 9.21951 18.8497 8.14634 18.3575L7.85366 18.2591L5.21951 19.342L5.90244 16.9793L5.70732 16.7824C5.02439 16.0933 3.46341 14.3212 3.46341 11.8601C3.46341 7.82383 7.26829 4.47668 11.9512 4.47668C16.7317 4.47668 20.5366 7.82383 20.5366 11.8601C20.5366 15.8964 16.7317 19.1451 11.9512 19.1451ZM7.65854 8.02073H16.7317V9.49741H7.65854V8.02073ZM7.65854 10.8756H16.7317V12.3523H7.65854V10.8756ZM7.65854 13.6321H12.1463V15.1088H7.65854V13.6321Z",
    fill: color
  }));
};

const _excluded$1q = ["color", "size"];
/**
 * @typedef {Object} TriggerFbAdsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TriggerFbAdsProps} props
 * @returns {JSX.Element}
 */

const TriggerFbAds = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.7561 22L2 21.196V7.22613H7.7561V22ZM3.46341 19.8894L6.29268 20.2915V8.73367H3.46341V19.8894ZM21.4146 9.13568C20.9268 8.63317 20.2439 8.33166 19.3659 8.33166L15.561 8.43216C16.9268 6.42211 17.122 4.81407 16.3415 3.60804C15.8537 2.50251 14.6829 2 13.5122 2H12.9268L12.8293 2.60302C12.3415 5.61809 10.2927 7.12563 9.02439 7.82915V9.43719C10.2927 8.93467 13.2195 7.32663 14.0976 3.50754C14.4878 3.60804 14.878 3.90955 15.0732 4.21106C15.6585 5.11558 15.0732 6.62312 13.4146 8.53266L12.3415 9.8392L19.2683 9.73869C19.6585 9.73869 19.9512 9.8392 20.1463 10.0402C20.5366 10.3417 20.5366 10.6432 20.5366 10.9447C19.9512 16.0704 18.9756 18.4824 17.6098 18.4824H9.02439V19.99H17.6098C20.6341 19.99 21.5122 15.4673 22 11.1457C22 10.3417 21.8049 9.63819 21.4146 9.13568Z",
    fill: color
  }));
};

const _excluded$1r = ["color", "size"];
/**
 * @typedef {Object} TriggerNewSubscriberProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TriggerNewSubscriberProps} props
 * @returns {JSX.Element}
 */

const TriggerNewSubscriber = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.186 7.05419V6.02463C17.0233 5.74384 17.5814 4.99507 17.5814 4.05911C17.5814 2.93596 16.6512 2 15.5349 2C14.4186 2 13.4884 2.93596 13.4884 4.05911C13.4884 4.99507 14.0465 5.74384 14.8837 6.02463V7.05419H4V21H5.39535V8.45813H18.6047V21H20V7.05419H16.186ZM15.5349 4.80788C15.1628 4.80788 14.8837 4.52709 14.8837 4.15271C14.8837 3.77833 15.1628 3.49754 15.5349 3.49754C15.907 3.49754 16.186 3.77833 16.186 4.15271C16.186 4.4335 15.907 4.80788 15.5349 4.80788ZM12.6512 13.9803H15.5349V15.3842H12.6512V18.2857H11.2558V15.3842H8.46512V13.9803H11.3488V11.1724H12.7442V13.9803H12.6512Z",
    fill: color
  }));
};

const _excluded$1s = ["color", "size"];
/**
 * @typedef {Object} TriggerFbComments20Props
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TriggerFbComments20Props} props
 * @returns {JSX.Element}
 */

const TriggerFbComments20 = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.7525 11.8477H7.14851V10.3249H16.7525V11.8477ZM7.14851 14.7919H14.6733V13.269H7.14851V14.7919ZM20.2178 10.1218C20.3168 10.6294 20.4158 11.1371 20.4158 11.6447C20.4158 15.7056 16.6535 19.0558 11.901 19.0558C10.6139 19.0558 9.22772 18.7513 8.13861 18.2437H7.94059L5.36634 19.3604L6.05941 17.0254L5.76238 16.7208C5.06931 16.1117 3.58416 14.2843 3.58416 11.7462C3.58416 7.98985 6.75248 4.94416 10.9109 4.43655V2.81218C5.86139 3.42132 2 7.17767 2 11.7462C2 14.4873 3.38614 16.4162 4.37624 17.4315L2.9901 22L7.94059 19.868C9.12871 20.3756 10.6139 20.6802 12 20.6802C17.4455 20.6802 22 16.7208 22 11.7462C22 11.2386 21.901 10.731 21.802 10.2234H20.2178V10.1218ZM19.7228 3.72589C19.2277 3.72589 18.9307 4.13198 18.9307 4.94416V5.04569C18.9307 5.85787 19.2277 6.26396 19.7228 6.26396C20.2178 6.26396 20.5149 5.85787 20.5149 5.04569V4.84264C20.4158 4.13198 20.2178 3.72589 19.7228 3.72589ZM22 2V8.29442H12.396V2H22ZM16.1584 6.26396H14.6733L15.3663 5.5533C15.7624 5.14721 16.0594 4.74112 16.0594 4.2335C16.0594 3.52284 15.5644 3.11675 14.7723 3.11675C13.9802 3.11675 13.3861 3.62437 13.3861 4.43655H14.1782C14.2772 3.92893 14.4752 3.72589 14.7723 3.72589C15.0693 3.72589 15.2673 3.92893 15.2673 4.2335C15.2673 4.53807 15.0693 4.94416 14.6733 5.35025L13.2871 6.8731V6.97462H16.0594V6.26396H16.1584ZM17.6436 6.46701C17.6436 6.16244 17.4455 5.95939 17.1485 5.95939C16.8515 5.95939 16.6535 6.16244 16.6535 6.46701C16.6535 6.77157 16.8515 6.97462 17.1485 6.97462C17.4455 6.97462 17.6436 6.67005 17.6436 6.46701ZM21.3069 4.84264C21.3069 3.62437 20.6139 3.01523 19.7228 3.01523C18.7327 3.01523 18.1386 3.72589 18.1386 4.84264V5.04569C18.1386 6.16244 18.7327 6.8731 19.7228 6.8731C20.7129 6.8731 21.3069 6.16244 21.3069 4.94416V4.84264Z",
    fill: color
  }));
};

const _excluded$1t = ["color", "size"];
/**
 * @typedef {Object} TelegramChannel2Props
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TelegramChannel2Props} props
 * @returns {JSX.Element}
 */

const TelegramChannel2 = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.46602 2 2 6.46602 2 12C2 17.534 6.46602 22 12 22C17.534 22 22 17.534 22 12C22 6.46602 17.4369 2 12 2ZM12 20.4466C7.33981 20.4466 3.45631 16.6602 3.45631 11.9029C3.45631 7.14563 7.24272 3.35922 12 3.35922C16.7573 3.35922 20.4466 7.24272 20.4466 12C20.4466 16.7573 16.6602 20.4466 12 20.4466Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2197 14.1121V16.4828H10.697V13.069L7.93939 12.0259L15.1288 9.27586L14.0455 15.4397L11.9773 14.0172V15.7241L15.1288 18L17 7L4 12.1207L9.2197 14.1121Z",
    fill: color
  }));
};

const _excluded$1u = ["color", "size"];
/**
 * @typedef {Object} TriggerIgStoryReplyProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TriggerIgStoryReplyProps} props
 * @returns {JSX.Element}
 */

const TriggerIgStoryReply = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.2683 17.122V12.7317H6.87805V11.2683H11.2683V6.87805H12.7317V11.2683H17.122V12.7317H12.7317V17.122H11.2683ZM11.9512 2V3.46341C16.6341 3.46341 20.439 7.26829 20.439 11.9512C20.439 16.6341 16.7317 20.5366 11.9512 20.5366V22C17.4146 22 21.9024 17.5122 21.9024 12.0488C21.9024 6.58537 17.5122 2 11.9512 2ZM10.1951 3.65854L9.80488 2.19512C8.82927 2.4878 7.7561 2.87805 6.87805 3.46341L7.65854 4.73171C8.43902 4.2439 9.31707 3.85366 10.1951 3.65854ZM6.39024 5.60976L5.41463 4.53659C4.14634 5.60976 3.17073 6.97561 2.58537 8.53659L3.95122 9.02439C4.43902 7.7561 5.31707 6.4878 6.39024 5.60976ZM3.46341 11.9512C3.46341 11.3659 3.56098 10.6829 3.65854 10.0976L2.19512 9.80488C2.09756 10.4878 2 11.2683 2 11.9512C2 13.7073 2.4878 15.3659 3.26829 16.9268L4.53659 16.2439C3.85366 14.9756 3.46341 13.5122 3.46341 11.9512ZM5.31707 17.2195L4.14634 18.0976C5.70732 20.1463 8.04878 21.5122 10.5854 21.8049L10.7805 20.439C8.63415 20.1463 6.68293 18.9756 5.31707 17.2195Z",
    fill: color
  }));
};

const _excluded$1v = ["color", "size"];
/**
 * @typedef {Object} IgLiveCommentsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {IgLiveCommentsProps} props
 * @returns {JSX.Element}
 */

const IgLiveComments = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.0244 12C13.0244 12.5882 12.5366 13.0784 11.9512 13.0784C11.3659 13.0784 10.878 12.5882 10.878 12C10.878 11.4118 11.3659 10.9216 11.9512 10.9216C12.6341 11.0196 13.0244 11.5098 13.0244 12ZM15.561 14.8431C16.439 12.9804 16.439 11.0196 15.561 9.15686H13.9024C15.0732 11.0196 15.0732 12.9804 13.9024 14.8431H15.561ZM10.0976 9.15686H8.43902C7.56098 11.0196 7.56098 12.9804 8.43902 14.8431H10.0976C8.92683 13.0784 8.92683 11.1176 10.0976 9.15686ZM18.3902 9.94118C18.1951 8.86275 17.8049 7.88235 17.3171 6.90196H15.561C16.2439 7.98039 16.7317 9.05882 17.0244 10.2353C17.5122 12.5882 16.9268 15.0392 15.4634 17.098H17.2195C18.4878 14.9412 18.9756 12.3922 18.3902 9.94118ZM7.07317 10.2353C7.26829 9.05882 7.85366 7.98039 8.53659 6.90196H6.78049C6.19512 7.88235 5.90244 8.86275 5.60976 9.94118C5.12195 12.3922 5.5122 14.9412 6.87805 17.098H8.63415C7.17073 15.0392 6.58537 12.5882 7.07317 10.2353ZM22 12C22 17.4902 17.5122 22 12.0488 22C6.58537 22 2 17.5882 2 12C2 6.41176 6.4878 2 11.9512 2C17.4146 2 22 6.5098 22 12ZM20.5366 12C20.5366 7.29412 16.7317 3.47059 12.0488 3.47059C7.36585 3.47059 3.56098 7.29412 3.56098 12C3.56098 16.7059 7.26829 20.6275 11.9512 20.6275C16.6341 20.6275 20.5366 16.7059 20.5366 12Z",
    fill: color
  }));
};

const _excluded$1w = ["color", "size"];
/**
 * @typedef {Object} OrphanMobileProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanMobileProps} props
 * @returns {JSX.Element}
 */

const OrphanMobile = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M17.6093 3.50754V20.4925H6.39073V3.50754H17.6093ZM19 2H5V22H19V2Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6093 6.87061H6.39075V5.37061H17.6093V6.87061Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6093 18.8304H6.39075V17.3304H17.6093V18.8304Z",
    fill: color
  }));
};

const _excluded$1x = ["color", "size"];
/**
 * @typedef {Object} OrphanDesktopProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanDesktopProps} props
 * @returns {JSX.Element}
 */

const OrphanDesktop = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 3V17.0777H22V3H2ZM20.5366 4.47668V12.8446H3.46341V4.47668H20.5366ZM3.46341 15.601V14.3212H20.5366V15.601H3.46341ZM13.9024 18.6529H15.3659V22H8.63415V18.6529H10.0976V20.5233H13.9024V18.6529Z",
    fill: color
  }));
};

const _excluded$1y = ["color", "size"];
/**
 * @typedef {Object} OrphanFullScreenPreviewProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanFullScreenPreviewProps} props
 * @returns {JSX.Element}
 */

const OrphanFullScreenPreview = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M8.63366 15.929L4.17822 12.0473L8.63366 7.88166V9.86982L7.14851 11.2899H16.8515L15.2673 9.86982V7.97633L19.8218 11.9527L15.3663 16.1183L15.2673 16.0237V14.2249L16.8515 12.7101H7.14851L8.73267 14.0355V15.929H8.63366ZM22 4V20H2V4H22ZM20.5149 5.42012H3.48515V18.5799H20.5149V5.42012Z",
    fill: color
  }));
};

const _excluded$1z = ["color", "size"];
/**
 * @typedef {Object} OrphanCardQuadrantProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanCardQuadrantProps} props
 * @returns {JSX.Element}
 */

const OrphanCardQuadrant = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 4V20H22V4H2ZM20.5 5.43713V15.1138H3.5V5.43713H20.5ZM3.5 18.5629V16.5509H20.5V18.5629H3.5Z",
    fill: color
  }));
};

const _excluded$1A = ["color", "size"];
/**
 * @typedef {Object} OrphanIntegrationProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanIntegrationProps} props
 * @returns {JSX.Element}
 */

const OrphanIntegration = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3633 5.35307C14.4073 5.43559 14.447 5.51307 14.4824 5.58428H18.9501V10.2655C19.1765 10.2802 19.4355 10.3138 19.707 10.3817C20.5886 10.6021 21.6326 11.2031 22.0236 12.6369L22.026 12.6461C22.4854 14.4178 21.4364 15.7891 20.5093 16.6087C20.0303 17.0321 19.5335 17.3567 19.1609 17.5742C19.0857 17.6181 19.0151 17.6579 18.9501 17.6936V22.1843H2.05005V15.5659L2.90796 15.6921L2.90917 15.6923L2.91145 15.6926L2.93201 15.6952C2.95155 15.6977 2.98243 15.7014 3.02313 15.7055C3.1047 15.7138 3.22474 15.724 3.37138 15.7303C3.66796 15.7431 4.05732 15.7394 4.4508 15.6801C5.29554 15.5529 5.83363 15.2352 5.97044 14.6606L5.97262 14.6514L5.97502 14.6424C6.14968 13.9825 6.0458 13.4673 5.81254 13.0414C5.56767 12.5942 5.15721 12.2071 4.67152 11.8833C4.18979 11.5622 3.67328 11.3294 3.26962 11.176C3.06965 11.1 2.90183 11.0452 2.78595 11.0099C2.72812 10.9923 2.68351 10.9796 2.65464 10.9717L2.62356 10.9633L2.61815 10.9619L2.61699 10.9616L2.05005 10.8199V5.58428H7.01662C7.02249 5.33365 7.04468 5.04245 7.09945 4.73868C7.25564 3.87257 7.73306 2.67111 9.10918 2.30897L9.11264 2.30807C11.0714 1.80259 12.5176 2.88088 13.3836 3.89809C13.8228 4.41392 14.1485 4.95053 14.3633 5.35307ZM8.57564 5.00487C8.69434 4.34666 8.96647 3.89838 9.48928 3.76001C10.6297 3.46658 11.5329 4.03811 12.2415 4.87046C12.5898 5.27963 12.8578 5.71803 13.0399 6.05924C13.1302 6.22843 13.1975 6.37023 13.2414 6.46774C13.2634 6.51641 13.2794 6.55381 13.2894 6.57777L13.2999 6.6033L13.3014 6.60693L13.4876 7.08428H17.45V11.9138L18.3154 11.7754L18.3247 11.7741C18.3353 11.7727 18.3541 11.7705 18.3799 11.768C18.4319 11.763 18.5111 11.7574 18.6097 11.7561C18.8099 11.7535 19.0733 11.7694 19.3431 11.8369C19.8605 11.9662 20.3655 12.2642 20.5752 13.027C20.8131 13.9534 20.3124 14.7806 19.5158 15.4849C19.1323 15.8239 18.7228 16.0931 18.4048 16.2787C18.247 16.3708 18.1149 16.4405 18.024 16.4864C17.9786 16.5093 17.9437 16.5262 17.9213 16.5368L17.8974 16.548L17.8938 16.5497L17.45 16.7482V20.6843H3.55005V17.2357C3.87254 17.2398 4.26499 17.2251 4.6743 17.1634C5.65255 17.016 7.06067 16.5354 7.4274 15.0174C7.69952 13.9809 7.54063 13.0741 7.12818 12.3209C6.72618 11.5868 6.10539 11.0364 5.50357 10.6352C4.89781 10.2314 4.27057 9.95169 3.80236 9.7738C3.71269 9.73973 3.6282 9.70915 3.55005 9.68194V7.08428H8.66481L8.54271 6.22965L8.54255 6.22842L8.54072 6.2137C8.53898 6.1991 8.53631 6.17526 8.53334 6.14339C8.52738 6.07946 8.5203 5.98427 8.51692 5.8673C8.51007 5.63013 8.51891 5.31947 8.57564 5.00487Z",
    fill: color
  }));
};

const _excluded$1B = ["color", "size"];
/**
 * @typedef {Object} OrphanSplitProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanSplitProps} props
 * @returns {JSX.Element}
 */

const OrphanSplit = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M15.7755 14.7962L18.4286 16.7867H16.6939C12.9184 16.7867 11.2857 15.5545 9.55102 14.2275C8.53061 13.4692 7.5102 12.7109 6.08163 12.1422C7.61224 11.5735 8.73469 10.7204 9.7551 9.96209C11.4898 8.63507 13.1224 7.30806 16.7959 7.30806H18.5306L15.8776 9.29858V11.0995L22 6.54976L15.8776 2V3.80095L18.5306 5.88626H16.7959C12.6122 5.88626 10.5714 7.40284 8.83673 8.82464C7.10204 10.1517 5.46939 11.3839 2 11.3839V12.8057C5.46939 12.8057 7 14.0379 8.63265 15.2701C10.3673 16.5972 12.4082 18.2085 16.6939 18.2085H18.4286L15.7755 20.1991V22L21.898 17.4502L15.7755 12.9005V14.7962Z",
    fill: color
  }));
};

const _excluded$1C = ["color", "size"];
/**
 * @typedef {Object} OrphanCallProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanCallProps} props
 * @returns {JSX.Element}
 */

const OrphanCall = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.6 17.3C19.3 17.3 19.1 17.2 18.9 17.1C18.6 16.9 16.2 15.6 16 15.5C15.3 15.1 15 14.6 15 13.9C15 13.3 15 12.2 15 12.2C14.5 12.1 13.3 11.8 12.1 11.7C10.7 11.7 9.3 12 8.8 12.2C8.7 12.3 8.7 12.3 8.7 12.3C8.7 12.3 8.7 12.4 8.7 12.5L8.8 14.5C8.9 15 8.6 15.7 7.8 16C7.2 16.2 5.4 16.8 4.6 17C4.1 17.2 3.5 17 3.2 16.6C2.8 16.3 2 15.4 2 13.7C2 12 3 10.2 4.4 9.2C5.8 8.1 8.8 7 11.8 7C14.2 7 16.3 7.5 18.3 8.4C21.1 9.8 22.6 12.6 21.8 15.1C21.7 15.4 21.4 16 21.3 16.2C20.7 17 20.1 17.3 19.6 17.3ZM16.4 12.3C16.4 12.3 16.4 13.3 16.4 13.9C16.4 14.1 16.5 14.1 16.7 14.2C16.9 14.3 19.2 15.6 19.6 15.8C19.6 15.8 19.8 15.7 20 15.4C20.1 15.2 20.3 14.8 20.4 14.6C21 12.9 19.8 10.8 17.7 9.8C15.9 8.9 14 8.5 11.9 8.5C9.3 8.5 6.7 9.4 5.4 10.4C4.4 11.1 3.7 12.5 3.6 13.7C3.6 14.7 4 15.3 4.3 15.6C5.1 15.4 6.9 14.8 7.4 14.6L7.3 12.6C7.3 12.2 7.2 11.4 8.2 10.9C9 10.5 10.5 10.2 12 10.3C13.5 10.3 15 10.7 15.5 10.9C16.2 11.1 16.4 11.8 16.4 12.3Z",
    fill: color
  }));
};

const _excluded$1D = ["color", "size"];
/**
 * @typedef {Object} OrphanBuyButtonProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanBuyButtonProps} props
 * @returns {JSX.Element}
 */

const OrphanBuyButton = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C21.9 6.5 17.5 2 12 2ZM12 20.5C7.3 20.5 3.5 16.7 3.5 12C3.5 7.3 7.3 3.4 12 3.4C16.7 3.4 20.5 7.3 20.5 12C20.4 16.7 16.6 20.5 12 20.5ZM10.1 8.9C10.1 9.8 10.8 10.6 12.3 11.1C14.4 11.9 15.5 13.1 15.5 14.7C15.5 16.1 14.6 17.5 12.7 17.8V18.8H11.2V17.8C9 17.4 8 15.6 8 13.9H9.5C9.5 15 10.1 16.3 11.9 16.3C13.5 16.3 13.9 15.2 13.9 14.6C13.9 13.7 13.1 13 11.6 12.4C9.1 11.5 8.6 10 8.6 8.9C8.6 7.5 9.7 6.3 11.2 6V5H12.7V5.9C13.4 6 14 6.3 14.5 6.8C15.2 7.4 15.6 8.3 15.6 9.2H14C14 8.8 13.8 8.3 13.4 7.9C13.1 7.6 12.7 7.3 11.9 7.4C11 7.4 10.1 7.9 10.1 8.9Z",
    fill: color
  }));
};

const _excluded$1E = ["color", "size"];
/**
 * @typedef {Object} OrphanAction2Props
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanAction2Props} props
 * @returns {JSX.Element}
 */

const OrphanAction2 = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.09615 12.0962C7.09615 14.5962 9.01923 16.6154 11.4231 16.9038V18.3462C8.25 18.0577 5.65385 15.3654 5.65385 12.0962C5.65385 8.63462 8.44231 5.84615 11.9038 5.84615C15.2692 5.84615 17.9615 8.44231 18.1538 11.7115H16.7115C16.5192 9.21154 14.4038 7.28846 11.9038 7.28846C9.30769 7.19231 7.09615 9.40385 7.09615 12.0962ZM3.44231 12C3.44231 7.28846 7.28846 3.44231 12 3.44231C16.6154 3.44231 20.3654 7.09615 20.5577 11.6154H22C21.8077 6.32692 17.3846 2 12 2C6.51923 2 2 6.51923 2 12C2 17.2885 6.23077 21.7115 11.4231 22V20.5577C7 20.2692 3.44231 16.5192 3.44231 12ZM19.5962 14.5V13.0577H13.25L13.3462 19.5H14.7885V15.4615L21.3269 22V19.9808L15.8462 14.5H19.5962Z",
    fill: color
  }));
};

const _excluded$1F = ["color", "size"];
/**
 * @typedef {Object} OrphanAdsCampaignTrafficProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanAdsCampaignTrafficProps} props
 * @returns {JSX.Element}
 */

const OrphanAdsCampaignTraffic = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M20.5075 19.4129L13.7413 12.6468L22 9.66169L2 2L9.66169 22L12.6468 13.7413L20.5075 21.5025V19.4129ZM11.7512 11.7512L9.56219 17.7214L4.58706 4.58706L17.7214 9.66169L11.7512 11.7512Z",
    fill: color
  }));
};

const _excluded$1G = ["color", "size"];
/**
 * @typedef {Object} OrphanBuilderSelectProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanBuilderSelectProps} props
 * @returns {JSX.Element}
 */

const OrphanBuilderSelect = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M5.7 14.963H7.95V16.3519H5.7V14.963ZM4.35 14.3148H3V16.2593H4.89V14.963H4.35V14.3148ZM4.35 4.77778H3V7.09259H4.35V4.77778ZM4.35 11.1667H3V13.4815H4.35V11.1667ZM4.35 8.01852H3V10.3333H4.35V8.01852ZM3 3.94444H4.35V3.38889H4.89V2H3V3.94444ZM14.88 2H12.45V3.38889H14.88V2ZM18.21 2H15.78V3.38889H18.21V2ZM11.55 2H9.12V3.38889H11.55V2ZM5.79 3.38889H8.22V2H5.79V3.38889ZM19.11 2V3.38889H19.65V3.94444H21V2H19.11ZM19.65 10.3333H21V8.01852H19.65V10.3333ZM19.65 7.18518H21V4.77778H19.65V7.18518ZM19.65 13.4815H21V11.1667H19.65V13.4815ZM19.65 14.963H19.11V16.3519H21V14.4074H19.65V14.963ZM17.67 16.3519L19.02 17.5556L13.17 17.463L9.39 22V16.3519H8.76V14.963H9.39V8.66667L16.23 14.963H18.03V16.3519H17.67ZM15.42 16.0741L10.74 11.7222V18.2037L12.63 15.9815L15.42 16.0741Z",
    fill: color
  }));
};

const _excluded$1H = ["color", "size"];
/**
 * @typedef {Object} OrphanFullTextProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanFullTextProps} props
 * @returns {JSX.Element}
 */

const OrphanFullText = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M5 19.1845H12.0989V20.6408H3.51648V2L19.8132 2V13.2621H18.3296V3.45631H5V19.1845ZM15.956 5.59223H6.97802V7.04854H15.8571V5.59223H15.956ZM15.956 8.99029H6.97802V10.4466H15.8571V8.99029H15.956ZM6.97802 13.8447H11.8022V12.3883H6.97802V13.8447ZM21 18.0194C21 20.1553 19.2198 22 16.945 22C14.7692 22 12.8901 20.2524 12.8901 18.0194C12.8901 15.8835 14.6703 14.0388 16.945 14.0388C19.2198 14.0388 21 15.7864 21 18.0194ZM19.5165 18.0194C19.5165 16.6602 18.4285 15.4951 16.945 15.4951C15.4615 15.4951 14.3736 16.5631 14.3736 18.0194C14.3736 19.3786 15.4615 20.5437 16.945 20.5437C18.4285 20.5437 19.5165 19.3786 19.5165 18.0194Z",
    fill: color
  }));
};

const _excluded$1I = ["color", "size"];
/**
 * @typedef {Object} OrphanMinimizedChatProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanMinimizedChatProps} props
 * @returns {JSX.Element}
 */

const OrphanMinimizedChat = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M3.46341 14.0323H14.5854V15.4839H2V6H20.5366V10.5484H19.0732V7.45161H3.46341V14.0323ZM15.3659 11.5161V10.0645H6.09756V11.5161H15.3659ZM22 14.7097C22 16.5484 20.5366 18 18.6829 18C16.8293 18 15.3659 16.5484 15.3659 14.7097C15.3659 12.871 16.8293 11.4194 18.6829 11.4194C20.439 11.4194 22 12.871 22 14.7097ZM20.5366 14.7097C20.5366 13.7419 19.6585 12.871 18.6829 12.871C17.7073 12.871 16.8293 13.7419 16.8293 14.7097C16.8293 15.6774 17.7073 16.5484 18.6829 16.5484C19.6585 16.5484 20.5366 15.6774 20.5366 14.7097Z",
    fill: color
  }));
};

const _excluded$1J = ["color", "size"];
/**
 * @typedef {Object} OrphanLongArrowProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanLongArrowProps} props
 * @returns {JSX.Element}
 */

const OrphanLongArrow = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0784 11.4L9.06177 4.37097L11.5036 10.65H2V12.15H11.5036L9.06177 18.429L22.0784 11.4ZM13.4047 11.4L11.9382 7.62898L18.9215 11.4L11.9382 15.171L13.4047 11.4Z",
    fill: color
  }));
};

const _excluded$1K = ["color", "size"];
/**
 * @typedef {Object} OrphanIntegromatProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanIntegromatProps} props
 * @returns {JSX.Element}
 */

const OrphanIntegromat = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5 17.4774 22 11.9497 22C6.42211 22 2 17.5 2 12C2 7.6 4.91457 3.8 8.93467 2.5V4.1C5.71859 5.3 3.50754 8.4 3.50754 12C3.50754 16.7 7.32663 20.5 12.0503 20.5C16.7739 20.5 20.593 16.7 20.593 12C20.593 8.4 18.3819 5.3 15.1658 4.1V2.5C19.0854 3.8 22 7.5 22 12ZM12.7538 3.5V2C12.5528 2 12.2513 2 12.0503 2C11.7487 2 11.4472 2 11.2462 2V3.5C11.5477 3.5 11.7487 3.5 12.0503 3.5C12.2513 3.5 12.5528 3.5 12.7538 3.5ZM11.2462 16.8H12.7538V5.1H11.2462V16.8Z",
    fill: color
  }));
};

const _excluded$1L = ["color", "size"];
/**
 * @typedef {Object} OrphanAdsCampaignMessagesProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanAdsCampaignMessagesProps} props
 * @returns {JSX.Element}
 */

const OrphanAdsCampaignMessages = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.0504 9.73869C19.0504 5.41709 15.4609 2 10.8742 2C6.28753 2 2.59826 5.41709 2.59826 9.73869C2.59826 11.2462 2.89739 12.3518 3.49565 13.4573L2 18.0804L6.98551 16.5729C7.8829 16.9749 9.07942 17.4774 10.8742 17.4774C15.4609 17.5779 19.0504 14.1608 19.0504 9.73869ZM7.18493 15.0653L4.39304 15.8693L5.29043 13.3568L4.9913 13.0553C4.39304 12.0503 4.09391 11.0452 4.09391 9.73869C4.09391 6.22111 7.08522 3.50754 10.8742 3.50754C14.6632 3.50754 17.5548 6.22111 17.5548 9.73869C17.5548 13.2563 14.6632 15.9698 10.8742 15.9698C9.17913 15.9698 8.18203 15.5678 7.38435 15.0653H7.18493ZM20.8452 17.9799L21.5432 22L17.8539 20.392C17.3554 20.593 16.8568 20.794 16.2585 20.794C14.1646 20.995 12.2701 20.2915 10.7745 18.8844H13.2672C14.0649 19.2864 15.062 19.4874 16.0591 19.3869C16.6574 19.2864 17.0562 19.1859 17.4551 18.9849L17.7542 18.7839L19.549 19.5879L19.2498 17.6784L19.4493 17.3769C20.0475 16.6734 21.2441 14.2613 19.7484 11.5477H21.4435C22.5403 14.1608 21.8423 16.6734 20.8452 17.9799Z",
    fill: color
  }));
};

const _excluded$1M = ["color", "size"];
/**
 * @typedef {Object} OrphanAdStatisticsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanAdStatisticsProps} props
 * @returns {JSX.Element}
 */

const OrphanAdStatistics = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.8738 2H12.0971V11.9512H22V11.1707C22 6.09756 17.9223 2 12.8738 2ZM13.5534 10.4878V3.46341C17.2427 3.85366 20.1553 6.78049 20.4466 10.3902H13.5534V10.4878ZM19.3786 14.1951H20.835C20.0583 18.6829 16.1748 22 11.5146 22C6.27184 22 2 17.7073 2 12.439C2 7.7561 5.39806 3.95122 9.76699 3.07317V4.53659C6.17476 5.31707 3.45631 8.53659 3.45631 12.439C3.45631 16.9268 7.04854 20.5366 11.5146 20.5366C15.301 20.5366 18.5049 17.8049 19.3786 14.1951Z",
    fill: color
  }));
};

const _excluded$1N = ["color", "size"];
/**
 * @typedef {Object} OrphanMainMenuProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanMainMenuProps} props
 * @returns {JSX.Element}
 */

const OrphanMainMenu = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0343 4.00293H22.0637V7.94999H2.0343V4.00293ZM3.5343 5.50293V6.44999H20.5637V5.50293H3.5343Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0343 10.0265H22.0637V13.9735H2.0343V10.0265ZM3.5343 11.5265V12.4735H20.5637V11.5265H3.5343Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0637 16.05H2.0343V19.997H22.0637V16.05ZM3.5343 18.497V17.55H20.5637V18.497H3.5343Z",
    fill: color
  }));
};

const _excluded$1O = ["color", "size"];
/**
 * @typedef {Object} OrphanLiveChatDoneProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanLiveChatDoneProps} props
 * @returns {JSX.Element}
 */

const OrphanLiveChatDone = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0627 7.15387L19.8378 3.94141L19.3085 4.46874L19.3074 4.46974L19.3043 4.47277L19.2934 4.48322L19.2571 4.51738C19.227 4.54548 19.1873 4.5821 19.1382 4.62712C19.0402 4.71706 18.9078 4.83743 18.7457 4.98425C18.4216 5.27773 17.9816 5.67408 17.465 6.13829C16.4318 7.06658 15.0945 8.26421 13.7702 9.44873C12.4461 10.6332 11.1355 11.8042 10.1558 12.6791L9.05524 13.6618L4.16216 8.78756L0.946899 11.9905L1.46119 12.5217L1.67531 12.7424C1.8129 12.8841 2.01177 13.0885 2.25714 13.3399C2.74781 13.8428 3.4247 14.5339 4.16941 15.287C5.65404 16.7883 7.42388 18.5518 8.52129 19.5539L9.03543 20.0233L9.54179 19.5455C11.2465 17.9367 14.2668 15.1966 16.9762 12.7446L18.0235 11.797C20.2705 9.76435 22.1393 8.07376 22.5293 7.68523L23.0627 7.15387ZM8.99874 15.7228L11.155 13.7979C12.1348 12.9228 13.4458 11.7515 14.7703 10.5667C16.7803 8.76879 18.8473 6.91684 19.8168 6.03766L20.9218 7.13849C20.1412 7.85841 18.6896 9.17168 17.0006 10.6997L15.9697 11.6324C13.5164 13.8526 10.7927 16.3231 9.02487 17.9736C7.96337 16.9709 6.50663 15.5172 5.23599 14.2323C4.49422 13.4822 3.81975 12.7935 3.3307 12.2923L3.0541 12.0086L4.16216 10.9048L8.99874 15.7228Z",
    fill: color
  }));
};

const _excluded$1P = ["color", "size"];
/**
 * @typedef {Object} OrphanFbChatProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanFbChatProps} props
 * @returns {JSX.Element}
 */

const OrphanFbChat = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0503 2.04169C6.61524 2.04169 2.05408 5.84245 2.05408 10.8073C2.05408 13.5471 3.47058 15.4846 4.38378 16.4691L3.17157 21.1108L7.94098 18.7627C9.21594 19.3104 10.7722 19.5729 12.0503 19.5729C17.4854 19.5729 22.0465 15.7722 22.0465 10.8073C22.0465 5.84245 17.4854 2.04169 12.0503 2.04169ZM3.55408 10.8073C3.55408 6.86593 7.23412 3.54169 12.0503 3.54169C16.8665 3.54169 20.5465 6.86593 20.5465 10.8073C20.5465 14.7487 16.8665 18.0729 12.0503 18.0729C10.8323 18.0729 9.34269 17.792 8.26097 17.2594L7.92971 17.0963L5.45166 18.3163L6.05139 16.0199L5.74235 15.7156C4.9899 14.9747 3.55408 13.2775 3.55408 10.8073Z",
    fill: color
  }));
};

const _excluded$1Q = ["color", "size"];
/**
 * @typedef {Object} OrphanTriggerZapProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanTriggerZapProps} props
 * @returns {JSX.Element}
 */

const OrphanTriggerZap = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 2H12.8V9.4H11.3V2ZM11.3 22H12.8V14.6H11.3V22ZM14.6 11.3V12.8H22V11.3H14.6ZM9.4 11.3H2V12.8H9.4V11.3ZM4.5 5.6L9.6 10.7L10.7 9.6L6.6 5.6H4.5ZM19.5 5.6H17.4L13.3 9.7L14.4 10.8L19.5 5.6ZM13.3 14.4L17.4 18.5H19.5L14.4 13.4L13.3 14.4ZM4.5 18.4H6.6L10.7 14.3L9.6 13.2L4.5 18.4Z",
    fill: color
  }));
};

const _excluded$1R = ["color", "size"];
/**
 * @typedef {Object} OrphanTableViewProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanTableViewProps} props
 * @returns {JSX.Element}
 */

const OrphanTableView = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M6 8H2V4H6V8ZM22 4H8V8H22V4ZM6 10.08H2V14H6V10.08ZM22 10.08H8V14H22V10.08ZM6 16H2V20H6V16ZM22 16H8V20H22V16Z",
    fill: color
  }));
};

const _excluded$1S = ["color", "size"];
/**
 * @typedef {Object} OrphanSubscribedNoInfoProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanSubscribedNoInfoProps} props
 * @returns {JSX.Element}
 */

const OrphanSubscribedNoInfo = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.3449 9.9798C12.3449 11.2929 12.0465 11.899 11.2507 11.899C10.4549 11.899 10.1565 11.1919 10.1565 9.9798C10.1565 8.66667 10.4549 7.9596 11.2507 7.9596C12.0465 7.9596 12.3449 8.66667 12.3449 9.9798ZM15.329 7.9596C14.5332 7.9596 14.2348 8.66667 14.2348 9.9798C14.2348 11.2929 14.5332 11.899 15.329 11.899C16.1247 11.899 16.4231 11.1919 16.4231 9.9798C16.5226 8.66667 16.1247 7.9596 15.329 7.9596ZM19.1088 4.72727C17.7163 2.90909 15.7269 2 13.439 2C7.07297 2 2.79576 9.47475 2 22H3.49205C4.08887 12.9091 7.07297 3.51515 13.439 3.51515C15.329 3.51515 16.821 4.22222 18.0147 5.63636C20.5014 8.66667 21.1977 14.7273 19.9046 22H21.3966C22.6898 14.4242 21.894 8.06061 19.1088 4.72727Z",
    fill: color
  }));
};

const _excluded$1T = ["color", "size"];
/**
 * @typedef {Object} OrphanOpenProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanOpenProps} props
 * @returns {JSX.Element}
 */

const OrphanOpen = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.0732 6.26531H17.5122L20.0488 13.7296H15.9512L15.7561 14.2143C15.7561 14.3112 14.5854 17.4133 11.561 17.4133C8.92683 17.4133 8.73171 14.9898 8.73171 14.699V14.0204H3.85366L6.29268 6.26531H4.73171L2 14.7959V21H22V14.699L19.0732 6.26531ZM3.46341 19.5459V15.4745H7.46341C7.7561 16.9286 8.82927 18.8673 11.6585 18.8673C14.878 18.8673 16.439 16.25 17.0244 15.1837H20.5366V19.5459H3.46341ZM9.70732 6.36224H7.65854L11.8537 2L16.3415 6.36224H14.1951L12.5366 4.81122V13.3418H11.1707V4.81122L9.70732 6.36224Z",
    fill: color
  }));
};

const _excluded$1U = ["color", "size"];
/**
 * @typedef {Object} OrphanArchiveProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanArchiveProps} props
 * @returns {JSX.Element}
 */

const OrphanArchive = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.0732 6.36224H17.5122L20.0488 13.8265H15.9512L15.7561 14.3112C15.7561 14.4082 14.5854 17.5102 11.561 17.5102C8.92683 17.5102 8.73171 15.0867 8.73171 14.7959V14.1173H3.85366L6.29268 6.36224H4.73171L2 14.7959V21H22V14.699L19.0732 6.36224ZM3.46341 19.6429V15.5714H7.46341C7.7561 17.0255 8.82927 18.9643 11.6585 18.9643C14.878 18.9643 16.439 16.3469 17.0244 15.2806H20.5366V19.6429H3.46341ZM11.7561 14.0204L7.17073 9.56122H9.21951L10.9756 11.3061V2H12.439V11.2092L14.0976 9.56122H16.1463L11.7561 14.0204Z",
    fill: color
  }));
};

const _excluded$1V = ["color", "size"];
/**
 * @typedef {Object} OrphanRestoreProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanRestoreProps} props
 * @returns {JSX.Element}
 */

const OrphanRestore = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.88893 11.2025H9.72319L6.05467 15.816L2 11.2025H3.9308L6.05467 13.5583L7.88893 11.2025ZM13.7779 8.06135L11.1713 12.9693H19.4737V11.4969H13.5848L15.419 8.06135H13.7779ZM14.7433 2.07362C12.6194 1.77914 10.592 2.3681 8.75779 3.84049C6.73045 5.5092 5.47544 8.15951 5.18582 11.2025H6.63391C6.92353 8.65031 7.98547 6.39264 9.72319 4.92025C11.1713 3.74233 12.909 3.25153 14.5502 3.44785C18.4118 4.03681 21.1149 8.25767 20.5357 12.9693C20.246 15.5215 19.0876 17.681 17.2533 19.1534C15.9983 20.135 14.5502 20.6258 13.1021 20.5276V22C13.1986 22 13.2952 22 13.3917 22C15.0329 22 16.6741 21.411 18.1222 20.3313C20.246 18.6626 21.5976 16.1104 21.8872 13.1656C22.6595 7.76687 19.3772 2.76074 14.7433 2.07362Z",
    fill: color
  }));
};

const _excluded$1W = ["color", "size"];
/**
 * @typedef {Object} CufTextProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CufTextProps} props
 * @returns {JSX.Element}
 */

const CufText = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2.05811 2.05811H22.043V6.64649H20.543V3.55811H3.55811V6.64649H2.05811V2.05811Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 20.5429V4.62628H12.75V20.5429H15.4343V22.0429L8.66663 22.0429V20.5429H11.25Z",
    fill: color
  }));
};

const _excluded$1X = ["color", "size"];
/**
 * @typedef {Object} CufNumberProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CufNumberProps} props
 * @returns {JSX.Element}
 */

const CufNumber = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 9.23077V7.69231H17.8L18.9 4H17.3L16.2 7.69231H10.5L11.6 4H10L8.9 7.69231H3.6V9.23077H8.4L6.7 14.7692H2V16.3077H6.3L5.2 20H6.8L7.9 16.3077H13.7L12.6 20H14.2L15.3 16.3077H20.5V14.7692H15.8L17.4 9.23077H22ZM14.1 14.7692H8.4L10 9.23077H15.8L14.1 14.7692Z",
    fill: color
  }));
};

const _excluded$1Y = ["color", "size"];
/**
 * @typedef {Object} CufBooleanProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CufBooleanProps} props
 * @returns {JSX.Element}
 */

const CufBoolean = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M6.25743 6.46701L2 2H4.07921L6.95049 5.04569L9.92079 2H12L7.74257 6.36548V11.5431H6.25743V6.46701ZM18.7327 2L2.09901 22H4.07921L20.7129 2H18.7327ZM20.4158 12.2538V19.665L15.3663 12.2538H13.6832V22H15.1683V14.6904L20.2178 22H22V12.2538H20.4158Z",
    fill: color
  }));
};

const _excluded$1Z = ["color", "size"];
/**
 * @typedef {Object} OrphanClickedProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanClickedProps} props
 * @returns {JSX.Element}
 */

const OrphanClicked = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 17.4C5.80002 15.4 5.30002 12.5 8.60002 8.79996C8.00002 8.29996 5.70002 6.89996 3.70002 5.69996C1.60002 4.29996 3.30002 1.89996 5.20002 3.09996C6.30002 3.69996 15 9.19996 15 9.19996C14.6 6.29996 15.1 4.59996 16.2 3.99996C16.9 3.59996 17.8 3.69996 18.5 4.19996C17.3 6.99996 18.1 10.6 20.8 13.6L16.1 21C16.1 21 12.3 19.4 9.00002 17.4Z",
    stroke: color,
    strokeWidth: "1.5"
  }));
};

const _excluded$1_ = ["color", "size"];
/**
 * @typedef {Object} OrphanActionProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrphanActionProps} props
 * @returns {JSX.Element}
 */

const OrphanAction = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.571 10.7345L14.8122 2.04456L3.15051 13.2655H9.42851L9.18772 21.8225L20.9874 10.7345H14.571ZM10.7886 18.2599L10.9713 11.7655H6.87283L13.2111 5.66677L13.0288 12.2345H17.2007L10.7886 18.2599Z",
    fill: color
  }));
};

const _excluded$1$ = ["color", "size"];
/**
 * @typedef {Object} DeleteTagProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DeleteTagProps} props
 * @returns {JSX.Element}
 */

const DeleteTag = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$1$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M17.3366 10.5248C18.5248 9.33663 18.5248 7.55446 17.3366 6.36634C16.1485 5.17822 14.3663 5.17822 13.1782 6.36634C12.5842 6.9604 12.2871 7.65347 12.2871 8.44554C12.2871 9.23762 12.5842 9.93069 13.1782 10.5248C13.7723 11.1188 14.4653 11.4158 15.2574 11.4158C15.9505 11.3168 16.7426 11.1188 17.3366 10.5248ZM14.2673 9.43564C13.9703 9.13861 13.8713 8.84158 13.8713 8.44554C13.8713 8.0495 14.0693 7.65347 14.2673 7.45545C14.4653 7.15842 14.8614 6.9604 15.2574 6.9604C15.6535 6.9604 15.9505 7.05941 16.2475 7.35644C16.8416 7.95049 16.8416 8.84158 16.2475 9.43564C15.7525 10.0297 14.7624 10.0297 14.2673 9.43564ZM12.5842 18.8416H14.6634L10.505 23L1 13.495L4.16832 10.3267H6.24752L3.07921 13.495L10.505 20.9208L12.5842 18.8416ZM21 3V12.505L18.1287 15.3762H16.0495L19.5149 11.9109V4.48515H12.0891L9.61386 6.9604H7.53465L11.495 3H21ZM2.48515 3.29703L19.8119 20.6238V22.703L2.48515 5.37624V3.29703Z",
    fill: color
  }));
};

const _excluded$20 = ["color", "size"];
/**
 * @typedef {Object} CouponProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CouponProps} props
 * @returns {JSX.Element}
 */

const Coupon = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$20);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M6.47525 9.87437C8.34653 9.87437 9.86139 8.33668 9.86139 6.43719C9.86139 4.53769 8.34653 3 6.47525 3C4.60396 3 3.08911 4.53769 3.08911 6.43719C3.08911 8.33668 4.60396 9.87437 6.47525 9.87437ZM6.47525 4.35678C7.63366 4.35678 8.52475 5.26131 8.52475 6.43719C8.52475 7.61307 7.63366 8.51759 6.47525 8.51759C5.31683 8.51759 4.42574 7.61307 4.42574 6.43719C4.42574 5.26131 5.31683 4.35678 6.47525 4.35678ZM17.4356 14.1256C15.5644 14.1256 14.0495 15.6633 14.0495 17.5628C14.0495 19.4623 15.5644 21 17.4356 21C19.3069 21 20.8218 19.4623 20.8218 17.5628C20.8218 15.6633 19.3069 14.1256 17.4356 14.1256ZM17.4356 19.6432C16.2772 19.6432 15.3861 18.7387 15.3861 17.5628C15.3861 16.3869 16.2772 15.4824 17.4356 15.4824C18.5941 15.4824 19.4851 16.3869 19.4851 17.5628C19.4851 18.7387 18.505 19.6432 17.4356 19.6432ZM21 3.63317L4.87129 20.0955H3L19.1287 3.63317H21Z",
    fill: color
  }));
};

const _excluded$21 = ["color", "size"];
/**
 * @typedef {Object} CufEnumProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CufEnumProps} props
 * @returns {JSX.Element}
 */

const CufEnum = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$21);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 5.25H2.25V6.75H21.75V5.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 11.25H2.25V12.75H21.75V11.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 17.25H2.25V18.75H21.75V17.25Z",
    fill: color
  }));
};

const _excluded$22 = ["color", "size"];
/**
 * @typedef {Object} CufNoIconProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CufNoIconProps} props
 * @returns {JSX.Element}
 */

const CufNoIcon = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$22);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 6.25C8.91391 6.25 6.25 8.91391 6.25 12.2C6.25 15.4861 8.91391 18.15 12.2 18.15C15.4861 18.15 18.15 15.4861 18.15 12.2C18.15 8.91391 15.4861 6.25 12.2 6.25ZM7.75 12.2C7.75 9.74233 9.74233 7.75 12.2 7.75C14.6577 7.75 16.65 9.74233 16.65 12.2C16.65 14.6577 14.6577 16.65 12.2 16.65C9.74233 16.65 7.75 14.6577 7.75 12.2Z",
    fill: color
  }));
};

const _excluded$23 = ["color", "size"];
/**
 * @typedef {Object} CufArrayProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CufArrayProps} props
 * @returns {JSX.Element}
 */

const CufArray = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$23);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25H3.25V21.75H9V20.25H4.75V3.75H9V2.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 2.25H15V3.75H19.25V20.25H15V21.75H20.75V2.25Z",
    fill: color
  }));
};

const _excluded$24 = ["color", "size"];
/**
 * @typedef {Object} PhoneOutgoingProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {PhoneOutgoingProps} props
 * @returns {JSX.Element}
 */

const PhoneOutgoing = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$24);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98009 4.00658C8.85578 3.75921 8.63187 3.40623 8.1952 3.16923C7.75936 2.93269 7.21813 2.86863 6.56724 2.97657L6.50944 2.98616L6.45383 3.0046C6.35212 3.03834 6.20388 3.07572 6.01389 3.12298L5.99673 3.12724C5.82979 3.16875 5.6265 3.2193 5.46383 3.27326L5.43433 3.28304L5.40574 3.29523C4.197 3.81069 3.41567 4.90817 3.10295 6.21763C2.79121 7.52302 2.93097 9.06976 3.56344 10.6216C4.23452 12.3364 5.46477 14.3912 7.69093 16.6063C9.93762 18.8418 12.9349 20.4384 14.8789 20.922L14.889 20.9243C16.621 21.3298 18.6119 20.9417 19.9089 19.6511C21.0301 18.5355 21.03 17.2841 21.0299 16.7122V16.7015C21.0299 16.4809 20.9922 16.2046 20.813 15.9371C20.6472 15.6895 20.4125 15.5287 20.1798 15.4111C19.9402 15.2784 19.62 15.0944 19.2654 14.8907C19.0256 14.7529 18.77 14.606 18.5131 14.46C17.9078 14.1158 17.2698 13.7611 16.9031 13.6019C16.4382 13.3777 16.0078 13.4067 15.6863 13.521C15.5321 13.5758 15.4109 13.6468 15.326 13.706C15.283 13.7359 15.2478 13.7639 15.2205 13.787C15.2188 13.7885 15.2171 13.7899 15.2155 13.7913C15.2039 13.8013 15.1938 13.8104 15.1851 13.8184L15.1717 13.8311L15.166 13.8366L15.1634 13.8391L15.1621 13.8404L15.1609 13.8415L15.1388 13.8635L15.118 13.8881L15.0762 13.937L14.9613 14.0715C14.8649 14.1841 14.7337 14.3369 14.5943 14.4977C14.3048 14.8319 14.0114 15.1644 13.9009 15.2744C13.8742 15.3009 13.8449 15.3309 13.8215 15.3549L13.7971 15.3798C13.779 15.3983 13.7645 15.4127 13.7522 15.4245C13.7267 15.4171 13.6912 15.4048 13.6441 15.3848L13.6283 15.378L13.6121 15.372C13.3605 15.2781 12.9385 15.0221 12.3942 14.6131C11.8744 14.2226 11.2945 13.7322 10.7295 13.2144C10.2226 12.6656 9.75536 12.0735 9.39344 11.5651C9.02964 11.0541 8.81085 10.6814 8.74461 10.5321C8.75011 10.5211 8.75717 10.5104 8.76296 10.5028L8.78286 10.4828C8.80408 10.4615 8.83454 10.4309 8.87211 10.3928C8.94716 10.3167 9.05109 10.2104 9.16675 10.0895C9.39285 9.85331 9.68246 9.54212 9.88445 9.29089C10.4869 8.54162 10.2183 7.75086 10.1204 7.47384C10.1155 7.44903 10.111 7.43075 10.1089 7.42212L10.108 7.4187C10.0968 7.37195 10.0824 7.32003 10.0674 7.26835C10.037 7.16363 9.99522 7.0306 9.94739 6.88286C9.85128 6.58599 9.72309 6.20623 9.59379 5.82583L9.46913 5.45965C9.38218 5.20446 9.29882 4.95975 9.22749 4.7478C9.17508 4.59202 9.13018 4.45693 9.09592 4.35081C9.07878 4.29771 9.06491 4.25375 9.05438 4.21916C9.04914 4.20193 9.04505 4.18813 9.04199 4.17743L9.03851 4.16501L9.03733 4.16058L9.0172 4.08043L8.98009 4.00658ZM15.118 13.8881L15.1313 13.8981C15.1293 13.8964 15.1276 13.895 15.1262 13.8939C15.1184 13.8875 15.118 13.8881 15.118 13.8881ZM16.1008 15.047L16.1972 14.9341C16.2053 14.9353 16.2244 14.9395 16.2559 14.9551L16.2755 14.9649L16.2957 14.9735C16.5625 15.0873 17.1277 15.3978 17.7717 15.764C18.0121 15.9006 18.2605 16.0433 18.4985 16.18C18.8709 16.394 19.2176 16.5931 19.4671 16.7311L19.4813 16.7389L19.4959 16.7462C19.5087 16.7525 19.5199 16.7584 19.5299 16.7638C19.5283 17.2664 19.4957 17.9462 18.8509 18.5878C17.9891 19.4454 16.5624 19.7739 15.2359 19.465C13.5793 19.0513 10.8201 17.6039 8.74895 15.543C6.65737 13.4619 5.54793 11.5783 4.95856 10.0703L4.9543 10.0598C4.41859 8.74775 4.33402 7.52038 4.56193 6.56605C4.78598 5.62783 5.29806 4.98403 5.96519 4.68761C6.06529 4.65632 6.20342 4.62154 6.37599 4.57861L6.39315 4.57435C6.53913 4.53805 6.71291 4.49484 6.86303 4.44848C7.25589 4.39077 7.42289 4.45676 7.47968 4.48758C7.52761 4.51359 7.56727 4.55199 7.61079 4.62635C7.68729 4.88169 7.8697 5.41678 8.05351 5.95598L8.17359 6.30859C8.30304 6.68939 8.42797 7.05963 8.5203 7.34485C8.5667 7.48815 8.60297 7.60419 8.62702 7.68697C8.62833 7.69146 8.62957 7.69577 8.63076 7.6999C8.63432 7.7123 8.63736 7.72314 8.63994 7.7325V7.77905L8.68744 7.92081C8.738 8.07156 8.76071 8.13929 8.76486 8.2135C8.76646 8.24226 8.7636 8.26082 8.75945 8.27482C8.75568 8.28751 8.74621 8.31271 8.71543 8.351C8.55742 8.54753 8.30703 8.81842 8.08313 9.05235C7.97379 9.16659 7.87522 9.26739 7.80402 9.3396C7.79958 9.34411 7.79524 9.3485 7.79102 9.35278C7.76146 9.38271 7.73742 9.40691 7.7203 9.42409L7.69802 9.4464L7.69091 9.4535C7.69091 9.4535 7.69093 9.45347 8.21994 9.98512C7.69094 9.45347 7.69001 9.4544 7.69001 9.4544L7.68904 9.45536L7.68701 9.45741L7.6825 9.46199L7.67184 9.47306C7.66404 9.48128 7.65483 9.49124 7.64448 9.50287C7.62387 9.52604 7.59828 9.55638 7.57008 9.59337C7.51464 9.66607 7.44388 9.77136 7.38207 9.90461C7.25745 10.1733 7.15378 10.5975 7.34406 11.0708C7.47055 11.3855 7.78842 11.897 8.17144 12.435C8.5697 12.9945 9.08487 13.6471 9.6501 14.2564L9.67051 14.2784L9.6926 14.2987C10.2906 14.8479 10.9173 15.3797 11.4932 15.8123C12.0449 16.2269 12.6063 16.594 13.0714 16.7712C13.4862 16.9452 13.9094 17.0065 14.3191 16.8317C14.505 16.7525 14.6434 16.6421 14.7402 16.5542C14.8004 16.4995 14.8752 16.4231 14.9228 16.3744C14.9302 16.3669 14.9369 16.36 14.9428 16.354C14.9492 16.3475 14.9546 16.342 14.9589 16.3377C15.1184 16.179 15.455 15.7951 15.728 15.48C15.8699 15.3162 16.0031 15.1611 16.1008 15.047ZM8.65264 7.78356C8.65264 7.78356 8.65133 7.77855 8.64982 7.77029C8.65207 7.77972 8.65264 7.78356 8.65264 7.78356Z",
    fill: color
  }));
};

const _excluded$25 = ["color", "size"];
/**
 * @typedef {Object} CameraProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CameraProps} props
 * @returns {JSX.Element}
 */

const Camera = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$25);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88388 8.83289C7.28653 10.1495 5.81266 13.0758 7.0361 15.4894C8.25955 17.903 11.4911 18.4441 14.0884 17.1276C16.6858 15.811 18.1596 12.8847 16.9362 10.4711C15.7127 8.05746 12.4812 7.5163 9.88388 8.83289ZM8.37395 14.8112C7.64983 13.3827 8.43059 11.2512 10.562 10.1707C12.6935 9.09032 14.8742 9.72067 15.5983 11.1492C16.3225 12.5778 15.5417 14.7093 13.4103 15.7897C11.2788 16.8701 9.09807 16.2398 8.37395 14.8112Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4387 7.25005L15.6387 4.05005H8.17312L6.27312 7.25005H2.05005V20.65H21.9501V7.25005H17.4387ZM7.12698 8.75005L9.02698 5.55005H14.7614L16.5614 8.75005H20.4501V19.15H3.55005V8.75005H7.12698Z",
    fill: color
  }));
};

const _excluded$26 = ["color", "size"];
/**
 * @typedef {Object} NewCuFsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {NewCuFsProps} props
 * @returns {JSX.Element}
 */

const NewCuFs = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$26);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 2H2V22H22V7.2L16.9 2ZM8.9 3.5H12.6V6.8H14.1V3.5H15V7.9H9V3.5H8.9ZM20.5 20.5H3.5V3.5H7.4V9.4H16.4V3.7L20.4 7.8V20.5H20.5ZM7.4 13.3H16.4V19.5H15V14.8H9V19.5H7.4V13.3Z",
    fill: color
  }));
};

const _excluded$27 = ["color", "size"];
/**
 * @typedef {Object} Cgt20Props
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {Cgt20Props} props
 * @returns {JSX.Element}
 */

const Cgt20 = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$27);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.7525 11.8477H7.14851V10.3249H16.7525V11.8477ZM7.14851 14.7919H14.6733V13.269H7.14851V14.7919ZM20.2178 10.1218C20.3168 10.6294 20.4158 11.1371 20.4158 11.6447C20.4158 15.7056 16.6535 19.0558 11.901 19.0558C10.6139 19.0558 9.22772 18.7513 8.13861 18.2437H7.94059L5.36634 19.3604L6.05941 17.0254L5.76238 16.7208C5.06931 16.1117 3.58416 14.2843 3.58416 11.7462C3.58416 7.98985 6.75248 4.94416 10.9109 4.43655V2.81218C5.86139 3.42132 2 7.17767 2 11.7462C2 14.4873 3.38614 16.4162 4.37624 17.4315L2.9901 22L7.94059 19.868C9.12871 20.3756 10.6139 20.6802 12 20.6802C17.4455 20.6802 22 16.7208 22 11.7462C22 11.2386 21.901 10.731 21.802 10.2234H20.2178V10.1218ZM19.7228 3.72589C19.2277 3.72589 18.9307 4.13198 18.9307 4.94416V5.04569C18.9307 5.85787 19.2277 6.26396 19.7228 6.26396C20.2178 6.26396 20.5149 5.85787 20.5149 5.04569V4.84264C20.4158 4.13198 20.2178 3.72589 19.7228 3.72589ZM22 2V8.29442H12.396V2H22ZM16.1584 6.26396H14.6733L15.3663 5.5533C15.7624 5.14721 16.0594 4.74112 16.0594 4.2335C16.0594 3.52284 15.5644 3.11675 14.7723 3.11675C13.9802 3.11675 13.3861 3.62437 13.3861 4.43655H14.1782C14.2772 3.92893 14.4752 3.72589 14.7723 3.72589C15.0693 3.72589 15.2673 3.92893 15.2673 4.2335C15.2673 4.53807 15.0693 4.94416 14.6733 5.35025L13.2871 6.8731V6.97462H16.0594V6.26396H16.1584ZM17.6436 6.46701C17.6436 6.16244 17.4455 5.95939 17.1485 5.95939C16.8515 5.95939 16.6535 6.16244 16.6535 6.46701C16.6535 6.77157 16.8515 6.97462 17.1485 6.97462C17.4455 6.97462 17.6436 6.67005 17.6436 6.46701ZM21.3069 4.84264C21.3069 3.62437 20.6139 3.01523 19.7228 3.01523C18.7327 3.01523 18.1386 3.72589 18.1386 4.84264V5.04569C18.1386 6.16244 18.7327 6.8731 19.7228 6.8731C20.7129 6.8731 21.3069 6.16244 21.3069 4.94416V4.84264Z",
    fill: color
  }));
};

const _excluded$28 = ["color", "size"];
/**
 * @typedef {Object} DefaultReplyProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DefaultReplyProps} props
 * @returns {JSX.Element}
 */

const DefaultReply = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$28);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1727 6.27836L10.2873 2.24658L2.38232 9.50831L10.063 16.3566V12.4867C12.2513 12.6027 13.6594 13.0444 14.551 13.6096C15.5079 14.2161 15.9206 14.996 16.0632 15.8258C16.1779 16.5661 16.1459 17.6996 15.6364 18.6147C15.1641 19.4632 14.2139 20.25 12.1872 20.25V21.75C16.3903 21.75 18.9007 20.3672 20.5463 18.0958L20.5544 18.0846L20.5621 18.0731C21.5337 16.6223 21.8254 14.9762 21.7341 13.6342C21.7281 12.1694 21.2329 10.9109 20.4571 9.87392C18.9266 7.73721 15.8765 6.09016 10.1727 6.27836ZM19.3234 17.227C18.7244 18.0508 17.9799 18.751 16.9878 19.2695C17.6779 17.975 17.6874 16.5035 17.5445 15.5891L17.5428 15.5789C17.3362 14.367 16.7034 13.198 15.3541 12.3427C14.0373 11.5079 12.0958 11.0082 9.32587 10.9605L8.56297 10.9474V13.0095L4.61764 9.49172L8.68705 5.75345L8.62708 7.86409L9.4457 7.8142C15.3996 7.45133 18.0547 9.09146 19.2416 10.7529L19.2466 10.76L19.2519 10.767C19.8619 11.5802 20.2341 12.5397 20.2341 13.6612V13.6882L20.2361 13.7152C20.3129 14.78 20.0812 16.0891 19.3234 17.227Z",
    fill: color
  }));
};

const _excluded$29 = ["color", "size"];
/**
 * @typedef {Object} FullscreenProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FullscreenProps} props
 * @returns {JSX.Element}
 */

const Fullscreen = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$29);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.0218 3.48352L20.5201 3.48352V11H22V2H13.0218V3.48352Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3485 5.67944L14.0464 10.9944L13 9.94539L18.3021 4.63044L19.3485 5.67944Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47991 13L3.47991 20.5165H10.9778V22H2.00006V13H3.47991Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14.0544L5.69821 19.3694L4.6518 18.3204L9.95361 13.0054L11 14.0544Z",
    fill: color
  }));
};

const _excluded$2a = ["color", "size"];
/**
 * @typedef {Object} ArrowDragProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ArrowDragProps} props
 * @returns {JSX.Element}
 */

const ArrowDrag = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M8.98113 7L12 3.98113L14.9245 7H17L12 2L7 7H8.98113Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0189 17L12 19.9808L9.07547 17H7L12 22L17 17H15.0189Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2452 7.30005H12.6603V16.6H11.2452V7.30005Z",
    fill: color
  }));
};

const _excluded$2b = ["color", "size"];
/**
 * @typedef {Object} SortProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SortProps} props
 * @returns {JSX.Element}
 */

const Sort = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M20 7.35354H17.9636L14.8606 4.12121L11.8545 7.35354H9.81818L14.8606 2L20 7.35354ZM9.13939 19.8788L6.03636 16.6465H4L9.13939 22L14.2788 16.6465H12.1455L9.13939 19.8788ZM14.1818 13.2121H15.6364V7.35354H14.1818V13.2121ZM9.81818 9.67677H8.36364V16.7475H9.81818V9.67677Z",
    fill: color
  }));
};

const _excluded$2c = ["color", "size"];
/**
 * @typedef {Object} ExitFullscreenProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ExitFullscreenProps} props
 * @returns {JSX.Element}
 */

const ExitFullscreen = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M15.6515 7.32056L20.9536 2.0056L22.0001 3.05461L16.698 8.36956L15.6515 7.32056Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 20.9456L7.30181 15.6306L8.34822 16.6796L3.04641 21.9946L2 20.9456Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11H21.9782V9.51648H14.4799V2H13V11Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 22H9.52011V14.4835H2.02222V13H11V22Z",
    fill: color
  }));
};

const _excluded$2d = ["color", "size"];
/**
 * @typedef {Object} DragConnectorProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DragConnectorProps} props
 * @returns {JSX.Element}
 */

const DragConnector = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M5.26531 19.383C5.26531 20.2926 4.55102 21 3.63265 21C2.71429 21 2 20.2926 2 19.383C2 18.4734 2.71429 17.766 3.63265 17.766C4.55102 17.766 5.26531 18.5745 5.26531 19.383ZM17.2041 11.1968L22.102 6.75L17.2041 2V4.12234L19.0408 5.84043C16.5918 5.73936 13.9388 5.73936 12.4082 7.05319C11.4898 7.8617 10.1633 9.57979 11.6939 12.9149C12.2041 14.0266 12.4082 14.9362 12.2041 15.8457C12 16.9574 10.8776 17.766 9.95918 18.1702C8.83673 18.5745 7.30612 18.6755 6.18367 18.6755V20.1915C7.5102 20.1915 9.14286 20.0904 10.5714 19.5851C12.3061 18.8777 13.4286 17.6649 13.7347 16.1489C13.9388 14.9362 13.7347 13.6223 13.1224 12.3085C12.5102 11.0957 12.102 9.37766 13.4286 8.26596C14.551 7.35638 17.102 7.35638 19.2449 7.45745L17.2041 9.07447V11.1968Z",
    fill: color
  }));
};

const _excluded$2e = ["color", "size"];
/**
 * @typedef {Object} ArrowLeftProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ArrowLeftProps} props
 * @returns {JSX.Element}
 */

const ArrowLeft = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M4.07042 12L9 16.9296V19L2 12L9 5V7.07042L4.07042 12Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12.7999L9 12.7999V11.2999L22 11.2999V12.7999Z",
    fill: color
  }));
};

const _excluded$2f = ["color", "size"];
/**
 * @typedef {Object} ArrowRightProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ArrowRightProps} props
 * @returns {JSX.Element}
 */

const ArrowRight = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.9296 12L15 7.07042V5L22 12L15 19V16.9296L19.9296 12Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11.2H15V12.7H2V11.2Z",
    fill: color
  }));
};

const _excluded$2g = ["color", "size"];
/**
 * @typedef {Object} ArrowDownProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ArrowDownProps} props
 * @returns {JSX.Element}
 */

const ArrowDown = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 2L12.8 15H11.3L11.3 2H12.8Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.9296L16.9296 15H19L12 22L5 15H7.07042L12 19.9296Z",
    fill: color
  }));
};

const _excluded$2h = ["color", "size"];
/**
 * @typedef {Object} ArrowUpProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ArrowUpProps} props
 * @returns {JSX.Element}
 */

const ArrowUp = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.07042 9L5 9L12 2L19 9L16.9296 9L12 4.07042L7.07042 9Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 22L11.2 9H12.7L12.7 22H11.2Z",
    fill: color
  }));
};

const _excluded$2i = ["color", "size"];
/**
 * @typedef {Object} ArrowTopRightProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ArrowTopRightProps} props
 * @returns {JSX.Element}
 */

const ArrowTopRight = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M9.17159 6.39288L9.17159 4.92887L19.0711 4.92887L19.0711 14.8284L17.6071 14.8284V6.39288L9.17159 6.39288Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36323 18.5053L13.5556 9.3129L14.6163 10.3736L5.42389 19.5659L4.36323 18.5053Z",
    fill: color
  }));
};

const _excluded$2j = ["color", "size"];
/**
 * @typedef {Object} ChevronLeftProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ChevronLeftProps} props
 * @returns {JSX.Element}
 */

const ChevronLeft = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M14 15.9174L10.0656 12.0496L14 8.08264V6L8 12.0496L14 18V15.9174Z",
    fill: color
  }));
};

const _excluded$2k = ["color", "size"];
/**
 * @typedef {Object} ChevronRightProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ChevronRightProps} props
 * @returns {JSX.Element}
 */

const ChevronRight = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.08264L13.9344 11.9504L10 15.9174L10 18L16 11.9504L10 6L10 8.08264Z",
    fill: color
  }));
};

const _excluded$2l = ["color", "size"];
/**
 * @typedef {Object} ChevronDownProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ChevronDownProps} props
 * @returns {JSX.Element}
 */

const ChevronDown = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M15.9174 9L12.0496 12.9344L8.08264 9L6 9L12.0496 15L18 9L15.9174 9Z",
    fill: color
  }));
};

const _excluded$2m = ["color", "size"];
/**
 * @typedef {Object} ChevronUpProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ChevronUpProps} props
 * @returns {JSX.Element}
 */

const ChevronUp = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M8.08264 15L11.9504 11.0656L15.9174 15L18 15L11.9504 9L6 15L8.08264 15Z",
    fill: color
  }));
};

const _excluded$2n = ["color", "size"];
/**
 * @typedef {Object} DoubleChevrotBackProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DoubleChevrotBackProps} props
 * @returns {JSX.Element}
 */

const DoubleChevrotBack = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0656 12.0496L17 15.9174L17 18L11 12.0496L17 6L17 8.08265L13.0656 12.0496ZM7.06557 12.0496L11 15.9174L11 18L5 12.0496L11 6L11 8.08264L7.06557 12.0496Z",
    fill: color
  }));
};

const _excluded$2o = ["color", "size"];
/**
 * @typedef {Object} DoubleChevrotForwardProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DoubleChevrotForwardProps} props
 * @returns {JSX.Element}
 */

const DoubleChevrotForward = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9344 11.9504L7 8.08264V6L13 11.9504L7 18V15.9174L10.9344 11.9504ZM16.9344 11.9504L13 8.08264V6L19 11.9504L13 18V15.9174L16.9344 11.9504Z",
    fill: color
  }));
};

const _excluded$2p = ["color", "size"];
/**
 * @typedef {Object} DoubleChevrotExpandProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DoubleChevrotExpandProps} props
 * @returns {JSX.Element}
 */

const DoubleChevrotExpand = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0496 9.93443L15.9174 6L18 6L12.0496 12L6 6L8.08265 6L12.0496 9.93443ZM12.0496 15.9344L15.9174 12L18 12L12.0496 18L6 12L8.08265 12L12.0496 15.9344Z",
    fill: color
  }));
};

const _excluded$2q = ["color", "size"];
/**
 * @typedef {Object} DoubleChevrotCollapseProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DoubleChevrotCollapseProps} props
 * @returns {JSX.Element}
 */

const DoubleChevrotCollapse = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9504 14.0656L8.08264 18L6 18L11.9504 12L18 18L15.9174 18L11.9504 14.0656ZM11.9504 8.06557L8.08264 12L6 12L11.9504 6L18 12L15.9174 12L11.9504 8.06557Z",
    fill: color
  }));
};

const _excluded$2r = ["color", "size"];
/**
 * @typedef {Object} SortUpProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SortUpProps} props
 * @returns {JSX.Element}
 */

const SortUp = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 7.6L7.35354 2L13.1111 7.6H10.8889L7.35354 4.1L4.12121 7.6H2ZM17.9596 10.8H10.8889V12.3H17.9596V10.8ZM19.9798 14.3H10.8889V15.8H19.9798V14.3ZM22 17.8H10.8889V19.3H21.899V17.8H22ZM8.16162 7.6H6.64646V22H8.16162V7.6Z",
    fill: color
  }));
};

const _excluded$2s = ["color", "size"];
/**
 * @typedef {Object} SortDownProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SortDownProps} props
 * @returns {JSX.Element}
 */

const SortDown = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M10.7379 16.4279H12.7767L7.63107 22L2 16.4279H4.13592L7.53398 19.9104L10.7379 16.4279ZM18.1165 5.18408H11.3204V6.67662H18.1165V5.18408ZM20.0583 8.76617H11.3204V10.2587H20.0583V8.76617ZM11.3204 12.2488V13.7413H22V12.2488H11.3204ZM8.21359 2H6.75728V16.4279H8.21359V2Z",
    fill: color
  }));
};

const _excluded$2t = ["color", "size"];
/**
 * @typedef {Object} DeleteProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DeleteProps} props
 * @returns {JSX.Element}
 */

const Delete = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.8144 2C9.84431 2 8.21557 4.57789 7.83234 5.43719H9.46108C10.0359 4.57789 11.0898 3.43216 12.8144 3.43216C13.3892 3.43216 13.8683 3.52764 14.1557 3.90955C14.5389 4.38693 14.7305 4.9598 14.8263 5.43719H16.2635C16.1677 4.76884 15.976 3.71859 15.2096 2.95477C14.6347 2.28643 13.7725 2 12.8144 2Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26946 17.6583H10.7066V9.63819H9.26946V17.6583Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1976 17.6583H14.6347V9.63819H13.1976V17.6583Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.29648H19.9042V7.72864H17.988V21H5.91617V7.72864H4V6.29648ZM7.35329 19.5678H16.5509V7.72864H7.35329V19.5678Z",
    fill: color
  }));
};

const _excluded$2u = ["color", "size"];
/**
 * @typedef {Object} DeleteForeverProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DeleteForeverProps} props
 * @returns {JSX.Element}
 */

const DeleteForever = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M9.46108 5.43719H7.83234C8.21557 4.57789 9.84431 2 12.8144 2C13.7725 2 14.6347 2.28643 15.2096 2.95477C15.976 3.71859 16.1677 4.76884 16.2635 5.43719H14.8263C14.7305 4.9598 14.5389 4.38693 14.1557 3.90955C13.8683 3.52764 13.3892 3.43216 12.8144 3.43216C11.0898 3.43216 10.0359 4.57789 9.46108 5.43719ZM20 6.29648V7.72864H18.0838V21H5.91617V7.72864H4V6.29648H5.91617H17.988H20ZM16.5509 7.72864H7.35329V19.5678H16.5509V7.72864ZM10.0359 17.2764L11.9521 15.3668L13.9641 17.3719H15.976L13.006 14.4121L15.3054 12.1206V10.0201L12.0479 13.3618L8.69461 10.0201V12.0251L10.994 14.3166L8.02395 17.2764H10.0359Z",
    fill: color
  }));
};

const _excluded$2v = ["color", "size"];
/**
 * @typedef {Object} EditProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {EditProps} props
 * @returns {JSX.Element}
 */

const Edit = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1433 1.97717L22.083 7.91681L10.0303 19.9695L10.0607 20L8.74376 21.3169L2.05322 22.0468L2.7831 15.3563L3.0714 15.068L3.06196 15.0585L16.1433 1.97717ZM13.2906 6.95121L5.18326 15.0585L9.0016 18.8769L17.1089 10.7695L13.2906 6.95121ZM14.3512 5.89055L18.1696 9.70889L19.9617 7.91681L16.1433 4.09847L14.3512 5.89055ZM4.194 16.2546L3.74689 20.3531L7.84545 19.906L4.194 16.2546Z",
    fill: color
  }));
};

const _excluded$2w = ["color", "size"];
/**
 * @typedef {Object} AddTagProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AddTagProps} props
 * @returns {JSX.Element}
 */

const AddTag = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4444 5.17932C13.7471 5.17932 12.3712 6.55525 12.3712 8.25255C12.3712 9.94985 13.7471 11.3258 15.4444 11.3258C17.1417 11.3258 18.5177 9.94985 18.5177 8.25255C18.5177 6.55525 17.1417 5.17932 15.4444 5.17932ZM13.8712 8.25255C13.8712 7.38368 14.5756 6.67932 15.4444 6.67932C16.3133 6.67932 17.0177 7.38368 17.0177 8.25255C17.0177 9.12143 16.3133 9.82579 15.4444 9.82579C14.5756 9.82579 13.8712 9.12143 13.8712 8.25255Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 13.7071L11.7071 3H21V12.2929L10.2929 23L1 13.7071ZM10.2929 20.8788L19.4848 11.6869V4.51515H12.3131L3.12121 13.7071L10.2929 20.8788Z",
    fill: color
  }));
};

const _excluded$2x = ["color", "size"];
/**
 * @typedef {Object} MagicWandProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MagicWandProps} props
 * @returns {JSX.Element}
 */

const MagicWand = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.3568 2H14.8643V7.8617H13.3568V2ZM13.3568 17.766H14.8643V11.9043H13.3568V17.766ZM16.1709 9.17553V10.6915H22V9.17553H16.1709ZM12.1508 9.17553H6.32161V10.6915H12.1508V9.17553ZM20.191 4.93085H18.0804L15.0653 7.96277L16.1709 9.07447L20.191 4.93085ZM8.13065 4.93085L12.1508 8.9734L13.2563 7.8617L10.2412 4.82979H8.13065V4.93085ZM15.0653 11.9043L18.0804 14.9362H20.191L16.0704 10.7926L15.0653 11.9043ZM2 21H4.11055L13.2563 11.8032L12.1508 10.6915L2 21Z",
    fill: color
  }));
};

const _excluded$2y = ["color", "size"];
/**
 * @typedef {Object} AttachProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AttachProps} props
 * @returns {JSX.Element}
 */

const Attach = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 14.1L14.5 18.6C13.4 19.7 11.9 20.3 10.4 20.3C8.9 20.3 7.4 19.7 6.3 18.6C5.2 17.5 4.6 16 4.6 14.5C4.6 12.9 5.2 11.5 6.3 10.4L12 4.6C12.7 3.9 13.7 3.5 14.7 3.5C15.7 3.5 16.7 3.9 17.4 4.6C18.1 5.3 18.5 6.3 18.5 7.3C18.5 8.3 18.1 9.3 17.4 10L11.7 15.7C11 16.4 9.8 16.4 9 15.7C8.6 15.3 8.4 14.9 8.4 14.4C8.4 13.9 8.6 13.4 9 13.1L14.6 7.5H12.6L8 12.1C6.7 13.4 6.7 15.6 8 16.9C9.3 18.2 11.5 18.2 12.8 16.9L18.5 11.2C19.5 10.2 20.1 8.8 20.1 7.4C20.1 6 19.5 4.6 18.5 3.6C17.5 2.6 16.1 2 14.7 2C13.3 2 12 2.6 10.9 3.6L5.1 9.4C3.8 10.8 3 12.6 3 14.6C3 16.6 3.8 18.4 5.1 19.8C6.5 21.2 8.3 21.9 10.3 21.9C12.3 21.9 14.1 21.1 15.5 19.8L21.2 14.1H19.1Z",
    fill: color
  }));
};

const _excluded$2z = ["color", "size"];
/**
 * @typedef {Object} HealthProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {HealthProps} props
 * @returns {JSX.Element}
 */

const Health = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.1388 4.50794C17.9729 4.50794 19.2976 5.31217 20.0109 6.82011C20.8261 8.62963 20.3166 10.8413 18.89 12.4497C17.0559 14.5608 11.961 19.8889 11.961 19.8889C11.961 19.8889 6.86617 14.5608 5.03203 12.4497C3.60547 10.7407 3.09599 8.5291 4.01306 6.82011C4.62444 5.31217 6.051 4.60847 7.88514 4.60847C9.71929 4.60847 11.3496 6.01587 11.961 7.32275C12.4705 5.91534 14.1009 4.50794 16.1388 4.50794ZM16.1388 3C14.4065 3 12.98 3.7037 11.961 4.70899C10.9421 3.7037 9.51549 3 7.88514 3C5.43962 3 3.50358 4.10582 2.5865 6.1164C1.46564 8.42857 1.97512 11.1429 3.91116 13.3545C5.74531 15.5661 10.7383 20.6931 10.9421 20.8942L12.0629 22L13.1838 20.7937C13.3876 20.5926 18.2786 15.3651 20.1128 13.254C21.9469 11.1429 22.5583 8.22751 21.4374 6.01587C20.4185 4.10582 18.5843 3 16.1388 3Z",
    fill: color
  }));
};

const _excluded$2A = ["color", "size"];
/**
 * @typedef {Object} StarProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {StarProps} props
 * @returns {JSX.Element}
 */

const Star = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76087 13.7257L5.80435 21L12 16.44L18.087 21L16.2391 13.7257L22 9.27429L14.7174 9.05714L12 2L9.3913 8.94857L2 9.27429L7.76087 13.7257ZM15.5876 17.2534L12.0079 14.5717L8.36562 17.2524L9.46903 13.15L6.15918 10.5925L10.4473 10.4035L12.0177 6.22045L13.6759 10.5268L17.768 10.6488L14.5429 13.1408L15.5876 17.2534Z",
    fill: color
  }));
};

const _excluded$2B = ["color", "size"];
/**
 * @typedef {Object} StarredProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {StarredProps} props
 * @returns {JSX.Element}
 */

const Starred = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.44L5.80435 21L7.76087 13.7257L2 9.27429L9.3913 8.94857L12 2L14.7174 9.05714L22 9.27429L16.2391 13.7257L18.1957 21L12 16.44Z",
    fill: color
  }));
};

const _excluded$2C = ["color", "size"];
/**
 * @typedef {Object} ArrowDropDownProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ArrowDropDownProps} props
 * @returns {JSX.Element}
 */

const ArrowDropDown = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M17 9L12.0633 15L7 9L17 9Z",
    fill: color
  }));
};

const _excluded$2D = ["color", "size"];
/**
 * @typedef {Object} ArrowDropUpProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ArrowDropUpProps} props
 * @returns {JSX.Element}
 */

const ArrowDropUp = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7 14L11.9367 8L17 14H7Z",
    fill: color
  }));
};

const _excluded$2E = ["color", "size"];
/**
 * @typedef {Object} SolidArrowUnsortedProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SolidArrowUnsortedProps} props
 * @returns {JSX.Element}
 */

const SolidArrowUnsorted = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.9367 5L7 11H17L11.9367 5Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0633 19L17 13L7 13L12.0633 19Z",
    fill: color
  }));
};

const _excluded$2F = ["color", "size"];
/**
 * @typedef {Object} ConditionProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ConditionProps} props
 * @returns {JSX.Element}
 */

const Condition = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 12.8299L20.75 6.42992V3.25H3.25V6.42992L9.25 12.8299V21.25L14.75 18.3167V12.8299ZM10.75 12.2367L4.75 5.83675V4.75H19.25V5.83675L13.25 12.2367V17.4167L10.75 18.75V12.2367Z",
    fill: color
  }));
};

const _excluded$2G = ["color", "size"];
/**
 * @typedef {Object} LiveChatProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {LiveChatProps} props
 * @returns {JSX.Element}
 */

const LiveChat = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 8.21685H7.40002V9.71685H17.1V8.21685Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 11.2003H7.40002V12.7003H17.1V11.2003Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 14.1837H7.40002V15.6837H12.3V14.1837Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25C6.1923 2.25 1.25 6.3652 1.25 11.6519C1.25 14.4894 2.81588 16.6006 3.75356 17.6211L2.32852 22.2591L7.58402 20.2195C8.95147 20.7825 10.6174 21.0539 12 21.0539C17.8077 21.0539 22.75 16.9387 22.75 11.6519C22.75 6.3652 17.8077 2.25 12 2.25ZM2.75 11.6519C2.75 7.3917 6.8077 3.75 12 3.75C17.1923 3.75 21.25 7.3917 21.25 11.6519C21.25 15.9122 17.1923 19.5539 12 19.5539C10.6844 19.5539 9.09531 19.2699 7.91286 18.7272L7.62447 18.5948L4.67148 19.7409L5.4499 17.2074L5.12886 16.8881C4.36868 16.1321 2.75 14.2281 2.75 11.6519Z",
    fill: color
  }));
};

const _excluded$2H = ["color", "size"];
/**
 * @typedef {Object} TicketProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TicketProps} props
 * @returns {JSX.Element}
 */

const Ticket = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2.98039 22L4.35294 17.4715C3.47059 16.5855 2 14.5181 2 11.8601C2 6.93782 6.5098 3 12 3C17.4902 3 22 6.93782 22 11.8601C22 16.7824 17.4902 20.7202 12 20.7202C10.6275 20.7202 9.05882 20.4249 7.88235 19.9326L2.98039 22ZM12 4.47668C7.29412 4.47668 3.47059 7.82383 3.47059 11.8601C3.47059 14.4197 5.03922 16.1917 5.72549 16.7824L6.01961 17.0777L5.33333 19.4404L7.98039 18.3575L8.27451 18.456C9.35294 18.9482 10.8235 19.2435 12.098 19.2435C16.8039 19.2435 20.6275 15.8964 20.6275 11.8601C20.6275 7.82383 16.8039 4.47668 12 4.47668ZM12 15.7979C11.6078 15.7979 11.2157 16.1917 11.2157 16.5855C11.2157 16.9793 11.6078 17.3731 12 17.3731C12.3922 17.3731 12.7843 16.9793 12.7843 16.5855C12.7843 16.1917 12.4902 15.7979 12 15.7979ZM12.7843 5.85492H11.3137V14.3212H12.7843V5.85492Z",
    fill: color
  }));
};

const _excluded$2I = ["color", "size"];
/**
 * @typedef {Object} MessengerProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MessengerProps} props
 * @returns {JSX.Element}
 */

const Messenger = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2.98039 22L4.35294 17.4715C3.47059 16.5855 2 14.5181 2 11.8601C2 6.93782 6.5098 3 12 3C17.4902 3 22 6.93782 22 11.8601C22 16.7824 17.4902 20.7202 12 20.7202C10.6275 20.7202 9.05882 20.4249 7.88235 19.9326L2.98039 22ZM12 4.47668C7.29412 4.47668 3.47059 7.82383 3.47059 11.8601C3.47059 14.4197 5.03922 16.1917 5.72549 16.7824L6.01961 17.0777L5.33333 19.4404L7.98039 18.3575L8.27451 18.456C9.35294 18.9482 10.8235 19.2435 12.098 19.2435C16.8039 19.2435 20.6275 15.8964 20.6275 11.8601C20.6275 7.82383 16.8039 4.47668 12 4.47668ZM12.9804 14.3212L17.6863 9.30052L13.4706 11.5648L11.2157 9.30052L6.5098 14.3212L10.7255 11.9586L12.9804 14.3212Z",
    fill: color
  }));
};

const _excluded$2J = ["color", "size"];
/**
 * @typedef {Object} SponsoredMessages2Props
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SponsoredMessages2Props} props
 * @returns {JSX.Element}
 */

const SponsoredMessages2 = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2.97561 22L4.34146 17.4715C3.46341 16.5855 2 14.5181 2 11.8601C2 6.93782 6.4878 3 11.9512 3C17.4146 3 21.9024 6.93782 21.9024 11.8601C21.9024 16.7824 17.4146 20.7202 11.9512 20.7202C10.5854 20.7202 9.02439 20.4249 7.85366 19.9326L2.97561 22ZM11.9512 4.47668C7.26829 4.47668 3.46341 7.82383 3.46341 11.8601C3.46341 14.4197 5.02439 16.1917 5.70732 16.7824L6 17.0777L5.31707 19.4404L7.95122 18.3575L8.2439 18.456C9.31707 18.9482 10.7805 19.2435 12.0488 19.2435C16.7317 19.2435 20.5366 15.8964 20.5366 11.8601C20.5366 7.82383 16.7317 4.47668 11.9512 4.47668ZM14.7805 14.2228C14.7805 15.3057 14.0976 16.3886 12.7317 16.6839V17.2746H11.2683V16.6839C9.60976 16.3886 8.92683 14.9119 8.92683 13.6321H10.3902C10.3902 13.9275 10.4878 15.3057 12.0488 15.3057C13.3171 15.3057 13.4146 14.3212 13.4146 14.2228C13.4146 13.6321 12.9268 13.1399 11.8537 12.7461C9.80488 11.9585 9.41463 10.6788 9.41463 9.79275C9.41463 8.70985 10.2927 7.72539 11.3659 7.43005V6.83938H12.7317V7.33161C13.2195 7.43005 13.6098 7.62694 14 8.02073C14.4878 8.51295 14.878 9.20207 14.878 9.89119H13.4146C13.4146 9.59586 13.2195 9.30052 13.0244 9.00518C12.8293 8.80829 12.5366 8.6114 12.0488 8.6114C11.3659 8.6114 10.7805 9.20207 10.7805 9.79275C10.7805 10.3834 11.2683 10.9741 12.2439 11.2694C14.3902 12.1554 14.7805 13.3368 14.7805 14.2228Z",
    fill: color
  }));
};

const _excluded$2K = ["color", "size"];
/**
 * @typedef {Object} FbChatProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FbChatProps} props
 * @returns {JSX.Element}
 */

const FbChat = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.9512 3C6.4878 3 2 6.93782 2 11.8601C2 14.5181 3.36585 16.487 4.34146 17.5699L2.97561 22L7.95122 19.9326C9.12195 20.4249 10.6829 20.7202 12.0488 20.7202C17.6098 20.7202 22 16.7824 22 11.8601C22 6.93782 17.5122 3 11.9512 3ZM11.9512 19.1451C10.6829 19.1451 9.21951 18.8497 8.14634 18.3575L7.85366 18.2591L5.21951 19.342L5.90244 16.9793L5.70732 16.7824C5.02439 16.0933 3.46341 14.3212 3.46341 11.8601C3.46341 7.82383 7.26829 4.47668 11.9512 4.47668C16.7317 4.47668 20.5366 7.82383 20.5366 11.8601C20.5366 15.8964 16.7317 19.1451 11.9512 19.1451Z",
    fill: color
  }));
};

const _excluded$2L = ["color", "size"];
/**
 * @typedef {Object} ActionMarkConversationAsDoneProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ActionMarkConversationAsDoneProps} props
 * @returns {JSX.Element}
 */

const ActionMarkConversationAsDone = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.9512 3C6.4878 3 2 6.93782 2 11.8601C2 14.6166 3.46341 16.5855 4.34146 17.5699L2.97561 22L7.95122 19.9326C9.12195 20.4249 10.6829 20.7202 12.0488 20.7202C17.6098 20.7202 22 16.7824 22 11.8601C22 6.93782 17.5122 3 11.9512 3ZM11.9512 19.1451C10.6829 19.1451 9.21951 18.8497 8.14634 18.3575L7.85366 18.2591L5.21951 19.342L5.90244 16.9793L5.70732 16.7824C5.02439 16.0933 3.46341 14.3212 3.46341 11.8601C3.46341 7.82383 7.26829 4.47668 11.9512 4.47668C16.7317 4.47668 20.5366 7.82383 20.5366 11.8601C20.5366 15.8964 16.7317 19.1451 11.9512 19.1451ZM14.6829 8.70985H16.5366L11.1707 15.9948L7.65854 11.6632H9.5122L11.0732 13.5337L14.6829 8.70985Z",
    fill: color
  }));
};

const _excluded$2M = ["color", "size"];
/**
 * @typedef {Object} FacebookMessengerProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FacebookMessengerProps} props
 * @returns {JSX.Element}
 */

const FacebookMessenger = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2.98039 22L4.35294 17.4715C3.47059 16.5855 2 14.5181 2 11.8601C2 6.93782 6.5098 3 12 3C17.4902 3 22 6.93782 22 11.8601C22 16.7824 17.4902 20.7202 12 20.7202C10.6275 20.7202 9.05882 20.4249 7.88235 19.9326L2.98039 22ZM12 4.47668C7.29412 4.47668 3.47059 7.82383 3.47059 11.8601C3.47059 14.4197 5.03922 16.1917 5.72549 16.7824L6.01961 17.0777L5.33333 19.4404L7.98039 18.3575L8.27451 18.456C9.35294 18.9482 10.8235 19.2435 12.098 19.2435C16.8039 19.2435 20.6275 15.8964 20.6275 11.8601C20.6275 7.82383 16.8039 4.47668 12 4.47668ZM12.9804 14.3212L17.6863 9.30052L13.4706 11.5648L11.2157 9.30052L6.5098 14.3212L10.7255 11.9586L12.9804 14.3212Z",
    fill: color
  }));
};

const _excluded$2N = ["color", "size"];
/**
 * @typedef {Object} MessageOpenProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MessageOpenProps} props
 * @returns {JSX.Element}
 */

const MessageOpen = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M18.0386 12.159L13.8841 15.6667V13.7179L15.8164 12.0615L13.8841 10.4051V8.45641L18.0386 12.159ZM13.8841 11.3795H6.25121V12.841H13.8841V11.3795ZM7.89372 19.8564C9.05314 20.3436 10.599 20.6359 11.9517 20.6359C17.4589 20.6359 21.9034 16.641 21.9034 11.8667C21.9034 7.09231 17.4589 3 11.9517 3C6.44444 3 2 6.99487 2 11.7692C2 14.4974 3.44928 16.4462 4.31884 17.4205L2.96618 22L7.89372 19.8564ZM20.5507 11.7692C20.5507 15.8615 16.686 19.0769 12.0483 19.0769C10.7923 19.0769 9.343 18.7846 8.28019 18.2974L7.99034 18.2L5.38164 19.2718L6.05797 16.9333L5.76812 16.641C4.99517 16.0564 3.44928 14.3026 3.44928 11.7692C3.44928 7.67692 7.31401 4.46154 11.9517 4.46154C16.686 4.46154 20.5507 7.77436 20.5507 11.7692Z",
    fill: color
  }));
};

const _excluded$2O = ["color", "size"];
/**
 * @typedef {Object} MessageBackProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MessageBackProps} props
 * @returns {JSX.Element}
 */

const MessageBack = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M9.76699 15.2429L5.68932 11.9133L9.76699 8.28993V10.2485L7.92233 11.8154L9.76699 13.3822V15.2429ZM16.7573 11.1299H9.76699V12.5988H16.8544V11.1299H16.7573ZM7.92233 19.8456C9.08738 20.3352 10.6408 20.629 12 20.629C17.534 20.629 22 16.6139 22 11.8154C22 6.91892 17.534 3.00175 12 3.00175C6.46602 2.90383 2 6.91892 2 11.7174C2 14.4595 3.45631 16.418 4.3301 17.3973L2.97087 22L7.92233 19.8456ZM20.6408 11.7174C20.6408 15.8305 16.7573 19.0621 12.0971 19.0621C10.835 19.0621 9.37864 18.7683 8.31068 18.2787L8.01942 18.1808L5.39806 19.258L6.07767 16.9077L5.78641 16.6139C5.00971 16.0263 3.45631 14.2636 3.45631 11.7174C3.45631 7.60442 7.33981 4.37276 12 4.37276C16.7573 4.37276 20.6408 7.70235 20.6408 11.7174Z",
    fill: color
  }));
};

const _excluded$2P = ["color", "size"];
/**
 * @typedef {Object} UserProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {UserProps} props
 * @returns {JSX.Element}
 */

const User = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.076 12.2463C14.976 12.2463 17.276 9.9803 17.276 7.12315C17.276 4.26601 14.976 2 12.076 2C9.17601 2 6.87601 4.26601 6.87601 7.12315C6.87601 9.9803 9.17601 12.2463 12.076 12.2463ZM12.076 3.47783C14.176 3.47783 15.776 5.15271 15.776 7.12315C15.776 9.0936 14.076 10.7685 12.076 10.7685C10.076 10.7685 8.37601 9.19212 8.37601 7.12315C8.37601 5.05419 10.076 3.47783 12.076 3.47783ZM3.17601 22C2.87601 21.0148 2.67601 19.734 2.77601 18.7488C3.27601 14.2167 8.97601 13.0345 11.976 13.0345H12.076C15.076 13.0345 20.776 14.2167 21.276 18.7488C21.376 19.734 21.176 21.0148 20.976 22H19.476C19.776 20.7192 19.876 19.6355 19.876 18.9458C19.476 15.399 14.576 14.5123 12.076 14.5123C9.57601 14.5123 4.67601 15.399 4.27601 18.9458C4.17601 19.6355 4.37601 20.7192 4.67601 22H3.17601Z",
    fill: color
  }));
};

const _excluded$2Q = ["color", "size"];
/**
 * @typedef {Object} CommunityProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CommunityProps} props
 * @returns {JSX.Element}
 */

const Community = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.8983 10.6C18.6511 10.6 20.1117 9.1 20.1117 7.3C20.1117 5.5 18.6511 4 16.8983 4C15.1456 4 13.685 5.4 13.685 7.2C13.685 9.1 15.1456 10.6 16.8983 10.6ZM16.8983 5.4C17.8721 5.4 18.6511 6.2 18.6511 7.2C18.6511 8.2 17.8721 9 16.8983 9C15.9246 9 15.1456 8.2 15.1456 7.2C15.1456 6.2 15.9246 5.4 16.8983 5.4ZM21.9618 15.3C22.0592 15.9 21.9618 16.6 21.767 17.3H20.3064C20.5012 16.6 20.5986 16 20.5012 15.5C20.3064 13.5 17.2878 13.1 16.2167 13.1C15.5351 13.1 13.9771 13.3 12.906 14V12.2C13.9771 11.7 15.243 11.5 16.1193 11.5H16.2167C18.0668 11.6 21.5723 12.4 21.9618 15.3ZM8.71885 13.7C10.9585 13.7 12.8086 11.8 12.8086 9.5C12.8086 7.2 10.9585 5.3 8.71885 5.3C6.47923 5.3 4.62912 7.2 4.62912 9.5C4.62912 11.8 6.38186 13.7 8.71885 13.7ZM8.71885 6.8C10.1795 6.8 11.348 8 11.348 9.5C11.348 11 10.1795 12.2 8.71885 12.2C7.25823 12.2 5.99236 11 5.99236 9.5C5.99236 8 7.16086 6.8 8.71885 6.8ZM15.4377 18.7C15.5351 19.4 15.3403 20.2 15.243 21H13.685C13.8797 20.2 13.9771 19.4 13.9771 18.9C13.685 16.4 10.0821 15.9 8.71885 15.9C7.35561 15.9 3.75274 16.4 3.46062 18.9C3.46062 19.4 3.55799 20.2 3.75274 21H2.19475C2.09737 20.2 2 19.4 2 18.7C2.3895 15.3 6.47923 14.4 8.62148 14.4H8.71885C10.9585 14.4 15.0482 15.3 15.4377 18.7Z",
    fill: color
  }));
};

const _excluded$2R = ["color", "size"];
/**
 * @typedef {Object} UserAddProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {UserAddProps} props
 * @returns {JSX.Element}
 */

const UserAdd = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.0126 12.6062C14.6751 12.6062 16.8621 10.4611 16.8621 7.84974C16.8621 5.23834 14.7702 3 12.0126 3C9.3502 3 7.16318 5.14508 7.16318 7.75648C7.16318 10.3679 9.3502 12.6062 12.0126 12.6062ZM12.0126 4.39896C13.9144 4.39896 15.4358 5.89119 15.4358 7.75648C15.4358 9.62176 13.9144 11.114 12.0126 11.114C10.1109 11.114 8.58949 9.62176 8.58949 7.75648C8.58949 5.89119 10.1109 4.39896 12.0126 4.39896ZM20 18.5751H17.7179V20.8135H16.2916V18.5751H14.0095V17.1762H16.2916V14.9378H17.7179V17.1762H20V18.5751ZM14.1046 14.9378C13.439 14.8446 12.7733 14.7513 12.2028 14.7513H12.1077C9.92072 14.7513 5.83196 15.4974 5.54669 18.4819C5.45161 19.1347 5.64178 20.0674 5.83196 21H4.31055C4.12038 20.0674 3.9302 19.1347 4.02529 18.2953C4.50073 14.3782 9.44528 13.3523 12.1077 13.3523C12.6783 13.3523 13.3439 13.4456 14.1046 13.5389V14.9378Z",
    fill: color
  }));
};

const _excluded$2S = ["color", "size"];
/**
 * @typedef {Object} UnassignProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {UnassignProps} props
 * @returns {JSX.Element}
 */

const Unassign = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.0126 12.6062C14.6751 12.6062 16.8621 10.4611 16.8621 7.84974C16.8621 5.23834 14.7702 3 12.0126 3C9.35019 3 7.16318 5.14508 7.16318 7.75648C7.16318 10.3679 9.35019 12.6062 12.0126 12.6062ZM12.0126 4.39896C13.9144 4.39896 15.4358 5.89119 15.4358 7.75648C15.4358 9.62176 13.9144 11.114 12.0126 11.114C10.1109 11.114 8.58949 9.62176 8.58949 7.75648C8.58949 5.89119 10.1109 4.39896 12.0126 4.39896ZM14.1046 14.9378C13.439 14.8446 12.7733 14.7513 12.2028 14.7513H12.1077C9.92072 14.7513 5.83196 15.4974 5.54669 18.4819C5.45161 19.1347 5.64178 20.0674 5.83196 21H4.31055C4.12038 20.0674 3.9302 19.1347 4.02529 18.2953C4.50073 14.3782 9.44528 13.3523 12.1077 13.3523C12.6783 13.3523 13.3439 13.4456 14.1046 13.5389V14.9378Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7123 20.773L15.4697 16.5303L16.5303 15.4697L20.773 19.7123L19.7123 20.773Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.773 16.5304L16.5303 20.773L15.4697 19.7123L19.7123 15.4697L20.773 16.5304Z",
    fill: color
  }));
};

const _excluded$2T = ["color", "size"];
/**
 * @typedef {Object} AssignProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AssignProps} props
 * @returns {JSX.Element}
 */

const Assign = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.7274 12.3137C14.2947 12.3137 16.4818 10.2647 16.4818 7.65686C16.4818 5.14216 14.3898 3 11.7274 3C9.06493 3 6.97301 5.04902 6.97301 7.65686C7.06809 10.2647 9.16002 12.3137 11.7274 12.3137ZM11.7274 4.4902C13.534 4.4902 15.0554 5.88725 15.0554 7.75C15.0554 9.51961 13.6291 11.0098 11.7274 11.0098C9.82563 11.0098 8.49441 9.51961 8.49441 7.75C8.49441 5.88725 9.92072 4.4902 11.7274 4.4902ZM16.2916 22V19.8578H9.82563V18.4608H16.1965V16.3186L20 19.1127L16.2916 22ZM5.45161 17.902C5.35652 18.5539 5.54669 19.3922 5.73687 20.3235H4.31055C4.12038 19.3922 3.9302 18.5539 4.02529 17.8088C4.50073 13.9902 9.3502 13.0588 11.7274 13.0588C11.7274 13.0588 11.7274 13.0588 11.8225 13.0588C13.7242 13.0588 16.9572 13.6176 18.5737 15.6667H16.4818C15.0554 14.7353 13.0586 14.4559 11.8225 14.4559H11.7274C9.63546 14.3627 5.83196 15.1078 5.45161 17.902Z",
    fill: color
  }));
};

const _excluded$2U = ["color", "size"];
/**
 * @typedef {Object} AudienceProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AudienceProps} props
 * @returns {JSX.Element}
 */

const Audience = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.9645 12.3137C14.6753 12.3137 16.8052 10.1716 16.8052 7.65686C16.8052 5.04902 14.5784 3 11.9645 3C9.3505 3 7.12379 5.14216 7.12379 7.65686C7.12379 10.2647 9.3505 12.3137 11.9645 12.3137ZM11.9645 4.39706C13.8039 4.39706 15.3529 5.88725 15.3529 7.65686C15.3529 9.42647 13.8039 10.9167 11.9645 10.9167C10.125 10.9167 8.57599 9.51961 8.57599 7.65686C8.57599 5.88725 10.125 4.39706 11.9645 4.39706ZM20 19.8578H12.2549V22L8.38236 19.2059L12.2549 16.4118V18.5539H20V19.8578ZM5.47796 18.0882C5.38114 18.7402 5.57477 19.6716 5.7684 20.5098H4.31619C4.12256 19.5784 3.92894 18.6471 4.02575 17.902C4.50982 14.0833 9.44732 13.0588 12.0613 13.0588C14.4816 13.0588 19.2255 13.9902 20 17.5294H18.5478C17.7733 15.1078 14.1912 14.4559 12.1581 14.4559H12.0613C9.83457 14.4559 5.86521 15.201 5.47796 18.0882Z",
    fill: color
  }));
};

const _excluded$2V = ["color", "size"];
/**
 * @typedef {Object} MenuProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MenuProps} props
 * @returns {JSX.Element}
 */

const Menu = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 6V7.52542H2V6H22ZM2 12.8136H22V11.2881H2V12.8136ZM2 18H22V16.4746H2V18Z",
    fill: color
  }));
};

const _excluded$2W = ["color", "size"];
/**
 * @typedef {Object} SelectAllProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SelectAllProps} props
 * @returns {JSX.Element}
 */

const SelectAll = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 6.27273V7.74126H8.66667V6.27273H22ZM8.66667 12.7343H22V11.2657H8.66667V12.7343ZM8.66667 17.8252H22V16.3566H8.66667V17.8252ZM4.48756 6.76224L3.89055 5.97902H2L4.48756 9.11189L7.87065 5H5.9801L4.48756 6.76224ZM4.48756 11.7552L3.89055 10.972H2L4.48756 14.1049L7.87065 9.99301H5.9801L4.48756 11.7552ZM4.48756 16.6503L3.89055 15.8671H2L4.48756 19L7.87065 14.8881H5.9801L4.48756 16.6503Z",
    fill: color
  }));
};

const _excluded$2X = ["color", "size"];
/**
 * @typedef {Object} TableViewProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TableViewProps} props
 * @returns {JSX.Element}
 */

const TableView = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 6V7.53846H5.3V6H22ZM5.3 12.7692H22V11.2308H5.3V12.7692ZM5.3 18H22V16.4615H5.3V18ZM2.8 6C2.4 6 2 6.41026 2 6.82051C2 7.23077 2.4 7.64103 2.8 7.64103C3.2 7.64103 3.6 7.23077 3.6 6.82051C3.6 6.41026 3.2 6 2.8 6ZM2.8 11.2308C2.4 11.2308 2 11.5385 2 11.9487C2 12.359 2.4 12.7692 2.8 12.7692C3.2 12.7692 3.6 12.359 3.6 11.9487C3.6 11.5385 3.2 11.2308 2.8 11.2308ZM2.8 16.359C2.4 16.359 2 16.7692 2 17.1795C2 17.5897 2.4 18 2.8 18C3.2 18 3.6 17.5897 3.6 17.1795C3.6 16.7692 3.2 16.359 2.8 16.359Z",
    fill: color
  }));
};

const _excluded$2Y = ["color", "size"];
/**
 * @typedef {Object} BuilderTextProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BuilderTextProps} props
 * @returns {JSX.Element}
 */

const BuilderText = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 9.18978H22V10.7226H2V9.18978ZM2 5V6.53285H22V5H2ZM2 14.8102H22V13.2774H2V14.8102ZM2 19H16V17.4672H2V19Z",
    fill: color
  }));
};

const _excluded$2Z = ["color", "size"];
/**
 * @typedef {Object} OptionsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OptionsProps} props
 * @returns {JSX.Element}
 */

const Options = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 8.6C14.7 8.6 15.8 7.7 16.1 6.5H22V5.1H16.1C15.8 3.9 14.7 3 13.4 3C12.1 3 11 3.9 10.7 5.1H2V6.6H10.7C11 7.8 12.1 8.6 13.4 8.6ZM13.4 4.5C14.1 4.5 14.7 5.1 14.7 5.8C14.7 6.5 14.1 7.1 13.4 7.1C12.7 7.1 12.1 6.5 12.1 5.8C12.1 5.1 12.7 4.5 13.4 4.5ZM19.2 14.2C20.8 14.2 22 12.9 22 11.4C22 9.8 20.7 8.6 19.2 8.6C17.9 8.6 16.8 9.5 16.5 10.7H2V12.2H16.5C16.9 13.3 17.9 14.2 19.2 14.2ZM19.2 10C19.9 10 20.5 10.6 20.5 11.3C20.5 12 19.9 12.6 19.2 12.6C18.5 12.6 17.9 12 17.9 11.3C17.9 10.6 18.5 10 19.2 10ZM8.1 14.1C6.8 14.1 5.7 15 5.4 16.2H2V17.7H5.4C5.7 18.9 6.8 19.8 8.1 19.8C9.4 19.8 10.5 18.9 10.8 17.7H22V16.2H10.8C10.5 15 9.4 14.1 8.1 14.1ZM8.1 18.2C7.4 18.2 6.8 17.6 6.8 16.9C6.8 16.2 7.4 15.6 8.1 15.6C8.8 15.6 9.4 16.2 9.4 16.9C9.5 17.7 8.9 18.2 8.1 18.2Z",
    fill: color
  }));
};

const _excluded$2_ = ["color", "size"];
/**
 * @typedef {Object} AutomationProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AutomationProps} props
 * @returns {JSX.Element}
 */

const Automation = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21.27 2.69927C19.4728 1.0008 15.6787 2.49945 11.9845 5.29694C8.29022 2.49945 4.49613 1.0008 2.69892 2.69927C1.00157 4.49765 2.49923 8.29424 5.29488 11.9909C2.49923 15.6876 1.00157 19.4842 2.69892 21.2826C3.19815 21.7821 3.89706 21.9819 4.69581 21.9819C6.69271 21.9819 9.28867 20.6831 11.8846 18.6849C14.4806 20.6831 17.1764 21.9819 19.0734 21.9819C19.8722 21.9819 20.5711 21.7821 21.0703 21.2826C22.7677 19.5841 21.27 15.6876 18.4744 11.9909C21.4697 8.29424 22.9674 4.49765 21.27 2.69927ZM16.2778 4.39774C17.5758 3.79828 18.4744 3.59846 19.1733 3.59846C19.6725 3.59846 19.972 3.69837 20.0719 3.89819C20.8706 4.69748 20.0719 7.39505 17.6756 10.792C16.9767 9.99271 16.2778 9.19343 15.5789 8.49406C14.88 7.79469 14.0812 7.09532 13.2824 6.39595C14.2809 5.49676 15.3792 4.8973 16.2778 4.39774ZM16.6772 11.9909C15.9783 12.7902 15.2793 13.5895 14.4806 14.4887C13.6818 15.288 12.7832 16.0872 11.9845 16.6867C11.1857 15.9873 10.387 15.288 9.48835 14.4887C8.6896 13.6894 7.89084 12.7902 7.29177 11.9909C7.99069 11.1916 8.6896 10.2924 9.48835 9.49316C10.2871 8.69388 11.1857 7.99451 11.9845 7.29514C12.7832 7.99451 13.6818 8.69388 14.4806 9.49316C15.2793 10.2924 15.9783 11.1916 16.6772 11.9909ZM3.89706 3.89819C3.9969 3.69837 4.29644 3.59846 4.79566 3.59846C5.39473 3.59846 6.39317 3.79828 7.69115 4.39774C8.6896 4.8973 9.68804 5.49676 10.7863 6.29604C9.88773 6.99541 9.18882 7.69478 8.39006 8.39415C7.69115 9.19343 6.99224 9.8928 6.29333 10.6921C3.79721 7.29514 3.0983 4.59756 3.89706 3.89819ZM3.89706 20.0836C3.49768 19.684 3.39784 18.4851 4.49613 16.2871C4.99535 15.288 5.59442 14.2889 6.39317 13.1898C7.09208 13.9891 7.791 14.7884 8.48991 15.4878C9.18882 16.1871 9.98758 16.9864 10.7863 17.5859C7.29177 20.1836 4.59597 20.8829 3.89706 20.0836ZM19.5727 16.2871C20.5711 18.4851 20.5711 19.684 20.1717 20.0836C19.373 20.8829 16.6772 20.0836 13.2824 17.6858C14.0812 16.9864 14.88 16.2871 15.5789 15.5877C16.2778 14.8883 16.9767 14.089 17.6756 13.2898C18.4744 14.2889 19.0734 15.3879 19.5727 16.2871ZM13.1826 11.9909C13.1826 12.6903 12.6834 13.1898 11.9845 13.1898C11.2856 13.1898 10.7863 12.6903 10.7863 11.9909C10.7863 11.2915 11.2856 10.792 11.9845 10.792C12.6834 10.792 13.1826 11.2915 13.1826 11.9909Z",
    fill: color
  }));
};

const _excluded$2$ = ["color", "size"];
/**
 * @typedef {Object} NoteProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {NoteProps} props
 * @returns {JSX.Element}
 */

const Note = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$2$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.63636 9.18653H12.5455V10.6632H7.63636V9.18653ZM7.63636 7.11917H16.2727V5.64249H7.63636V7.11917ZM19 13.9119L15.7273 17.456L12.4545 21H5V2H19V13.9119ZM15.7273 15.3886H13.9091V17.3575L14.8182 16.3731L15.7273 15.3886ZM17.6364 13.9119V3.47668H6.36364V19.4249H12.5455V13.9119H17.6364Z",
    fill: color
  }));
};

const _excluded$30 = ["color", "size"];
/**
 * @typedef {Object} PublicChangelogProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {PublicChangelogProps} props
 * @returns {JSX.Element}
 */

const PublicChangelog = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$30);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M4.47541 19.5156H12.0492V21H3V2H18.1475V9.22396H16.6721V3.48438H4.47541V19.5156ZM15.0984 6.84896H5.7541V8.33333H15.0984V6.84896ZM5.7541 11.8958H11.0656V10.4115H5.7541V11.8958ZM17.459 10.6094C18.8361 10.6094 19.918 11.6979 19.918 13.0833C19.918 14.4688 18.8361 15.5573 17.459 15.5573C16.082 15.5573 15 14.4688 15 13.0833C15 11.6979 16.082 10.6094 17.459 10.6094ZM17.459 12.0938C16.8689 12.0938 16.4754 12.5885 16.4754 13.0833C16.4754 13.5781 16.9672 14.0729 17.459 14.0729C17.9508 14.0729 18.4426 13.5781 18.4426 13.0833C18.4426 12.5885 18.0492 12.0938 17.459 12.0938ZM17.459 16.0521C15.8852 16.0521 14.1148 16.8437 13.918 18.625C13.918 18.9219 13.918 19.3177 14.0164 19.6146H15.4918C15.3934 19.3177 15.3934 18.9219 15.3934 18.724C15.4918 17.4375 17.459 17.4375 17.459 17.4375C17.459 17.4375 19.4262 17.4375 19.5246 18.724C19.5246 18.9219 19.5246 19.3177 19.4262 19.6146H20.9016C21 19.2187 21 18.9219 21 18.625C20.9016 16.8437 19.0328 16.0521 17.459 16.0521Z",
    fill: color
  }));
};

const _excluded$31 = ["color", "size"];
/**
 * @typedef {Object} TextProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TextProps} props
 * @returns {JSX.Element}
 */

const Text = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$31);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.9091 5.5625L14.8182 6.55208L15.7273 7.54167H13.9091V5.5625ZM12.5455 2H5V21H19V9.02604L15.7273 5.46354L12.5455 2ZM6.36364 19.5156V3.48438H12.5455V9.02604H17.6364V19.5156H6.36364ZM12.5455 12.3906H7.63636V13.875H12.5455V12.3906ZM16.3636 15.8542H7.63636V17.3385H16.2727V15.8542H16.3636Z",
    fill: color
  }));
};

const _excluded$32 = ["color", "size"];
/**
 * @typedef {Object} BookProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BookProps} props
 * @returns {JSX.Element}
 */

const Book = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$32);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.0116 6.45312V4.27604H17.0233V2H6.13953C4.46512 2 3 3.38542 3 4.96875V21H9.69767H21V6.45312H19.0116ZM6.13953 3.48438H15.4535V4.27604H7.39535V5.76042H17.4419V6.55208H16.2907H6.13953C5.30233 6.45312 4.56977 5.76042 4.56977 4.96875C4.56977 4.17708 5.30233 3.48438 6.13953 3.48438ZM19.3256 19.5156H4.56977V7.54167C4.98837 7.83854 5.61628 7.9375 6.13953 7.9375H8.54651H19.3256V19.5156ZM6.55814 14.9635H17.0233V10.2135H6.55814V14.9635ZM8.12791 11.6979H15.4535V13.4792H8.12791V11.6979Z",
    fill: color
  }));
};

const _excluded$33 = ["color", "size"];
/**
 * @typedef {Object} WelcomeMessageProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {WelcomeMessageProps} props
 * @returns {JSX.Element}
 */

const WelcomeMessage = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$33);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95072 4.221C5.86038 4.37477 5.79045 4.54113 5.74367 4.71557C4.74751 4.4083 3.78184 4.79038 3.29509 5.57765C3.01068 6.03766 2.91175 6.61185 3.07077 7.18472C3.11196 7.33308 3.16919 7.4773 3.24187 7.61641C2.96657 7.78293 2.73202 8.01437 2.55921 8.29387C2.28028 8.74502 2.17171 9.30911 2.30973 9.87735C2.44883 10.45 2.82299 10.9691 3.40717 11.37L3.42479 11.3821L3.57764 11.4747C3.4242 11.6102 3.2913 11.7705 3.18484 11.9518C2.91424 12.4124 2.83324 12.9864 3.0219 13.5506C3.20839 14.1083 3.63368 14.5887 4.25458 14.9451C5.87833 15.9897 7.78499 17.2294 8.38068 17.6382C8.4275 17.6703 8.48225 17.7091 8.54333 17.7526C8.54333 17.7526 8.54333 17.7526 8.54333 17.7526C8.55206 17.7588 8.56092 17.7652 8.5699 17.7716C8.8301 17.9569 9.19481 18.2167 9.55019 18.4033C13.7506 21.0013 19.283 19.7509 21.8331 15.4174L21.8345 15.415L22.9211 13.5977L22.5688 13.1879C20.3596 10.6174 19.7851 7.7747 20.6652 5.60055L20.9081 5.00072L20.3503 4.67265C19.5088 4.17776 18.5146 3.97099 17.5968 4.44331L17.5821 4.45089L17.5677 4.45911C16.8594 4.86416 16.4477 5.6162 16.245 6.49569C16.1257 7.01283 16.0698 7.60756 16.0754 8.27219C15.3645 7.81667 14.426 7.21487 13.4607 6.5947C11.4611 5.31 9.36938 3.96103 8.92486 3.65601L8.91566 3.6497L8.90628 3.64366C8.35158 3.28684 7.75334 3.17283 7.1998 3.30035C6.65536 3.42576 6.2145 3.77198 5.95072 4.221ZM11.5455 9.28898C11.9538 8.65983 11.9537 8.65979 11.9537 8.65979L11.5455 9.28898ZM11.2105 8.17699L11.9537 8.65979L11.2023 9.95585C10.5468 9.61847 8.57812 8.33664 6.87442 7.20208C6.68642 7.08302 6.51909 6.95108 6.37344 6.80832C6.01826 6.57381 5.73105 6.38251 5.55823 6.26434C5.0334 5.95509 4.69441 6.16675 4.57093 6.36647C4.50009 6.48104 4.47214 6.62508 4.51612 6.7835C4.55941 6.93944 4.69074 7.16898 5.04298 7.40045C6.7762 8.45026 10.2281 10.6443 10.8534 11.0734L10.0333 12.3259C10.0412 12.3137 10.0926 12.2324 10.429 11.6918L10.0319 12.328L9.84299 12.2103C9.7217 12.1347 9.54746 12.0261 9.33553 11.8937C8.9117 11.6291 8.33696 11.2695 7.73353 10.8904C6.54377 10.1427 5.21855 9.30365 4.73709 8.9743C4.48775 8.81641 4.29559 8.80956 4.17001 8.83828C4.03317 8.86958 3.91272 8.95707 3.83505 9.08269C3.75874 9.20612 3.72774 9.36026 3.76735 9.52331C3.80524 9.67929 3.92256 9.89974 4.23968 10.1219C5.10337 10.645 6.28932 11.3723 7.32595 12.0229C8.34228 12.6607 9.28515 13.2677 9.58626 13.5156L8.72297 14.7373C8.72335 14.7367 8.73537 14.7178 9.10952 14.0946L8.72297 14.7373L8.61594 14.6729C8.54716 14.6314 8.448 14.5716 8.32618 14.4978C8.08262 14.3504 7.74819 14.1471 7.38492 13.9241C6.66991 13.4851 5.82317 12.9573 5.34604 12.6307C5.09604 12.4724 4.90316 12.4658 4.78033 12.4935C4.64666 12.5237 4.54003 12.6063 4.47818 12.7116C4.4189 12.8125 4.3984 12.9371 4.44446 13.0748C4.49074 13.2132 4.62946 13.4337 5.01299 13.6509L5.03144 13.6613L5.04927 13.6728C6.6699 14.7153 8.6091 15.9757 9.22936 16.4013C9.32296 16.4656 9.41467 16.5307 9.50534 16.5952C9.76006 16.7761 10.0067 16.9514 10.2647 17.0842L10.292 17.0982L10.3181 17.1145C13.8279 19.301 18.4271 18.2502 20.5415 14.6546L20.5443 14.65L21.085 13.7456C19.077 11.2044 18.3101 8.27683 19.0385 5.72493C18.7362 5.64439 18.4918 5.6747 18.2986 5.76935C18.0962 5.89176 17.8557 6.18593 17.7066 6.83266C17.5556 7.4878 17.5232 8.41152 17.6696 9.61644L17.8614 11.1964L16.5205 10.3384C16.5205 10.3384 16.5208 10.3386 16.925 9.70686L16.5205 10.3384L15.3325 9.57768C14.614 9.11726 13.6463 8.49679 12.6499 7.85669C10.6801 6.5911 8.57583 5.23442 8.08662 4.89999C7.83347 4.73959 7.64788 4.73641 7.53651 4.76206C7.41485 4.79009 7.31015 4.86828 7.24406 4.98079C7.17899 5.09154 7.15431 5.23123 7.19588 5.37959C7.21718 5.45564 7.26079 5.55006 7.3452 5.6524C7.95944 6.05722 8.75033 6.57441 9.50654 7.06761C10.1469 7.48522 10.7587 7.8833 11.2105 8.17699Z",
    fill: color
  }));
};

const _excluded$34 = ["color", "size"];
/**
 * @typedef {Object} ThumbUpProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ThumbUpProps} props
 * @returns {JSX.Element}
 */

const ThumbUp = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$34);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.7561 22L2 21.196V7.22613H7.7561V22ZM3.46341 19.8894L6.29268 20.2915V8.73367H3.46341V19.8894ZM21.4146 9.13568C20.9268 8.63317 20.2439 8.33166 19.3659 8.33166L15.561 8.43216C16.9268 6.42211 17.122 4.81407 16.3415 3.60804C15.8537 2.50251 14.6829 2 13.5122 2H12.9268L12.8293 2.60302C12.3415 5.61809 10.2927 7.12563 9.02439 7.82915V9.43719C10.2927 8.93467 13.2195 7.32663 14.0976 3.50754C14.4878 3.60804 14.878 3.90955 15.0732 4.21106C15.6585 5.11558 15.0732 6.62312 13.4146 8.53266L12.3415 9.8392L19.2683 9.73869C19.6585 9.73869 19.9512 9.8392 20.1463 10.0402C20.5366 10.3417 20.5366 10.6432 20.5366 10.9447C19.9512 16.0704 18.9756 18.4824 17.6098 18.4824H9.02439V19.99H17.6098C20.6341 19.99 21.5122 15.4673 22 11.1457C22 10.3417 21.8049 9.63819 21.4146 9.13568Z",
    fill: color
  }));
};

const _excluded$35 = ["color", "size"];
/**
 * @typedef {Object} ThumbDownProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ThumbDownProps} props
 * @returns {JSX.Element}
 */

const ThumbDown = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$35);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.2439 2L22 2.80402L22 16.7739L16.2439 16.7739L16.2439 2ZM20.5366 4.11055L17.7073 3.70854L17.7073 15.2663L20.5366 15.2663L20.5366 4.11055ZM2.58536 14.8643C3.07317 15.3668 3.7561 15.6683 4.63415 15.6683L8.43902 15.5678C7.07317 17.5779 6.87805 19.1859 7.65854 20.392C8.14634 21.4975 9.31707 22 10.4878 22L11.0732 22L11.1707 21.397C11.6585 18.3819 13.7073 16.8744 14.9756 16.1709L14.9756 14.5628C13.7073 15.0653 10.7805 16.6734 9.90244 20.4925C9.5122 20.392 9.12195 20.0905 8.92683 19.7889C8.34146 18.8844 8.92683 17.3769 10.5854 15.4673L11.6585 14.1608L4.73171 14.2613C4.34146 14.2613 4.04878 14.1608 3.85366 13.9598C3.46341 13.6583 3.46341 13.3568 3.46341 13.0553C4.04878 7.92965 5.02439 5.51759 6.39024 5.51759L14.9756 5.51759L14.9756 4.01005L6.39024 4.01005C3.36585 4.01005 2.4878 8.53266 2 12.8543C2 13.6583 2.19512 14.3618 2.58536 14.8643Z",
    fill: color
  }));
};

const _excluded$36 = ["color", "size"];
/**
 * @typedef {Object} MoreHorProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MoreHorProps} props
 * @returns {JSX.Element}
 */

const MoreHor = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$36);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47583 12C2.47583 13.6435 3.80814 14.9758 5.45164 14.9758C7.09513 14.9758 8.42744 13.6435 8.42744 12C8.42744 10.3565 7.09513 9.02417 5.45164 9.02417C3.80814 9.02417 2.47583 10.3565 2.47583 12ZM5.45164 13.4758C4.63657 13.4758 3.97583 12.815 3.97583 12C3.97583 11.1849 4.63657 10.5242 5.45164 10.5242C6.2667 10.5242 6.92744 11.1849 6.92744 12C6.92744 12.815 6.2667 13.4758 5.45164 13.4758Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25002 12C9.25002 13.6435 10.5823 14.9758 12.2258 14.9758C13.8693 14.9758 15.2016 13.6435 15.2016 12C15.2016 10.3565 13.8693 9.02417 12.2258 9.02417C10.5823 9.02417 9.25002 10.3565 9.25002 12ZM12.2258 13.4758C11.4108 13.4758 10.75 12.815 10.75 12C10.75 11.1849 11.4108 10.5242 12.2258 10.5242C13.0409 10.5242 13.7016 11.1849 13.7016 12C13.7016 12.815 13.0409 13.4758 12.2258 13.4758Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0242 12C16.0242 13.6435 17.3565 14.9758 19 14.9758C20.6435 14.9758 21.9758 13.6435 21.9758 12C21.9758 10.3565 20.6435 9.02417 19 9.02417C17.3565 9.02417 16.0242 10.3565 16.0242 12ZM19 13.4758C18.185 13.4758 17.5242 12.815 17.5242 12C17.5242 11.1849 18.185 10.5242 19 10.5242C19.8151 10.5242 20.4758 11.1849 20.4758 12C20.4758 12.815 19.8151 13.4758 19 13.4758Z",
    fill: color
  }));
};

const _excluded$37 = ["color", "size"];
/**
 * @typedef {Object} MoreChannelsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MoreChannelsProps} props
 * @returns {JSX.Element}
 */

const MoreChannels = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$37);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "#E1E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.2569C12.6941 13.2569 13.2569 12.631 13.2569 12C13.2569 11.3689 12.6941 10.743 12 10.743C11.3058 10.743 10.7431 11.3689 10.7431 12C10.7431 12.631 11.3058 13.2569 12 13.2569Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3992 13.2569C17.0933 13.2569 17.6561 12.6941 17.6561 12C17.6561 11.3058 17.0933 10.743 16.3992 10.743C15.705 10.743 15.1423 11.3058 15.1423 12C15.1423 12.6941 15.705 13.2569 16.3992 13.2569Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60078 13.2569C8.29496 13.2569 8.8577 12.631 8.8577 12C8.8577 11.3689 8.29496 10.743 7.60078 10.743C6.90661 10.743 6.34387 11.3689 6.34387 12C6.34387 12.631 6.90661 13.2569 7.60078 13.2569Z",
    fill: color
  }));
};

const _excluded$38 = ["color", "size"];
/**
 * @typedef {Object} MoreVertProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MoreVertProps} props
 * @returns {JSX.Element}
 */

const MoreVert = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$38);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2258 2.25C10.5823 2.25 9.25 3.58231 9.25 5.22581C9.25 6.8693 10.5823 8.20161 12.2258 8.20161C13.8693 8.20161 15.2016 6.8693 15.2016 5.22581C15.2016 3.58231 13.8693 2.25 12.2258 2.25ZM10.75 5.22581C10.75 4.41074 11.4107 3.75 12.2258 3.75C13.0409 3.75 13.7016 4.41074 13.7016 5.22581C13.7016 6.04087 13.0409 6.70161 12.2258 6.70161C11.4107 6.70161 10.75 6.04087 10.75 5.22581Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2258 9.02419C10.5823 9.02419 9.25 10.3565 9.25 12C9.25 13.6435 10.5823 14.9758 12.2258 14.9758C13.8693 14.9758 15.2016 13.6435 15.2016 12C15.2016 10.3565 13.8693 9.02419 12.2258 9.02419ZM10.75 12C10.75 11.1849 11.4107 10.5242 12.2258 10.5242C13.0409 10.5242 13.7016 11.1849 13.7016 12C13.7016 12.8151 13.0409 13.4758 12.2258 13.4758C11.4107 13.4758 10.75 12.8151 10.75 12Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2258 15.7984C10.5823 15.7984 9.25 17.1307 9.25 18.7742C9.25 20.4177 10.5823 21.75 12.2258 21.75C13.8693 21.75 15.2016 20.4177 15.2016 18.7742C15.2016 17.1307 13.8693 15.7984 12.2258 15.7984ZM10.75 18.7742C10.75 17.9591 11.4107 17.2984 12.2258 17.2984C13.0409 17.2984 13.7016 17.9591 13.7016 18.7742C13.7016 19.5893 13.0409 20.25 12.2258 20.25C11.4107 20.25 10.75 19.5893 10.75 18.7742Z",
    fill: color
  }));
};

const _excluded$39 = ["color", "size"];
/**
 * @typedef {Object} DragItemProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DragItemProps} props
 * @returns {JSX.Element}
 */

const DragItem = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$39);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92376 4.26746C7.86682 4.26746 7.01001 5.12427 7.01001 6.1812C7.01001 7.23814 7.86682 8.09495 8.92376 8.09495C9.98069 8.09495 10.8375 7.23814 10.8375 6.1812C10.8375 5.12427 9.98069 4.26746 8.92376 4.26746ZM8.51001 6.1812C8.51001 5.9527 8.69525 5.76746 8.92376 5.76746C9.15226 5.76746 9.3375 5.9527 9.3375 6.1812C9.3375 6.40971 9.15226 6.59495 8.92376 6.59495C8.69525 6.59495 8.51001 6.40971 8.51001 6.1812Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0672 4.26746C14.0102 4.26746 13.1534 5.12427 13.1534 6.1812C13.1534 7.23814 14.0102 8.09495 15.0672 8.09495C16.1241 8.09495 16.9809 7.23813 16.9809 6.1812C16.9809 5.12427 16.1241 4.26746 15.0672 4.26746ZM14.6534 6.1812C14.6534 5.9527 14.8387 5.76746 15.0672 5.76746C15.2957 5.76746 15.4809 5.95269 15.4809 6.1812C15.4809 6.40971 15.2957 6.59495 15.0672 6.59495C14.8387 6.59495 14.6534 6.40971 14.6534 6.1812Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92376 10.0862C7.86682 10.0862 7.01001 10.943 7.01001 11.9999C7.01001 13.0569 7.86682 13.9137 8.92376 13.9137C9.98069 13.9137 10.8375 13.0569 10.8375 11.9999C10.8375 10.943 9.98069 10.0862 8.92376 10.0862ZM8.51001 11.9999C8.51001 11.7714 8.69525 11.5862 8.92376 11.5862C9.15226 11.5862 9.3375 11.7714 9.3375 11.9999C9.3375 12.2284 9.15226 12.4137 8.92376 12.4137C8.69525 12.4137 8.51001 12.2284 8.51001 11.9999Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0672 10.0862C14.0102 10.0862 13.1534 10.943 13.1534 11.9999C13.1534 13.0569 14.0102 13.9137 15.0672 13.9137C16.1241 13.9137 16.9809 13.0569 16.9809 11.9999C16.9809 10.943 16.1241 10.0862 15.0672 10.0862ZM14.6534 11.9999C14.6534 11.7714 14.8387 11.5862 15.0672 11.5862C15.2957 11.5862 15.4809 11.7714 15.4809 11.9999C15.4809 12.2284 15.2957 12.4137 15.0672 12.4137C14.8387 12.4137 14.6534 12.2284 14.6534 11.9999Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92376 15.9049C7.86682 15.9049 7.01001 16.7617 7.01001 17.8187C7.01001 18.8756 7.86682 19.7324 8.92376 19.7324C9.98069 19.7324 10.8375 18.8756 10.8375 17.8187C10.8375 16.7617 9.98069 15.9049 8.92376 15.9049ZM8.51001 17.8187C8.51001 17.5902 8.69525 17.4049 8.92376 17.4049C9.15226 17.4049 9.3375 17.5902 9.3375 17.8187C9.3375 18.0472 9.15226 18.2324 8.92376 18.2324C8.69525 18.2324 8.51001 18.0472 8.51001 17.8187Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0672 15.9049C14.0102 15.9049 13.1534 16.7617 13.1534 17.8187C13.1534 18.8756 14.0102 19.7324 15.0672 19.7324C16.1241 19.7324 16.9809 18.8756 16.9809 17.8187C16.9809 16.7617 16.1241 15.9049 15.0672 15.9049ZM14.6534 17.8187C14.6534 17.5902 14.8387 17.4049 15.0672 17.4049C15.2957 17.4049 15.4809 17.5902 15.4809 17.8187C15.4809 18.0472 15.2957 18.2324 15.0672 18.2324C14.8387 18.2324 14.6534 18.0472 14.6534 17.8187Z",
    fill: color
  }));
};

const _excluded$3a = ["color", "size"];
/**
 * @typedef {Object} FilterProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FilterProps} props
 * @returns {JSX.Element}
 */

const Filter = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 6.09961H22V7.59961H2V6.09961Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59998 11.1969H18.4V12.6969H5.59998V11.1969Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16.4004H9V17.9004H15V16.4004Z",
    fill: color
  }));
};

const _excluded$3b = ["color", "size"];
/**
 * @typedef {Object} BuilderAudioProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BuilderAudioProps} props
 * @returns {JSX.Element}
 */

const BuilderAudio = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2461 16.5124L21.0382 21.9284V1.96167L10.243 7.48765H3.0636V16.5124H10.2461ZM11.1737 8.69631L19.5382 4.41461V19.4974L11.1737 15.2996V8.69631ZM9.67371 8.98765V15.0124H4.5636V8.98765H9.67371Z",
    fill: color
  }));
};

const _excluded$3c = ["color", "size"];
/**
 * @typedef {Object} NotificationProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {NotificationProps} props
 * @returns {JSX.Element}
 */

const Notification = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M20.4006 18.9307C18.9094 17.9406 18.0146 16.2574 18.0146 14.4752V11.505C18.0146 8.93069 16.3246 6.65346 14.038 5.76238C14.2368 5.36634 14.3363 4.9703 14.3363 4.47525C14.3363 3.08911 13.2427 2 11.9503 2C10.6579 2 9.46491 3.08911 9.46491 4.47525C9.46491 4.9703 9.66374 5.46535 9.86257 5.76238C7.47661 6.65346 5.88597 8.83168 5.88597 11.505V14.5743C5.88597 16.3564 4.99123 18.0396 3.5 19.0297H6.68129H8.57018C8.76901 20.8119 10.1608 22.099 11.9503 22.099C13.7398 22.099 15.231 20.7129 15.3304 19.0297H17.5175H20.4006V18.9307ZM11.9503 3.48515C12.4474 3.48515 12.9444 3.88119 12.9444 4.47525C12.9444 4.9703 12.5468 5.46535 11.9503 5.46535C11.3538 5.46535 10.9561 5.06931 10.9561 4.47525C10.9561 3.88119 11.3538 3.48515 11.9503 3.48515ZM11.9503 20.5149C10.9561 20.5149 10.1608 19.8218 10.0614 18.9307H13.8392C13.6404 19.8218 12.845 20.5149 11.9503 20.5149ZM6.68129 17.4455C7.07895 16.5545 7.37719 15.5644 7.37719 14.4752V11.505C7.27778 8.93069 9.3655 6.95049 11.9503 6.95049C14.5351 6.95049 16.5234 9.0297 16.5234 11.505V14.5743C16.5234 15.5644 16.7222 16.6535 17.2193 17.5446H6.68129V17.4455Z",
    fill: color
  }));
};

const _excluded$3d = ["color", "size"];
/**
 * @typedef {Object} NotificationMuteProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {NotificationMuteProps} props
 * @returns {JSX.Element}
 */

const NotificationMute = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 20.9109L20.8889 22L2 3.38614L3.11111 2.29703L22 20.9109ZM8.66667 6.35644C9.07071 6.15842 9.47475 5.9604 9.87879 5.76238C9.67677 5.36634 9.47475 4.9703 9.47475 4.47525C9.47475 3.08911 10.6869 2 12 2C13.3131 2 14.5253 3.08911 14.5253 4.47525C14.5253 4.9703 14.3232 5.46535 14.1212 5.76238C16.5455 6.65346 18.1616 8.83168 18.1616 11.505V14.5743C18.1616 15.0693 18.2626 15.5644 18.3636 15.9604L16.6465 14.2772V11.505C16.6465 8.93069 14.6263 6.95049 12 6.95049C11.1919 6.95049 10.4848 7.14851 9.77778 7.44554L8.66667 6.35644ZM10.9899 4.47525C10.9899 4.9703 11.3939 5.46535 12 5.46535C12.6061 5.46535 13.0101 5.06931 13.0101 4.47525C13.0101 3.9802 12.6061 3.48515 12 3.48515C11.3939 3.48515 10.9899 3.88119 10.9899 4.47525ZM14.9293 17.4455L16.4444 18.9307H15.4343C15.2323 20.7129 13.8182 22 12 22C10.1818 22 8.66667 20.6139 8.56566 18.9307H6.64646H3.41414C4.92929 17.9406 5.83838 16.2574 5.83838 14.4752V11.505C5.83838 10.6139 6.0404 9.82178 6.34343 9.0297L7.55556 10.2178C7.45455 10.6139 7.35354 11.0099 7.35354 11.505V14.5743C7.35354 15.5644 7.15152 16.6535 6.64646 17.5446H14.9293V17.4455ZM13.9192 18.9307H10.0808C10.2828 19.8218 11.0909 20.5149 12 20.5149C12.9091 20.5149 13.8182 19.8218 13.9192 18.9307Z",
    fill: color
  }));
};

const _excluded$3e = ["color", "size"];
/**
 * @typedef {Object} SequencesProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SequencesProps} props
 * @returns {JSX.Element}
 */

const Sequences = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M23 12.4712L9.8 2.94238V7.86385L3 2.94238V9.74867L6.8 12.4712L3 15.1937V22L9.8 17.0785V22L23 12.4712ZM11.3 5.97903L20.4 12.4712L11.3 18.9633V16.0314L16.2 12.4712L11.3 8.91097V5.97903ZM4.5 16.0314L9.4 12.4712L4.5 8.91097V5.97903L13.6 12.4712L4.5 18.9633V16.0314Z",
    fill: color
  }));
};

const _excluded$3f = ["color", "size"];
/**
 * @typedef {Object} SequencesAddProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SequencesAddProps} props
 * @returns {JSX.Element}
 */

const SequencesAdd = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M23 12.4712L9.8 2.94241V7.86387L3 2.94241V9.74869L6.8 12.4712L3 15.1937V22L9.8 17.0785V22L23 12.4712ZM11.3 5.97906L20.4 12.4712L11.3 18.9634V16.0314L16.2 12.4712L11.3 8.911V5.97906ZM4.5 16.0314L9.4 12.4712L4.5 8.911V5.97906L13.6 12.4712L4.5 18.9634V16.0314ZM19.7 5.35079H18V3.7801H19.7V2H21.2V3.7801H23V5.35079H21.3V7.2356H19.8V5.35079H19.7Z",
    fill: color
  }));
};

const _excluded$3g = ["color", "size"];
/**
 * @typedef {Object} SequencesRemoveProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SequencesRemoveProps} props
 * @returns {JSX.Element}
 */

const SequencesRemove = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M23 20.9109L21.9109 22L3 3.08911L4.08911 2L23 20.9109ZM11.3168 5.86139L20.3267 12L17.8515 13.6832L18.9406 14.7723L23 12L9.83168 2.9901V5.66337L11.3168 7.14851V5.86139ZM11.3168 18.1386V15.3663L12.4059 14.5743L11.3168 13.4851L4.58416 18.1386V15.3663L9.43564 12L4.58416 8.63366V6.75248L3.09901 5.26733V9.42574L6.86139 12L3.09901 14.5743V21.0099L9.83168 16.3564V21.0099L15.1782 17.3465L14.0891 16.2574L11.3168 18.1386Z",
    fill: color
  }));
};

const _excluded$3h = ["color", "size"];
/**
 * @typedef {Object} SendProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SendProps} props
 * @returns {JSX.Element}
 */

const Send = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5884 21.488L11.9433 2.323L2.42004 21.4948L11.9496 17.4021L21.5884 21.488ZM18.4115 18.5121L12.75 16.1122V10.0001H11.25V16.0701L5.57992 18.5053L11.9521 5.67711L18.4115 18.5121Z",
    fill: color
  }));
};

const _excluded$3i = ["color", "size"];
/**
 * @typedef {Object} Send2Props
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {Send2Props} props
 * @returns {JSX.Element}
 */

const Send2 = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42521 21.4931L21.5902 11.848L2.41837 2.32471L6.51107 11.8543L2.42521 21.4931ZM5.40109 18.3162L7.801 12.6546L13.9132 12.6546L13.9132 11.1546L7.84308 11.1546L5.40794 5.48459L18.2361 11.8567L5.40109 18.3162Z",
    fill: color
  }));
};

const _excluded$3j = ["color", "size"];
/**
 * @typedef {Object} PlayProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {PlayProps} props
 * @returns {JSX.Element}
 */

const Play = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 12.0508L5 3L5 21L22 12.0508ZM18.7759 12.0508L6.46552 18.5593L6.46552 5.44068L18.7759 12.0508Z",
    fill: color
  }));
};

const _excluded$3k = ["color", "size"];
/**
 * @typedef {Object} WarningProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {WarningProps} props
 * @returns {JSX.Element}
 */

const Warning = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.0508 3L3 20H21L12.0508 3ZM12.0508 6.22414L18.5593 18.5345H5.44068L12.0508 6.22414ZM12.7627 14.8218H11.2373V9.54598H12.7627V14.8218ZM13.0678 16.6782C13.0678 17.2644 12.661 17.6552 12.0508 17.6552C11.4407 17.6552 11.0339 17.2644 11.0339 16.6782C11.0339 16.092 11.4407 15.7011 12.0508 15.7011C12.661 15.7011 13.0678 16.1897 13.0678 16.6782Z",
    fill: color
  }));
};

const _excluded$3l = ["color", "size"];
/**
 * @typedef {Object} BroadcastingProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BroadcastingProps} props
 * @returns {JSX.Element}
 */

const Broadcasting = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.52 21.988L20.6998 2.97803L1.76599 9.24355L10.7944 12.8923L14.52 21.988ZM14.3579 17.6348L12.2717 12.5416L16.2033 8.61004L15.1426 7.54938L11.2382 11.4538L6.11647 9.3839L18.3569 5.33334L14.3579 17.6348Z",
    fill: color
  }));
};

const _excluded$3m = ["color", "size"];
/**
 * @typedef {Object} MessageTemplatesProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MessageTemplatesProps} props
 * @returns {JSX.Element}
 */

const MessageTemplates = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21 21V3H6.40541V6.58065H3L6.40541 21H21ZM7.86486 4.45161H19.5405V19.5484H7.86486V6.58065V4.45161ZM4.84865 8.03226H6.40541V14.6129L4.84865 8.03226ZM18.1784 11.3226H9.22703V9.87097H18.1784V11.3226ZM18.1784 8.03226H9.22703V6.58065H18.1784V8.03226ZM14.2865 14.6129H9.22703V13.1613H14.2865V14.6129Z",
    fill: color
  }));
};

const _excluded$3n = ["color", "size"];
/**
 * @typedef {Object} DuplicateSmsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DuplicateSmsProps} props
 * @returns {JSX.Element}
 */

const DuplicateSms = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.0526 20.0415C12.7502 20.0415 13.3157 19.4745 13.3157 18.7751C13.3157 18.0757 12.7502 17.5088 12.0526 17.5088C11.355 17.5088 10.7894 18.0757 10.7894 18.7751C10.7894 19.4745 11.355 20.0415 12.0526 20.0415Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1578 5.59546H13.842V4.09546H10.1578V5.59546Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09216 4.00119C5.09216 2.639 6.16302 1.56274 7.52637 1.56274H16.4737C17.8371 1.56274 18.908 2.639 18.908 4.00119V19.8983C19.0434 21.3757 17.7388 22.3743 16.4737 22.3743H7.52637C6.16302 22.3743 5.09216 21.298 5.09216 19.9359V4.00119ZM7.52637 3.06274C6.99499 3.06274 6.59216 3.46388 6.59216 4.00119V19.9359C6.59216 20.4732 6.99499 20.8743 7.52637 20.8743H16.4737C17.0906 20.8743 17.4566 20.4158 17.4125 20.0185L17.408 19.9773V4.00119C17.408 3.46388 17.0051 3.06274 16.4737 3.06274H7.52637Z",
    fill: color
  }));
};

const _excluded$3o = ["color", "size"];
/**
 * @typedef {Object} HeadlineBlockEmailProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {HeadlineBlockEmailProps} props
 * @returns {JSX.Element}
 */

const HeadlineBlockEmail = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H22V10.3H2V2ZM20.5 8.8V3.5H3.5V8.8H20.5Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 13.55H2V15.05H17.1V13.55Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 16.95H22V18.45H2V16.95Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.45H2V21.95H12V20.45Z",
    fill: color
  }));
};

const _excluded$3p = ["color", "size"];
/**
 * @typedef {Object} ButtonEmailBlockProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ButtonEmailBlockProps} props
 * @returns {JSX.Element}
 */

const ButtonEmailBlock = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M3.50754 12.404H8.93467V13.9192H2V2L22 2V13.1111H20.4925V3.51515H3.50754V12.404ZM17.5779 16.5455L19.7889 18.7677V20.8889L16.4724 17.5556L14.8643 22L10.5427 10.4848L22 14.9293L17.5779 16.5455ZM17.6784 14.8283L13.1558 13.1111L14.8643 17.6566L15.5678 15.6364L17.6784 14.8283Z",
    fill: color
  }));
};

const _excluded$3q = ["color", "size"];
/**
 * @typedef {Object} LinkProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {LinkProps} props
 * @returns {JSX.Element}
 */

const Link = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5913 7.75C5.50429 7.75 3.75 9.49084 3.75 11.5C3.75 13.5092 5.50429 15.25 7.5913 15.25H9.4087V16.75H7.5913C4.70441 16.75 2.25 14.3658 2.25 11.5C2.25 8.63416 4.70441 6.25 7.5913 6.25H9.4087C12.2956 6.25 14.75 8.63416 14.75 11.5H13.25C13.25 9.49084 11.4957 7.75 9.4087 7.75H7.5913ZM16.4087 7.75H14.5913V6.25H16.4087C19.2956 6.25 21.75 8.63416 21.75 11.5C21.75 14.3658 19.2956 16.75 16.4087 16.75H14.5772L14.5631 16.7495C11.7138 16.6421 9.25 14.3802 9.25 11.4062H10.75C10.75 13.4904 12.4875 15.1633 14.606 15.25H16.4087C18.4957 15.25 20.25 13.5092 20.25 11.5C20.25 9.49084 18.4957 7.75 16.4087 7.75Z",
    fill: color
  }));
};

const _excluded$3r = ["color", "size"];
/**
 * @typedef {Object} CartProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CartProps} props
 * @returns {JSX.Element}
 */

const Cart = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21.901 6.77901H19.2277L15.3663 3V5.0884L17.0495 6.77901H6.75248L8.53465 5.0884V3L4.67327 6.77901H2V12.7459H3.58416L5.56436 21H18.4356L20.4158 12.7459H22V6.77901H21.901ZM3.48515 8.27072H20.4158V11.2541H3.48515V8.27072ZM17.2475 19.5083H6.65346L5.06931 12.7459H7.84158V17.1215H9.32673V12.7459H11.2079V17.1215H12.6931V12.7459H14.5743V17.1215H16.0594V12.7459H18.8317L17.2475 19.5083Z",
    fill: color
  }));
};

const _excluded$3s = ["color", "size"];
/**
 * @typedef {Object} ShopifyDeprecatedProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ShopifyDeprecatedProps} props
 * @returns {JSX.Element}
 */

const ShopifyDeprecated = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M10.3048 9.83969C11.0269 9.6775 11.7818 9.81343 12.2771 9.96765L11.8498 11.3967C11.4869 11.2837 11.022 11.2191 10.6566 11.3011C10.4851 11.3397 10.3584 11.4051 10.2662 11.492C10.1779 11.5753 10.0837 11.7129 10.0296 11.9625C9.97084 12.233 10.0331 12.3575 10.1417 12.4817C10.3067 12.6701 10.5694 12.8322 10.9894 13.0896L10.9928 13.0916C11.3567 13.3146 11.8582 13.622 12.2122 14.0734C12.6098 14.5804 12.7902 15.2192 12.6303 16.0037C12.3943 17.162 11.4029 17.6075 10.5411 17.7093C9.67979 17.811 8.72041 17.6207 8.01894 17.3048L8.61935 15.9414C9.09973 16.1577 9.78311 16.2878 10.3415 16.2218C10.8993 16.1559 11.1046 15.9456 11.158 15.6835C11.2326 15.3176 11.1497 15.1316 11.0342 14.9845C10.8764 14.7831 10.6173 14.6073 10.2174 14.3622L10.1363 14.3128C9.79773 14.1065 9.34355 13.8299 9.0167 13.4566C8.60664 12.9882 8.39688 12.3804 8.56114 11.6239C8.67111 11.1173 8.8978 10.7047 9.22524 10.3961C9.54875 10.0911 9.93263 9.92329 10.3048 9.83969Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65942 6.39596C8.74782 4.08615 10.6786 2.22955 13.5313 2.22974C14.804 2.22982 15.7703 2.79884 16.392 3.68151C16.8584 4.34358 17.1228 5.16598 17.2189 6.04043L20.4245 8.22104L21.2307 20.8941L17.2299 22.1823L17.2235 22.1843L17.2231 22.235L17.0401 22.2175C16.9647 22.2215 16.8902 22.2141 16.8188 22.1962L2.67615 20.8386L4.98419 6.62784L7.65942 6.39596ZM13.4688 3.70764C14.2174 3.70769 14.7516 4.01979 15.1248 4.54955C15.3433 4.85983 15.5097 5.25215 15.6139 5.70651L9.42113 6.24326C10.3579 4.6749 11.7094 3.70753 13.4688 3.70764ZM15.8126 7.20062C15.8165 7.20852 15.8206 7.21633 15.8249 7.22405L15.7343 20.5852L4.41346 19.4985L6.27752 8.02136L15.8099 7.19514C15.8108 7.19697 15.8117 7.1988 15.8126 7.20062ZM17.2342 20.605L19.6596 19.8241L18.9741 9.04857L17.3202 7.92347L17.2342 20.605Z",
    fill: color
  }));
};

const _excluded$3t = ["color", "size"];
/**
 * @typedef {Object} ShopifyProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ShopifyProps} props
 * @returns {JSX.Element}
 */

const Shopify = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M18.7991 6.00693C18.7874 5.90157 18.6938 5.85474 18.6235 5.85474C18.5533 5.85474 17.0196 5.73767 17.0196 5.73767C17.0196 5.73767 15.9542 4.6723 15.8255 4.56694C15.7084 4.44987 15.486 4.48499 15.3923 4.5084C15.3806 4.5084 15.1582 4.57865 14.7952 4.69572C14.4323 3.65377 13.8118 2.70548 12.6996 2.70548H12.5943C12.2899 2.30743 11.8918 2.12012 11.564 2.12012C8.98842 2.12012 7.74744 5.33962 7.3611 6.97864C6.35428 7.29474 5.64013 7.50547 5.55818 7.54059C4.99623 7.7162 4.98452 7.72791 4.91428 8.25473C4.85574 8.65278 3.39233 19.9737 3.39233 19.9737L14.7835 22.1045L20.965 20.7698C20.9767 20.7464 18.8108 6.1123 18.7991 6.00693ZM14.163 4.85962C13.8821 4.94157 13.5425 5.04694 13.203 5.16401V4.95328C13.203 4.32108 13.1211 3.80597 12.9689 3.39621C13.5543 3.46645 13.9172 4.11035 14.163 4.85962ZM12.2547 3.52499C12.4069 3.92304 12.5123 4.48499 12.5123 5.25767V5.37474C11.8801 5.57376 11.2128 5.77279 10.5221 5.99523C10.9084 4.52011 11.646 3.79426 12.2547 3.52499ZM11.5055 2.79914C11.6226 2.79914 11.7396 2.84597 11.8333 2.91621C11.0021 3.30255 10.124 4.27426 9.7611 6.24108C9.21085 6.41669 8.68403 6.56888 8.18061 6.73279C8.60208 5.23425 9.65573 2.79914 11.5055 2.79914Z",
    fill: "#95BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6235 5.83095C18.5532 5.83095 17.0196 5.71387 17.0196 5.71387C17.0196 5.71387 15.9542 4.64851 15.8254 4.54314C15.7786 4.49632 15.7201 4.4729 15.6732 4.4729L14.8186 22.1041L21.0001 20.7694C21.0001 20.7694 18.8342 6.11192 18.8225 6.00656C18.7757 5.90119 18.6937 5.85436 18.6235 5.83095Z",
    fill: "#5E8E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6995 9.2498L11.9502 11.5093C11.9502 11.5093 11.2712 11.1464 10.4634 11.1464C9.25754 11.1464 9.199 11.9074 9.199 12.0947C9.199 13.1249 11.8917 13.523 11.8917 15.9464C11.8917 17.8547 10.6858 19.0839 9.05851 19.0839C7.09169 19.0839 6.10828 17.8664 6.10828 17.8664L6.6351 16.1337C6.6351 16.1337 7.66535 17.0234 8.53168 17.0234C9.10534 17.0234 9.33949 16.5786 9.33949 16.2508C9.33949 14.9044 7.13852 14.8459 7.13852 12.6215C7.13852 10.76 8.47315 8.95712 11.1775 8.95712C12.1844 8.94541 12.6995 9.2498 12.6995 9.2498Z",
    fill: "white"
  }));
};

const _excluded$3u = ["color", "size"];
/**
 * @typedef {Object} FlowProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FlowProps} props
 * @returns {JSX.Element}
 */

const Flow = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3908 7.09854C12.9722 6.46051 13.9073 6.1309 15.2988 6.05616V3.00781H22.0671V10.7604H15.2988V7.55869C14.136 7.63186 13.6897 7.90017 13.4995 8.10885C13.2597 8.37196 13.2209 8.71785 13.1407 9.43256L13.1356 9.47854C13.0618 10.1349 12.9355 11.0687 12.0935 11.7642C12.0025 11.8393 11.9052 11.91 11.8011 11.9764C11.9352 12.058 12.0582 12.1465 12.1709 12.2421C13.0004 12.9452 13.1008 13.8887 13.1614 14.5354C13.2306 15.2755 13.2656 15.6233 13.5096 15.8856C13.7021 16.0927 14.1524 16.3561 15.2988 16.4363V13.429H22.0671V21.0868H15.2988V17.9395C13.9193 17.857 12.9904 17.53 12.4111 16.9071C11.8019 16.252 11.7293 15.3951 11.6809 14.8236C11.6801 14.8139 11.6792 14.8042 11.6784 14.7946C11.6749 14.7531 11.6715 14.7133 11.6679 14.6752C11.6065 14.0192 11.524 13.66 11.201 13.3862C10.8882 13.1211 10.2304 12.8404 8.79881 12.7679V15.9711H2.03052V8.21851H8.79881V11.2269C10.166 11.147 10.8171 10.8729 11.1383 10.6077C11.4791 10.3261 11.5723 9.95735 11.6449 9.31108C11.6507 9.2598 11.6563 9.20521 11.6621 9.14778C11.7196 8.58188 11.8051 7.74132 12.3908 7.09854ZM16.7988 4.50781V9.26044H20.5671V4.50781H16.7988ZM3.53052 9.71851V14.4711H7.29881V9.71851H3.53052ZM16.7988 19.5868V14.929H20.5671V19.5868H16.7988Z",
    fill: color
  }));
};

const _excluded$3v = ["color", "size"];
/**
 * @typedef {Object} MagnetProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MagnetProps} props
 * @returns {JSX.Element}
 */

const Magnet = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M20.1633 6.11415C18.6327 3.70111 16.0816 2.39404 13.0204 2.09241C11.6578 1.95825 9.62755 1.98066 7.47194 2.09237C5.53316 2.19292 3.63265 2.69567 2.61224 2.9973L2 3.22259V10.0353L2.91837 9.73372C3.42857 9.63317 3.93878 9.43209 4.44898 9.33154H4.55102C5.36735 9.13046 6.18367 8.92937 6.89796 8.72828C8.73469 8.22557 10.0612 8.02448 11.1837 8.02448C12.6122 8.02448 13.6327 8.22557 14.3469 8.82883C15.2653 9.53263 15.6735 10.6386 15.6735 12.0462C15.6735 13.4538 15.1633 14.5598 14.3469 15.2636C13.6327 15.8669 12.6122 16.068 11.1837 16.068C9.7551 16.068 8.02041 15.6658 6.89796 15.3641C6.18367 15.1631 5.26531 14.962 4.55102 14.7609C4.39361 14.7299 4.2362 14.6893 4.0788 14.645C3.37633 14.4475 2.67888 14.2241 2 13.9565V20.894L2.61224 21.0951C3.63265 21.3968 5.26531 21.5978 7.40816 21.7989C8.93878 21.8995 10.1633 22 11.3878 22C12 22 12.6122 22 13.1224 21.8995C16.2857 21.5978 18.7347 20.2908 20.2653 17.8777C21.4898 16.068 22 14.2582 22 12.0462C21.898 9.73371 21.3878 7.92394 20.1633 6.11415ZM4.2449 7.82339L4.04082 7.92394C3.93878 7.92394 3.73469 8.02448 3.53061 8.02448V4.30437C3.93878 4.20383 4.55102 4.10328 5.06122 4.00274V7.6223C4.85714 7.72285 4.55102 7.82339 4.2449 7.82339ZM3.53061 15.8669C4 16 3.93878 15.9674 4.2449 16.068C4.55102 16.1685 4.85714 16.269 5.06122 16.3696V19.9891C4.44898 19.8886 3.93878 19.7881 3.53061 19.6875V15.8669ZM18.9388 16.9728C17.6122 18.9837 15.5714 20.0897 12.9184 20.2908C11.5918 20.3913 9.7551 20.3913 7.5102 20.1902C6.69388 20.0897 7.56769 20.1953 6.69388 20.0897V16.7718C8.53061 17.2745 9.95918 17.4756 11.1837 17.4756C12.9184 17.5761 14.2449 17.1739 15.2653 16.3696C16.1837 15.6658 17.2041 14.3587 17.2041 11.9457C17.2041 9.53263 16.1837 8.22557 15.2653 7.52176C14.2449 6.71741 12.9184 6.41578 11.1837 6.41578C9.95918 6.41578 8.53061 6.71741 6.69388 7.11959V3.80165C7.5102 3.70111 7.21254 3.73198 7.5102 3.70111C9.44898 3.50002 11.4898 3.50002 12.9184 3.60056C15.5714 3.80165 17.6122 4.90763 18.9388 6.9185C19.9592 8.42665 20.4694 10.0353 20.4694 11.9457C20.3673 13.856 19.9592 15.4647 18.9388 16.9728Z",
    fill: color
  }));
};

const _excluded$3w = ["color", "size"];
/**
 * @typedef {Object} ZapierProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ZapierProps} props
 * @returns {JSX.Element}
 */

const Zapier = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.0039C14.2496 12.6727 14.1273 13.313 13.9044 13.904C13.3135 14.1271 12.6729 14.2496 12.0039 14.25H11.9961C11.3274 14.2496 10.6871 14.1274 10.0961 13.9044C9.87321 13.3136 9.75045 12.6731 9.75 12.0041V11.9963C9.75045 11.3275 9.87294 10.6873 10.0955 10.0963C10.6867 9.87335 11.3272 9.75068 11.9961 9.75023H12.0039C12.6729 9.75068 13.3135 9.87335 13.9044 10.0963C14.1271 10.6873 14.2495 11.3276 14.25 11.9964V12.0041V12.0041L14.25 12.0039ZM20.8749 10.5H15.6213L19.3361 6.78526C19.0444 6.37567 18.7191 5.99112 18.3635 5.63561L18.3634 5.63525C18.0081 5.28007 17.6239 4.9551 17.2148 4.6637L13.5 8.37845V3.12519C13.0059 3.04216 12.5057 3.00029 12.0047 3L11.9951 3C11.4941 3.00027 10.994 3.04211 10.5 3.1251V8.37872L6.78522 4.66397C6.37585 4.95547 5.99149 5.2806 5.63615 5.63597L5.63479 5.63718C5.27993 5.99226 4.95525 6.37627 4.6641 6.78522L8.37885 10.5H3.1251C3.1251 10.5 3.00018 11.4868 3 11.9967V12.0032C3.00019 12.5048 3.04203 13.0055 3.1251 13.5002H8.37867L4.66392 17.2149C5.2481 18.0351 5.96504 18.752 6.78522 19.3362L10.5 15.6216V20.8749C10.9936 20.9578 11.4932 20.9996 11.9937 21H12.0066C12.507 20.9996 13.0066 20.9578 13.5001 20.8749V15.6213L17.2149 19.336C17.6241 19.0446 18.0084 18.7196 18.3636 18.3644L18.3645 18.3637C18.7197 18.0084 19.0447 17.6242 19.3361 17.215L15.6213 13.5002H20.8749C20.9578 13.0066 20.9996 12.5071 21 12.0066V11.9937C20.9996 11.4933 20.9578 10.9937 20.8749 10.5002V10.5Z",
    fill: "#FF4A00"
  }));
};

const _excluded$3x = ["color", "size"];
/**
 * @typedef {Object} FolderOpenProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FolderOpenProps} props
 * @returns {JSX.Element}
 */

const FolderOpen = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M20.4694 9.9V7.4H11.3878L9.65306 4H2V20H20.1633L22 9.9H20.4694ZM18.8367 18.5H3.53061V5.5H8.73469L9.95918 8L10.3673 8.8H11.2857H18.9388V9.8H5.97959V11.3H20.0612L18.8367 18.5Z",
    fill: color
  }));
};

const _excluded$3y = ["color", "size"];
/**
 * @typedef {Object} FolderAdsCampaignProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FolderAdsCampaignProps} props
 * @returns {JSX.Element}
 */

const FolderAdsCampaign = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 7.34177L9.5 4H2V20H22V7.34177H11.2ZM20.5 18.481H3.5V5.51899H8.6L9.8 8.05063L10.2 8.86076H11.1H20.4V18.481H20.5ZM9.9 12.6076L11.1 14.2278L13.6 10.5823H15.4L11.1 16.7595L8 12.6076H9.9Z",
    fill: color
  }));
};

const _excluded$3z = ["color", "size"];
/**
 * @typedef {Object} FolderProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FolderProps} props
 * @returns {JSX.Element}
 */

const Folder = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 7.34177L9.5 4H2V20H22V7.34177H11.2ZM20.5 18.481H3.5V5.51899H8.6L9.8 8.05063L10.2 8.86076H11.1H20.4V18.481H20.5Z",
    fill: color
  }));
};

const _excluded$3A = ["color", "size"];
/**
 * @typedef {Object} FolderAddProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FolderAddProps} props
 * @returns {JSX.Element}
 */

const FolderAdd = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M8.90002 14.4304V12.9114H11.2V10.5823H12.7V12.9114H14.9V14.4304H12.7V16.6582H11.2V14.4304H8.90002Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 4L11.2 7.34177H22V20H2V4H9.5ZM9.8 8.05063L8.6 5.51899H3.5V18.481H20.4V8.86076H10.2L9.8 8.05063Z",
    fill: color
  }));
};

const _excluded$3B = ["color", "size"];
/**
 * @typedef {Object} MoveToProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MoveToProps} props
 * @returns {JSX.Element}
 */

const MoveTo = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M17 13.5191L13.2 9.87354V12.0001L14.9 13.6204L13.2 15.3419V17.4685L17 13.5191Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12.9114H13.1V14.4304H7V12.9114Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 7.34177L9.5 4H2V20H22V7.34177H11.2ZM8.6 5.51899L9.8 8.05063L10.2 8.86076H20.4V18.481H3.4V5.51899H8.6Z",
    fill: color
  }));
};

const _excluded$3C = ["color", "size"];
/**
 * @typedef {Object} TemplateStoreProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TemplateStoreProps} props
 * @returns {JSX.Element}
 */

const TemplateStore = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6335 3H3V10.6335H10.6335V3ZM9.2199 4.41361V9.2199H4.41361V4.41361H9.2199Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3H13.3665V10.6335H21V3ZM19.5864 4.41361V9.2199H14.7801V4.41361H19.5864Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13.3665H10.6335V21H3V13.3665ZM9.2199 19.5864V14.7801H4.41361V19.5864H9.2199Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8861 16.3862H21V17.8862H17.8861V21H16.3861V17.8862H13.3665V16.3862H16.3861V13.3665H17.8861V16.3862Z",
    fill: color
  }));
};

const _excluded$3D = ["color", "size"];
/**
 * @typedef {Object} MosaicViewProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MosaicViewProps} props
 * @returns {JSX.Element}
 */

const MosaicView = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H10.6335V10.6335H3V3ZM9.2199 9.2199V4.41361H4.41361V9.2199H9.2199Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3665 3H21V10.6335H13.3665V3ZM19.5864 9.2199V4.41361H14.7801V9.2199H19.5864Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6335 13.3665H3V21H10.6335V13.3665ZM9.2199 14.7801V19.5864H4.41361V14.7801H9.2199Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3665 13.3665H21V21H13.3665V13.3665ZM19.5864 19.5864V14.7801H14.7801V19.5864H19.5864Z",
    fill: color
  }));
};

const _excluded$3E = ["color", "size"];
/**
 * @typedef {Object} AdsAdSetProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AdsAdSetProps} props
 * @returns {JSX.Element}
 */

const AdsAdSet = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H10.6335V10.6335H3V3ZM9.2199 9.2199V8.08496H4.41361V9.2199H9.2199ZM9.2199 4.41361V6.58496H4.41361V4.41361H9.2199Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3665 3H21V10.6335H13.3665V3ZM19.5864 6.58496V4.41361H14.7801V6.58496H19.5864ZM19.5864 8.08496H14.7801V9.2199H19.5864V8.08496Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6335 13.3665H3V21H10.6335V13.3665ZM9.2199 14.7801V16.9517H4.41361V14.7801H9.2199ZM4.41361 18.4517H9.2199V19.5864H4.41361V18.4517Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3665 13.3665H21V21H13.3665V13.3665ZM19.5864 16.9517V14.7801H14.7801V16.9517H19.5864ZM19.5864 18.4517H14.7801V19.5864H19.5864V18.4517Z",
    fill: color
  }));
};

const _excluded$3F = ["color", "size"];
/**
 * @typedef {Object} QrProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {QrProps} props
 * @returns {JSX.Element}
 */

const Qr = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M5.58459 5.63867H6.96921V7.05228H5.58459V5.63867Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H9.55385V9.6911H3V3ZM8.16923 8.27749V4.41361H4.38462V8.27749H8.16923Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0461 5.63867H16.6615V7.05228H18.0461V5.63867Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6308 3H14.0769V9.6911H20.6308V3ZM19.2461 4.41361V8.27749H15.4615V4.41361H19.2461Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58459 16.9478H6.96921V18.3614H5.58459V16.9478Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14.3088H9.55385V20.9999H3V14.3088ZM8.16923 19.5863V15.7225H4.38462V19.5863H8.16923Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0193 9.7854H12.5193V11.4856H20.6308V12.9856H19.0731V15.8168H17.5731V12.9856H12.5193V14.4071H16.2116V19.021H14.7116V15.9071H11.0193V12.9856H9.46155V11.4856H11.0193V9.7854Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61538 12.9856H3V11.4856H7.61538V12.9856Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5193 3V7.90052H11.0193V3H12.5193Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6116 17.8901H11.1116V20.9962H14.1693V19.4962H12.6116V17.8901Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1038 15.8167V18.7342H18.9807V20.996H16.1077V19.496H17.4807V17.2342H19.6038V15.8167H21.1038Z",
    fill: color
  }));
};

const _excluded$3G = ["color", "size"];
/**
 * @typedef {Object} PublishProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {PublishProps} props
 * @returns {JSX.Element}
 */

const Publish = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5763 10.4637L20.9348 3.10425L19.2509 3.71921C17.9365 4.19925 16.1431 4.58587 14.3583 4.58893C13.1878 4.52029 12.0531 4.27732 10.8862 4.02747C10.3336 3.90913 9.77374 3.78925 9.19944 3.68561C7.4671 3.373 5.31234 3.24217 3.52699 3.92681L3.04553 4.11143V21H4.54553V15.6834C5.95922 15.3817 7.58057 15.476 9.0325 15.738C9.50633 15.8235 10.0105 15.9312 10.5337 16.0429C11.7564 16.3039 13.0835 16.5873 14.3727 16.6628C16.2532 16.8732 18.3213 16.6691 19.9999 15.6392L20.6535 15.2382L17.5763 10.4637ZM9.29889 14.2619C7.85267 14.0009 6.14412 13.873 4.54553 14.1555V5.17056C5.86472 4.81059 7.46771 4.89734 8.93306 5.16177C9.40688 5.24728 9.911 5.35491 10.4342 5.46663C11.6636 5.7291 12.9985 6.01412 14.2944 6.08774L14.3157 6.08895H14.337C15.6581 6.08895 16.9746 5.90075 18.1391 5.61737L15.8712 10.587L18.5301 14.7125C17.3464 15.215 15.9311 15.3302 14.5211 15.17L14.5001 15.1676L14.479 15.1664C13.3009 15.0995 12.1596 14.8551 10.9857 14.6037C10.433 14.4854 9.87318 14.3655 9.29889 14.2619Z",
    fill: color
  }));
};

const _excluded$3H = ["color", "size"];
/**
 * @typedef {Object} BotProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BotProps} props
 * @returns {JSX.Element}
 */

const Bot = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5814 4.05911C17.5814 4.99507 17.0233 5.74384 16.186 6.02463V7.05419H20V21H18.6047V8.45813H5.39535V21H4V7.05419H14.8837V6.02463C14.0465 5.74384 13.4884 4.99507 13.4884 4.05911C13.4884 2.93596 14.4186 2 15.5349 2C16.6512 2 17.5814 2.93596 17.5814 4.05911ZM14.8837 4.15271C14.8837 4.52709 15.1628 4.80788 15.5349 4.80788C15.907 4.80788 16.186 4.4335 16.186 4.15271C16.186 3.77833 15.907 3.49754 15.5349 3.49754C15.1628 3.49754 14.8837 3.77833 14.8837 4.15271Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37211 16.6946C8.93025 17.6305 10.0465 18.4729 12.093 18.4729C14.1395 18.4729 15.2558 17.6305 15.814 16.6946H17.3954C16.4651 18.7537 14.6047 19.8768 12.093 19.8768C9.58141 19.8768 7.72094 18.7537 6.79071 16.6946H8.37211Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8837 13.1378C10.8837 11.7339 10.5116 10.9851 9.67439 10.9851C8.83718 10.9851 8.46509 11.7339 8.46509 13.1378C8.46509 14.4482 8.83718 15.1969 9.67439 15.1969C10.5116 15.1969 10.8837 14.4482 10.8837 13.1378Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3256 10.9851C15.1628 10.9851 15.5349 11.7339 15.5349 13.1378C15.5349 14.4482 15.1628 15.1969 14.3256 15.1969C13.4884 15.1969 13.1163 14.4482 13.1163 13.1378C13.1163 11.7339 13.4884 10.9851 14.3256 10.9851Z",
    fill: color
  }));
};

const _excluded$3I = ["color", "size"];
/**
 * @typedef {Object} BotRemoveProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BotRemoveProps} props
 * @returns {JSX.Element}
 */

const BotRemove = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.186 7.05419V6.02463C17.0233 5.74384 17.5814 4.99507 17.5814 4.05911C17.5814 2.93596 16.6512 2 15.5349 2C14.4186 2 13.4884 2.93596 13.4884 4.05911C13.4884 4.99507 14.0465 5.74384 14.8837 6.02463V7.05419H4V21H5.39535V8.45813H18.6047V21H20V7.05419H16.186ZM15.5349 4.80788C15.1628 4.80788 14.8837 4.52709 14.8837 4.15271C14.8837 3.77833 15.1628 3.49754 15.5349 3.49754C15.907 3.49754 16.186 3.77833 16.186 4.15271C16.186 4.4335 15.907 4.80788 15.5349 4.80788ZM13.1163 15.3842L16 18.2857H14.0465L12.093 16.3202L10.1395 18.2857H8.27907L11.1628 15.3842L8.93023 13.1379V11.1724L12.093 14.3547L15.2558 11.0788V13.0443L13.1163 15.3842Z",
    fill: color
  }));
};

const _excluded$3J = ["color", "size"];
/**
 * @typedef {Object} KeywordsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {KeywordsProps} props
 * @returns {JSX.Element}
 */

const Keywords = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M6.53608 5H8.70102L13.2371 18.8923H11.5876L10.2474 14.9077H4.7835L3.54639 18.8923H2L6.53608 5ZM5.29897 13.5077H9.93813L7.567 6.4L5.29897 13.5077Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2681 16.0923C14.2681 13.7231 16.6392 12.9692 19.1134 12.9692H20.5567V12.2154C20.5567 10.6 19.9381 9.95386 18.4949 9.95386C17.1546 9.95386 16.433 10.4923 16.2268 11.7846H14.6804C14.8866 9.52309 16.6392 8.66156 18.4949 8.66156C20.3505 8.66156 22 9.4154 22 12.3231V19H20.4536V17.7077C19.732 18.5692 18.9072 19 17.4639 19C15.7113 19 14.2681 18.1385 14.2681 16.0923ZM20.4536 15.3385V14.0462H19.1134C17.1546 14.0462 15.7113 14.5846 15.7113 16.0923C15.7113 17.1692 16.2268 17.8154 17.567 17.8154C19.2165 17.7077 20.4536 16.8462 20.4536 15.3385Z",
    fill: color
  }));
};

const _excluded$3K = ["color", "size"];
/**
 * @typedef {Object} ProtectProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ProtectProps} props
 * @returns {JSX.Element}
 */

const Protect = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 13.8687C13.2 13.0687 12.5 12.3687 11.7 12.3687C10.9 12.3687 10.2 13.0687 10.2 13.8687C10.2 14.4687 10.6 14.9687 11.1 15.2687V16.9687C11 17.2687 11.3 17.4687 11.6 17.4687H11.8C12.1 17.4687 12.3 17.2687 12.3 16.9687V15.2687C12.8 15.0687 13.2 14.4687 13.2 13.8687Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81362 18.8791C3.04526 15.8163 4.25939 11.9133 7.25001 9.64406V5.96855C7.25001 3.55434 9.28579 1.51855 11.7 1.51855C14.1142 1.51855 16.15 3.55434 16.15 5.96855V8.7765C17.0676 9.30648 17.8499 10.0594 18.4098 11.0291C20.3528 14.3943 18.6952 18.7739 15.0367 20.8862C11.3782 22.9985 6.75659 22.2443 4.81362 18.8791ZM8.75001 5.96855C8.75001 4.38277 10.1142 3.01855 11.7 3.01855C13.2858 3.01855 14.65 4.38277 14.65 5.96855V8.13978C12.8073 7.60339 10.6758 7.7862 8.75001 8.72287V5.96855ZM8.93672 10.321C5.80363 12.13 4.68665 15.6593 6.11262 18.1291C7.53858 20.5989 11.1536 21.3962 14.2867 19.5872C17.4198 17.7783 18.5368 14.2489 17.1108 11.7791C15.6849 9.30935 12.0698 8.51208 8.93672 10.321Z",
    fill: color
  }));
};

const _excluded$3L = ["color", "size"];
/**
 * @typedef {Object} UnprotectProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {UnprotectProps} props
 * @returns {JSX.Element}
 */

const Unprotect = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 13.8687C13.2 13.0687 12.5 12.3687 11.7 12.3687C10.9 12.3687 10.2 13.0687 10.2 13.8687C10.2 14.4687 10.6 14.9687 11.1 15.2687V16.9687C11 17.2687 11.3 17.4687 11.6 17.4687H11.8C12.1 17.4687 12.3 17.2687 12.3 16.9687V15.2687C12.8 15.0687 13.2 14.4687 13.2 13.8687Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75001 5.96855C8.75001 4.38277 10.1142 3.01855 11.7 3.01855C13.2858 3.01855 14.65 4.38277 14.65 5.96855V8.13979C12.6256 7.55049 10.2526 7.82923 8.18666 9.02202C4.52819 11.1343 2.87059 15.5139 4.81356 18.8791C6.75653 22.2443 11.3782 22.9985 15.0367 20.8862C18.6951 18.7739 20.3527 14.3943 18.4098 11.0291C17.8499 10.0594 17.0676 9.30652 16.15 8.77653V5.96855C16.15 3.55434 14.1142 1.51855 11.7 1.51855C9.28579 1.51855 7.25001 3.55434 7.25001 5.96855H8.75001ZM8.93666 10.321C5.80357 12.13 4.68659 15.6593 6.11256 18.1291C7.53852 20.5989 11.1536 21.3962 14.2867 19.5872C17.4197 17.7783 18.5367 14.2489 17.1108 11.7791C15.6848 9.30935 12.0697 8.51208 8.93666 10.321Z",
    fill: color
  }));
};

const _excluded$3M = ["color", "size"];
/**
 * @typedef {Object} RulesProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {RulesProps} props
 * @returns {JSX.Element}
 */

const Rules = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.571 10.7347L14.8122 2.04468L3.15051 13.2656H9.42851L9.18772 21.8227L20.9874 10.7347H14.571ZM10.7886 18.26L10.9713 11.7656H6.87283L13.2111 5.66689L13.0288 12.2347H17.2007L10.7886 18.26Z",
    fill: color
  }));
};

const _excluded$3N = ["color", "size"];
/**
 * @typedef {Object} DelayProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DelayProps} props
 * @returns {JSX.Element}
 */

const Delay = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M18 22H6V15.7313L9.34426 11.9502L6 8.26866V2H18V8.26866L14.6557 11.9502L18 15.6318V22ZM7.47541 20.5075H16.5246V16.3284L12.6885 11.9502L16.5246 7.67164V3.49254H7.47541V7.67164L11.3115 11.9502L7.47541 16.2289V20.5075Z",
    fill: color
  }));
};

const _excluded$3O = ["color", "size"];
/**
 * @typedef {Object} PauseProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {PauseProps} props
 * @returns {JSX.Element}
 */

const Pause = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3H10.8V21H4V3ZM9.3 19.5V4.5H5.5V19.5H9.3Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1 3H20V21H13.1V3ZM18.5 19.5V4.5H14.7V19.5H18.5Z",
    fill: color
  }));
};

const _excluded$3P = ["color", "size"];
/**
 * @typedef {Object} Stop2Props
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {Stop2Props} props
 * @returns {JSX.Element}
 */

const Stop2 = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 5.5H5.5V18.5H18.5V5.5ZM4 4V20H20V4H4Z",
    fill: color
  }));
};

const _excluded$3Q = ["color", "size"];
/**
 * @typedef {Object} TriggersLinesProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TriggersLinesProps} props
 * @returns {JSX.Element}
 */

const TriggersLines = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3L20 12.0588L6 21V3ZM7.5 5.75722L17.2261 12.0506L7.5 18.2622V5.75722Z",
    fill: color
  }));
};

const _excluded$3R = ["color", "size"];
/**
 * @typedef {Object} StopRecordProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {StopRecordProps} props
 * @returns {JSX.Element}
 */

const StopRecord = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16 8H8V16H16V8Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5098 6.5098 2 12 2C17.5882 2 22 6.5098 22 12C22 17.4902 17.4902 22 12 22C6.5098 22 2 17.4902 2 12ZM3.47059 12.098C3.47059 16.8039 7.29412 20.6275 12 20.6275C16.8039 20.6275 20.6275 16.8039 20.6275 12C20.6275 7.29412 16.7059 3.56863 12 3.56863C7.29412 3.56863 3.47059 7.39216 3.47059 12.098Z",
    fill: color
  }));
};

const _excluded$3S = ["color", "size"];
/**
 * @typedef {Object} CloudProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CloudProps} props
 * @returns {JSX.Element}
 */

const Cloud = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 14.2C22 16.5 20.1 18.4 17.8 18.4H17.4V16.9H17.8C19.3 16.9 20.5 15.7 20.5 14.2C20.5 13.2 20 12.3 19.1 11.8L18.6 11.5L18.7 11C19.2 9.2 19 7.6 18.2 6.6C17.6 5.9 16.7 5.5 15.5 5.5C13 5.5 11.8 7.3 11.2 8.7L10.8 9.9L10 8.9C9.6 8.5 9.2 8.4 8.6 8.4C7 8.4 6.3 9.8 6 11.1L5.9 11.5L5.5 11.6C4.3 11.9 3.5 13 3.5 14.2C3.5 15.7 4.7 16.9 6.2 16.9H17.5V18.4H6.2C3.9 18.4 2 16.5 2 14.2C2 12.5 3.1 10.9 4.7 10.3C5.4 8.1 6.8 6.9 8.6 6.9C9.2 6.9 9.8 7 10.3 7.3C11.4 5.2 13.3 4 15.6 4C17.3 4 18.6 4.6 19.5 5.7C20.5 6.9 20.8 8.8 20.3 10.8C21.3 11.6 22 12.9 22 14.2Z",
    fill: color
  }));
};

const _excluded$3T = ["color", "size"];
/**
 * @typedef {Object} CloudErrorProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CloudErrorProps} props
 * @returns {JSX.Element}
 */

const CloudError = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 14.2C22 16.5 20.1 18.4 17.8 18.4H17.4V16.9H17.8C19.3 16.9 20.5 15.7 20.5 14.2C20.5 13.2 20 12.3 19.1 11.8L18.6 11.5L18.7 11C19.2 9.2 19 7.6 18.2 6.6C17.6 5.9 16.7 5.5 15.5 5.5C13 5.5 11.8 7.3 11.2 8.7L10.8 9.9L10 8.9C9.6 8.5 9.2 8.4 8.6 8.4C7 8.4 6.3 9.8 6 11.1L5.9 11.5L5.5 11.6C4.3 11.9 3.5 13 3.5 14.2C3.5 15.7 4.7 16.9 6.2 16.9H7V18.4H6.2C3.9 18.4 2 16.5 2 14.2C2 12.5 3.1 10.9 4.7 10.3C5.4 8.1 6.8 6.9 8.6 6.9C9.2 6.9 9.8 7 10.3 7.3C11.4 5.2 13.3 4 15.6 4C17.3 4 18.6 4.6 19.5 5.7C20.5 6.9 20.8 8.8 20.3 10.8C21.3 11.6 22 12.9 22 14.2ZM8.6 20.5H10.7L12.2 19L13.7 20.5H15.8L13.3 17.9L15.2 16V13.9L12.3 16.8L9.3 14V16.1L11.1 17.9L8.6 20.5Z",
    fill: color
  }));
};

const _excluded$3U = ["color", "size"];
/**
 * @typedef {Object} CloudUploadProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CloudUploadProps} props
 * @returns {JSX.Element}
 */

const CloudUpload = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M8.86567 14.5169L12.1493 11.1798L15.4328 14.5169H13.3433L12.1493 13.3034L10.9552 14.5169H8.86567ZM20.209 10.8764C20.607 8.75281 20.3085 6.93258 19.4129 5.7191C18.5174 4.60674 17.1244 4 15.4328 4C13.1443 4 11.3532 5.11236 10.1592 7.33708C9.76119 7.03371 9.16418 6.93258 8.56716 6.93258C6.77612 6.93258 5.28358 8.14607 4.68657 10.3708C3.09453 10.9775 2 12.5955 2 14.3146C2 16.6404 3.89055 18.5618 6.1791 18.5618H6.97512V17.0449H6.1791C4.68657 17.0449 3.49254 15.8315 3.49254 14.3146C3.49254 13.1011 4.28856 11.9888 5.48259 11.6854L5.8806 11.5843L5.9801 11.1798C6.27861 9.96629 6.97512 8.44944 8.56716 8.44944C9.16418 8.44944 9.66169 8.65169 9.9602 9.05618L10.7562 10.0674L11.2537 8.85393C11.8507 7.33708 13.0448 5.61798 15.5323 5.61798C16.7264 5.61798 17.6219 6.02247 18.2189 6.73034C19.0149 7.74157 19.1144 9.25843 18.7164 11.1798L18.6169 11.7865L19.1144 12.0899C20.01 12.5955 20.5075 13.5056 20.5075 14.5169C20.5075 16.0337 19.3134 17.2472 17.8209 17.2472H17.4229V18.764H17.8209C20.1095 18.764 22 16.8427 22 14.5169C21.9005 13 21.204 11.6854 20.209 10.8764ZM11.3532 22H12.8458V14.618H11.3532V22Z",
    fill: color
  }));
};

const _excluded$3V = ["color", "size"];
/**
 * @typedef {Object} CloudDownloadProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CloudDownloadProps} props
 * @returns {JSX.Element}
 */

const CloudDownload = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18.5L12.2 21.8L8.9 18.5H11L12.2 19.7L13.4 18.5H15.5ZM20.3 10.8C20.7 8.7 20.4 6.9 19.5 5.7C18.6 4.6 17.2 4 15.6 4C13.3 4 11.5 5.1 10.3 7.3C9.8 7 9.3 6.9 8.6 6.9C6.8 6.9 5.3 8.1 4.7 10.3C3.1 10.9 2 12.5 2 14.2C2 16.5 3.9 18.4 6.2 18.4H7V16.9H6.2C4.7 16.9 3.5 15.7 3.5 14.2C3.5 13 4.3 11.9 5.5 11.6L5.9 11.5L6 11.1C6.3 9.9 7 8.4 8.6 8.4C9.2 8.4 9.7 8.6 10 9L10.8 10L11.3 8.8C11.9 7.3 13.1 5.6 15.6 5.6C16.8 5.6 17.7 6 18.3 6.7C19.1 7.7 19.2 9.2 18.8 11.1L18.7 11.7L19.2 12C20.1 12.5 20.6 13.4 20.6 14.4C20.6 15.9 19.4 17.1 17.9 17.1H17.5V18.6H17.8C20.1 18.6 22 16.7 22 14.4C22 12.9 21.4 11.6 20.3 10.8ZM12.9 11.2H11.4V18.5H12.9V11.2Z",
    fill: color
  }));
};

const _excluded$3W = ["color", "size"];
/**
 * @typedef {Object} PopularProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {PopularProps} props
 * @returns {JSX.Element}
 */

const Popular = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4257 2.33851L8.74896 1.44312L9.36262 3.24222C10.1988 5.69379 10.2987 7.34346 10.1534 8.42403C10.0142 9.45989 9.64505 10.0092 9.4211 10.2756C8.98942 10.6956 8.56543 10.7851 8.16485 10.6769C7.87944 10.5733 7.42043 10.1386 7.25708 9.32446L6.88664 7.4782L5.88632 9.07359C4.80312 10.8011 4.25 12.8592 4.25 14.3259C4.25 18.4114 7.76218 21.7501 12 21.7501C16.2378 21.7501 19.75 18.4114 19.75 14.3259C19.75 11.1683 18.0834 8.53782 16.138 6.54624C14.188 4.54997 11.8837 3.11707 10.4257 2.33851ZM11.6401 8.62391C11.7778 7.59935 11.7269 6.2858 11.3221 4.60117C12.5044 5.35587 13.8636 6.36458 15.0649 7.59439C16.8731 9.44551 18.25 11.7195 18.25 14.3259C18.25 17.5214 15.4723 20.2501 12 20.2501C8.52767 20.2501 5.75 17.5214 5.75 14.3259C5.75 13.4887 5.98929 12.3289 6.47649 11.1819C6.81115 11.6213 7.23452 11.9486 7.70554 12.1051L7.72097 12.1102L7.7366 12.1147C8.74489 12.4018 9.72809 12.0877 10.5005 11.3178L10.5209 11.2975L10.5397 11.2756C10.9269 10.8253 11.4536 10.0108 11.6401 8.62391Z",
    fill: color
  }));
};

const _excluded$3X = ["color", "size"];
/**
 * @typedef {Object} PopularFilledProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {PopularFilledProps} props
 * @returns {JSX.Element}
 */

const PopularFilled = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4257 2.33851L8.74896 1.44312L9.36262 3.24222C10.1988 5.69379 10.2987 7.34346 10.1534 8.42403C10.0142 9.45989 9.64505 10.0092 9.4211 10.2756C8.98942 10.6956 8.56543 10.7851 8.16485 10.6769C7.87944 10.5733 7.42043 10.1386 7.25708 9.32446L6.88664 7.4782L5.88632 9.07359C4.80312 10.8011 4.25 12.8592 4.25 14.3259C4.25 18.4114 7.76218 21.7501 12 21.7501C16.2378 21.7501 19.75 18.4114 19.75 14.3259C19.75 11.1683 18.0834 8.53782 16.138 6.54624C14.188 4.54997 11.8837 3.11707 10.4257 2.33851Z",
    fill: color
  }));
};

const _excluded$3Y = ["color", "size"];
/**
 * @typedef {Object} AlignLeftProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AlignLeftProps} props
 * @returns {JSX.Element}
 */

const AlignLeft = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11 9.25L3 9.25V10.75L11 10.75V9.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13.25L14 13.25V14.75L3 14.75V13.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 5.25H3V6.75H21V5.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17.25H3V18.75H21V17.25Z",
    fill: color
  }));
};

const _excluded$3Z = ["color", "size"];
/**
 * @typedef {Object} AlignCenterProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AlignCenterProps} props
 * @returns {JSX.Element}
 */

const AlignCenter = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21 5.25H3V6.75H21V5.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.25H9V10.75H15V9.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13.25H17V14.75H7V13.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17.25H3V18.75H21V17.25Z",
    fill: color
  }));
};

const _excluded$3_ = ["color", "size"];
/**
 * @typedef {Object} AlignRightProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AlignRightProps} props
 * @returns {JSX.Element}
 */

const AlignRight = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21 9.25L13 9.25V10.75L21 10.75V9.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.25L21 13.25V14.75L10 14.75V13.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 5.25H3V6.75H21V5.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17.25H3V18.75H21V17.25Z",
    fill: color
  }));
};

const _excluded$3$ = ["color", "size"];
/**
 * @typedef {Object} AlignWideProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AlignWideProps} props
 * @returns {JSX.Element}
 */

const AlignWide = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21 5.25H3V6.75H21V5.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9.25H3V10.75H21V9.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13.25H21V14.75H3V13.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17.25H3V18.75H21V17.25Z",
    fill: color
  }));
};

const _excluded$40 = ["color", "size"];
/**
 * @typedef {Object} SpacingProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SpacingProps} props
 * @returns {JSX.Element}
 */

const Spacing = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$40);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M14.5128 8.53465L11.9487 6.05941L9.48718 8.53465H7.33333L11.9487 3.9802L16.6667 8.53465H14.5128ZM6 2V3.48515H18V2H6ZM11.9487 20.1188L16.7692 15.4653H14.6154L11.9487 18.0396L9.28205 15.4653H7.12821L11.9487 20.1188ZM11.2308 15.4653H12.7692V8.53465H11.2308V15.4653ZM6 22H18V20.5149H6V22Z",
    fill: color
  }));
};

const _excluded$41 = ["color", "size"];
/**
 * @typedef {Object} BoldProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BoldProps} props
 * @returns {JSX.Element}
 */

const Bold = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$41);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M15.1603 11.5435C16.4427 10.8635 17.1756 9.67351 17.1756 8.14351V7.97351C17.1756 5.08351 15.0687 3.46851 11.4046 3.46851H6V20.4685H12.1374C15.8931 20.4685 18 18.6835 18 15.6235V15.5385C18 13.4985 17.084 12.2235 15.1603 11.5435ZM8.29008 10.7785V5.33851H11.4046C14.5191 5.33851 14.8855 6.86851 14.8855 7.97351V8.05851C14.8855 9.92851 13.7863 10.7785 11.4046 10.7785H8.29008ZM15.8015 15.5385V15.6235C15.8015 17.6635 14.6107 18.5985 12.1374 18.5985H8.29008V12.5635H11.6794C14.4275 12.5635 15.8015 13.5835 15.8015 15.5385Z",
    fill: color
  }));
};

const _excluded$42 = ["color", "size"];
/**
 * @typedef {Object} ItalicProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ItalicProps} props
 * @returns {JSX.Element}
 */

const Italic = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$42);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M8.48019 19.25L13.9177 4.75H10V3.25H21V4.75H15.5197L10.0822 19.25H14V20.75H3V19.25H8.48019Z",
    fill: color
  }));
};

const _excluded$43 = ["color", "size"];
/**
 * @typedef {Object} UnderlineProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {UnderlineProps} props
 * @returns {JSX.Element}
 */

const Underline = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$43);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.4141 16.7412C15.1641 16.7412 16.3672 15.2867 16.3672 11.9231V3.46851H18V12.1958C18 16.1049 16.0234 18.2867 12.4141 18.2867C8.97656 18.2867 7 16.1049 7 12.3776V3.46851H8.54688V12.1958C8.54688 15.2867 9.75 16.7412 12.4141 16.7412Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25781 20.105H17.8281V21.4686H7.25781V20.105Z",
    fill: color
  }));
};

const _excluded$44 = ["color", "size"];
/**
 * @typedef {Object} SendMessageProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SendMessageProps} props
 * @returns {JSX.Element}
 */

const SendMessage = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$44);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M17 8.25H9V9.75H17V8.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11.25H9V12.75H17V11.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.25H13V15.75H9V14.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8953 4.25C8.14064 4.25 4.0407 7.6411 4.0407 12C4.0407 13.581 4.52066 15.2739 5.52405 16.5772L2.07825 19.75H12.8953C17.6501 19.75 21.75 16.3589 21.75 12C21.75 7.6411 17.6501 4.25 12.8953 4.25ZM5.5407 12C5.5407 8.66876 8.7547 5.75 12.8953 5.75C17.036 5.75 20.25 8.66876 20.25 12C20.25 15.3312 17.036 18.25 12.8953 18.25H5.92175L7.65346 16.6555L7.09943 16.1028C6.08279 15.0887 5.5407 13.5208 5.5407 12Z",
    fill: color
  }));
};

const _excluded$45 = ["color", "size"];
/**
 * @typedef {Object} UndoProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {UndoProps} props
 * @returns {JSX.Element}
 */

const Undo = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$45);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M9.12871 14.71L6.65347 17.2962L4.17822 14.71H2L6.75248 19.4686L11.2079 14.71H9.12871Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 11.7098C20.6138 8.08912 17.5445 4.15809 12.891 4.46843C10.7128 4.67533 8.93065 5.60636 7.74253 7.36498C6.05936 9.64085 5.76233 12.7443 5.86134 14.7098H7.34649C7.24748 13.0546 7.4455 10.2615 8.93065 8.29602C9.92075 6.95119 11.3069 6.22705 12.9901 6.02016C16.6534 5.81326 19.1287 8.70981 20.4158 11.7098H22Z",
    fill: color
  }));
};

const _excluded$46 = ["color", "size"];
/**
 * @typedef {Object} RedoProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {RedoProps} props
 * @returns {JSX.Element}
 */

const Redo = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$46);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M14.8713 14.71L17.3465 17.2962L19.8218 14.71H22L17.2475 19.4686L12.7921 14.71H14.8713Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00005 11.7098C3.38618 8.08912 6.45549 4.15809 11.109 4.46843C13.2872 4.67533 15.0694 5.60636 16.2575 7.36498C17.9406 9.64085 18.2377 12.7443 18.1387 14.7098H16.6535C16.7525 13.0546 16.5545 10.2615 15.0694 8.29602C14.0793 6.95119 12.6931 6.22705 11.0099 6.02016C7.34658 5.81326 4.87133 8.70981 3.5842 11.7098H2.00005Z",
    fill: color
  }));
};

const _excluded$47 = ["color", "size"];
/**
 * @typedef {Object} AnalyticsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AnalyticsProps} props
 * @returns {JSX.Element}
 */

const Analytics = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$47);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5924 2V21.9744H22V2H16.5924ZM20.5088 20.4752H18.0836V3.49921H20.5088V20.4752Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27679 21.961V6.22678H14.6844V21.961H9.27679ZM10.768 20.4617H13.1931V7.72599H10.768V20.4617Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 22V11.2127H7.40759V22H2ZM3.49123 20.5008H5.91636V12.7119H3.49123V20.5008Z",
    fill: color
  }));
};

const _excluded$48 = ["color", "size"];
/**
 * @typedef {Object} SystemFieldProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SystemFieldProps} props
 * @returns {JSX.Element}
 */

const SystemField = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$48);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.0498 15.202L7.37313 10.7685H9.56219L12.0498 13.133L14.4378 10.7685H16.5274L12.0498 15.202ZM16.9254 6.4335V7.91133H20.607V20.5222H3.49254V7.91133H7.17413V6.4335H2V22H22V6.4335H16.9254ZM12.7463 2H11.2537V10.7685H12.7463V2ZM7.17413 18.0591H16.9254V16.5813H7.17413V18.0591Z",
    fill: color
  }));
};

const _excluded$49 = ["color", "size"];
/**
 * @typedef {Object} CustomFieldProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CustomFieldProps} props
 * @returns {JSX.Element}
 */

const CustomField = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$49);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.0498 15.202L7.37313 10.7685H9.56219L12.0498 13.133L14.4378 10.7685H16.5274L12.0498 15.202ZM16.9254 6.4335V7.91133H20.607V20.5222H3.49254V7.91133H7.17413V6.4335H2V22H22V6.4335H16.9254ZM12.7463 2H11.2537V10.7685H12.7463V2Z",
    fill: color
  }));
};

const _excluded$4a = ["color", "size"];
/**
 * @typedef {Object} CustomFieldRemoveProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CustomFieldRemoveProps} props
 * @returns {JSX.Element}
 */

const CustomFieldRemove = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22 6.1206V22H2V6.1206H7.24752V7.62814H3.48515V20.4925H20.5149V7.62814H16.8515V6.1206H22ZM9.52475 10.3417L11.802 8.03015L14.0792 10.3417H16.1584L12.8911 6.92462L15.5644 4.11055V2.1005L11.802 5.9196L8.0396 2V4.11055L10.8119 6.92462L7.44554 10.3417H9.52475Z",
    fill: color
  }));
};

const _excluded$4b = ["color", "size"];
/**
 * @typedef {Object} GuestChatChannelProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GuestChatChannelProps} props
 * @returns {JSX.Element}
 */

const GuestChatChannel = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "url(#paint0_linear_GuestChatChannel_7619_1724)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80564 16.192C6.96256 15.028 7.29186 13.8375 7.91667 13.462C8.84933 12.9016 10.4088 12.5866 12 12.5866C10.8068 12.5866 9.66667 11.6845 9.66667 10.2519V9.08462C9.66667 7.65201 10.8068 6.75 12 6.75C13.1932 6.75 14.3333 7.65201 14.3333 9.08462V10.2519C14.3333 11.6845 13.1932 12.5866 12 12.5866C13.5912 12.5866 15.1507 12.9016 16.0833 13.462C16.6858 13.8241 16.9865 15.1533 17.1644 16.1633C17.2156 16.4535 17.0377 16.7357 16.7513 16.8049C16.1492 16.9503 15.5299 17.0485 14.9167 17.1099C13.0513 17.2967 10.9487 17.2967 9.08333 17.1099C8.45929 17.0474 7.82898 16.9468 7.21694 16.7972C6.94456 16.7306 6.76818 16.4699 6.80564 16.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5866C13.1932 12.5866 14.3333 11.6845 14.3333 10.2519C14.3333 10.1723 14.3333 10.4217 14.3333 9.08462C14.3333 7.65201 13.1932 6.75 12 6.75C10.8068 6.75 9.66667 7.65201 9.66667 9.08462C9.66667 9.56216 9.66667 10.2519 9.66667 10.2519C9.66667 11.6845 10.8068 12.5866 12 12.5866ZM12 12.5866C10.4088 12.5866 8.84933 12.9016 7.91667 13.462C7.29186 13.8375 6.96256 15.028 6.80564 16.192C6.76818 16.4699 6.94456 16.7306 7.21694 16.7972C7.82898 16.9468 8.45929 17.0474 9.08333 17.1099C10.9487 17.2967 13.0513 17.2967 14.9167 17.1099C15.5299 17.0485 16.1492 16.9503 16.7513 16.8049C17.0377 16.7357 17.2156 16.4535 17.1644 16.1633C16.9865 15.1533 16.6858 13.8241 16.0833 13.462C15.1507 12.9016 13.5912 12.5866 12 12.5866Z",
    stroke: "white",
    strokeWidth: "0.875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_GuestChatChannel_7619_1724",
    x1: "4",
    y1: "2.5",
    x2: "18",
    y2: "22",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.75",
    stopColor: "#F38167"
  }))));
};

const _excluded$4c = ["color", "size"];
/**
 * @typedef {Object} TriggersProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TriggersProps} props
 * @returns {JSX.Element}
 */

const Triggers = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M9.13727 7.70219C9.13727 6.8155 10.1463 6.30661 10.8595 6.8335L16.7981 11.2212C17.3826 11.653 17.3826 12.5267 16.7981 12.9585L10.8595 17.3462C10.1463 17.8731 9.13727 17.3642 9.13727 16.4775V7.70219Z",
    fill: "#14CE63",
    stroke: "#0BCB6B",
    strokeWidth: "1.44049"
  }));
};

const _excluded$4d = ["color", "size"];
/**
 * @typedef {Object} StartFlowProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {StartFlowProps} props
 * @returns {JSX.Element}
 */

const StartFlow = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#0BCB6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80005 8.06225C7.80005 6.17866 9.89931 5.05517 11.4666 6.1L17.3792 10.0417C18.7794 10.9752 18.7794 13.0328 17.3792 13.9662L11.4666 17.908C9.89931 18.9528 7.80005 17.8293 7.80005 15.9457V8.06225ZM10.4681 7.59769C10.097 7.35033 9.60005 7.61631 9.60005 8.06225V15.9457C9.60005 16.3917 10.097 16.6577 10.4681 16.4103L16.3807 12.4686C16.7122 12.2476 16.7122 11.7604 16.3807 11.5394L10.4681 7.59769Z",
    fill: "white"
  }));
};

const _excluded$4e = ["color", "size"];
/**
 * @typedef {Object} AppleProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AppleProps} props
 * @returns {JSX.Element}
 */

const Apple = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.2672 5.19231C13.2656 5.19231 14.5172 4.50572 15.2625 3.59027C15.9375 2.76065 16.4297 1.60203 16.4297 0.443421C16.4297 0.286078 16.4156 0.128735 16.3875 0C15.2766 0.0429116 13.9406 0.758106 13.1391 1.71647C12.5063 2.44596 11.9297 3.59027 11.9297 4.76319C11.9297 4.93484 11.9578 5.10648 11.9719 5.1637C12.0422 5.178 12.1547 5.19231 12.2672 5.19231ZM8.75156 22.5C10.1156 22.5 10.7203 21.5702 12.4219 21.5702C14.1516 21.5702 14.5312 22.4714 16.05 22.4714C17.5406 22.4714 18.5391 21.0696 19.4813 19.6964C20.5359 18.123 20.9719 16.5782 21 16.5067C20.9016 16.4781 18.0469 15.2908 18.0469 11.958C18.0469 9.06866 20.2969 7.76701 20.4234 7.66688C18.9328 5.49269 16.6687 5.43547 16.05 5.43547C14.3766 5.43547 13.0125 6.46535 12.1547 6.46535C11.2266 6.46535 10.0031 5.49269 8.55469 5.49269C5.79844 5.49269 3 7.80992 3 12.1869C3 14.9046 4.04062 17.7797 5.32031 19.6392C6.41719 21.2127 7.37344 22.5 8.75156 22.5Z",
    fill: color
  }));
};

const _excluded$4f = ["color", "size"];
/**
 * @typedef {Object} GoogleProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GoogleProps} props
 * @returns {JSX.Element}
 */

const Google = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 12.2266C21.6 11.5175 21.5364 10.8357 21.4182 10.1812H12V14.0493H17.3818C17.15 15.2993 16.4455 16.3584 15.3864 17.0675V19.5766H18.6182C20.5091 17.8357 21.6 15.2721 21.6 12.2266Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9992 22.0001C14.6992 22.0001 16.9629 21.1047 18.6174 19.5774L15.3856 17.0683C14.4901 17.6683 13.3447 18.0229 11.9992 18.0229C9.39469 18.0229 7.19014 16.2638 6.40378 13.9001H3.06287V16.4911C4.70832 19.7592 8.09014 22.0001 11.9992 22.0001Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40455 13.8995C6.20455 13.2995 6.09091 12.6585 6.09091 11.9995C6.09091 11.3404 6.20455 10.6995 6.40455 10.0995V7.50854H3.06364C2.38636 8.85854 2 10.3858 2 11.9995C2 13.6131 2.38636 15.1404 3.06364 16.4904L6.40455 13.8995Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9992 5.97727C13.4674 5.97727 14.7856 6.48182 15.822 7.47273L18.6901 4.60455C16.9583 2.99091 14.6947 2 11.9992 2C8.09014 2 4.70832 4.24091 3.06287 7.50909L6.40378 10.1C7.19014 7.73636 9.39469 5.97727 11.9992 5.97727Z",
    fill: "#EA4335"
  }));
};

const _excluded$4g = ["color", "size"];
/**
 * @typedef {Object} GoogleAltProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GoogleAltProps} props
 * @returns {JSX.Element}
 */

const GoogleAlt = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 12.2266C21.6 11.5175 21.5364 10.8357 21.4182 10.1812H12V14.0493H17.3818C17.15 15.2993 16.4455 16.3584 15.3864 17.0675V19.5766H18.6182C20.5091 17.8357 21.6 15.2721 21.6 12.2266Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9992 22.0002C14.6992 22.0002 16.9628 21.1048 18.6174 19.5775L15.3856 17.0684C14.4901 17.6684 13.3446 18.023 11.9992 18.023C9.39465 18.023 7.1901 16.2639 6.40374 13.9002H3.06283V16.4911C4.70828 19.7593 8.0901 22.0002 11.9992 22.0002Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40455 13.8995C6.20455 13.2995 6.09091 12.6586 6.09091 11.9995C6.09091 11.3404 6.20455 10.6995 6.40455 10.0995V7.50863H3.06364C2.38636 8.85863 2 10.3859 2 11.9995C2 13.6132 2.38636 15.1404 3.06364 16.4904L6.40455 13.8995Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9992 5.97727C13.4674 5.97727 14.7856 6.48182 15.8219 7.47273L18.6901 4.60455C16.9583 2.99091 14.6946 2 11.9992 2C8.0901 2 4.70909 4.24044 3.06364 7.50863L6.40455 10.0995C7.19091 7.7359 9.39465 5.97727 11.9992 5.97727Z",
    fill: color
  }));
};

const _excluded$4h = ["color", "size"];
/**
 * @typedef {Object} FacebookProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FacebookProps} props
 * @returns {JSX.Element}
 */

const Facebook = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 6.47758 17.5224 2 12 2C6.47758 2 2 6.47758 2 12C2 16.9908 5.65634 21.1281 10.4377 21.8791V14.8913H7.8979V12H10.4377V9.79635C10.4377 7.29035 11.9311 5.90517 14.2149 5.90517C15.3089 5.90517 16.4537 6.10064 16.4537 6.10064V8.56165H15.1922C13.9505 8.56165 13.5623 9.33229 13.5623 10.124V11.9999H16.3355L15.8925 14.8912H13.5623V21.879C18.3436 21.1294 21.9999 16.9922 21.9999 11.9999L22 12Z",
    fill: color
  }));
};

const _excluded$4i = ["color", "size"];
/**
 * @typedef {Object} OmnichannelWidgetProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OmnichannelWidgetProps} props
 * @returns {JSX.Element}
 */

const OmnichannelWidget = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.0504 9.73869C19.0504 5.41708 15.4609 2 10.8742 2C6.28753 2 2.59826 5.41708 2.59826 9.73869C2.59826 11.2462 2.89739 12.3518 3.49565 13.4573L2 18.0804L6.98551 16.5729C7.8829 16.9749 9.07942 17.4774 10.8742 17.4774C15.4609 17.5779 19.0504 14.1608 19.0504 9.73869ZM7.18493 15.0653L4.39304 15.8693L5.29043 13.3568L4.9913 13.0553C4.39304 12.0503 4.09391 11.0452 4.09391 9.73869C4.09391 6.22111 7.08522 3.50754 10.8742 3.50754C14.6632 3.50754 17.5548 6.22111 17.5548 9.73869C17.5548 13.2563 14.6632 15.9698 10.8742 15.9698C9.17913 15.9698 8.18203 15.5678 7.38435 15.0653H7.18493ZM20.8452 17.9799L21.5432 22L17.8539 20.392C17.3554 20.593 16.8568 20.794 16.2585 20.794C14.1646 20.995 12.2701 20.2915 10.7745 18.8844H13.2672C14.0649 19.2864 15.062 19.4874 16.0591 19.3869C16.6574 19.2864 17.0562 19.1859 17.4551 18.9849L17.7542 18.7839L19.549 19.5879L19.2498 17.6784L19.4493 17.3769C20.0475 16.6734 21.2441 14.2613 19.7484 11.5477H21.4435C22.5403 14.1608 21.8423 16.6734 20.8452 17.9799Z",
    fill: color
  }));
};

const _excluded$4j = ["color", "size"];
/**
 * @typedef {Object} IncreaseEngagementProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {IncreaseEngagementProps} props
 * @returns {JSX.Element}
 */

const IncreaseEngagement = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M9.68068 13.6418C12.4124 13.6418 12.8026 12.1493 13.2904 9.9602C13.388 9.66169 13.4856 9.26368 13.5831 8.86567C13.7782 8.06965 13.5831 7.47264 13.388 7.17413C13.1929 6.87562 12.9002 6.57711 12.2173 6.37811C11.7295 6.37811 10.6563 6.1791 9.77824 6.0796C10.5587 4.88557 10.6563 3.89055 10.1685 2.99502C9.68068 2.39801 8.99775 2 8.1197 2H7.53434L7.43678 2.59701C7.14409 4.28856 5.68068 5.68159 3.53434 6.37811L2.94897 6.47761V13.5423H4.70507L9.68068 13.6418ZM4.50995 7.67164C6.65629 6.87562 8.1197 5.48259 8.70507 3.69154C8.80263 3.69154 8.80263 3.79104 8.90019 3.79104C9.19287 4.18905 8.80263 5.08458 7.92458 6.1791L7.04653 7.17413L8.41239 7.37313C8.41239 7.37313 11.2417 7.77114 12.0221 7.87065C12.1197 7.87065 12.2173 7.87065 12.2173 7.97015C12.2173 8.06965 12.3148 8.16915 12.2173 8.46766C12.1197 8.86567 12.0221 9.26368 11.9246 9.56219C11.4368 11.6517 11.3392 12.0498 9.77824 12.0498H4.50995V7.67164ZM22.0709 4.88557V10.6567H20.6075V7.47264L13.4856 16.4279H7.53434L3.14409 21.9005L2.07092 21.005L6.85141 14.9353H12.8026L19.5343 6.37811H16.3148V4.88557H22.0709Z",
    fill: color
  }));
};

const _excluded$4k = ["color", "size"];
/**
 * @typedef {Object} ShowcaseProductsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ShowcaseProductsProps} props
 * @returns {JSX.Element}
 */

const ShowcaseProducts = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 13.5484H19.2188V21H4.59375V13.5484H6V19.4516H17.8125V13.5484ZM21 8.22581V8.41935C21 9.96774 19.7812 11.3226 18.1875 11.3226C17.3438 11.3226 16.5938 10.9355 16.125 10.3548C15.6563 10.9355 14.9063 11.3226 14.0625 11.3226C13.2188 11.3226 12.4688 10.9355 12 10.3548C11.5313 10.9355 10.7813 11.3226 9.9375 11.3226C9.09375 11.3226 8.34375 10.9355 7.875 10.3548C7.40625 10.9355 6.65625 11.3226 5.8125 11.3226C4.3125 11.3226 3 10.0645 3 8.41935V8.22581L6 3H17.8125L21 8.22581ZM19.5938 8.6129L16.9688 4.45161H6.84375L4.21875 8.6129C4.3125 9.3871 4.875 9.87097 5.625 9.87097C6.375 9.87097 7.03125 9.19355 7.03125 8.41935H8.4375C8.4375 9.19355 9.09375 9.87097 9.84375 9.87097C10.5938 9.87097 11.25 9.29032 11.25 8.41935H12.6563C12.6563 9.19355 13.3125 9.87097 14.0625 9.87097C14.8125 9.87097 15.4688 9.19355 15.4688 8.41935H16.875C16.875 9.19355 17.5312 9.87097 18.2812 9.87097C18.9375 9.87097 19.5 9.3871 19.5938 8.6129ZM15.1875 15.1935L14.1563 14.129L10.7813 17.6129L11.8125 18.6774L15.1875 15.1935ZM8.4375 15.0968L9.375 16.1613L12.75 12.6774L11.7188 11.6129L8.4375 15.0968Z",
    fill: color
  }));
};

const _excluded$4l = ["color", "size"];
/**
 * @typedef {Object} FaqProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FaqProps} props
 * @returns {JSX.Element}
 */

const Faq = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M20.9 17.9799L21.6 22L17.9 20.392C17.4 20.593 16.9 20.794 16.3 20.794C14.2 20.995 12.3 20.2915 10.8 18.8844H13.3C14.1 19.2864 15.1 19.4874 16.1 19.3869C16.7 19.2864 17.1 19.1859 17.5 18.9849L17.8 18.7839L19.6 19.5879L19.3 17.6784L19.5 17.3769C20.1 16.6734 21.3 14.2613 19.8 11.5477H21.5C22.6 14.1608 21.9 16.6734 20.9 17.9799ZM10.9 17.5779C9 17.5779 7.8 17.1759 7 16.6734L2 18.0804L3.6 13.4573C3 12.3518 2.7 11.1457 2.7 9.73869C2.6 5.41709 6.3 2 10.9 2C15.5 2 19.1 5.41709 19.1 9.73869C19.1 14.0603 15.5 17.5779 10.9 17.5779ZM7.5 15.1658C8.2 15.5678 9.2 16.0704 10.9 16.0704C14.7 16.0704 17.6 13.3568 17.6 9.8392C17.6 6.32161 14.7 3.60804 10.9 3.60804C7.1 3.60804 4.1 6.32161 4.1 9.8392C4.1 11.0452 4.4 12.0503 5 13.0553L5.2 13.3568L4.3 15.8693L7.2 15.0653L7.5 15.1658ZM11.5 13.8593C11.5 13.4573 11.2 13.0553 10.7 13.0553C10.3 13.0553 9.9 13.3568 9.9 13.8593C9.9 14.3618 10.2 14.6633 10.7 14.6633C11.1 14.6633 11.5 14.2613 11.5 13.8593ZM11.4 7.22613C12.1 7.32663 12.4 7.82915 12.4 8.23116C12.4 8.53266 12.3 8.93467 11.6 9.53769C10.6 10.2412 10 10.9447 10 12.2513H11.5C11.5 11.6482 11.6 11.3467 12.5 10.6432C13.5 9.8392 13.9 9.13568 13.9 8.13065C13.9 6.92462 13 5.9196 11.7 5.61809C10.7 5.41709 9.6 5.61809 8.9 6.22111C8.2 6.82412 7.9 7.62814 7.9 8.63317H9.4C9.4 8.03015 9.5 7.62814 9.9 7.32663C10.2 7.22613 10.8 7.12563 11.4 7.22613Z",
    fill: color
  }));
};

const _excluded$4m = ["color", "size"];
/**
 * @typedef {Object} WebsiteRedirectProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {WebsiteRedirectProps} props
 * @returns {JSX.Element}
 */

const WebsiteRedirect = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M8.3 7.92638H4.6V6.45399H8.3V7.92638ZM22 4V20H2V4H22ZM3.5 5.47239V9.00613H20.5V5.47239H3.5ZM20.5 18.5276V10.4785H3.5V18.5276H20.5ZM9 17.2515V15.2883L8 14.4049L9 13.5215V11.5583L5.7 14.3067L9 17.2515ZM14.8 13.7178L15.7 14.4049L14.8 15.1902V17.1534L18 14.5031L14.8 11.8528V13.7178ZM10.1 17.0552H11.7L13.4 12.0491H11.8L10.1 17.0552Z",
    fill: color
  }));
};

const _excluded$4n = ["color", "size"];
/**
 * @typedef {Object} TelegramProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TelegramProps} props
 * @returns {JSX.Element}
 */

const Telegram = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1686 11.8311C8.30849 9.59178 11.7359 8.11545 13.4508 7.40216C18.3472 5.36558 19.3646 5.01181 20.0278 5.00012C20.1736 4.99756 20.4998 5.0337 20.711 5.20511C20.8894 5.34985 20.9385 5.54536 20.9619 5.68259C20.9854 5.81981 21.0147 6.13242 20.9914 6.37668C20.7261 9.1646 19.578 15.9302 18.9939 19.0527C18.7467 20.3739 18.2601 20.8169 17.7889 20.8603C16.7651 20.9545 15.9876 20.1837 14.9959 19.5336C13.4441 18.5164 12.5674 17.8832 11.0612 16.8905C9.32038 15.7434 10.4489 15.1129 11.4409 14.0825C11.7005 13.8129 16.2118 9.70955 16.2991 9.33731C16.31 9.29076 16.3202 9.11722 16.2171 9.02559C16.114 8.93396 15.9618 8.9653 15.852 8.99022C15.6964 9.02554 13.2174 10.6641 8.41502 13.9058C7.71136 14.389 7.07401 14.6244 6.50297 14.6121C5.87344 14.5985 4.66248 14.2561 3.76225 13.9635C2.65809 13.6046 1.78052 13.4148 1.85693 12.8052C1.89674 12.4878 2.33396 12.163 3.1686 11.8311Z",
    fill: color
  }));
};

const _excluded$4o = ["color", "size"];
/**
 * @typedef {Object} TapProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TapProps} props
 * @returns {JSX.Element}
 */

const Tap = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M8.84998 7.3C8.84998 5.31421 10.4142 3.75 12.4 3.75C14.3858 3.75 15.95 5.31421 15.95 7.3H17.45C17.45 4.48579 15.2142 2.25 12.4 2.25C9.58576 2.25 7.34998 4.48579 7.34998 7.3H8.84998Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4663 4.91254C13.4683 4.93432 14.35 5.76153 14.35 6.99986V14.3971C14.8038 14.1138 15.2417 13.9069 15.6584 13.7732C16.4422 13.5218 17.2071 13.5149 17.8354 13.829L17.8612 13.8419L17.8859 13.8567C18.6602 14.3214 19.05 15.1983 19.05 16.0999V16.7352L18.4233 16.8397C16.3962 17.1775 14.6665 18.8884 13.8184 21.7154L13.658 22.2499H6.45522C6.43719 22.2513 6.4188 22.2521 6.40005 22.2522C6.1795 22.2537 6.02113 22.161 5.94124 22.1015C5.80368 21.999 5.73536 21.8741 5.71933 21.8448L5.71823 21.8428C5.67125 21.7572 5.64192 21.6689 5.62655 21.6204C5.58957 21.5039 5.55233 21.3506 5.51625 21.1801C5.44245 20.8312 5.35817 20.3361 5.28131 19.7469C5.12806 18.5719 4.99939 16.9848 5.05002 15.3876C5.05235 13.7648 5.51702 12.3647 6.6804 11.5084C7.64873 10.7956 8.96343 10.5633 10.55 10.7315V7.09986C10.55 6.45601 10.7373 5.89863 11.1058 5.49546C11.4747 5.09173 11.9738 4.90183 12.4663 4.91254ZM12.05 7.09986C12.05 6.74371 12.1502 6.57609 12.213 6.50739C12.2753 6.43924 12.3512 6.41039 12.4337 6.41218C12.5213 6.41409 12.6192 6.45198 12.6974 6.5341C12.7696 6.60999 12.85 6.75126 12.85 6.99986V17.5618L14.0962 16.4622C14.893 15.7592 15.5795 15.3738 16.1166 15.2015C16.6319 15.0362 16.9603 15.0799 17.1388 15.1586C17.2531 15.2345 17.3615 15.3591 17.4383 15.5307C15.1875 16.2008 13.4742 18.1349 12.5555 20.7499H6.9593C6.90064 20.4534 6.83273 20.0437 6.76871 19.5529C6.62235 18.4307 6.50128 16.9228 6.54962 15.424L6.55001 15.412V15.3999C6.55001 14.0279 6.93593 13.1828 7.56963 12.7164C8.2264 12.2329 9.35038 12.0033 11.1641 12.3375L12.05 12.5006V7.09986Z",
    fill: color
  }));
};

const _excluded$4p = ["color", "size"];
/**
 * @typedef {Object} NewOrphanMobileProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {NewOrphanMobileProps} props
 * @returns {JSX.Element}
 */

const NewOrphanMobile = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.0526 20.0415C12.7502 20.0415 13.3157 19.4745 13.3157 18.7751C13.3157 18.0757 12.7502 17.5088 12.0526 17.5088C11.355 17.5088 10.7894 18.0757 10.7894 18.7751C10.7894 19.4745 11.355 20.0415 12.0526 20.0415Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1578 5.59546H13.842V4.09546H10.1578V5.59546Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09216 4.00119C5.09216 2.639 6.16302 1.56274 7.52637 1.56274H16.4737C17.8371 1.56274 18.908 2.639 18.908 4.00119V19.8983C19.0434 21.3757 17.7388 22.3743 16.4737 22.3743H7.52637C6.16302 22.3743 5.09216 21.298 5.09216 19.9359V4.00119ZM7.52637 3.06274C6.99499 3.06274 6.59216 3.46388 6.59216 4.00119V19.9359C6.59216 20.4732 6.99499 20.8743 7.52637 20.8743H16.4737C17.0906 20.8743 17.4566 20.4158 17.4125 20.0185L17.408 19.9773V4.00119C17.408 3.46388 17.0051 3.06274 16.4737 3.06274H7.52637Z",
    fill: color
  }));
};

const _excluded$4q = ["color", "size"];
/**
 * @typedef {Object} ExportProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ExportProps} props
 * @returns {JSX.Element}
 */

const Export = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.6V20.5H3.5V3.5H7.5L6 2H2V22H22V18.1L20.5 16.6Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 19L5 13.3L12.7 5.6L9.2 2H22V14.8L18.4 11.2L10.6 19ZM7.1 13.3L10.7 16.9L18.4 9.2L20.5 11.3V3.5H12.8L14.8 5.5L7.1 13.3Z",
    fill: color
  }));
};

const _excluded$4r = ["color", "size"];
/**
 * @typedef {Object} AiProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AiProps} props
 * @returns {JSX.Element}
 */

const Ai = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M16.0659 9.28154C15.2281 9.54696 14.4383 9.91273 13.7095 10.3645C12.3576 11.2027 11.2161 12.337 10.3701 13.676C9.73484 14.6815 9.26614 15.8024 9 17C8.73386 15.8024 8.26516 14.6815 7.62988 13.676C6.78386 12.337 5.6424 11.2027 4.29046 10.3645C3.56174 9.91273 2.77186 9.54696 1.93414 9.28154C1.88278 9.26527 1.83124 9.24937 1.77952 9.23386L1 9L1.77952 8.76614C1.83124 8.75063 1.88278 8.73473 1.93414 8.71846C2.77186 8.45304 3.56174 8.08728 4.29046 7.63548C5.6424 6.7973 6.78386 5.66302 7.62988 4.32401C8.26516 3.31855 8.73386 2.19765 9 1C9.26614 2.19765 9.73484 3.31855 10.3701 4.32401C11.2161 5.66302 12.3576 6.7973 13.7095 7.63548C14.4383 8.08728 15.2281 8.45304 16.0659 8.71846C16.1172 8.73473 16.1688 8.75063 16.2205 8.76614L17 9L16.2205 9.23386C16.1688 9.24937 16.1172 9.26527 16.0659 9.28154Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4162 18.176C21.8926 18.3419 21.3989 18.5705 20.9435 18.8528C20.0985 19.3767 19.3851 20.0856 18.8563 20.9225C18.4593 21.5509 18.1663 22.2515 18 23C17.8337 22.2515 17.5407 21.5509 17.1437 20.9225C16.6149 20.0856 15.9015 19.3767 15.0565 18.8528C14.6011 18.5705 14.1074 18.3419 13.5838 18.176C13.5517 18.1658 13.5195 18.1559 13.4872 18.1462L13 18L13.4872 17.8538C13.5195 17.8441 13.5517 17.8342 13.5838 17.824C14.1074 17.6581 14.6011 17.4295 15.0565 17.1472C15.9015 16.6233 16.6149 15.9144 17.1437 15.0775C17.5407 14.4491 17.8337 13.7485 18 13C18.1663 13.7485 18.4593 14.4491 18.8563 15.0775C19.3851 15.9144 20.0985 16.6233 20.9435 17.1472C21.3989 17.4295 21.8926 17.6581 22.4162 17.824C22.4483 17.8342 22.4805 17.8441 22.5128 17.8538L23 18L22.5128 18.1462C22.5088 18.1474 22.5047 18.1486 22.5007 18.1498C22.4724 18.1583 22.4443 18.1671 22.4162 18.176Z",
    fill: color
  }));
};

const _excluded$4s = ["color", "size"];
/**
 * @typedef {Object} AiStepProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AiStepProps} props
 * @returns {JSX.Element}
 */

const AiStep = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4162 6.17596C21.8926 6.34185 21.3989 6.57045 20.9435 6.85282C20.0985 7.37669 19.3851 8.08561 18.8563 8.92249C18.4593 9.55091 18.1663 10.2515 18 11C17.8337 10.2515 17.5407 9.55091 17.1437 8.92249C16.6149 8.08561 15.9015 7.37669 15.0565 6.85282C14.6011 6.57045 14.1074 6.34185 13.5838 6.17596C13.5517 6.16579 13.5195 6.15586 13.4872 6.14616L13 6L13.4872 5.85384C13.5195 5.84414 13.5517 5.83421 13.5838 5.82404C14.1074 5.65815 14.6011 5.42955 15.0565 5.14718C15.9015 4.62331 16.6149 3.91439 17.1437 3.07751C17.5407 2.44909 17.8337 1.74853 18 1C18.1663 1.74853 18.4593 2.44909 18.8563 3.07751C19.3851 3.91439 20.0985 4.62331 20.9435 5.14718C21.3989 5.42955 21.8926 5.65815 22.4162 5.82404C22.4483 5.83421 22.4805 5.84414 22.5128 5.85384L23 6L22.5128 6.14616C22.4805 6.15586 22.4483 6.16579 22.4162 6.17596ZM18 4.47008C18.4408 5.04625 18.9581 5.56123 19.5379 6C18.9581 6.43877 18.4408 6.95375 18 7.52992C17.5592 6.95375 17.0419 6.43877 16.4621 6C17.0419 5.56123 17.5592 5.04625 18 4.47008Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8086 9.50005C12.8086 11.8 10.9585 13.7 8.71885 13.7C6.38186 13.7 4.62912 11.8 4.62912 9.50005C4.62912 7.20005 6.47923 5.30005 8.71885 5.30005C10.9585 5.30005 12.8086 7.20005 12.8086 9.50005ZM11.348 9.50005C11.348 8.00005 10.1795 6.80005 8.71885 6.80005C7.16086 6.80005 5.99236 8.00005 5.99236 9.50005C5.99236 11 7.25823 12.2 8.71885 12.2C10.1795 12.2 11.348 11 11.348 9.50005Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3319 20.3772C15.4219 19.7904 15.5097 19.2179 15.4377 18.7C15.0482 15.3 10.9585 14.4 8.71885 14.4H8.62148C6.47923 14.4 2.3895 15.3 2 18.7C2 19.4 2.09737 20.2 2.19475 21H3.75274C3.55799 20.2 3.46062 19.4 3.46062 18.9C3.75274 16.4 7.35561 15.9 8.71885 15.9C10.0821 15.9 13.685 16.4 13.9771 18.9C13.9771 19.4 13.8797 20.2 13.685 21H15.243C15.2683 20.7919 15.3002 20.5837 15.3319 20.3772Z",
    fill: color
  }));
};

const _excluded$4t = ["color", "size"];
/**
 * @typedef {Object} AiPositiveCommentRepliesProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AiPositiveCommentRepliesProps} props
 * @returns {JSX.Element}
 */

const AiPositiveCommentReplies = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.3265 8.60867C11.9186 8.24159 12.5604 7.94441 13.241 7.72875C13.2775 7.71718 13.3142 7.70585 13.3509 7.69475L14 7.5L13.3666 7.30999C13.3246 7.29738 13.2827 7.28447 13.241 7.27125C12.5604 7.05559 11.9186 6.75841 11.3265 6.39133C10.2281 5.71031 9.30062 4.78871 8.61322 3.70076C8.09706 2.88382 7.71624 1.97309 7.5 1C7.28376 1.97309 6.90294 2.88382 6.38678 3.70076C5.69938 4.78871 4.77195 5.71031 3.6735 6.39133C3.08141 6.75841 2.43964 7.05559 1.75899 7.27125C1.71725 7.28447 1.67538 7.29738 1.63336 7.30999L1 7.5L1.63336 7.69001C1.67538 7.70261 1.71726 7.71553 1.75899 7.72875C2.43964 7.94441 3.08141 8.24159 3.6735 8.60867C4.77195 9.28969 5.69938 10.2113 6.38678 11.2992C6.90294 12.1162 7.28376 13.0269 7.5 14C7.71624 13.0269 8.09706 12.1162 8.61322 11.2992C9.30062 10.2113 10.2281 9.28969 11.3265 8.60867Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9756 11.8051C17.6125 11.1967 18.5041 10.7708 19.5867 10.7708C21.1152 10.7708 22.2615 11.4401 22.8984 12.5961C23.5989 13.9348 23.2168 15.6993 22.0705 16.9771C20.9241 18.2549 17.8672 21.4189 17.7399 21.5406L17.0393 22.2708L16.3388 21.6014C16.2114 21.4797 13.0908 18.3766 11.9445 17.0379C10.7345 15.6993 10.416 14.0565 11.1166 12.657C11.6897 11.4401 12.8998 10.7708 14.4282 10.7708C15.4472 10.7708 16.3388 11.1967 16.9756 11.8051Z",
    fill: color
  }));
};

const _excluded$4u = ["color", "size"];
/**
 * @typedef {Object} AiInstantAnswersProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AiInstantAnswersProps} props
 * @returns {JSX.Element}
 */

const AiInstantAnswers = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.3265 8.60867C11.9186 8.24159 12.5604 7.94441 13.241 7.72875C13.2775 7.71718 13.3142 7.70585 13.3509 7.69475L14 7.5L13.3666 7.30999C13.3246 7.29738 13.2827 7.28447 13.241 7.27125C12.5604 7.05559 11.9186 6.75841 11.3265 6.39133C10.2281 5.71031 9.30062 4.78871 8.61322 3.70076C8.09706 2.88382 7.71624 1.97309 7.5 1C7.28376 1.97309 6.90294 2.88382 6.38678 3.70076C5.69938 4.78871 4.77195 5.71031 3.6735 6.39133C3.08141 6.75841 2.43964 7.05559 1.75899 7.27125C1.71725 7.28447 1.67538 7.29738 1.63336 7.30999L1 7.5L1.63336 7.69001C1.67538 7.70261 1.71726 7.71553 1.75899 7.72875C2.43964 7.94441 3.08141 8.24159 3.6735 8.60867C4.77195 9.28969 5.69938 10.2113 6.38678 11.2992C6.90294 12.1162 7.28376 13.0269 7.5 14C7.71624 13.0269 8.09706 12.1162 8.61322 11.2992C9.30062 10.2113 10.2281 9.28969 11.3265 8.60867Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.6386C10 12.468 12.9884 10 16.5 10C20.0116 10 23 12.468 23 15.6386C23 18.8092 20.0116 21.2772 16.5 21.2772C15.664 21.2772 14.6567 21.1144 13.8299 20.7768L10.6521 22L11.5138 19.2185C10.9468 18.6064 10 17.3403 10 15.6386Z",
    fill: color
  }));
};

const _excluded$4v = ["color", "size"];
/**
 * @typedef {Object} AiIntentionProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AiIntentionProps} props
 * @returns {JSX.Element}
 */

const AiIntention = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9435 6.85282C21.3989 6.57045 21.8926 6.34185 22.4162 6.17596C22.4483 6.16579 22.4805 6.15586 22.5128 6.14616L23 6L22.5128 5.85384C22.4805 5.84414 22.4483 5.83421 22.4162 5.82404C21.8926 5.65815 21.3989 5.42955 20.9435 5.14718C20.0985 4.62332 19.3851 3.91439 18.8563 3.07751C18.4593 2.44909 18.1663 1.74853 18 1C17.8337 1.74853 17.5407 2.44909 17.1437 3.07751C16.6149 3.91439 15.9015 4.62332 15.0565 5.14718C14.6011 5.42955 14.1074 5.65815 13.5838 5.82404C13.5517 5.83421 13.5195 5.84414 13.4872 5.85384L13 6L13.4872 6.14616C13.4953 6.14858 13.5034 6.15102 13.5114 6.15348C13.5356 6.16084 13.5598 6.16833 13.5838 6.17596C14.1074 6.34185 14.6011 6.57045 15.0565 6.85282C15.9015 7.37669 16.6149 8.08561 17.1437 8.92249C17.5407 9.55091 17.8337 10.2515 18 11C18.1663 10.2515 18.4593 9.55091 18.8563 8.92249C19.3851 8.08561 20.0985 7.37669 20.9435 6.85282ZM19.5379 6C18.9581 5.56123 18.4408 5.04625 18 4.47008C17.5592 5.04625 17.0419 5.56123 16.4621 6C17.0419 6.43877 17.5592 6.95375 18 7.52992C18.4408 6.95375 18.9581 6.43877 19.5379 6Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5604 14.597C11.8792 14.3993 12.2248 14.2393 12.5913 14.1232C12.6138 14.1161 12.6363 14.1091 12.659 14.1023L13 14L12.659 13.8977C12.6363 13.8909 12.6138 13.8839 12.5913 13.8768C12.2248 13.7607 11.8792 13.6007 11.5604 13.403C10.969 13.0363 10.4696 12.5401 10.0994 11.9543C9.82149 11.5144 9.61644 11.024 9.5 10.5C9.38356 11.024 9.17851 11.5144 8.90057 11.9543C8.53044 12.5401 8.03105 13.0363 7.43958 13.403C7.12076 13.6007 6.77519 13.7607 6.40869 13.8768C6.38621 13.8839 6.36367 13.8909 6.34104 13.8977L6 14L6.34104 14.1023C6.36367 14.1091 6.38621 14.1161 6.40869 14.1232C6.77519 14.2393 7.12076 14.3993 7.43958 14.597C8.03105 14.9637 8.53044 15.4599 8.90057 16.0457C9.17851 16.4856 9.38356 16.976 9.5 17.5C9.61644 16.976 9.82149 16.4856 10.0994 16.0457C10.4696 15.4599 10.969 14.9637 11.5604 14.597Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 22L2.42903 17.6091C1.85742 16.5591 1.57161 15.5091 1.57161 14.0773C1.57161 9.97275 5.09654 6.72729 9.47889 6.72729C13.8612 6.72729 17.2909 9.97275 17.2909 14.0773C17.2909 18.2773 13.8612 21.5228 9.47889 21.4273C7.76406 21.4273 6.62084 20.95 5.76342 20.5682L1 22ZM4.05527 17.4592L3.31352 19.7383L5.86492 18.9714L6.37362 19.1979C7.16425 19.55 8.07804 19.9273 9.47889 19.9273H9.49523L9.51156 19.9277C13.1068 20.006 15.7909 17.3831 15.7909 14.0773C15.7909 10.8836 13.1177 8.22729 9.47889 8.22729C5.81557 8.22729 3.07161 10.9065 3.07161 14.0773C3.07161 15.2684 3.29929 16.0705 3.74646 16.8919L4.05527 17.4592Z",
    fill: color
  }));
};

const _excluded$4w = ["color", "size"];
/**
 * @typedef {Object} AiFilledProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AiFilledProps} props
 * @returns {JSX.Element}
 */

const AiFilled = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M8.38068 9.39744L9.32639 12.6559H7.43498L8.38068 9.39744Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 2.79086 2.79086 1 5 1H19C21.2091 1 23 2.79086 23 5V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V5ZM11.8561 16.1999L9.20003 7.63989H7.58492L4.95398 16.1999H6.41888L7.06688 13.9679H9.71849L10.3665 16.1999H11.8561ZM13 16.1999V14.8639H14.896V8.97589H13V7.63989H18.2V8.97589H16.304V14.8639H18.2V16.1999H13Z",
    fill: color
  }));
};

const _excluded$4x = ["color", "size"];
/**
 * @typedef {Object} BigcommerceProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BigcommerceProps} props
 * @returns {JSX.Element}
 */

const Bigcommerce = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.5377 13.3858H15.0606C15.7781 13.3858 16.2325 12.9909 16.2325 12.3539C16.2325 11.7557 15.7781 11.322 15.0606 11.322H12.5377C12.454 11.322 12.3824 11.3939 12.3824 11.4658V13.2366C12.3943 13.3204 12.4543 13.3805 12.5377 13.3805V13.3858ZM12.5377 17.4659H15.144C15.9453 17.4659 16.4234 17.0594 16.4234 16.3411C16.4234 15.7157 15.969 15.2163 15.144 15.2163H12.5377C12.454 15.2163 12.3824 15.2882 12.3824 15.3602V17.3105C12.3943 17.4062 12.4543 17.4659 12.5377 17.4659ZM21.7681 2.0436L14.3071 9.48582H15.5268C17.4281 9.48582 18.5519 10.6822 18.5519 11.9865C18.5519 13.0184 17.8581 13.7688 17.1143 14.1041C16.9946 14.1519 16.9946 14.3229 17.1262 14.3674C17.9872 14.7019 18.5969 15.5994 18.5969 16.6525C18.5969 18.136 17.6043 19.3205 15.6793 19.3205H10.3971C10.3133 19.3205 10.2418 19.2486 10.2418 19.1766V13.5415L2.05134 21.7007C1.94384 21.8083 2.0154 22 2.17103 22H21.8638C21.9356 22 21.995 21.9375 21.995 21.8687V2.15148C22.031 2.02015 21.8638 1.94823 21.7678 2.04392L21.7681 2.0436Z",
    fill: "#34313F"
  }));
};

const _excluded$4y = ["color", "size"];
/**
 * @typedef {Object} WoocommerceProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {WoocommerceProps} props
 * @returns {JSX.Element}
 */

const Woocommerce = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21.087 5.5H2.91304C1.85657 5.5 1 6.33154 1 7.35714V14.7857C1 15.8113 1.85657 16.6429 2.91304 16.6429H12L15.8261 18.5L14.8696 16.6429H21.087C22.1434 16.6429 23 15.8113 23 14.7857V7.35714C23 6.33154 22.1434 5.5 21.087 5.5Z",
    fill: "#A64A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.864 9.21429C19.8837 9.21429 19.9272 9.21661 19.9965 9.23193C20.1601 9.26768 20.2639 9.32386 20.3887 9.55043C20.537 9.80996 20.6087 10.1461 20.6087 10.5788C20.6087 11.2279 20.4571 11.8041 20.1433 12.344C19.8057 12.9286 19.5589 12.9286 19.4403 12.9286C19.4207 12.9286 19.3772 12.9262 19.3078 12.9109C19.1443 12.8752 19.0405 12.819 18.9209 12.6017C18.7712 12.3352 18.6957 11.9828 18.6957 11.5557C18.6957 10.9061 18.8458 10.3346 19.1562 9.80764C19.5044 9.21429 19.7564 9.21429 19.864 9.21429ZM19.864 7.82143C19.0653 7.82143 18.4168 8.25368 17.9094 9.11818C17.477 9.85268 17.2609 10.6652 17.2609 11.5557C17.2609 12.2215 17.3938 12.7916 17.6602 13.267C17.9596 13.8116 18.4006 14.1399 18.9912 14.2699C19.149 14.3042 19.2987 14.3214 19.4403 14.3214C20.2471 14.3214 20.8957 13.8892 21.395 13.0247C21.8273 12.2814 22.0435 11.4689 22.0435 10.5788C22.0435 9.90468 21.9105 9.34289 21.6441 8.87582C21.3447 8.33121 20.9038 8.00296 20.3131 7.87296C20.1553 7.83861 20.0056 7.82143 19.864 7.82143ZM14.1249 9.21429C14.1445 9.21429 14.188 9.21661 14.2531 9.231C14.4123 9.26629 14.5262 9.32711 14.6496 9.55089C14.7978 9.80996 14.8696 10.1461 14.8696 10.5788C14.8696 11.2279 14.718 11.8041 14.4042 12.344C14.0666 12.9286 13.8198 12.9286 13.7012 12.9286C13.6816 12.9286 13.638 12.9262 13.5687 12.9109C13.4051 12.8752 13.3013 12.819 13.1818 12.6017C13.0321 12.3352 12.9565 11.9828 12.9565 11.5557C12.9565 10.9061 13.1067 10.3346 13.4171 9.80764C13.7653 9.21429 14.0173 9.21429 14.1249 9.21429ZM14.1249 7.82143C13.3262 7.82143 12.6777 8.25368 12.1703 9.11818C11.7379 9.85268 11.5217 10.6652 11.5217 11.5557C11.5217 12.2215 11.6547 12.7916 11.9211 13.267C12.2205 13.8116 12.6614 14.1399 13.2521 14.2699C13.4099 14.3042 13.5596 14.3214 13.7012 14.3214C14.508 14.3214 15.1565 13.8892 15.6558 13.0247C16.0882 12.2814 16.3043 11.4689 16.3043 10.5788C16.3043 9.90468 16.1714 9.34289 15.905 8.87582C15.6056 8.33121 15.1565 8.00296 14.574 7.87296C14.4162 7.83861 14.2665 7.82143 14.1249 7.82143ZM9.36957 15.25C9.16822 15.25 8.97165 15.1674 8.83248 15.0155C7.78222 13.8646 7.13704 12.3529 6.75683 11.142C6.2097 12.2656 5.47126 13.7025 4.72374 14.9115C4.57596 15.1506 4.29617 15.2792 4.01065 15.2435C3.72561 15.205 3.49174 15.0053 3.41665 14.736C2.35874 10.9628 1.97852 8.25925 1.96322 8.14596C1.91061 7.76525 2.18609 7.41471 2.57826 7.36318C2.9757 7.31304 3.332 7.57907 3.38509 7.96025C3.38843 7.983 3.65817 9.89957 4.35739 12.6955C5.41817 10.7418 6.30774 8.73282 6.31922 8.70729C6.44691 8.41943 6.75874 8.24811 7.07487 8.29175C7.39435 8.33354 7.64591 8.57729 7.68944 8.88743C7.69278 8.91157 7.94865 10.6633 8.76313 12.3468C9.107 9.01975 10.1372 7.31443 10.1893 7.22993C10.3935 6.89982 10.835 6.79304 11.1736 6.99082C11.5136 7.18861 11.6236 7.61668 11.4199 7.94632C11.4079 7.96675 10.087 10.1962 10.087 14.5536C10.087 14.8428 9.90235 15.1024 9.624 15.2045C9.54078 15.2351 9.45517 15.25 9.36957 15.25Z",
    fill: "white"
  }));
};

const _excluded$4z = ["color", "size"];
/**
 * @typedef {Object} AmazonProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AmazonProps} props
 * @returns {JSX.Element}
 */

const Amazon = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.8001 19.5C17.7001 21.05 14.5501 22 12.0001 22C8.35005 22 5.10005 20.55 2.60005 18.3C2.40005 18.1 2.60005 17.9 2.80005 18C5.50005 19.55 8.55005 20.45 11.9501 20.45C14.2501 20.45 17.1501 19.95 19.5001 18.95C19.8501 18.85 20.1501 19.25 19.8001 19.5ZM20.5501 18.45C20.3001 18.1 18.8001 18.3 18.1501 18.35C17.9501 18.35 17.9001 18.2 18.1001 18.05C19.2501 17.2 21.2001 17.45 21.4001 17.75C21.6001 18.05 21.3501 20 20.2501 20.9C20.1001 21.05 19.9001 20.95 20.0001 20.8C20.2501 20.2 20.8001 18.8 20.5501 18.45Z",
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4501 14.9C17.9501 14.25 17.4501 13.7 17.4501 12.45V8.3C17.4501 6.55 17.4501 5 16.2001 3.8C15.2001 2.85 13.5501 2.5 12.2501 2.5C9.50005 2.5 7.10005 3.6 6.50005 6.7C6.45005 7.05 6.70005 7.2 6.90005 7.25L9.45005 7.55C9.70005 7.55 9.85005 7.3 9.90005 7.05C10.1001 6 10.9501 5.5 11.9501 5.5C12.5001 5.5 13.5501 5.8 13.5501 7V8.5C11.9501 8.5 10.2501 8.5 8.85005 9.1C7.20005 9.8 6.05005 11.25 6.05005 13.4C6.05005 16.15 7.75005 17.5 9.95005 17.5C11.8001 17.5 12.9001 17.05 14.3501 15.6C14.8001 16.3 15.0001 16.7 15.8501 17.45C16.0501 17.55 16.3001 17.55 16.4501 17.4C16.9501 16.95 17.9001 16.1 18.4501 15.65C18.7001 15.45 18.6501 15.15 18.4501 14.9ZM13.5001 11.05C13.5001 12.05 13.4501 14.5 11.0001 14.5C9.50005 14.5 9.50005 13 9.50005 13C9.50005 10.75 11.6001 10.5 13.5001 10.5V11.05Z",
    fill: "#37474F"
  }));
};

const _excluded$4A = ["color", "size"];
/**
 * @typedef {Object} HotmartProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {HotmartProps} props
 * @returns {JSX.Element}
 */

const Hotmart = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.0359 22.4467H11.9641C11.9539 22.4467 11.9436 22.4467 11.9334 22.4467C7.82194 22.4159 4.5 19.0325 4.5 14.8698C4.5 14.8493 4.5 14.8288 4.5 14.8083C4.51025 14.7057 4.51025 14.6032 4.51025 14.5007C4.5205 14.4187 4.5205 14.3366 4.53076 14.2546C4.55126 14.0598 4.58202 13.8035 4.57177 13.8035C4.57177 13.8035 4.57177 13.8035 4.57177 13.8137C4.85885 11.0455 6.35578 8.08236 8.00649 6.33937C8.01674 6.32912 8.027 6.31886 8.03725 6.31886C8.06801 6.31886 8.09877 6.34962 8.07826 6.39064C7.88346 6.83151 7.46309 8.09262 8.03725 8.13363C8.0475 8.13363 8.05776 8.13363 8.06801 8.13363C8.24231 8.13363 8.34484 8.01059 8.44737 7.78503C9.13431 6.39064 9.76999 2.57655 12.9792 1.51025C12.9894 1.5 12.9997 1.5 13.0099 1.5C13.0509 1.5 13.0817 1.53076 13.0407 1.59228C12.4563 2.5458 12.1179 4.08373 12.9894 5.51914C13.3483 6.10355 13.7071 6.32912 14.0044 6.32912C14.1377 6.32912 14.2608 6.27785 14.353 6.19583C14.7221 5.86774 14.6299 4.91422 14.4658 4.60663C14.4453 4.56562 14.4761 4.53486 14.5068 4.53486C14.5273 4.53486 14.5376 4.53486 14.5478 4.54511C16.8753 6.13431 15.7782 8.43096 16.8342 8.50273C16.8548 8.50273 16.8753 8.50273 16.8855 8.50273C17.4392 8.50273 17.4084 7.84655 17.3059 7.47745C17.2956 7.43643 17.3161 7.40567 17.3469 7.40567C17.3674 7.40567 17.3879 7.41593 17.4084 7.44668C18.8438 9.76384 19.4897 12.5629 19.5 14.4494V14.5314C19.5 14.6442 19.5 14.757 19.4897 14.8698C19.4897 14.8903 19.4897 14.9108 19.4897 14.9313C19.459 19.0837 16.1268 22.4364 12.0359 22.4467ZM11.9949 11.353C10.0878 11.353 8.53964 12.9115 8.51914 14.839C8.50888 16.7871 10.0468 18.3763 11.9744 18.3865C11.9846 18.3865 11.9846 18.3865 11.9949 18.3865C13.9019 18.3865 15.4604 16.8281 15.4706 14.9005C15.4911 12.9627 13.9429 11.3735 12.0256 11.353C12.0154 11.353 12.0051 11.353 11.9949 11.353Z",
    fill: "#F03C21"
  }));
};

const _excluded$4B = ["color", "size"];
/**
 * @typedef {Object} CreatorProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CreatorProps} props
 * @returns {JSX.Element}
 */

const Creator = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.2041 7.05769C14.551 7.05769 16.4898 8.97596 16.4898 11.2981C16.4898 12.9135 15.5714 14.3269 14.1429 15.0337V17.1538H10.1633V15.0337C8.83673 14.3269 7.81633 12.9135 7.81633 11.2981C7.91837 8.97596 9.7551 7.05769 12.2041 7.05769ZM12.2041 5.54327C9.04082 5.54327 6.38776 8.16827 6.38776 11.2981C6.38776 13.1154 7.20408 14.8317 8.73469 15.8413V17.1538V18.6683H10.1633H14.1429H15.6735V17.1538V15.8413C17.102 14.7308 18.0204 13.1154 18.0204 11.2981C17.9184 8.16827 15.3673 5.54327 12.2041 5.54327ZM15.5714 19.9856H8.63265V21.5H15.5714V19.9856ZM12.7143 1H11.1837V4.02885H12.7143V1ZM5.06122 10.0865H2V11.601H5.06122V10.0865ZM22 10.0865H18.9388V11.601H22V10.0865ZM19.551 4.43269L18.4286 3.32212L16.2857 5.44231L17.4082 6.55289L19.551 4.43269ZM7.61224 5.44231L5.46939 3.32212L4.34694 4.43269L6.4898 6.55289L7.61224 5.44231Z",
    fill: color
  }));
};

const _excluded$4C = ["color", "size"];
/**
 * @typedef {Object} InstagramDmListProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {InstagramDmListProps} props
 * @returns {JSX.Element}
 */

const InstagramDmList = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M15.8085 10.3885C16.3434 10.2308 16.6581 9.69933 16.5114 9.20136C16.3646 8.7034 15.812 8.42751 15.2771 8.58515C14.7422 8.74279 14.4275 9.27427 14.5742 9.77223C14.721 10.2702 15.2736 10.5461 15.8085 10.3885Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14342 11.83C9.14342 10.4895 10.3102 9.40274 11.7502 9.40274C13.1896 9.40274 14.3569 10.4895 14.3569 11.83C14.3569 13.1705 13.1896 14.2573 11.7502 14.2573C10.3108 14.2573 9.14342 13.1705 9.14342 11.83ZM10.7847 12.1821C10.9415 12.7146 11.5329 13.0101 12.1051 12.8413C12.6772 12.6725 13.0141 12.1039 12.8569 11.571C12.7001 11.0385 12.1087 10.743 11.5365 10.9118C10.9643 11.0806 10.6275 11.6492 10.7847 12.1821Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9898 22.4887L13.1174 19.3373C13.1796 19.327 13.2419 19.3162 13.3043 19.3049C18.4979 18.3634 22.1243 14.3795 21.4041 10.4067C20.8798 7.51431 18.1962 5.42517 14.7711 4.86607L14.1479 6.05496C16.8155 6.50956 18.8999 8.14663 19.3096 10.4067C19.8643 13.4664 17.144 16.5344 13.1975 17.36L13.2949 14.9557L9.0418 19.2784V19.3534L12.9898 22.4887Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4701 2.7097L11.8682 2.31665L13.9217 5.11282L12.2177 8.17131L10.8633 7.6033L12.0869 5.94262C11.6896 5.96488 11.2864 6.01211 10.8801 6.08577C6.79153 6.82694 3.9367 9.96314 4.50365 13.0907C4.8818 15.1767 6.68674 16.7321 9.06014 17.3166L9.00657 19.2784L8.96697 19.3106C5.6679 18.6898 3.10724 16.6342 2.59639 13.8161C1.87621 9.84325 5.50264 5.8594 10.6962 4.91791C11.2514 4.81727 11.802 4.75547 12.3436 4.73021L10.4701 2.7097Z",
    fill: color
  }));
};

const _excluded$4D = ["color", "size"];
/**
 * @typedef {Object} RealEstateProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {RealEstateProps} props
 * @returns {JSX.Element}
 */

const RealEstate = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22.1 12H20L11.9 4.1L4.00002 12H1.90002L11.9 2L22.1 12ZM17.8 20.6H12.7V12.5H11.2V20.6H6.00005V12.5H4.50005V22.1H19.3V12.5H17.8V20.6ZM14.4 12H16.6L11.9 7.4L7.50005 12H9.60005L11.9 9.5L14.4 12Z",
    fill: color
  }));
};

const _excluded$4E = ["color", "size"];
/**
 * @typedef {Object} BasicsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BasicsProps} props
 * @returns {JSX.Element}
 */

const Basics = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1365 1.95117L17.4088 11.4773H6.8642L12.1365 1.95117ZM12.1365 5.04881L9.4088 9.97726H14.8642L12.1365 5.04881Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 17.5C12.75 15.1528 14.6528 13.25 17 13.25C19.3472 13.25 21.25 15.1528 21.25 17.5C21.25 19.8472 19.3472 21.75 17 21.75C14.6528 21.75 12.75 19.8472 12.75 17.5ZM17 14.75C15.4812 14.75 14.25 15.9812 14.25 17.5C14.25 19.0188 15.4812 20.25 17 20.25C18.5188 20.25 19.75 19.0188 19.75 17.5C19.75 15.9812 18.5188 14.75 17 14.75Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 13.25H11.25V21.75H2.75V13.25ZM4.25 14.75V20.25H9.75V14.75H4.25Z",
    fill: color
  }));
};

const _excluded$4F = ["color", "size"];
/**
 * @typedef {Object} FitnessProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FitnessProps} props
 * @returns {JSX.Element}
 */

const Fitness = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M18.8372 6.64417V3H14.2791V11.0613H9.62791V3H5.16279V6.64417H2V17.4663H5.16279V21.1104H9.72093V12.7178H14.3721V21H18.9302V17.3558H22.093V6.64417H18.8372ZM5.16279 15.8098H3.39535V8.30061H5.16279V15.8098ZM8.32558 19.3436H6.55814V17.3558V6.64417V4.65644H8.32558V19.3436ZM17.4419 6.64417V17.4663V19.454H15.6744V4.65644H17.4419V6.64417ZM20.6047 15.8098H18.8372V8.30061H20.6047V15.8098Z",
    fill: color
  }));
};

const _excluded$4G = ["color", "size"];
/**
 * @typedef {Object} HotelProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {HotelProps} props
 * @returns {JSX.Element}
 */

const Hotel = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 2V7.07463H3.57635V22H20.5222V7.07463H22.0985V2H2ZM18.9458 20.5075H5.05419V7.07463H19.0443V20.5075H18.9458ZM20.5222 5.58209H3.47783V3.49254H20.5222V5.58209ZM10.9655 8.56716H6.63054V12.9453H10.9655V8.56716ZM9.48768 11.4527H8.10837V10.0597H9.48768V11.4527ZM17.3695 8.56716H13.0345V12.9453H17.3695V8.56716ZM15.8916 11.4527H14.5123V10.0597H15.8916V11.4527ZM10.9655 14.6368H6.63054V19.0149H10.9655V14.6368ZM9.48768 17.5224H8.10837V16.1294H9.48768V17.5224ZM17.3695 14.6368H13.0345V19.0149H17.3695V14.6368ZM15.8916 17.5224H14.5123V16.1294H15.8916V17.5224Z",
    fill: color
  }));
};

const _excluded$4H = ["color", "size"];
/**
 * @typedef {Object} OrganizationProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {OrganizationProps} props
 * @returns {JSX.Element}
 */

const Organization = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.8431 16.2V11.3H12.7843V7.8H14.9412V2H9.15686V7.8H11.3137V11.2H4.15686V16.1H2V22H7.68627V16.2H5.62745V12.8H11.3137V16.2H9.15686V22H14.8431V16.2H12.7843V12.8H18.4706V16.2H16.3137V22H22V16.2H19.8431ZM10.6275 3.5H13.3725V6.3H10.6275V3.5ZM6.21569 20.5H3.47059V17.7H6.21569V20.5ZM13.3725 20.5H10.6275V17.7H13.3725V20.5ZM20.5294 20.5H17.7843V17.7H20.5294V20.5Z",
    fill: color
  }));
};

const _excluded$4I = ["color", "size"];
/**
 * @typedef {Object} ProfessionalConsultingProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ProfessionalConsultingProps} props
 * @returns {JSX.Element}
 */

const ProfessionalConsulting = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.27053 15.5155C9.39614 15.5155 11.2029 13.5876 11.2029 11.3196C11.2029 9.05155 9.39614 7.12371 7.27053 7.12371C5.14493 7.12371 3.33816 9.05155 3.33816 11.3196C3.33816 13.701 5.14493 15.5155 7.27053 15.5155ZM7.27053 8.82474C8.54589 8.82474 9.6087 9.95876 9.6087 11.3196C9.6087 12.6804 8.54589 13.8144 7.27053 13.8144C5.99517 13.8144 4.93237 12.6804 4.93237 11.3196C4.93237 9.95876 5.99517 8.82474 7.27053 8.82474ZM13.6473 20.2784C13.7536 21.0722 13.5411 21.9794 13.3285 22.8866H11.7343C11.9469 21.9794 12.1594 21.0722 12.0531 20.5052C11.8406 18.2371 8.54589 17.7835 7.37681 17.7835C7.37681 17.7835 7.37681 17.7835 7.27053 17.7835C5.99517 17.7835 2.80676 18.2371 2.5942 20.6186C2.5942 21.1856 2.70048 22.2062 2.91304 23H1.31884C1.10628 21.9794 1 20.9588 1 20.2784C1.42512 16.8763 5.25121 15.9691 7.37681 15.9691C9.39614 15.9691 13.3285 16.8763 13.6473 20.2784ZM17.686 1C14.8164 1 12.372 3.38144 12.372 6.2165C12.372 7.57732 12.9034 8.82474 13.7536 9.73196L12.372 13.2474L17.8986 11.6598C21.2995 10.6392 23 8.82474 23 6.10309C22.8937 3.38144 20.5556 1 17.686 1ZM17.4734 10.0722L15.1353 10.7526L15.7729 9.27835L15.2415 8.82474C14.3913 8.14433 13.9662 7.23711 13.9662 6.2165C13.9662 4.28866 15.6667 2.70103 17.686 2.70103C19.7053 2.70103 21.4058 4.28866 21.4058 6.2165C21.2995 7.35052 20.8744 9.05155 17.4734 10.0722Z",
    fill: color
  }));
};

const _excluded$4J = ["color", "size"];
/**
 * @typedef {Object} MessengerListProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MessengerListProps} props
 * @returns {JSX.Element}
 */

const MessengerList = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.52948 13.2864L10.8727 12.4106L13.4438 14.093L16.7055 10.3554L13.2027 11.4588L10.5688 9.90433L7.52948 13.2864Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.989 22.4892L13.1166 19.3376C13.1788 19.3273 13.2411 19.3165 13.3034 19.3052C18.4974 18.3636 22.124 14.3795 21.4038 10.4064C20.8795 7.51389 18.1957 5.42462 14.7704 4.86549L14.1471 6.05445C16.8149 6.50908 18.8995 8.14625 19.3092 10.4064C19.8639 13.4663 17.1434 16.5345 13.1967 17.3602L13.294 14.9558L9.0407 19.2787V19.3537L12.989 22.4892Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.469 2.70899L11.8672 2.31592L13.921 5.11226L12.2168 8.17093L10.8623 7.60289L12.086 5.94211C11.6887 5.96437 11.2855 6.0116 10.8791 6.08527C6.79028 6.82647 3.93527 9.96287 4.50225 13.0906C4.88043 15.1768 6.68549 16.7322 9.05904 17.3168L9.00547 19.2787L8.96586 19.3109C5.66658 18.69 3.10575 16.6343 2.59487 13.8161C1.87464 9.84298 5.50131 5.85888 10.6953 4.91734C11.2505 4.81669 11.8011 4.75489 12.3427 4.72962L10.469 2.70899Z",
    fill: color
  }));
};

const _excluded$4K = ["color", "size"];
/**
 * @typedef {Object} IntegromatProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {IntegromatProps} props
 * @returns {JSX.Element}
 */

const Integromat = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22.4714 19.3948H18.6414C18.3489 19.3948 18.1128 19.1571 18.1128 18.8662V4.72526C18.1128 4.4328 18.3505 4.19665 18.6414 4.19665H22.4714C22.7638 4.19665 23 4.4328 23 4.72526V18.8662C23 19.1571 22.7638 19.3948 22.4714 19.3948ZM5.42312 19.2118L11.7726 6.57694C11.904 6.31576 11.7992 5.99829 11.538 5.86692L8.11619 4.14661C7.85501 4.01524 7.53754 4.12002 7.40617 4.38119L1.05666 17.0161C0.925291 17.2773 1.03007 17.5947 1.29125 17.7261L4.7131 19.4464C4.97428 19.5762 5.29175 19.4714 5.42312 19.2118ZM14.8207 19.1618L17.5372 5.38992C17.5935 5.10372 17.409 4.82691 17.1228 4.76905L13.3678 4.01055C13.0816 3.95268 12.8017 4.13879 12.7438 4.42498V4.42655L10.0273 18.1984C9.97099 18.4846 10.1555 18.7614 10.4417 18.8193L14.1967 19.5778C14.4829 19.6357 14.7628 19.4496 14.8207 19.1634V19.1618Z",
    fill: "#6C00CB"
  }));
};

const _excluded$4L = ["color", "size"];
/**
 * @typedef {Object} HubspotProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {HubspotProps} props
 * @returns {JSX.Element}
 */

const Hubspot = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21.2908 11.5661C20.7952 10.7204 20.0882 10.0179 19.2389 9.52802C18.5907 9.15118 17.9202 8.91182 17.1634 8.8086V6.09821C17.5304 5.94605 17.8437 5.68756 18.0621 5.35566C18.2806 5.02376 18.3945 4.63402 18.3891 4.23671C18.3905 3.96843 18.3388 3.70238 18.237 3.45412C18.1351 3.20586 17.9856 2.98029 17.7961 2.78987C17.607 2.59989 17.3818 2.44862 17.134 2.34585C16.8862 2.24308 16.6206 2.18969 16.3523 2.18969C15.8091 2.18969 15.2877 2.40502 14.9028 2.78853C14.518 3.17205 14.3008 3.69259 14.2991 4.23627C14.2991 5.0678 14.7404 5.77743 15.499 6.09821V8.79303C14.8708 8.88379 14.2608 9.07555 13.6931 9.35984L6.43797 3.86655C6.48869 3.67479 6.53318 3.47636 6.53318 3.26726C6.53273 2.01484 5.5179 1 4.26548 1C3.01306 1 2 2.01484 2 3.26726C2 4.51968 3.01484 5.53451 4.26726 5.53451C4.69481 5.53451 5.09034 5.40905 5.43158 5.2035L5.90675 5.56343L12.4149 10.2559C12.0705 10.5718 11.7497 10.9313 11.4935 11.3352C10.9743 12.1583 10.6566 13.0628 10.6566 14.0505V14.2543C10.6588 14.9239 10.7794 15.5881 11.013 16.2163C11.2101 16.7525 11.4984 17.2414 11.8565 17.6828L9.69426 19.8499C9.05448 19.6123 8.33684 19.7703 7.85278 20.2539C7.52355 20.5813 7.33846 21.0276 7.34024 21.493C7.34202 21.9579 7.52355 22.401 7.85456 22.732C8.18557 23.063 8.62826 23.2463 9.09363 23.2463C9.55901 23.2463 10.0048 23.063 10.3327 22.732C10.6602 22.401 10.847 21.9583 10.8452 21.493C10.8452 21.3146 10.8177 21.137 10.7638 20.9671L12.9973 18.7336C13.3029 18.9459 13.6335 19.1238 13.9899 19.2769C14.7222 19.5981 15.5132 19.7645 16.3132 19.7658H16.4658C17.4028 19.7658 18.2868 19.5451 19.1165 19.0953C19.9694 18.638 20.6862 17.963 21.1938 17.1386C21.7148 16.3071 22 15.3857 22 14.3722V14.3215C22 13.3253 21.7691 12.407 21.2873 11.5653L21.2908 11.5661ZM18.5635 16.2533C17.9576 16.9269 17.2604 17.3428 16.4729 17.3428H16.3234C15.8736 17.3428 15.4323 17.2187 15.0029 16.9914C14.5322 16.7467 14.1331 16.3832 13.8453 15.9374C13.5329 15.496 13.3634 15.0142 13.3634 14.5034V14.3508C13.3634 13.8485 13.46 13.3716 13.7029 12.9218C13.9627 12.4128 14.3138 12.048 14.7805 11.7441C15.2472 11.4402 15.7277 11.2943 16.274 11.2943H16.3252C16.8173 11.2943 17.2875 11.3913 17.7284 11.6169C18.1756 11.8518 18.5551 12.197 18.8314 12.6197C19.105 13.0437 19.2745 13.5264 19.3252 14.0283L19.3372 14.3455C19.3372 15.036 19.0725 15.6758 18.5448 16.2564L18.5635 16.2533Z",
    fill: "#F8761F"
  }));
};

const _excluded$4M = ["color", "size"];
/**
 * @typedef {Object} KlaviyoProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {KlaviyoProps} props
 * @returns {JSX.Element}
 */

const Klaviyo = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M1.44931 11.0643L11.3094 4.53391C11.739 4.28687 12.2653 4.28687 12.6949 4.53391L22.555 11.0643C22.9417 11.2577 23.1135 11.7195 22.9202 12.1169C22.845 12.278 22.7161 12.4069 22.555 12.4821L21.2339 13.3521C18.0009 8.25023 11.2557 6.73578 6.15379 9.95802C4.7897 10.828 3.6297 11.9773 2.75969 13.3521L1.42783 12.4821C1.04116 12.278 0.890791 11.8054 1.08413 11.4188C1.17005 11.2684 1.29894 11.1395 1.44931 11.0643ZM11.986 10.9891C9.16121 10.9999 6.52972 12.4499 5.026 14.8451L7.29231 16.3488C8.84973 13.7603 12.2116 12.9332 14.7894 14.4906C15.552 14.9525 16.1857 15.5862 16.6476 16.3488L18.9139 14.8451C17.4316 12.4391 14.8109 10.9784 11.986 10.9891ZM11.986 16.4455C10.9872 16.4562 10.0742 16.9932 9.5801 17.8633L11.1053 18.8622C11.3523 19.077 11.6638 19.1844 11.986 19.1844C12.3083 19.1844 12.6305 19.0662 12.8668 18.8622L14.392 17.8633C13.9087 16.9825 12.9849 16.4455 11.986 16.4455Z",
    fill: "url(#paint0_linear_Klaviyo_9051_313)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_Klaviyo_9051_313",
    x1: "11.9951",
    y1: "19.1806",
    x2: "11.9951",
    y2: "4.35041",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.3314",
    stopColor: "#92C84E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.4859",
    stopColor: "#71BF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.7506",
    stopColor: "#15B158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.903",
    stopColor: "#23AC69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#23AC69"
  }))));
};

const _excluded$4N = ["color", "size"];
/**
 * @typedef {Object} ActivecampaignProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ActivecampaignProps} props
 * @returns {JSX.Element}
 */

const Activecampaign = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6889 10.4844C19.1777 10.8267 19.4222 11.2667 19.4222 11.7556V12C19.4222 12.3911 19.2755 12.9289 18.6889 13.3689C18.3955 13.5644 15.4133 15.6178 12.2844 17.8178C9.20443 19.9689 5.73331 22.3644 5.3422 22.6578V23L5.14666 22.6578V22.6089V20.8C5.14666 20.1644 5.19555 19.8711 5.87999 19.4311C6.46666 19.04 15.5111 12.7822 16.7333 11.9511C15.56 11.12 6.56444 4.91111 5.97778 4.47111L5.92887 4.42222C5.48887 4.08 5.09775 3.83556 5.09775 3.15112V1L5.29332 1.09778C5.73332 1.48889 18.2977 10.24 18.6889 10.4844ZM10.8178 12.9289C10.5244 12.9289 10.1822 12.8311 9.88886 12.5867C9.10664 12.0489 5.04888 9.26222 5.04888 9.21333L5 9.16445V7.79556C5 7.50223 5.14666 7.20889 5.39111 7.11111C5.63555 6.96444 5.97777 7.01334 6.2711 7.20889C6.85777 7.60001 12.7244 11.6578 12.8222 11.7067L12.9689 11.8044L12.8222 11.9022C12.8222 11.9022 12.4311 12.1467 11.9911 12.4889C11.5022 12.7822 11.16 12.9289 10.8178 12.9289Z",
    fill: "#010202"
  }));
};

const _excluded$4O = ["color", "size"];
/**
 * @typedef {Object} ChatGptProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ChatGptProps} props
 * @returns {JSX.Element}
 */

const ChatGpt = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M21.5497 10.1254C21.7996 9.37478 21.8863 8.57947 21.804 7.79267C21.7217 7.00588 21.4722 6.24574 21.0723 5.56316C20.4795 4.53071 19.5741 3.71329 18.4866 3.22883C17.3991 2.74438 16.1858 2.61795 15.0218 2.86779C14.4968 2.27609 13.8514 1.80338 13.1289 1.48128C12.4064 1.15918 11.6234 0.995129 10.8324 1.00011C9.64229 0.997239 8.48202 1.37238 7.51887 2.07144C6.55571 2.7705 5.83943 3.75737 5.47331 4.88976C4.69802 5.04846 3.96558 5.37095 3.32501 5.83564C2.68445 6.30033 2.15055 6.8965 1.75904 7.58424C1.16153 8.61382 0.906475 9.80658 1.03066 10.9905C1.15485 12.1744 1.65187 13.2883 2.45003 14.1714C2.20011 14.922 2.11342 15.7173 2.19574 16.5041C2.27807 17.2909 2.52751 18.0511 2.92739 18.7336C3.52023 19.766 4.4257 20.5834 5.51318 21.0678C6.60066 21.5523 7.81391 21.6787 8.97792 21.429C9.50294 22.0207 10.1483 22.4934 10.8708 22.8155C11.5933 23.1376 12.3763 23.3017 13.1673 23.2967C14.358 23.2998 15.5189 22.9245 16.4824 22.225C17.446 21.5255 18.1623 20.5379 18.5282 19.4048C19.3035 19.2461 20.0359 18.9237 20.6765 18.459C21.3171 17.9943 21.851 17.3981 22.2424 16.7103C22.8392 15.6808 23.0937 14.4884 22.9692 13.305C22.8447 12.1215 22.3476 11.0082 21.5497 10.1254ZM13.1691 21.8391C12.1917 21.8405 11.2449 21.4982 10.4944 20.8721C10.5282 20.8536 10.5876 20.8211 10.6263 20.7974L15.0658 18.233C15.1772 18.1696 15.2697 18.0776 15.3338 17.9666C15.398 17.8556 15.4314 17.7295 15.4306 17.6014V11.3425L17.3071 12.426C17.317 12.4309 17.3254 12.4381 17.3318 12.4471C17.3382 12.4561 17.3422 12.4665 17.3436 12.4774V17.6607C17.3422 18.7677 16.902 19.8291 16.1196 20.6123C15.3371 21.3955 14.2762 21.8366 13.1691 21.8391ZM4.19156 18.0049C3.70197 17.1589 3.52552 16.1678 3.6931 15.2048C3.72606 15.2246 3.78364 15.2598 3.82497 15.2835L8.26446 17.8479C8.3751 17.9126 8.50094 17.9467 8.6291 17.9467C8.75725 17.9467 8.8831 17.9126 8.99373 17.8479L14.4139 14.7183V16.8853C14.4145 16.8964 14.4124 16.9074 14.4077 16.9174C14.4031 16.9275 14.396 16.9362 14.3871 16.9429L9.89924 19.534C8.93929 20.0869 7.79923 20.2364 6.7292 19.9497C5.65916 19.663 4.74653 18.9636 4.19156 18.0049ZM3.02365 8.31301C3.51112 7.46597 4.28104 6.81742 5.19858 6.48094C5.19858 6.51918 5.19639 6.58691 5.19639 6.6339V11.7627C5.1956 11.8908 5.22894 12.0168 5.29298 12.1277C5.35702 12.2386 5.44946 12.3305 5.56078 12.3939L10.9809 15.5231L9.1045 16.6066C9.09524 16.6127 9.08461 16.6164 9.07356 16.6174C9.06252 16.6184 9.05139 16.6167 9.04118 16.6123L4.55287 14.0189C3.5946 13.464 2.8955 12.5517 2.60883 11.4821C2.32217 10.4125 2.47135 9.27281 3.02365 8.31301ZM18.4407 11.9007L13.0205 8.77104L14.897 7.68798C14.9063 7.68187 14.9169 7.67816 14.9279 7.67717C14.939 7.67618 14.9501 7.67794 14.9603 7.68229L19.4486 10.2735C20.1362 10.6706 20.6965 11.2555 21.0637 11.9596C21.431 12.6637 21.59 13.4578 21.5223 14.249C21.4545 15.0402 21.1628 15.7957 20.6812 16.4271C20.1996 17.0585 19.548 17.5396 18.8029 17.8141V12.5319C18.8039 12.404 18.7709 12.2782 18.7073 12.1672C18.6437 12.0563 18.5517 11.9643 18.4407 11.9007ZM20.3084 9.08972C20.2754 9.06949 20.2178 9.03476 20.1765 9.01106L15.737 6.44666C15.6263 6.38208 15.5005 6.34806 15.3724 6.34806C15.2442 6.34806 15.1184 6.38208 15.0078 6.44666L9.58757 9.57635V7.40932C9.58695 7.39826 9.58907 7.38722 9.59375 7.37717C9.59843 7.36713 9.60551 7.35839 9.61438 7.35174L14.1023 4.76272C14.7898 4.36628 15.576 4.17382 16.3689 4.20787C17.1619 4.24191 17.9287 4.50105 18.5797 4.95496C19.2308 5.40887 19.7391 6.03878 20.0452 6.77102C20.3513 7.50325 20.4426 8.30751 20.3084 9.08972ZM8.56738 12.9521L6.69043 11.8686C6.68058 11.8637 6.67209 11.8565 6.66573 11.8475C6.65937 11.8385 6.65533 11.8281 6.65398 11.8172V6.6339C6.6545 5.84002 6.88114 5.06272 7.30738 4.39298C7.73361 3.72324 8.3418 3.18876 9.06076 2.85211C9.77972 2.51546 10.5797 2.39057 11.3671 2.49205C12.1544 2.59353 12.8966 2.9172 13.5067 3.42515C13.4728 3.44361 13.4139 3.47614 13.3748 3.49988L8.93528 6.06425C8.82387 6.12756 8.73135 6.21941 8.66723 6.33035C8.60311 6.44129 8.5697 6.5673 8.57044 6.69543L8.56738 12.9521ZM9.58667 10.7543L12.0008 9.36007L14.4148 10.7534V13.5411L12.0008 14.9345L9.58668 13.5411L9.58667 10.7543Z",
    fill: "black"
  }));
};

const _excluded$4P = ["color", "size"];
/**
 * @typedef {Object} MailChimpProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MailChimpProps} props
 * @returns {JSX.Element}
 */

const MailChimp = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M17.1449 11.0789C17.2905 11.0789 17.436 11.0789 17.5815 11.0789C17.6741 10.8805 17.6741 10.5894 17.5815 10.2587C17.4889 9.76918 17.3434 9.43844 17.0523 9.47813C16.7613 9.53105 16.7613 9.91471 16.8539 10.4042C16.8936 10.6953 16.9994 10.9334 17.1449 11.0789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5784 11.5155C14.7768 11.6081 14.9224 11.6611 14.962 11.6081C15.015 11.5552 14.962 11.5155 14.9091 11.4097C14.8165 11.2113 14.5652 11.0657 14.3799 10.9731C13.8904 10.7747 13.3613 10.8276 12.9247 11.1716C12.7792 11.2642 12.6336 11.4097 12.6866 11.5155C12.6866 11.5685 12.7395 11.5685 12.7792 11.5685C12.8718 11.5685 13.3083 11.37 13.7978 11.3303C14.0889 11.3171 14.3799 11.4229 14.5784 11.5155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1418 11.7536C13.8508 11.8065 13.7053 11.8991 13.6126 11.9917C13.52 12.0843 13.4671 12.1373 13.4671 12.1902V12.2431H13.52C13.573 12.2431 13.7185 12.1902 13.7185 12.1902C14.1021 12.0446 14.3535 12.0447 14.5916 12.0976C14.7372 12.0976 14.7901 12.1505 14.8298 12.0976C14.8298 12.0976 14.8298 12.0446 14.8298 12.005C14.8165 11.8594 14.5255 11.7139 14.1418 11.7536Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2718 12.6269C16.4703 12.7195 16.6555 12.6798 16.7613 12.5343C16.8142 12.3888 16.7084 12.1903 16.5232 12.0977C16.3247 12.0051 16.1395 12.0448 16.0337 12.1903C15.9278 12.3358 16.0734 12.5343 16.2718 12.6269Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4757 11.5684C17.3301 11.5684 17.1846 11.7139 17.1846 11.9521C17.1846 12.1505 17.2772 12.3357 17.4757 12.3357C17.6212 12.3357 17.7667 12.1902 17.7667 11.9521C17.727 11.7536 17.6212 11.5684 17.4757 11.5684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22275 15.339C7.16983 15.286 7.13014 15.286 7.07722 15.339C7.0243 15.339 6.98461 15.339 6.93169 15.339C6.83909 15.339 6.73325 15.286 6.69356 15.1934C6.65387 15.1008 6.64064 14.9553 6.69356 14.7569L6.74648 14.6643C6.89201 14.3732 7.09045 13.9366 6.83909 13.5C6.64064 13.1561 6.40251 12.9709 6.05854 12.9179C5.71457 12.865 5.38383 13.0106 5.18538 13.2619C4.84141 13.6456 4.80173 14.1351 4.84141 14.3203C4.84141 14.3732 4.89433 14.4129 4.93402 14.4129C4.98694 14.4129 5.07955 14.36 5.13247 14.2144V14.1615C5.13247 14.0689 5.18538 13.9631 5.27799 13.8176C5.3706 13.672 5.51613 13.5794 5.66165 13.5794C5.80718 13.5265 6.00562 13.5794 6.15115 13.672C6.38928 13.8176 6.49512 14.1086 6.38928 14.3997C6.24375 14.5452 6.19084 14.7833 6.19084 15.0347C6.24375 15.4713 6.53481 15.6697 6.77294 15.7094C7.01107 15.7094 7.20952 15.5639 7.20952 15.4713C7.26244 15.3919 7.22275 15.3919 7.22275 15.339Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.299 14.5187C21.299 14.4658 21.2461 14.2805 21.1535 13.9895L20.9551 13.5529C21.299 13.0634 21.299 12.5872 21.2461 12.349C21.1932 12.058 21.0477 11.7669 20.8095 11.4759C20.5714 11.1848 19.9893 10.8938 19.2617 10.6953L18.878 10.6027C18.878 10.6027 18.878 9.67664 18.8251 9.29298C18.8251 9.00193 18.7722 8.56535 18.6267 8.12878C18.4811 7.54667 18.1901 7.01749 17.8064 6.67352C18.7722 5.65484 19.4072 4.49063 19.4072 3.52487C19.4072 1.68595 17.1317 1.10385 14.2741 2.26805L13.692 2.50619C13.692 2.50619 12.6336 1.44782 12.5807 1.44782C9.4453 -1.35686 -0.569526 9.82217 2.61881 12.5342L3.29352 13.1163C3.09508 13.6058 3.05539 14.135 3.09508 14.7171C3.18769 15.4448 3.58457 16.1724 4.15345 16.7545C4.73555 17.2837 5.50287 17.6276 6.28342 17.6276C7.54023 20.5382 10.3978 22.2712 13.7317 22.3771C17.3169 22.4697 20.3597 20.7763 21.6165 17.7732C21.7092 17.5747 22.0531 16.609 22.0531 15.7358C22.1325 14.8494 21.643 14.5187 21.299 14.5187ZM6.5877 16.7942C6.49509 16.7942 6.34957 16.8471 6.24373 16.7942C5.18536 16.7413 3.96823 15.7755 3.87563 14.6113C3.78302 13.3545 4.40481 12.3887 5.56902 12.1373C5.71454 12.0844 5.86007 12.0844 6.05851 12.0844C6.69354 12.1374 7.6593 12.6136 7.89743 14.016C8.08265 15.3389 7.80482 16.5957 6.5877 16.7942ZM5.3838 11.37C4.65617 11.5156 4.03438 11.8992 3.63749 12.4813C3.39936 12.2829 2.96278 11.8992 2.90986 11.7537C2.27484 10.5895 3.58458 8.2743 4.51065 7.00426C6.73322 3.81592 10.2655 1.3949 11.8663 1.81825C12.1574 1.91085 13.0305 2.92953 13.0305 2.92953C13.0305 2.92953 11.39 3.85561 9.88187 5.11242C7.84451 6.6206 6.29665 8.89609 5.3838 11.37ZM16.801 16.3047L16.8539 16.2518C16.8539 16.1988 16.801 16.1988 16.801 16.1988C16.801 16.1988 15.1076 16.437 13.5068 15.8549C13.7052 15.2728 14.1418 15.4712 14.8562 15.5638C16.113 15.6564 17.2772 15.4712 18.0975 15.2198C18.8251 15.0214 19.7909 14.5848 20.5185 14.016C20.7566 14.5451 20.8625 15.1802 20.8625 15.1802C20.8625 15.1802 21.0609 15.1272 21.2064 15.2331C21.352 15.3257 21.4446 15.5241 21.4049 16.0136C21.2593 16.9794 20.8228 17.707 20.201 18.4346C19.8173 18.8712 19.2749 19.2549 18.706 19.5459C18.415 19.6915 18.071 19.837 17.7403 19.9296C15.1208 20.7498 12.5146 19.8767 11.6943 17.8922C11.6414 17.7467 11.5488 17.6012 11.5488 17.4027C11.2048 16.093 11.4959 14.5451 12.4749 13.5794C12.5278 13.5265 12.5675 13.4339 12.5675 13.3412C12.5675 13.2486 12.5146 13.1957 12.4749 13.1428C12.1309 12.6533 10.9799 11.8331 11.2181 10.2323C11.3636 9.06808 12.3823 8.30076 13.2951 8.34045H13.5332C13.9169 8.34045 14.3138 8.43306 14.5916 8.43306C15.1208 8.43306 15.65 8.38014 16.2321 7.90387C16.4305 7.75835 16.5761 7.61282 16.8671 7.5599C16.92 7.5599 16.9597 7.50698 17.1052 7.5599C17.2508 7.5599 17.3963 7.61282 17.4889 7.70543C17.9784 8.0494 18.0181 8.7638 18.071 9.3459C18.071 9.68987 18.1239 10.4572 18.1239 10.6556C18.1768 11.1451 18.2695 11.2377 18.5605 11.3303C18.706 11.3833 18.8516 11.4229 19.05 11.4759C19.685 11.6743 20.0687 11.8198 20.3068 12.058C20.4523 12.2035 20.5053 12.349 20.5449 12.4946C20.6376 13.0237 20.1084 13.6984 18.7986 14.3335C17.3434 15.0082 15.65 15.1537 14.4461 15.0082L14.0095 14.9553C13.0438 14.8097 12.5146 16.0665 13.0834 16.8868C13.4671 17.416 14.4858 17.8129 15.4515 17.8129C17.78 17.8129 19.566 16.8471 20.201 15.9739L20.2539 15.8813C20.3068 15.8284 20.2539 15.7887 20.201 15.8284C19.6718 16.2121 17.2508 17.6673 14.6842 17.2308C14.6842 17.2308 14.3932 17.1778 14.1021 17.0852C13.864 16.9926 13.4274 16.7942 13.3216 16.3047C15.4912 16.9397 16.801 16.3047 16.801 16.3047ZM9.5379 7.01749C10.3185 6.09141 11.3239 5.27118 12.1971 4.8346C12.25 4.8346 12.25 4.8346 12.25 4.88752C12.1971 5.03305 12.0515 5.27118 12.0118 5.46962C12.0118 5.52254 12.0648 5.52254 12.0648 5.52254C12.5939 5.13888 13.5597 4.74199 14.3932 4.7023C14.4461 4.7023 14.4461 4.75522 14.4461 4.75522C14.3006 4.84783 14.208 4.99336 14.0624 5.13888C14.0624 5.13888 14.0624 5.1918 14.1154 5.1918C14.6975 5.1918 15.5177 5.39024 16.0469 5.72098C16.0998 5.72098 16.0469 5.81359 15.994 5.81359C15.1737 5.61515 13.864 5.46962 12.4616 5.81359C11.2048 6.10464 10.2788 6.59414 9.60405 7.07041C9.5379 7.05718 9.49822 7.05717 9.5379 7.01749Z",
    fill: "black"
  }));
};

const _excluded$4Q = ["color", "size"];
/**
 * @typedef {Object} ConvertKitProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ConvertKitProps} props
 * @returns {JSX.Element}
 */

const ConvertKit = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.02303 11.245C9.72869 11.7197 10.5685 13.9906 10.5906 16.2747C10.5911 16.326 10.5454 16.368 10.4887 16.368H7.08278C7.0266 16.368 6.98083 16.3268 6.98053 16.2758C6.97029 14.5038 6.65363 12.9401 4.71702 12.8725C4.65924 12.8706 4.6111 12.9125 4.6111 12.965V16.2756C4.6111 16.3266 4.56544 16.368 4.50915 16.368H1.10256C1.04627 16.368 1.00061 16.3267 1.00061 16.2756V7.84011C1.00061 7.78908 1.04627 7.74768 1.10256 7.74768H4.50915C4.56544 7.74768 4.6111 7.78908 4.6111 7.84011V11C4.6111 11.0469 4.65299 11.0849 4.70471 11.0849C4.74571 11.0849 4.78214 11.0607 4.79405 11.025C5.67156 8.41926 7.31041 7.76406 9.97157 7.74795C10.0281 7.74759 10.0743 7.78917 10.0743 7.84038V10.9925C10.0743 11.0435 10.0287 11.0849 9.97237 11.0849H7.04009C6.99087 11.0849 6.95094 11.1211 6.95094 11.1657C6.95094 11.2044 6.98122 11.2377 7.02303 11.245ZM16.3491 13.2203V11.1773C16.3491 11.1263 16.3947 11.0849 16.451 11.0849H18.9578C19.0072 11.0849 19.0472 11.0486 19.0472 11.0039C19.0472 10.9651 19.0167 10.9319 18.9747 10.9244C17.0134 10.5717 16.108 9.54804 16.0767 7.8402C16.0758 7.78944 16.1208 7.74768 16.1766 7.74768H19.8576C19.9139 7.74768 19.9596 7.78908 19.9596 7.84011V9.27885C19.9596 9.32988 20.0052 9.37128 20.0615 9.37128H22.1721C22.2284 9.37128 22.2741 9.41268 22.2741 9.46371V10.9925C22.2741 11.0435 22.2284 11.0849 22.1721 11.0849H20.0615C20.0052 11.0849 19.9596 11.1263 19.9596 11.1773V12.8252C19.9596 13.4074 20.3533 13.5994 20.8768 13.5994C21.6973 13.5994 22.5066 13.2642 22.8312 13.1123C22.8991 13.0806 22.9798 13.1253 22.9798 13.1945V15.7598C22.9798 15.8283 22.9381 15.8913 22.8712 15.9233C22.5508 16.0761 21.56 16.4998 20.4267 16.4998C18.0959 16.5 16.3491 15.6385 16.3491 13.2203ZM11.5574 16.2756V11.1771C11.5574 11.1261 11.6031 11.0847 11.6594 11.0847H15.0659C15.1222 11.0847 15.1679 11.1261 15.1679 11.1771V16.2756C15.1679 16.3266 15.1222 16.368 15.0659 16.368H11.6594C11.6031 16.368 11.5574 16.3267 11.5574 16.2756ZM11.3645 9.07131C11.3645 9.93909 12.0405 10.6426 13.3391 10.6426C14.6377 10.6426 15.3136 9.93909 15.3136 9.07131C15.3136 8.20353 14.6376 7.5 13.3391 7.5C12.0405 7.5 11.3645 8.20353 11.3645 9.07131Z",
    fill: "black"
  }));
};

const _excluded$4R = ["color", "size"];
/**
 * @typedef {Object} GoogleSheetsProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {GoogleSheetsProps} props
 * @returns {JSX.Element}
 */

const GoogleSheets = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.7181 21.6475C19.7179 21.9764 19.5871 22.2917 19.3545 22.5243C19.1219 22.7569 18.8065 22.8877 18.4776 22.8879H5.24148C4.91256 22.8879 4.59708 22.7574 4.36432 22.525C4.13155 22.2926 4.00052 21.9774 4 21.6484V2.27509C3.99987 2.11202 4.03189 1.95052 4.09424 1.79984C4.15658 1.64916 4.24802 1.51225 4.36333 1.39694C4.47864 1.28163 4.61555 1.19019 4.76623 1.12785C4.91691 1.0655 5.07841 1.03348 5.24148 1.03361H13.7361L19.7181 7.13424V21.6475Z",
    fill: "#23A566"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3944 6.9751L19.7181 12.0636V7.09865H15.0023C14.7964 7.10098 14.5934 7.0499 14.4132 6.95039L14.3944 6.9751Z",
    fill: "#1C8F5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7181 7.12435H14.9894C14.6605 7.12409 14.3451 6.99331 14.1126 6.76073C13.88 6.52815 13.7492 6.21278 13.7489 5.88387V1L19.7181 7.12435Z",
    fill: "#8ED1B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9334 18.8591H7.75408V11.767H15.9334V18.8591ZM12.3523 12.7901V14.0315H14.9282V12.792L12.3523 12.7901ZM12.3523 14.8134V15.9995H14.9282V14.8075L12.3523 14.8134ZM12.3523 16.7557V17.8538H14.9282V16.7497L12.3523 16.7557ZM11.3411 17.8479V16.7497H8.76624V17.8479H11.3411ZM11.3411 15.9867V14.8075H8.76624V15.9926L11.3411 15.9867ZM11.3411 14.0444V12.7901H8.76624V14.0315L11.3411 14.0444Z",
    fill: "white"
  }));
};

const _excluded$4S = ["color", "size"];
/**
 * @typedef {Object} SalesforceProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SalesforceProps} props
 * @returns {JSX.Element}
 */

const Salesforce = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9098_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1194 6.36646C10.4772 5.9901 10.908 5.69071 11.3854 5.48662C11.8629 5.28253 12.377 5.17804 12.8963 5.17955C14.3451 5.17955 15.6008 5.98149 16.2765 7.1764C16.8779 6.91233 17.5276 6.7758 18.1844 6.77543C20.7923 6.77543 22.9091 8.90061 22.9091 11.5231C22.9091 14.1456 20.7923 16.2711 18.1844 16.2711C17.8623 16.2711 17.5567 16.2388 17.2506 16.1748C16.9506 16.7095 16.5136 17.1548 15.9846 17.4649C15.4556 17.775 14.8536 17.9388 14.2404 17.9393C13.7014 17.9393 13.186 17.8107 12.7273 17.5944C12.1236 18.9979 10.7311 19.9842 9.10532 19.9842C8.30094 19.9855 7.51549 19.7402 6.85486 19.2813C6.19423 18.8224 5.69019 18.1719 5.41068 17.4177C5.16933 17.466 4.91964 17.498 4.6623 17.498C2.63379 17.482 1 15.8378 1 13.8009C1 12.4377 1.73239 11.2505 2.82715 10.6088C2.5962 10.0775 2.47836 9.50394 2.48112 8.92461C2.48112 6.59112 4.38026 4.69824 6.73079 4.69824C8.11524 4.69824 9.33867 5.34786 10.1194 6.36646Z",
    fill: "#009DDC"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9098_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "21.9091",
    height: "15.3016",
    fill: "white",
    transform: "translate(1 4.69824)"
  }))));
};

const _excluded$4T = ["color", "size"];
/**
 * @typedef {Object} PipedriveProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {PipedriveProps} props
 * @returns {JSX.Element}
 */

const Pipedrive = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.142 1C10.7541 1 9.37313 2.07155 8.70692 2.81183C8.62775 2.17407 8.20708 1.3466 6.56528 1.3466H3V5.07825H4.46121C4.70857 5.07825 4.78811 5.15706 4.78811 5.40406V22.4435H9.03784V16.0481C9.03784 15.8755 9.03455 15.7142 9.03018 15.5698C9.69383 16.1794 10.9617 17.0189 12.9421 17.0189C17.0958 17.0189 20 13.7262 20 9.01019C20 4.2194 17.2425 1 13.142 1ZM12.2788 13.3172C9.99082 13.3172 8.95137 11.1267 8.95137 9.09703C8.95137 5.90025 10.6997 4.76083 12.3353 4.76083C14.3416 4.76083 15.6908 6.49057 15.6908 9.06711C15.6908 12.0052 13.9757 13.3172 12.2788 13.3172Z",
    fill: "#231F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.142 1C10.7541 1 9.37277 2.07155 8.70692 2.81146C8.62739 2.17407 8.20708 1.3466 6.56528 1.3466H3V5.07825H4.46121C4.70857 5.07825 4.78811 5.15706 4.78811 5.40369V14.8992C6.74113 14.2198 8.74195 13.5649 10.7814 12.9352C9.53257 12.2205 8.95137 10.6144 8.95137 9.09666C8.95137 5.90025 10.6997 4.76083 12.3353 4.76083C14.3416 4.76083 15.6908 6.49057 15.6908 9.06711C15.6908 10.1492 15.4558 11.0074 15.0768 11.6634C16.6642 11.2139 18.2736 10.7779 19.9077 10.3583C19.9606 9.92304 20 9.47501 20 9.01019C20 4.2194 17.2425 1 13.142 1Z",
    fill: "#3B3B3C"
  }));
};

const _excluded$4U = ["color", "size"];
/**
 * @typedef {Object} WiseagentProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {WiseagentProps} props
 * @returns {JSX.Element}
 */

const Wiseagent = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M6.40583 12.8027C6.49478 13.4182 7.96306 14.1535 8.87332 13.1893C9.97097 11.9019 8.81817 11.0142 8.75472 11.0082C8.43984 11.0325 8.76895 12.2322 8.39892 12.5441C7.85217 13.1454 6.40049 12.5761 6.40583 12.8027Z",
    fill: "#00559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8992 12.725C15.6027 12.9112 16.7994 14.1636 18.0904 13.2753C19.3849 12.2209 18.228 10.7479 18.0524 10.8564C17.8259 10.9815 18.2861 11.6273 17.6812 12.3105C17.1612 12.8732 15.952 12.5921 15.8992 12.725Z",
    fill: "#00559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6352 8.21577C19.6352 8.21577 21.3549 11.1843 21.088 14.4227C21.0252 15.2583 19.7834 19.0927 14.0704 16.4983C15.2487 18.4291 16.3191 20.1796 16.3191 20.1796H21.378C21.4681 18.6011 23.326 15.2939 20.192 8.28515C22.2847 6.77121 22.4324 5.6611 22.8771 5.25489C23.1191 5.05327 22.9655 4.31735 22.7455 4.0167L18.4165 5.32546C18.4165 5.32546 13.8611 2.40788 7.66952 5.22999C4.86935 3.72376 3.06603 5.05802 3.20005 5.4915C3.35245 6.14381 4.25441 7.00782 5.32893 7.72594C4.40088 8.73998 1.27338 17.7886 1 20.179H6.2131C6.57543 18.3579 6.98401 17.8978 6.98401 17.8978C10.6126 18.9059 13.1548 15.8892 13.1548 15.8892C7.01722 18.0875 5.0941 16.4822 4.62444 12.6769C4.49576 11.5615 5.85434 8.59232 7.05576 8.4583C5.01405 6.23869 4.59361 5.8651 4.72407 5.54369C4.97372 5.12028 10.3274 7.71349 13.5124 14.7578C13.1014 12.0721 13.3078 10.8778 13.3078 10.8778C11.5507 8.0177 9.37026 6.40354 9.37026 6.40354C11.8561 5.46067 15.126 5.76488 16.5332 6.43023C15.2659 7.81193 15.0252 10.2397 15.0252 10.2397C17.7874 6.90878 21.4237 4.96195 22.417 4.66545C22.1151 5.92084 19.6352 8.21577 19.6352 8.21577Z",
    fill: "#00559B"
  }));
};

const _excluded$4V = ["color", "size"];
/**
 * @typedef {Object} FlodeskProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {FlodeskProps} props
 * @returns {JSX.Element}
 */

const Flodesk = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M14.0117 2.02253C13.1017 2.12612 12.2989 2.40359 11.718 2.81793C11.4628 2.99921 11.0262 3.44315 10.8597 3.69102C10.3159 4.48642 10.0347 5.59998 10.0347 6.94291V7.46084H9.01737H8V8.84817V10.2355H9.01737H10.0347V16.1177V22H11.6625H13.2903V16.1177V10.2355H14.5482H15.806L15.7986 8.85557L15.7875 7.47934L14.5149 7.46824L13.2422 7.46084L13.2644 6.89482C13.2755 6.51746 13.3051 6.26589 13.3458 6.12901C13.6159 5.26332 14.2559 4.87117 15.3991 4.87117H15.806V3.46905C15.806 2.44798 15.7949 2.05583 15.7616 2.03733C15.6987 1.99664 14.3447 1.98554 14.0117 2.02253Z",
    fill: "black"
  }));
};

const _excluded$4W = ["color", "size"];
/**
 * @typedef {Object} DeepSeekProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {DeepSeekProps} props
 * @returns {JSX.Element}
 */

const DeepSeek = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M22.7685 5.34246C22.5357 5.23012 22.4349 5.44484 22.2992 5.55446C22.2525 5.5898 22.213 5.636 22.1736 5.67768C21.8326 6.03736 21.4348 6.27291 20.9151 6.24483C20.1552 6.20315 19.5062 6.43871 18.9323 7.01311C18.8104 6.30462 18.4053 5.88243 17.7893 5.61063C17.4666 5.4693 17.1403 5.32887 16.9139 5.02174C16.7562 4.80339 16.7131 4.55968 16.6343 4.3205C16.5839 4.17554 16.5335 4.02786 16.3657 4.0034C16.1824 3.97532 16.1109 4.12662 16.0394 4.25346C15.7525 4.77168 15.6416 5.34246 15.6526 5.92048C15.6773 7.22149 16.2328 8.25794 17.3374 8.99451C17.463 9.07877 17.495 9.16394 17.4556 9.28715C17.3805 9.54083 17.2906 9.78726 17.2118 10.0418C17.1614 10.204 17.0862 10.2384 16.9102 10.1687C16.3156 9.91608 15.7754 9.55318 15.3189 9.09961C14.5334 8.34945 13.8239 7.52137 12.9384 6.87268C12.7332 6.72285 12.5226 6.58051 12.3068 6.44596C11.4039 5.57892 12.426 4.86681 12.6625 4.78256C12.91 4.69377 12.7477 4.39117 11.9484 4.39479C11.1491 4.39842 10.4176 4.66206 9.48537 5.01449C9.34684 5.06696 9.20431 5.10846 9.05913 5.13861C8.18797 4.97638 7.29701 4.94522 6.41643 5.0462C4.68855 5.23646 3.30899 6.0446 2.29426 7.42262C1.07512 9.07877 0.788208 10.9614 1.13928 12.9238C1.50869 14.9931 2.57751 16.7063 4.21922 18.0454C5.92236 19.4343 7.88307 20.1147 10.1206 19.9842C11.4791 19.9072 12.9925 19.7269 14.6983 18.2991C15.1292 18.5111 15.5802 18.5953 16.33 18.6587C16.9075 18.7122 17.463 18.6316 17.8929 18.5428C18.5666 18.4014 18.5199 17.7845 18.2769 17.6721C16.3016 16.7625 16.7351 17.133 16.3401 16.8332C17.3447 15.659 18.8572 14.4395 19.4493 10.4885C19.4952 10.1741 19.4558 9.97661 19.4493 9.72293C19.4457 9.56891 19.4814 9.50821 19.6602 9.491C20.1561 9.44015 20.6372 9.29396 21.0764 9.06065C22.356 8.36938 22.873 7.23508 22.9949 5.87428C23.0133 5.6659 22.9913 5.45208 22.7685 5.34246ZM11.6157 17.5897C9.70078 16.102 8.77222 15.6119 8.38906 15.6327C8.02973 15.6545 8.09481 16.0594 8.17365 16.324C8.25614 16.5849 8.36339 16.7643 8.51372 16.9935C8.61822 17.1448 8.68972 17.3704 8.41014 17.5398C7.79324 17.9167 6.72167 17.413 6.67126 17.3885C5.4237 16.6619 4.37964 15.7034 3.6454 14.3924C2.93592 13.1304 2.52342 11.7768 2.45559 10.3318C2.43726 9.98205 2.54084 9.85883 2.89283 9.79541C3.35493 9.70801 3.82839 9.69607 4.29439 9.76008C6.24868 10.0427 7.91148 10.9062 9.30662 12.2733C10.1023 13.0525 10.7045 13.9829 11.3251 14.8925C11.9851 15.8583 12.6946 16.7788 13.5984 17.5326C13.9174 17.7971 14.1713 17.9983 14.4151 18.1459C13.68 18.2275 12.4535 18.2456 11.6157 17.5897ZM12.5323 11.7551C12.5321 11.7101 12.5431 11.6657 12.5641 11.6258C12.5852 11.5859 12.6158 11.5517 12.6533 11.5261C12.6907 11.5005 12.7339 11.4843 12.7791 11.4789C12.8243 11.4735 12.8702 11.479 12.9127 11.4951C12.9669 11.5143 13.0138 11.5498 13.0466 11.5965C13.0795 11.6433 13.0968 11.699 13.096 11.756C13.0962 11.7928 13.0889 11.8292 13.0746 11.8632C13.0603 11.8972 13.0394 11.928 13.0129 11.9539C12.9865 11.9798 12.9551 12.0002 12.9206 12.014C12.8861 12.0278 12.8491 12.0346 12.8119 12.0341C12.7749 12.0342 12.7384 12.0271 12.7042 12.0131C12.6701 11.999 12.6392 11.9784 12.6133 11.9524C12.5873 11.9265 12.5669 11.8956 12.5531 11.8617C12.5394 11.8278 12.5317 11.7916 12.5323 11.7551ZM15.3831 13.201C15.1998 13.2744 15.0173 13.3378 14.8423 13.346C14.5789 13.3551 14.3204 13.2738 14.1108 13.1159C13.8596 12.9075 13.68 12.7915 13.6048 12.4291C13.5789 12.252 13.5838 12.0719 13.6195 11.8964C13.6836 11.6001 13.6121 11.4099 13.4004 11.2378C13.229 11.0964 13.0099 11.0575 12.7697 11.0575C12.6875 11.0527 12.6076 11.0285 12.5369 10.9868C12.4361 10.9379 12.3536 10.8147 12.4324 10.6624C12.4581 10.6135 12.5791 10.4939 12.6084 10.4722C12.9347 10.2892 13.3115 10.349 13.6589 10.4867C13.9815 10.6171 14.2254 10.8563 14.5764 11.1952C14.9348 11.6038 14.9999 11.717 15.2043 12.0232C15.3657 12.2633 15.5123 12.5098 15.6122 12.7915C15.6737 12.9682 15.5948 13.1123 15.3831 13.201Z",
    fill: "#4D6BFE"
  }));
};

const _excluded$4X = ["color", "size"];
/**
 * @typedef {Object} ApptivoProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ApptivoProps} props
 * @returns {JSX.Element}
 */

const Apptivo = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12.4983 8.84533C8.81355 12.2194 8.54718 17.8575 8.63597 18.3015C8.63597 18.3015 15.5172 19.0118 19.202 14.9719C22.8868 10.9319 23.1532 5.02735 23.1532 5.02735C22.4428 4.84976 16.1831 5.4713 12.4983 8.84533Z",
    fill: "#1FADE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79467 13.196C8.05882 14.9274 8.05882 18.3015 8.05882 18.3015C8.05882 18.3015 4.50721 18.479 2.7758 16.2593C1.0444 14.0395 1 11.8642 1 11.8642C1 11.8642 3.53052 11.4646 5.79467 13.196Z",
    fill: "#1FADE4"
  }));
};

const _excluded$4Y = ["color", "size"];
/**
 * @typedef {Object} ZillowProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ZillowProps} props
 * @returns {JSX.Element}
 */

const Zillow = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12.0148V8.65944L12.0092 1.15894L21 8.65944V11.7292C18.7004 12.1711 13.6008 13.7444 11.4294 14.7319C11.4123 14.7392 11.3903 14.7367 11.4159 14.7013C12.6634 13.023 14.8995 10.682 16.9098 9.02684C16.9232 9.01707 16.9342 9.00609 16.9415 8.99266C16.9501 8.97802 16.9562 8.96337 16.9586 8.9475C16.9599 8.93163 16.9599 8.91577 16.955 8.90112C16.9513 8.88525 16.944 8.8706 16.9342 8.8584C16.662 8.50809 15.6648 7.22647 15.356 6.85786C15.3023 6.79439 15.2608 6.76021 15.1693 6.78462C12.2447 7.55359 5.7927 10.2645 3 12.0148ZM5.98067 17.5417C5.93429 17.4843 5.93063 17.455 5.99044 17.361C7.2867 15.3531 9.93416 12.2309 11.6222 10.9078C11.6527 10.8834 11.6442 10.8626 11.6088 10.8748C9.84994 11.4814 4.85163 13.7481 3.00122 14.8527V22.0212H21V15.1212C18.5417 15.5619 11.195 17.8663 7.85427 19.6826C7.79325 19.7241 7.70902 19.7119 7.6602 19.652L5.98067 17.5417Z",
    fill: "#006AFF"
  }));
};

const _excluded$4Z = ["color", "size"];
/**
 * @typedef {Object} CanvaProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {CanvaProps} props
 * @returns {JSX.Element}
 */

const Canva = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "#7D2AE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "url(#paint0_radial_9151_260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "url(#paint1_radial_9151_260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "url(#paint2_radial_9151_260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "url(#paint3_radial_9151_260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7495 14.2566C16.6588 14.2566 16.5789 14.3332 16.4957 14.5007C15.5569 16.4044 13.9354 17.7513 12.059 17.7513C9.88932 17.7513 8.54571 15.7928 8.54571 13.087C8.54571 8.50364 11.0994 5.85365 13.3424 5.85365C14.3906 5.85365 15.0306 6.51232 15.0306 7.5605C15.0306 8.80453 14.3239 9.4632 14.3239 9.90195C14.3239 10.0989 14.4464 10.2181 14.6893 10.2181C15.6653 10.2181 16.8108 9.09667 16.8108 7.51236C16.8108 5.97619 15.4738 4.84705 13.2308 4.84705C9.52387 4.84705 6.22943 8.28372 6.22943 13.0388C6.22943 16.7195 8.33126 19.1518 11.5743 19.1518C15.0164 19.1518 17.0067 15.7271 17.0067 14.6155C17.0067 14.3694 16.8808 14.2566 16.7495 14.2566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9151_260",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.24957 20.4991) rotate(-49.416) scale(17.0151)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#6420FF",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9151_260",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.82417 3.50101) rotate(54.703) scale(19.1877)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#00C4CC",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9151_260",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.24947 20.4989) rotate(-45.1954) scale(16.8092 7.73075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#6420FF",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9151_260",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.99684 3.96421) rotate(66.5198) scale(17.3205 29.0157)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4CC",
    stopOpacity: "0.725916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.0001",
    stopColor: "#00C4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#00C4CC",
    stopOpacity: "0"
  }))));
};

const _excluded$4_ = ["color", "size"];
/**
 * @typedef {Object} KajabiProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {KajabiProps} props
 * @returns {JSX.Element}
 */

const Kajabi = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 22.2294V2H21.9996L2 22.2294Z",
    fill: "#2B74E7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 22.2295L14.0004 14.1379L22.0002 22.2295H6Z",
    fill: "#2B74E7"
  }));
};

const _excluded$4$ = ["color", "size"];
/**
 * @typedef {Object} MagentoProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MagentoProps} props
 * @returns {JSX.Element}
 */

const Magento = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M13.2716 16.0061V3.79581L12.0708 3.06196L10.8692 3.79972V15.9966L7.75775 14.0809V3.63896L12.0708 0.999878L16.4204 3.65775V14.0876L13.2716 16.0061ZM12.0708 22.4355L3 16.9398V6.49652L5.35587 5.10866V15.553L12.0727 19.6371L18.7957 15.5589L18.8234 15.5431L18.8205 5.12426L21.1531 6.49652V16.9398L12.0708 22.4355Z",
    fill: "#EC6737"
  }));
};

const _excluded$50 = ["color", "size"];
/**
 * @typedef {Object} ArrowDownRightProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ArrowDownRightProps} props
 * @returns {JSX.Element}
 */

const ArrowDownRight = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$50);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M19.9296 13.5L15 8.57042V6.5L22 13.5L15 20.5L15 18.4296L19.9296 13.5Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30005 2.59998H3.70005V12.9H15V14.3H2.30005V2.59998Z",
    fill: color
  }));
};

const _excluded$51 = ["color", "size"];
/**
 * @typedef {Object} ReturnKeyProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ReturnKeyProps} props
 * @returns {JSX.Element}
 */

const ReturnKey = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$51);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M7.32484 19.1821L2.5 14.3573L7.32484 9.53242V19.1821ZM5.84652 15.2345V13.48H20.451V15.2345H5.84652ZM18.7452 15.2345V5H20.4997V15.2345H18.7452ZM14.0179 6.75449V5H20.451V6.75449H14.0179Z",
    fill: color
  }));
};

const _excluded$52 = ["color", "size"];
/**
 * @typedef {Object} UnreadProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {UnreadProps} props
 * @returns {JSX.Element}
 */

const Unread = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$52);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21951 19.342L5.90244 16.9793L5.70732 16.7824C5.3538 16.4257 4.76498 15.7787 4.27921 14.8963C3.82658 14.074 3.46341 13.0472 3.46341 11.8601C3.46341 7.82383 7.26829 4.47668 11.9512 4.47668C16.7317 4.47668 20.5366 7.82383 20.5366 11.8601C20.5366 13.0881 20.1844 14.2432 19.5597 15.2562C18.131 17.5725 15.2773 19.1451 11.9512 19.1451C10.6829 19.1451 9.21951 18.8497 8.14634 18.3575L7.85366 18.2591L5.21951 19.342ZM4.34146 17.5699C4.2998 17.5232 4.25681 17.4743 4.21273 17.4232C3.83083 16.9802 3.36644 16.3725 2.96189 15.6137C2.42904 14.6143 2 13.3526 2 11.8601C2 6.93782 6.4878 3 11.9512 3C17.5122 3 22 6.93782 22 11.8601C22 13.4255 21.556 14.8912 20.7716 16.1625C19.0893 18.8887 15.8413 20.7202 12.0488 20.7202C10.6829 20.7202 9.12195 20.4249 7.95122 19.9326L2.97561 22L4.34146 17.5699ZM12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    fill: color
  }));
};

const _excluded$53 = ["color", "size"];
/**
 * @typedef {Object} PrivacyProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {PrivacyProps} props
 * @returns {JSX.Element}
 */

const Privacy = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$53);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M11.04 11.01H12.945V15.395H11.04V11.01Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.995 23.085L11.665 22.925C11.57 22.88 1.995 18.085 1.995 6.25002V5.50002H2.74499C8.79 5.50002 11.42 2.77002 11.445 2.74002L12 2.15002L12.55 2.74502C12.55 2.74502 15.205 5.50002 21.245 5.50002H21.995V6.25002C21.995 18.085 12.42 22.875 12.325 22.925L11.995 23.085ZM3.505 6.98502C3.84 16.27 10.41 20.51 11.99 21.4C13.57 20.51 20.145 16.27 20.475 6.98502C15.765 6.81502 13.07 5.12002 11.99 4.25502C10.91 5.12002 8.21 6.81502 3.505 6.98502Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10C12.5523 10 13 9.55231 13 9.00002C13 8.44774 12.5523 8.00002 12 8.00002C11.4477 8.00002 11 8.44774 11 9.00002C11 9.55231 11.4477 10 12 10Z",
    fill: color
  }));
};

const _excluded$54 = ["color", "size"];
/**
 * @typedef {Object} LocationProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {LocationProps} props
 * @returns {JSX.Element}
 */

const Location = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$54);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0031 9C15.0031 10.6569 13.6599 12 12.0031 12C10.3462 12 9.00305 10.6569 9.00305 9C9.00305 7.34315 10.3462 6 12.0031 6C13.6599 6 15.0031 7.34315 15.0031 9ZM13.5031 9C13.5031 9.82843 12.8315 10.5 12.0031 10.5C11.1746 10.5 10.5031 9.82843 10.5031 9C10.5031 8.17157 11.1746 7.5 12.0031 7.5C12.8315 7.5 13.5031 8.17157 13.5031 9Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0312 2L12.0157 2.00001L12.0002 2.00005C6.01756 2.01909 2.00684 7.51041 6.00016 13.5C8.22689 16.6811 10.0488 19.2551 11.0797 20.7068C11.6691 21.5368 12.0002 22 12.0002 22C12.0002 22 12.3311 21.5368 12.9205 20.7068C13.9513 19.2551 15.7733 16.6811 18 13.5C21.9933 7.51041 18.0138 2.01904 12.0312 2ZM6.54296 6.26055C7.48247 4.66342 9.47296 3.50477 12.0157 3.50001C14.5584 3.50477 16.5177 4.66342 17.4572 6.26055C18.367 7.80711 18.4877 10.0559 16.7611 12.6542C15.0173 15.1453 13.5227 17.2627 12.4636 18.758L11.9999 19.4117L11.5366 18.758C10.4774 17.2627 8.98285 15.1453 7.2391 12.6542C5.51243 10.0559 5.63319 7.80711 6.54296 6.26055Z",
    fill: color
  }));
};

const _excluded$55 = ["color", "size"];
/**
 * @typedef {Object} TikTokProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TikTokProps} props
 * @returns {JSX.Element}
 */

const TikTok = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$55);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M10.2271 9.78853V8.94867C9.94592 8.91045 9.66027 8.88648 9.36881 8.88648C5.85699 8.88648 3 11.7436 3 15.2554C3 17.4101 4.07656 19.3169 5.71891 20.47C4.6589 19.332 4.02943 17.8076 4.02943 16.1334C4.02943 12.672 6.78467 9.86895 10.2271 9.78853Z",
    fill: "#25F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3774 19.0631C11.9442 19.0631 13.2445 17.7957 13.3026 16.2428L13.3073 2.39686L15.8193 2.3756C15.7666 2.09067 15.7376 1.79752 15.7376 1.49756H12.2775L12.2719 15.3648C12.2137 16.9177 10.9356 18.164 9.36883 18.164C8.88184 18.164 8.4233 18.0423 8.01962 17.8298C8.54827 18.5625 9.40698 19.0631 10.3774 19.0631Z",
    fill: "#25F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5516 7.10543V6.31146C19.5851 6.31146 18.685 6.02416 17.9301 5.5319C18.6023 6.30396 19.5153 6.88358 20.5516 7.10543Z",
    fill: "#25F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9301 5.5319C17.1937 4.68613 16.7462 3.58248 16.7462 2.37561L15.8193 2.3756C16.0634 3.69398 16.8459 4.82503 17.9301 5.5319Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36881 12.3467C7.76505 12.3467 6.46019 13.6515 6.46019 15.2554C6.46019 16.3722 7.0938 17.3426 8.01962 17.8298C7.6746 17.3517 7.46877 16.7668 7.46877 16.1334C7.46877 14.5296 8.77367 13.2247 10.3774 13.2247C10.6768 13.2247 10.964 13.2741 11.2357 13.3592V9.82672C10.9545 9.78847 10.6689 9.76453 10.3774 9.76453C10.327 9.76453 10.2772 9.76714 10.2271 9.76831V12.4811C9.95539 12.3961 9.66819 12.3467 9.36881 12.3467Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5516 7.08233V9.77163C18.7574 9.77163 17.0948 9.19764 15.7377 8.22352V15.2554C15.7377 18.7672 12.8806 21.6242 9.36882 21.6242C8.0117 21.6242 6.75337 21.1962 5.71891 20.47C6.88243 21.719 8.53979 22.5022 10.3774 22.5022C13.8892 22.5022 16.7462 19.6452 16.7462 16.1334V9.1016C18.1034 10.0756 19.766 10.6497 21.5602 10.6497V7.18945C21.2143 7.18945 20.8771 7.15199 20.5516 7.08233Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7377 15.2554V8.22352C17.0948 9.19761 18.7575 9.77163 20.5516 9.77163V7.08233C19.5153 6.86049 18.6023 6.30392 17.9301 5.5319C16.8459 4.82503 16.0634 3.69398 15.8193 2.3756L13.286 2.37561L13.2805 16.2429C13.2223 17.7957 11.9442 19.0421 10.3774 19.0421C9.40699 19.0421 8.54828 18.5625 8.0196 17.8298C7.09378 17.3426 6.46019 16.3722 6.46019 15.2554C6.46019 13.6515 7.76505 12.3467 9.36881 12.3467C9.66822 12.3467 9.95538 12.3961 10.2271 12.4812V9.76835C6.78466 9.84877 4.00861 12.6721 4.00861 16.1334C4.00861 17.8076 4.6589 19.332 5.71891 20.4699C6.7534 21.1962 8.0117 21.6242 9.36882 21.6242C12.8806 21.6242 15.7377 18.7672 15.7377 15.2554Z",
    fill: "black"
  }));
};

const _excluded$56 = ["color", "size"];
/**
 * @typedef {Object} ClaudeProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {ClaudeProps} props
 * @returns {JSX.Element}
 */

const Claude = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$56);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M5.92417 15.2958L9.8575 13.09L9.92417 12.8983L9.8575 12.7917H9.66667L9.00833 12.7517L6.76 12.6908L4.81083 12.61L2.9225 12.5083L2.44667 12.4075L2 11.82L2.04583 11.5267L2.44583 11.2592L3.0175 11.3092L4.28417 11.395L6.1825 11.5267L7.55917 11.6075L9.6 11.82H9.92417L9.97 11.6892L9.85833 11.6075L9.7725 11.5267L7.8075 10.1967L5.68083 8.79L4.5675 7.98L3.96417 7.57083L3.66083 7.18583L3.52917 6.34583L4.07583 5.74417L4.81 5.79417L4.9975 5.845L5.74167 6.41667L7.33167 7.64667L9.4075 9.17417L9.71167 9.4275L9.8325 9.34167L9.84833 9.28083L9.71167 9.0525L8.5825 7.01417L7.3775 4.93917L6.84083 4.07917L6.69917 3.56333C6.64519 3.36521 6.61608 3.16114 6.6125 2.95583L7.23583 2.11167L7.58 2L8.41 2.11167L8.76 2.415L9.27667 3.59333L10.1117 5.45083L11.4075 7.97583L11.7875 8.72417L11.99 9.4175L12.0658 9.63H12.1975V9.50833L12.3042 8.08667L12.5017 6.34083L12.6933 4.095L12.76 3.46167L13.0733 2.70333L13.6958 2.29333L14.1825 2.52667L14.5825 3.0975L14.5267 3.4675L14.2883 5.01L13.8225 7.42917L13.5192 9.0475H13.6958L13.8983 8.84583L14.7192 7.7575L16.0958 6.0375L16.7042 5.35417L17.4125 4.60083L17.8683 4.24167H18.7292L19.3625 5.1825L19.0792 6.15417L18.1925 7.27667L17.4583 8.22833L16.405 9.645L15.7467 10.7783L15.8075 10.87L15.9642 10.8533L18.3442 10.3483L19.63 10.115L21.1642 9.8525L21.8583 10.1758L21.9342 10.505L21.6608 11.1775L20.02 11.5825L18.0958 11.9675L15.23 12.645L15.195 12.67L15.2358 12.7208L16.5267 12.8425L17.0783 12.8725H18.43L20.9467 13.06L21.605 13.495L22 14.0267L21.9342 14.4308L20.9217 14.9475L16.3642 13.865L15.2708 13.5908H15.1192V13.6825L16.03 14.5725L17.7017 16.0808L19.7925 18.0225L19.8983 18.5042L19.63 18.8833L19.3467 18.8425L17.5092 17.4617L16.8 16.8392L15.195 15.4892H15.0883V15.6308L15.4583 16.1717L17.4125 19.1058L17.5142 20.0058L17.3725 20.3L16.8658 20.4775L16.3092 20.3758L15.1642 18.7717L13.985 16.9658L13.0325 15.3467L12.9158 15.4133L12.3542 21.4583L12.0908 21.7667L11.4833 22L10.9775 21.6158L10.7092 20.9933L10.9775 19.7633L11.3017 18.16L11.5642 16.885L11.8025 15.3017L11.9442 14.775L11.9342 14.74L11.8175 14.755L10.6225 16.3942L8.80583 18.8483L7.3675 20.3858L7.0225 20.5225L6.425 20.2142L6.48083 19.6625L6.815 19.1717L8.805 16.6417L10.005 15.0733L10.78 14.1683L10.775 14.0367H10.7292L5.44333 17.4667L4.50167 17.5883L4.09583 17.2083L4.14667 16.5867L4.33917 16.3842L5.92917 15.2908L5.92417 15.2958Z",
    fill: "#D97757"
  }));
};

const _excluded$57 = ["color", "size"];
/**
 * @typedef {Object} TikTokChannel2Props
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TikTokChannel2Props} props
 * @returns {JSX.Element}
 */

const TikTokChannel2 = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$57);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2263 2.29688H11.7806L11.7754 15.4009C11.7307 16.4323 10.879 17.2572 9.83945 17.2572C9.51548 17.2572 9.21053 17.1765 8.94039 17.0343C8.3194 16.7075 7.89858 16.0588 7.89858 15.3164C7.89858 14.2841 8.71046 13.4359 9.7285 13.3785L10.3608 13.3428V8.9139L9.67356 8.93153C6.22747 9.01996 3.45264 11.8494 3.45264 15.3164C3.45264 17.4791 4.53391 19.391 6.17823 20.5454C7.21507 21.2734 8.47812 21.7032 9.83945 21.7032C13.3618 21.7032 16.2263 18.8387 16.2263 15.3164V10.1932C17.3241 10.7499 18.5652 11.0639 19.8775 11.0639H20.5475V6.61797H19.8775C19.1448 6.61797 18.4632 6.40053 17.8903 6.02696C17.0661 5.48963 16.4732 4.63085 16.2884 3.63302C16.2481 3.41518 16.2263 3.19288 16.2263 2.96688V2.29688ZM13.1149 15.4396L13.1154 15.4272L13.1201 3.63688H14.9322C14.9432 3.71763 14.9562 3.79769 14.9708 3.87696C15.2243 5.24608 16.0361 6.41774 17.1584 7.14944C17.7634 7.54397 18.4595 7.81186 19.2075 7.91301V9.69102C17.9994 9.57164 16.8844 9.13287 15.947 8.46003L14.8863 7.69874V15.3164C14.8863 18.0987 12.6218 20.3632 9.83945 20.3632C8.76445 20.3632 7.76846 20.0246 6.94817 19.4487C5.64402 18.5331 4.79264 17.0219 4.79264 15.3164C4.79264 12.8128 6.62633 10.7281 9.02075 10.3358V12.1388C7.60614 12.5033 6.55858 13.7891 6.55858 15.3164C6.55858 16.5788 7.27526 17.6723 8.31635 18.2201C8.77094 18.4594 9.2892 18.5972 9.83945 18.5972C11.6089 18.5972 13.0493 17.1908 13.1149 15.4396Z",
    fill: color
  }));
};

const _excluded$58 = ["color", "size"];
/**
 * @typedef {Object} AutomationsPausedFilledProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AutomationsPausedFilledProps} props
 * @returns {JSX.Element}
 */

const AutomationsPausedFilled = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$58);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5H9V22.5H3V1.5Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5H21V22.5H15V1.5Z",
    fill: color
  }));
};

const _excluded$59 = ["color", "size"];
/**
 * @typedef {Object} AutomationsStoppedFilledProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AutomationsStoppedFilledProps} props
 * @returns {JSX.Element}
 */

const AutomationsStoppedFilled = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$59);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M3 3H21V21H3V3Z",
    fill: color
  }));
};

const _excluded$5a = ["color", "size"];
/**
 * @typedef {Object} External24Props
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {External24Props} props
 * @returns {JSX.Element}
 */

const External24 = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12V20.5H3.5V3.5H12L10.5 2H2V22H22V13.5L20.5 12Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0487 6.15842L17.965 5.06931L11.4162 11.6395L12.5 12.7286L19.0487 6.15842Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5266 9.01485V3.48515H15L13.5222 2H22.0044V10.5L20.5266 9.01485Z",
    fill: color
  }));
};

const _excluded$5b = ["color", "size"];
/**
 * @typedef {Object} BulletProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {BulletProps} props
 * @returns {JSX.Element}
 */

const Bullet = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
    fill: color
  }));
};

const _excluded$5c = ["color", "size"];
/**
 * @typedef {Object} NavCollapseProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {NavCollapseProps} props
 * @returns {JSX.Element}
 */

const NavCollapse = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M2 5L2 19H3.5L3.5 5H2Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.9296L7.07042 12L12 7.07042V5L5 12L12 19V16.9296Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.7999L22 12.7999V11.2999L12 11.2999V12.7999Z",
    fill: color
  }));
};

const _excluded$5d = ["color", "size"];
/**
 * @typedef {Object} NavExpandProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {NavExpandProps} props
 * @returns {JSX.Element}
 */

const NavExpand = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.07042L16.9296 12L12 16.9296L12 19L19 12L12 5V7.07042Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.2001H2L2 12.7001H12V11.2001Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19H22L22 5H20.5V19Z",
    fill: color
  }));
};

const _excluded$5e = ["color", "size"];
/**
 * @typedef {Object} RetailProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {RetailProps} props
 * @returns {JSX.Element}
 */

const Retail = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65942 6.39596C8.74782 4.08615 10.6786 2.22955 13.5313 2.22974C14.804 2.22982 15.7703 2.79884 16.392 3.68151C16.8584 4.34358 17.1228 5.16598 17.2189 6.04043L20.4245 8.22104L21.2307 20.8941L17.2299 22.1823L17.2235 22.1843L17.2231 22.235L17.0401 22.2175C16.9647 22.2215 16.8902 22.2141 16.8188 22.1962L2.67615 20.8386L4.98419 6.62784L7.65942 6.39596ZM13.4688 3.70764C14.2174 3.70769 14.7516 4.01979 15.1248 4.54955C15.3433 4.85983 15.5097 5.25215 15.6139 5.70651L9.42113 6.24326C10.3579 4.6749 11.7094 3.70753 13.4688 3.70764ZM15.8126 7.20062C15.8165 7.20852 15.8206 7.21633 15.8249 7.22405L15.7343 20.5852L4.41346 19.4985L6.27752 8.02136L15.8099 7.19514C15.8108 7.19697 15.8117 7.1988 15.8126 7.20062ZM17.2342 20.605L19.6596 19.8241L18.9741 9.04857L17.3202 7.92347L17.2342 20.605Z",
    fill: color
  }));
};

const _excluded$5f = ["color", "size"];
/**
 * @typedef {Object} MessengerChannelProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {MessengerChannelProps} props
 * @returns {JSX.Element}
 */

const MessengerChannel = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "url(#paint0_linear_MessengerChannel_7619_1719)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11.7277C5 8.13397 8.11522 5.22119 11.958 5.22119C15.8008 5.22119 18.916 8.13397 18.916 11.7277C18.916 15.3215 15.8008 18.2343 11.958 18.2343C11.2635 18.2343 10.5926 18.1391 9.9597 17.9617L7.58508 19.279V16.7886C6.00817 15.5961 5 13.7721 5 11.7277ZM7.77708 13.6454L9.65079 10.6474C9.98917 10.106 10.7189 9.97105 11.2285 10.3556L12.694 11.4614C12.8258 11.5608 13.0082 11.5578 13.1366 11.4542L15.1731 9.81011C15.4883 9.55573 15.9182 9.93534 15.7048 10.2795L13.7239 13.4747C13.3718 14.0426 12.5957 14.1618 12.0894 13.7257L10.7446 12.5673C10.6142 12.455 10.4225 12.4508 10.2873 12.5572L8.30465 14.1186C7.98785 14.3681 7.56336 13.9873 7.77708 13.6454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_MessengerChannel_7619_1719",
    x1: "13.5",
    y1: "27.5",
    x2: "3.5",
    y2: "-2.16672e-07",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.1137",
    stopColor: "#006DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#00C6FF"
  }))));
};

const _excluded$5g = ["color", "size"];
/**
 * @typedef {Object} EmailChannelProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {EmailChannelProps} props
 * @returns {JSX.Element}
 */

const EmailChannel = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "url(#paint0_linear_EmailChannel_7619_1721)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66592 8.5143C5.60503 8.71306 5.57227 8.92412 5.57227 9.14283V14.857C5.57227 16.0405 6.53164 16.9999 7.7151 16.9999H16.2864C17.4699 16.9999 18.4293 16.0405 18.4293 14.857V9.14283C18.4293 8.92411 18.3965 8.71305 18.3356 8.51428L12.4753 13.7234C12.2047 13.964 11.7968 13.964 11.5262 13.7234L5.66592 8.5143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22859 7.59944C6.26377 7.61861 6.29733 7.64204 6.32855 7.6698L11.5262 12.2899C11.7968 12.5305 12.2047 12.5305 12.4753 12.2899L17.6729 7.6698C17.7042 7.64204 17.7377 7.6186 17.7729 7.59944C17.3876 7.22826 16.8637 7 16.2864 7H7.7151C7.13784 7 6.61389 7.22826 6.22859 7.59944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_EmailChannel_7619_1721",
    x1: "24",
    y1: "29.5",
    x2: "6.5",
    y2: "-4.89987e-07",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4440FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.9493",
    stopColor: "#9D6FFF"
  }))));
};

const _excluded$5h = ["color", "size"];
/**
 * @typedef {Object} SmsChannelProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {SmsChannelProps} props
 * @returns {JSX.Element}
 */

const SmsChannel = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "url(#paint0_linear_SmsChannel_7619_1720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.042 5C15.8848 5 19 7.91278 19 11.5065C19 13.5509 17.9918 15.3749 16.4149 16.5675V19.0578L14.0403 17.7405C13.4074 17.9179 12.7365 18.0131 12.042 18.0131C8.1992 18.0131 5.08398 15.1003 5.08398 11.5065C5.08398 7.91278 8.1992 5 12.042 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_SmsChannel_7619_1720",
    x1: "12",
    y1: "32",
    x2: "28.5",
    y2: "-8.19564e-07",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03BAAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.922652",
    stopColor: "#2CE979"
  }))));
};

const _excluded$5i = ["color", "size"];
/**
 * @typedef {Object} WhatsAppChannelProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {WhatsAppChannelProps} props
 * @returns {JSX.Element}
 */

const WhatsAppChannel = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "url(#paint0_linear_WhatsAppChannel_7619_1726)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11.5065C5 7.91278 8.11522 5 11.958 5C15.8008 5 18.916 7.91278 18.916 11.5065C18.916 15.1003 15.8008 18.0131 11.958 18.0131C11.2635 18.0131 10.5926 17.9179 9.9597 17.7405L7.58508 19.0578V16.5675C6.00817 15.3749 5 13.5509 5 11.5065ZM15.7569 12.9568C15.7548 12.9336 15.7529 12.9136 15.7521 12.897C15.7441 12.7389 15.6021 12.7147 15.6021 12.7147C15.6021 12.7147 14.4386 12.1511 14.1994 12.0415C13.9605 11.932 13.8388 12.1107 13.8388 12.1107C13.8388 12.1107 13.486 12.5566 13.3724 12.7024C13.363 12.7145 13.354 12.7264 13.3452 12.7381C13.2468 12.8683 13.1697 12.9702 12.8982 12.8808C12.6022 12.7834 12.0087 12.4639 11.5237 12.0294C11.0391 11.595 10.6684 11.0201 10.5632 10.8458C10.4578 10.6712 10.5794 10.562 10.5794 10.562C10.5794 10.562 10.8864 10.2082 11.0333 10.0187C11.1771 9.83334 11.0925 9.62678 11.0559 9.5377C11.0551 9.53575 11.0536 9.53202 11.0536 9.53202C11.0186 9.44684 10.5468 8.3386 10.4779 8.18234C10.4092 8.02594 10.2592 8 10.2592 8H9.69973C9.59967 8 9.40786 8.12164 9.40786 8.12164C8.83294 8.48961 8.73552 9.34836 8.71867 9.53373C8.70182 9.71909 8.68497 10.1125 8.98829 10.7753C9.29161 11.4379 10.0331 12.3368 10.9488 13.1908C11.8315 14.0141 13.1685 14.385 13.6436 14.5168C13.6612 14.5217 13.6776 14.5263 13.6928 14.5305C14.1175 14.6491 15.0143 14.4385 15.4359 13.9831C15.8133 13.5759 15.7749 13.1541 15.7569 12.9568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_WhatsAppChannel_7619_1726",
    x1: "12",
    y1: "32",
    x2: "-4.5",
    y2: "-8.19564e-07",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EBF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.922652",
    stopColor: "#2CE979"
  }))));
};

const _excluded$5j = ["color", "size"];
/**
 * @typedef {Object} InstagramChannelProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {InstagramChannelProps} props
 * @returns {JSX.Element}
 */

const InstagramChannel = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "#FB2690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "url(#paint0_linear_InstagramChannel_7619_1727)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "url(#paint1_radial_7619_1727)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "url(#paint2_radial_7619_1727)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 5C7.85749 5 6.86834 5.40972 6.13903 6.13903C5.40972 6.86834 5 7.85749 5 8.88889V15.1111C5 16.1425 5.40972 17.1317 6.13903 17.861C6.86834 18.5903 7.85749 19 8.88889 19H15.1111C16.1425 19 17.1317 18.5903 17.861 17.861C18.5903 17.1317 19 16.1425 19 15.1111V8.88889C19 7.85749 18.5903 6.86834 17.861 6.13903C17.1317 5.40972 16.1425 5 15.1111 5H8.88889ZM16.6667 6.55556C17.0944 6.55556 17.4444 6.90556 17.4444 7.33333C17.4444 7.76111 17.0944 8.11111 16.6667 8.11111C16.2389 8.11111 15.8889 7.76111 15.8889 7.33333C15.8889 6.90556 16.2389 6.55556 16.6667 6.55556ZM12 8.11111C13.0314 8.11111 14.0206 8.52083 14.7499 9.25014C15.4792 9.97945 15.8889 10.9686 15.8889 12C15.8889 13.0314 15.4792 14.0206 14.7499 14.7499C14.0206 15.4792 13.0314 15.8889 12 15.8889C10.9686 15.8889 9.97945 15.4792 9.25014 14.7499C8.52083 14.0206 8.11111 13.0314 8.11111 12C8.11111 10.9686 8.52083 9.97945 9.25014 9.25014C9.97945 8.52083 10.9686 8.11111 12 8.11111ZM12 9.66667C11.6935 9.66677 11.39 9.72724 11.1068 9.84464C10.8237 9.96203 10.5664 10.134 10.3498 10.3509C10.1331 10.5677 9.96125 10.825 9.84404 11.1083C9.72684 11.3915 9.66656 11.695 9.66667 12.0016C9.66677 12.3081 9.72724 12.6116 9.84464 12.8947C9.96203 13.1779 10.134 13.4351 10.3509 13.6518C10.5677 13.8685 10.825 14.0403 11.1083 14.1575C11.3915 14.2747 11.695 14.335 12.0016 14.3349C12.6206 14.3347 13.2142 14.0886 13.6518 13.6507C14.0894 13.2128 14.3351 12.619 14.3349 12C14.3347 11.381 14.0886 10.7873 13.6507 10.3498C13.2128 9.91218 12.619 9.66646 12 9.66667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_InstagramChannel_7619_1727",
    x1: "7.5",
    y1: "-10",
    x2: "13",
    y2: "15.5",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.122265",
    stopColor: "#4263DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#D53585",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7619_1727",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.50955e-07 29.5) rotate(-38.6798) scale(29.7078)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#FF3F00",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_7619_1727",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.5 26) rotate(-37.9987) scale(20.3039)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.01",
    stopColor: "#FDDB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#F06942",
    stopOpacity: "0"
  }))));
};

const _excluded$5k = ["color", "size"];
/**
 * @typedef {Object} WebChatProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {WebChatProps} props
 * @returns {JSX.Element}
 */

const WebChat = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "url(#paint0_linear_WebChat_7619_1728)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.387 7C15.6905 7 16.8466 7.64005 17.6669 8.54974C18.4861 9.45817 19 10.6663 19 11.8657C19 12.4379 18.8888 13.1034 18.6846 13.7203C18.4833 14.3284 18.1786 14.9284 17.7632 15.3443L14.6666 18.7154C14.6016 18.7861 14.4935 18.8871 14.3348 18.9416L14.2119 18.6007L14.3348 18.9416C14.1534 19.0038 13.9125 19.0306 13.6845 18.9491C13.4244 18.8561 13.2306 18.6373 13.1907 18.3237C13.1886 18.3073 13.1876 18.2907 13.1876 18.2742V16.7314H9.61296C8.30952 16.7314 7.15339 16.0913 6.3331 15.1816C5.51394 14.2732 5 13.0651 5 11.8657C5 10.6663 5.51394 9.45817 6.3331 8.54974C7.15339 7.64005 8.30952 7 9.61296 7H14.387ZM15.75 10.5C15.75 10.0858 15.4142 9.75 15 9.75H10C9.58579 9.75 9.25 10.0858 9.25 10.5C9.25 10.9142 9.58579 11.25 10 11.25H15C15.4142 11.25 15.75 10.9142 15.75 10.5ZM15 12.25C15.4142 12.25 15.75 12.5858 15.75 13C15.75 13.4142 15.4142 13.75 15 13.75H12C11.5858 13.75 11.25 13.4142 11.25 13C11.25 12.5858 11.5858 12.25 12 12.25H15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_WebChat_7619_1728",
    x1: "24",
    y1: "-12",
    x2: "-13.5",
    y2: "24",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B18E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#006DFF"
  }))));
};

const _excluded$5l = ["color", "size"];
/**
 * @typedef {Object} TelegramChannelProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TelegramChannelProps} props
 * @returns {JSX.Element}
 */

const TelegramChannel = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_TelegramChannel_7619_1729)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43201 11.8734C8.93026 10.3493 11.263 9.34452 12.4301 8.85905C15.7627 7.47294 16.4551 7.23216 16.9065 7.22421C17.0058 7.22246 17.2277 7.24706 17.3715 7.36372C17.4929 7.46223 17.5263 7.5953 17.5423 7.6887C17.5583 7.78209 17.5782 7.99485 17.5623 8.16109C17.3817 10.0586 16.6003 14.6633 16.2028 16.7885C16.0346 17.6877 15.7034 17.9892 15.3827 18.0187C14.6858 18.0829 14.1567 17.5582 13.4817 17.1158C12.4256 16.4235 11.8289 15.9925 10.8037 15.3169C9.61896 14.5362 10.387 14.107 11.0622 13.4057C11.2389 13.2222 14.3093 10.4295 14.3687 10.1761C14.3762 10.1444 14.3831 10.0263 14.3129 9.96396C14.2427 9.9016 14.1392 9.92293 14.0644 9.93989C13.9585 9.96393 12.2713 11.0791 9.00276 13.2855C8.52385 13.6143 8.09007 13.7745 7.70141 13.7661C7.27295 13.7569 6.44876 13.5239 5.83606 13.3247C5.08456 13.0804 4.48728 12.9513 4.53929 12.5364C4.56638 12.3203 4.86395 12.0993 5.43201 11.8734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_TelegramChannel_7619_1729",
    x1: "4",
    y1: "2",
    x2: "18",
    y2: "23",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#008ED1"
  }))));
};

const _excluded$5m = ["color", "size"];
/**
 * @typedef {Object} TikTokChannelProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {TikTokChannelProps} props
 * @returns {JSX.Element}
 */

const TikTokChannel = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "url(#paint0_linear_TikTokChannel_10099_15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2218 7.67026C15.5215 7.21368 15.016 6.48316 14.8584 5.63156C14.8243 5.44756 14.8056 5.2582 14.8056 5.06445H12.5707L12.5671 14.0214C12.5295 15.0244 11.704 15.8295 10.6919 15.8295C10.3774 15.8295 10.0812 15.7508 9.82047 15.6136C9.22248 15.2989 8.81322 14.6721 8.81322 13.9508C8.81322 12.9148 9.65607 12.072 10.6919 12.072C10.8853 12.072 11.0708 12.1039 11.2463 12.1589V9.87721C11.0647 9.85248 10.8802 9.83703 10.6919 9.83703C8.4236 9.83703 6.57828 11.6825 6.57828 13.9508C6.57828 15.3425 7.27362 16.5741 8.33444 17.3189C9.0026 17.788 9.81537 18.0645 10.6919 18.0645C12.9603 18.0645 14.8056 16.2191 14.8056 13.9508V9.40884C15.6822 10.038 16.7561 10.4088 17.915 10.4088V8.17379C17.2908 8.17379 16.7094 7.98821 16.2218 7.67026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_TikTokChannel_10099_15",
    x1: "0",
    y1: "0",
    x2: "24",
    y2: "24",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1"
  }))));
};

const _excluded$5n = ["color", "size"];
/**
 * @typedef {Object} AiKnowledgeProps
 * @property {string} [color='currentColor']
 * @property {string|number} [size='24']
 *
 * @param {AiKnowledgeProps} props
 * @returns {JSX.Element}
 */

const AiKnowledge = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, otherProps), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5L5.47541 19.5156V3.48438H17.6721V10.4115H19.1475V2H4V21H12V19.5Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4435 18.1028C20.8989 17.8205 21.3926 17.5919 21.9162 17.426C21.9443 17.4171 21.9724 17.4083 22.0007 17.3998L22.5 17.25L22.0128 17.1038C22.0088 17.1026 22.0047 17.1014 22.0007 17.1002C21.9724 17.0917 21.9443 17.0829 21.9162 17.074C21.3926 16.9081 20.8989 16.6795 20.4435 16.3972C19.5985 15.8733 18.8851 15.1644 18.3563 14.3275C17.9593 13.6991 17.6663 12.9985 17.5 12.25C17.3337 12.9985 17.0407 13.6991 16.6437 14.3275C16.1149 15.1644 15.4015 15.8733 14.5565 16.3972C14.1011 16.6795 13.6074 16.9081 13.0838 17.074C13.0517 17.0842 13.0195 17.0941 12.9872 17.1038L12.5 17.25L12.9872 17.3962C13.0195 17.4059 13.0517 17.4158 13.0838 17.426C13.6074 17.5919 14.1011 17.8205 14.5565 18.1028C15.4015 18.6267 16.1149 19.3356 16.6437 20.1725C17.0407 20.8009 17.3337 21.5015 17.5 22.25C17.6663 21.5015 17.9593 20.8009 18.3563 20.1725C18.8851 19.3356 19.5985 18.6267 20.4435 18.1028Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7541 6.84896H16.0984V8.33333H6.7541V6.84896Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0656 11.8958H6.7541V10.4115H12.0656V11.8958Z",
    fill: color
  }));
};

export { Action, ActionMarkConversationAsDone, Activecampaign, AddCircle, AddTag, Ads, AdsAd, AdsAdSet, Ai, AiFilled, AiInstantAnswers, AiIntention, AiKnowledge, AiPositiveCommentReplies, AiStep, AlignCenter, AlignLeft, AlignRight, AlignWide, All, Amazon, Analytics, Apple, Apptivo, Archive, ArrowDown, ArrowDownRight, ArrowDrag, ArrowDropDown, ArrowDropUp, ArrowLeft, ArrowRight, ArrowTopRight, ArrowUp, Assign, AssignGroup, Attach, Attention, Audience, Audio, Automation, AutomationsPausedFilled, AutomationsStoppedFilled, Basics, Bigcommerce, Bold, Book, Bot, BotRemove, Broadcasting, BuilderAudio, BuilderCard, BuilderGallery, BuilderInput, BuilderList, BuilderText, Bullet, ButtonEmailBlock, Calendar, Camera, CannedResponse, Canva, Cart, Cgt20, ChatGpt, CheckCircle, CheckboxDone, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Claude, ClearMobile, Close, Cloud, CloudDownload, CloudError, CloudUpload, Community, Condition, ConvertChannels, ConvertKit, Copy, CopyToAnotherFlow, Coupon, Create, Creator, CreditCard, CufArray, CufBoolean, CufEnum, CufNoIcon, CufNumber, CufText, CustomField, CustomFieldRemove, Dashboard, Data, DeepSeek, DefaultReply, Delay, Delete, DeleteForever, DeleteTag, DoubleChevrotBack, DoubleChevrotCollapse, DoubleChevrotExpand, DoubleChevrotForward, DoubleTick, DragConnector, DragItem, DuplicateSms, Edit, EmailChannel, ExitFullscreen, Export, External24, Facebook, FacebookMessenger, Faq, FbChat, Female, Filter, Fitness, Flodesk, Flow, Folder, FolderAdd, FolderAdsCampaign, FolderOpen, Fullscreen, GoToFlow, Google, GoogleAlt, GoogleSheets, GrowthTools, GtAdsJson, GtBar, GtBox, GtButton, GtCheckbox, GtCustomerChat, GtFbCode, GtFbComment, GtLanding, GtModal, GtPageTakeover, GtRef, GtSlideIn, GtTakeover, GuestChatChannel, HeadlineBlockEmail, Health, Help, Hide, Home, Hotel, Hotmart, Hubspot, Id, IgLiveComments, Image, Inbox, IncreaseEngagement, Info, InstagramChannel, InstagramChannel3, InstagramDmList, Integromat, Italic, Kajabi, Keyboard, Keywords, Klaviyo, Link, LiveChat, Location, Logout, Magento, MagicWand, Magnet, MailChimp, Male, Mention, Menu, MessageBack, MessageOpen, MessageTemplates, Messenger, MessengerChannel, MessengerList, Mic, Minus, MoreChannels, MoreHor, MoreVert, MosaicView, MoveTo, Nationality, NavCollapse, NavExpand, NewCuFs, NewMessage, NewOrphanMobile, NodeAdd, Note, Notification, NotificationMute, OmnichannelWidget, Options, Organization, OrphanAction, OrphanAction2, OrphanAdStatistics, OrphanAdsCampaignMessages, OrphanAdsCampaignTraffic, OrphanArchive, OrphanBuilderSelect, OrphanBuyButton, OrphanCall, OrphanCardQuadrant, OrphanClicked, OrphanDesktop, OrphanFbChat, OrphanFullScreenPreview, OrphanFullText, OrphanIntegration, OrphanIntegromat, OrphanLiveChatDone, OrphanLongArrow, OrphanMainMenu, OrphanMinimizedChat, OrphanMobile, OrphanOpen, OrphanRestore, OrphanSplit, OrphanSubscribedNoInfo, OrphanTableView, OrphanTriggerZap, OtnRequest, Pause, PhoneOutgoing, Pin, Pipedrive, Play, Plus, Popular, PopularFilled, Privacy, ProfessionalConsulting, Protect, PublicChangelog, Publish, Qr, Question, RealEstate, Redo, Reels, Retail, Retry, ReturnKey, Rules, Salesforce, Search, SelectAll, Send, Send2, SendMessage, Sequences, SequencesAdd, SequencesRemove, Settings, Share, Shopify, ShopifyDeprecated, Show, ShowFlow, ShowcaseProducts, Smile, Sms, SmsChannel, SolidArrowUnsorted, Sort, SortDown, SortUp, Spacing, Spinner, SponsoredMessages, SponsoredMessages2, Star, Starred, StartFlow, Stop, Stop2, StopRecord, SystemField, TableView, Tap, Telegram, TelegramChannel, TelegramChannel2, TemplateMediaBg, TemplateStore, TemplateTextMedia, Templates, Text, ThumbDown, ThumbUp, Tick, Ticket, TikTok, TikTokChannel, TikTokChannel2, Time, TimeAdd, Transgender, TriggerFbAds, TriggerFbComments, TriggerFbComments20, TriggerIgStoryReply, TriggerNewSubscriber, Triggers, TriggersLines, Unassign, Underline, Undo, Unpin, Unprotect, Unread, Unsubscribed, User, UserAdd, Video, VideoCircleTg, Warning, WebChat, WebsiteRedirect, WelcomeMessage, WhatsAppChannel, WhatsAppWidget, Wiseagent, Woocommerce, Zapier, Zillow };
